/**-----------------------------------------------------------------------------------------
* Copyright © 2026 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
import * as i0 from '@angular/core';
import { EventEmitter, Output, HostBinding, Input, Component, Directive, Injectable, HostListener, ViewChild, ViewChildren, forwardRef, isDevMode, ViewContainerRef, ContentChild, ContentChildren, ChangeDetectionStrategy, NgModule } from '@angular/core';
import * as i10 from '@progress/kendo-angular-common';
import { isDocumentAvailable, isObjectPresent, removeHTMLAttributes, parseAttributes, isSafari, normalizeKeys, Keys, setHTMLAttributes, replaceMessagePlaceholder, isChanged, TemplateContextDirective, ResizeSensorComponent, closest as closest$1, hasFocusableParent, parseCSSClassNames, isControlRequired, guid, hasObservers, SeparatorComponent, SuffixTemplateDirective, PrefixTemplateDirective, KendoInput, KENDO_WEBMCP_HOST, MultiTabStop, anyChanged, EventsOutsideAngularDirective, scrollbarWidth, ToggleButtonTabStopDirective, ResizeBatchService, KENDO_ADORNMENTS, KENDO_TOGGLEBUTTONTABSTOP } from '@progress/kendo-angular-common';
const _c0 = ["kendoSearchbar", ""];
const _c1 = ["content"];
const _c2 = ["list"];
const _c3 = ["virtualContainer"];
const _c4 = a0 => ({
  "k-disabled": a0
});
const _c5 = (a0, a1) => ({
  templateRef: a0,
  $implicit: a1
});
const _c6 = (a0, a1, a2) => ({
  "height.px": a0,
  "minHeight.px": a1,
  "boxSizing": a2
});
const _c7 = (a0, a1) => ({
  "k-disabled": a0,
  "k-table-alt-row": a1
});
const _forTrack0 = ($index, $item) => $item.groupIndex;
const _forTrack1 = ($index, $item) => $item.offsetIndex;
function ListComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c4, ctx_r0.isDisabledDefaultItem))("index", -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getDefaultItemText(), " ");
  }
}
function ListComponent_Conditional_1_ng_template_1_Template(rf, ctx) {}
function ListComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, ListComponent_Conditional_1_ng_template_1_Template, 0, 0, "ng-template", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c4, ctx_r0.isDisabledDefaultItem))("index", -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction2(5, _c5, ctx_r0.template.templateRef, ctx_r0.defaultItem));
  }
}
function ListComponent_Conditional_2_Conditional_1_ng_template_0_Template(rf, ctx) {}
function ListComponent_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListComponent_Conditional_2_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction2(1, _c5, ctx_r0.customItemTemplate.templateRef, ctx_r0.text));
  }
}
function ListComponent_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.useCustomValueText, " ");
  }
}
function ListComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵconditionalCreate(1, ListComponent_Conditional_2_Conditional_1_Template, 1, 4, null, 10)(2, ListComponent_Conditional_2_Conditional_2_Template, 1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("multipleSelection", true)("index", -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.customItemTemplate ? 1 : 2);
  }
}
function ListComponent_Conditional_3_Conditional_1_ng_template_0_Template(rf, ctx) {}
function ListComponent_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListComponent_Conditional_3_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction2(1, _c5, ctx_r0.fixedGroupTemplate.templateRef, ctx_r0.currentGroup));
  }
}
function ListComponent_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r0.listGroupStickyHeaderTextClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.currentGroup);
  }
}
function ListComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵconditionalCreate(1, ListComponent_Conditional_3_Conditional_1_Template, 1, 4, null, 10);
    i0.ɵɵconditionalCreate(2, ListComponent_Conditional_3_Conditional_2_Template, 2, 3, "span", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.listGroupStickyHeaderClass);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction3(5, _c6, ctx_r0.virtual == null ? null : ctx_r0.virtual.itemHeight, ctx_r0.virtual == null ? null : ctx_r0.virtual.itemHeight, ctx_r0.virtual ? "border-box" : "inherit"));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.fixedGroupTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.fixedGroupTemplate ? 2 : -1);
  }
}
function ListComponent_Conditional_6_For_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 16);
    i0.ɵɵlistener("change", function ListComponent_Conditional_6_For_3_Conditional_1_Template_input_change_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ɵ$index_33_r3 = i0.ɵɵnextContext().$index;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onCheckedChange($event, ɵ$index_33_r3 + ctx_r0.startFrom));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ɵ$index_33_r3 = i0.ɵɵnextContext().$index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.checkboxClasses)("checked", ctx_r0.isChecked(ɵ$index_33_r3));
  }
}
function ListComponent_Conditional_6_For_3_Conditional_2_ng_template_0_Template(rf, ctx) {}
function ListComponent_Conditional_6_For_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListComponent_Conditional_6_For_3_Conditional_2_ng_template_0_Template, 0, 0, "ng-template", 10);
  }
  if (rf & 2) {
    const dataItem_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction2(1, _c5, ctx_r0.template.templateRef, dataItem_r4));
  }
}
function ListComponent_Conditional_6_For_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.getText(dataItem_r4));
  }
}
function ListComponent_Conditional_6_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 13);
    i0.ɵɵconditionalCreate(1, ListComponent_Conditional_6_For_3_Conditional_1_Template, 1, 2, "input", 14);
    i0.ɵɵconditionalCreate(2, ListComponent_Conditional_6_For_3_Conditional_2_Template, 1, 4, null, 10);
    i0.ɵɵconditionalCreate(3, ListComponent_Conditional_6_For_3_Conditional_3_Template, 2, 1, "span", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ɵ$index_33_r3 = ctx.$index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r0.listItemClass);
    i0.ɵɵstyleProp("width", ctx_r0.rowWidth ?? null, "px");
    i0.ɵɵproperty("checkboxes", ctx_r0.checkboxes)("height", ctx_r0.virtual == null ? null : ctx_r0.virtual.itemHeight)("index", ɵ$index_33_r3 + ctx_r0.startFrom)("multipleSelection", ctx_r0.multipleSelection)("ngClass", i0.ɵɵpureFunction2(15, _c7, ctx_r0.isDisabled(ɵ$index_33_r3), ctx_r0.isAltRow(ɵ$index_33_r3)));
    i0.ɵɵattribute("id", ctx_r0.optionPrefix + "-" + ɵ$index_33_r3)("tabIndex", -1)("aria-selected", ctx_r0.isItemSelected(ɵ$index_33_r3));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.checkboxes.enabled ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.template ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.template ? 3 : -1);
  }
}
function ListComponent_Conditional_6_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-resize-sensor", 17);
    i0.ɵɵlistener("resize", function ListComponent_Conditional_6_Conditional_4_Template_kendo_resize_sensor_resize_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.listResize.emit());
    });
    i0.ɵɵelementEnd();
  }
}
function ListComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", null, 1);
    i0.ɵɵrepeaterCreate(2, ListComponent_Conditional_6_For_3_Template, 4, 18, "li", 12, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵconditionalCreate(4, ListComponent_Conditional_6_Conditional_4_Template, 1, 0, "kendo-resize-sensor");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.listClass);
    i0.ɵɵattribute("role", "listbox")("id", ctx_r0.id)("aria-live", ctx_r0.ariaLive)("aria-multiselectable", ctx_r0.isMultiselect)("aria-hidden", !ctx_r0.show);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r0.data);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r0.virtual ? 4 : -1);
  }
}
function ListComponent_Conditional_7_For_3_Conditional_2_Conditional_2_ng_template_0_Template(rf, ctx) {}
function ListComponent_Conditional_7_For_3_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListComponent_Conditional_7_For_3_Conditional_2_Conditional_2_ng_template_0_Template, 0, 0, "ng-template", 10);
  }
  if (rf & 2) {
    const dataItem_r6 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction2(1, _c5, ctx_r0.groupTemplate.templateRef, dataItem_r6.value));
  }
}
function ListComponent_Conditional_7_For_3_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const dataItem_r6 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵtextInterpolate1(" ", dataItem_r6.value, " ");
  }
}
function ListComponent_Conditional_7_For_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 21)(1, "span");
    i0.ɵɵconditionalCreate(2, ListComponent_Conditional_7_For_3_Conditional_2_Conditional_2_Template, 1, 4, null, 10);
    i0.ɵɵconditionalCreate(3, ListComponent_Conditional_7_For_3_Conditional_2_Conditional_3_Template, 1, 1);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const dataItem_r6 = i0.ɵɵnextContext().$implicit;
    const groupUl_r7 = i0.ɵɵreference(1);
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r0.listGroupItemClass);
    i0.ɵɵstyleProp("width", ctx_r0.rowWidth ?? null, "px");
    i0.ɵɵclassProp("k-table-alt-row", ctx_r0.isAltRow(dataItem_r6.index - 1));
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction3(13, _c6, ctx_r0.virtual == null ? null : ctx_r0.virtual.itemHeight, ctx_r0.virtual == null ? null : ctx_r0.virtual.itemHeight, ctx_r0.virtual ? "border-box" : "inherit"));
    i0.ɵɵattribute("group-index", dataItem_r6.index)("id", groupUl_r7.getAttribute("aria-labelledby"));
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r0.listGroupItemTextClass);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.groupTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.groupTemplate ? 3 : -1);
  }
}
function ListComponent_Conditional_7_For_3_For_4_Conditional_1_ng_template_0_Template(rf, ctx) {}
function ListComponent_Conditional_7_For_3_For_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ListComponent_Conditional_7_For_3_For_4_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 10);
  }
  if (rf & 2) {
    const item_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction2(1, _c5, ctx_r0.template.templateRef, item_r8.value));
  }
}
function ListComponent_Conditional_7_For_3_For_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.getText(item_r8.value));
  }
}
function ListComponent_Conditional_7_For_3_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 22);
    i0.ɵɵconditionalCreate(1, ListComponent_Conditional_7_For_3_For_4_Conditional_1_Template, 1, 4, null, 10);
    i0.ɵɵconditionalCreate(2, ListComponent_Conditional_7_For_3_For_4_Conditional_2_Template, 2, 1, "span", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r8 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r0.listItemClass);
    i0.ɵɵstyleProp("width", ctx_r0.rowWidth ?? null, "px");
    i0.ɵɵproperty("height", ctx_r0.virtual == null ? null : ctx_r0.virtual.itemHeight)("index", item_r8.offsetIndex)("multipleSelection", ctx_r0.multipleSelection)("ngClass", i0.ɵɵpureFunction2(14, _c7, ctx_r0.isDisabled(item_r8.offsetIndex), ctx_r0.isAltRow(item_r8.index - 1)));
    i0.ɵɵattribute("absolute-index", item_r8.index)("id", ctx_r0.optionPrefix + "-" + (item_r8.index - 1 - item_r8.groupIndex))("tabIndex", -1)("aria-selected", ctx_r0.isItemSelected(item_r8.offsetIndex));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.template ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.template ? 2 : -1);
  }
}
function ListComponent_Conditional_7_For_3_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-resize-sensor", 17);
    i0.ɵɵlistener("resize", function ListComponent_Conditional_7_For_3_Conditional_5_Template_kendo_resize_sensor_resize_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.listResize.emit());
    });
    i0.ɵɵelementEnd();
  }
}
function ListComponent_Conditional_7_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 18, 2);
    i0.ɵɵconditionalCreate(2, ListComponent_Conditional_7_For_3_Conditional_2_Template, 4, 17, "li", 19);
    i0.ɵɵrepeaterCreate(3, ListComponent_Conditional_7_For_3_For_4_Template, 3, 17, "li", 20, _forTrack1);
    i0.ɵɵconditionalCreate(5, ListComponent_Conditional_7_For_3_Conditional_5_Template, 1, 0, "kendo-resize-sensor");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r6 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("role", "group")("aria-labelledby", ctx_r0.generateGroupId(dataItem_r6));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(dataItem_r6.header ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(dataItem_r6.items);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r0.virtual ? 5 : -1);
  }
}
function ListComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, null, 1);
    i0.ɵɵrepeaterCreate(2, ListComponent_Conditional_7_For_3_Template, 6, 4, "ul", 18, _forTrack0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r0.groupedData);
  }
}
function ListComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9, 3)(2, "div")(3, "kendo-resize-sensor", 17);
    i0.ɵɵlistener("resize", function ListComponent_Conditional_8_Template_kendo_resize_sensor_resize_3_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.listResize.emit());
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("height", ctx_r0.scrollHeight, "px");
  }
}
const _c8 = ["actionSheetSearchBar"];
const _c9 = a0 => ({
  duration: a0
});
const _c10 = (a0, a1) => ({
  "k-adaptive-actionsheet": true,
  "k-actionsheet-fullscreen": a0,
  "k-actionsheet-bottom": a1
});
const _c11 = a0 => ({
  height: a0
});
function AdaptiveRendererComponent_ng_template_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.title);
  }
}
function AdaptiveRendererComponent_ng_template_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.subtitle);
  }
}
function AdaptiveRendererComponent_ng_template_2_Conditional_7_Conditional_3_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-icon", 17);
  }
}
function AdaptiveRendererComponent_ng_template_2_Conditional_7_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AdaptiveRendererComponent_ng_template_2_Conditional_7_Conditional_3_ng_template_0_Template, 1, 0, "ng-template", 16);
  }
}
function AdaptiveRendererComponent_ng_template_2_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "kendo-textbox", 15, 1);
    i0.ɵɵlistener("valueChange", function AdaptiveRendererComponent_ng_template_2_Conditional_7_Template_kendo_textbox_valueChange_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onValueChange($event));
    });
    i0.ɵɵconditionalCreate(3, AdaptiveRendererComponent_ng_template_2_Conditional_7_Conditional_3_Template, 1, 0, null, 16);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r1.searchBarValue || "")("placeholder", ctx_r1.filterable ? ctx_r1.messageFor("filterInputPlaceholder") : ctx_r1.placeholder);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.filterable ? 3 : -1);
  }
}
function AdaptiveRendererComponent_ng_template_2_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function AdaptiveRendererComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "div", 6);
    i0.ɵɵconditionalCreate(3, AdaptiveRendererComponent_ng_template_2_Conditional_3_Template, 2, 1, "div", 7);
    i0.ɵɵconditionalCreate(4, AdaptiveRendererComponent_ng_template_2_Conditional_4_Template, 2, 1, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 9)(6, "button", 10);
    i0.ɵɵlistener("click", function AdaptiveRendererComponent_ng_template_2_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleClose());
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵconditionalCreate(7, AdaptiveRendererComponent_ng_template_2_Conditional_7_Template, 4, 3, "div", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 12)(9, "div", 13);
    i0.ɵɵtemplate(10, AdaptiveRendererComponent_ng_template_2_ng_container_10_Template, 1, 0, "ng-container", 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.title ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.subtitle ? 4 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("svgIcon", ctx_r1.checkIcon)("tabIndex", -1);
    i0.ɵɵattribute("title", ctx_r1.messageFor("adaptiveCloseButtonTitle"));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showTextInput ? 7 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.sharedPopupActionSheetTemplate);
  }
}
const _c12 = ["container"];
const _c13 = ["popupTemplate"];
const _c14 = ["optionsList"];
const _c15 = a0 => ({
  templateRef: a0
});
function AutoCompleteComponent_Conditional_2_ng_template_1_Template(rf, ctx) {}
function AutoCompleteComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtemplate(1, AutoCompleteComponent_Conditional_2_ng_template_1_Template, 0, 0, "ng-template", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.prefixTemplate == null ? null : ctx_r1.prefixTemplate.templateRef);
  }
}
function AutoCompleteComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-separator");
  }
}
function AutoCompleteComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵlistener("click", function AutoCompleteComponent_Conditional_5_Template_span_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearValue($event));
    })("mousedown", function AutoCompleteComponent_Conditional_5_Template_span_mousedown_0_listener($event) {
      return $event.preventDefault();
    });
    i0.ɵɵelement(1, "kendo-icon-wrapper", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("visibility", ctx_r1.clearButtonVisibility);
    i0.ɵɵattribute("title", ctx_r1.messageFor("clearTitle"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("svgIcon", ctx_r1.xIcon);
  }
}
function AutoCompleteComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 9);
  }
}
function AutoCompleteComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-separator");
  }
}
function AutoCompleteComponent_Conditional_8_ng_template_1_Template(rf, ctx) {}
function AutoCompleteComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtemplate(1, AutoCompleteComponent_Conditional_8_ng_template_1_Template, 0, 0, "ng-template", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.suffixTemplate == null ? null : ctx_r1.suffixTemplate.templateRef);
  }
}
function AutoCompleteComponent_ng_template_9_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function AutoCompleteComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AutoCompleteComponent_ng_template_9_ng_container_0_Template, 1, 0, "ng-container", 15);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const sharedPopupActionSheetTemplate_r4 = i0.ɵɵreference(16);
    i0.ɵɵproperty("ngTemplateOutlet", sharedPopupActionSheetTemplate_r4);
  }
}
function AutoCompleteComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-resize-sensor", 16);
    i0.ɵɵlistener("resize", function AutoCompleteComponent_Conditional_13_Template_kendo_resize_sensor_resize_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onResize());
    });
    i0.ɵɵelementEnd();
  }
}
function AutoCompleteComponent_ng_template_15_Conditional_0_ng_template_0_Template(rf, ctx) {}
function AutoCompleteComponent_ng_template_15_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AutoCompleteComponent_ng_template_15_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r1.headerTemplate.templateRef));
  }
}
function AutoCompleteComponent_ng_template_15_Conditional_3_Conditional_1_ng_template_0_Template(rf, ctx) {}
function AutoCompleteComponent_ng_template_15_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AutoCompleteComponent_ng_template_15_Conditional_3_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r1.noDataTemplate == null ? null : ctx_r1.noDataTemplate.templateRef));
  }
}
function AutoCompleteComponent_ng_template_15_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.messageFor("noDataText"));
  }
}
function AutoCompleteComponent_ng_template_15_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵconditionalCreate(1, AutoCompleteComponent_ng_template_15_Conditional_3_Conditional_1_Template, 1, 3, null, 17);
    i0.ɵɵconditionalCreate(2, AutoCompleteComponent_ng_template_15_Conditional_3_Conditional_2_Template, 2, 1, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-live", "polite");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.noDataTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.noDataTemplate ? 2 : -1);
  }
}
function AutoCompleteComponent_ng_template_15_Conditional_4_ng_template_0_Template(rf, ctx) {}
function AutoCompleteComponent_ng_template_15_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AutoCompleteComponent_ng_template_15_Conditional_4_ng_template_0_Template, 0, 0, "ng-template", 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r1.footerTemplate.templateRef));
  }
}
function AutoCompleteComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵconditionalCreate(0, AutoCompleteComponent_ng_template_15_Conditional_0_Template, 1, 3, null, 17);
    i0.ɵɵelementStart(1, "kendo-list", 18, 3);
    i0.ɵɵlistener("pageChange", function AutoCompleteComponent_ng_template_15_Template_kendo_list_pageChange_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.pageChange($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(3, AutoCompleteComponent_ng_template_15_Conditional_3_Template, 3, 3, "div", 19);
    i0.ɵɵconditionalCreate(4, AutoCompleteComponent_ng_template_15_Conditional_4_Template, 1, 3, null, 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.headerTemplate ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("size", ctx_r1.isAdaptive ? "large" : ctx_r1.size)("rounded", ctx_r1.rounded)("id", ctx_r1.listBoxId)("optionPrefix", ctx_r1.optionPrefix)("data", ctx_r1.data)("textField", ctx_r1.valueField)("valueField", ctx_r1.valueField)("template", ctx_r1.template)("groupTemplate", ctx_r1.groupTemplate)("fixedGroupTemplate", ctx_r1.fixedGroupTemplate)("height", ctx_r1.listHeight)("show", ctx_r1.isOpen)("virtual", ctx_r1.virtual)("showStickyHeader", ctx_r1.showStickyHeader);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.data.length === 0 ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.footerTemplate ? 4 : -1);
  }
}
const _c16 = ["select"];
const _c17 = a0 => ({
  mousedown: a0
});
function ComboBoxComponent_Conditional_2_ng_template_1_Template(rf, ctx) {}
function ComboBoxComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtemplate(1, ComboBoxComponent_Conditional_2_ng_template_1_Template, 0, 0, "ng-template", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.prefixTemplate == null ? null : ctx_r1.prefixTemplate.templateRef);
  }
}
function ComboBoxComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-separator");
  }
}
function ComboBoxComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵlistener("click", function ComboBoxComponent_Conditional_5_Template_span_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearValue($event));
    });
    i0.ɵɵelement(1, "kendo-icon-wrapper", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("visibility", ctx_r1.clearButtonVisibility);
    i0.ɵɵproperty("kendoEventsOutsideAngular", i0.ɵɵpureFunction1(5, _c17, ctx_r1.preventEventDefault));
    i0.ɵɵattribute("title", ctx_r1.messageFor("clearTitle"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("svgIcon", ctx_r1.xIcon);
  }
}
function ComboBoxComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 10);
  }
}
function ComboBoxComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-separator");
  }
}
function ComboBoxComponent_Conditional_8_ng_template_1_Template(rf, ctx) {}
function ComboBoxComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtemplate(1, ComboBoxComponent_Conditional_8_ng_template_1_Template, 0, 0, "ng-template", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.suffixTemplate == null ? null : ctx_r1.suffixTemplate.templateRef);
  }
}
function ComboBoxComponent_ng_template_12_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ComboBoxComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ComboBoxComponent_ng_template_12_ng_container_0_Template, 1, 0, "ng-container", 18);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const sharedPopupActionSheetTemplate_r4 = i0.ɵɵreference(19);
    i0.ɵɵproperty("ngTemplateOutlet", sharedPopupActionSheetTemplate_r4);
  }
}
function ComboBoxComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-resize-sensor", 19);
    i0.ɵɵlistener("resize", function ComboBoxComponent_Conditional_14_Template_kendo_resize_sensor_resize_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onResize());
    });
    i0.ɵɵelementEnd();
  }
}
function ComboBoxComponent_ng_template_18_Conditional_0_ng_template_0_Template(rf, ctx) {}
function ComboBoxComponent_ng_template_18_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ComboBoxComponent_ng_template_18_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 20);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r1.headerTemplate.templateRef));
  }
}
function ComboBoxComponent_ng_template_18_Conditional_3_Conditional_1_ng_template_0_Template(rf, ctx) {}
function ComboBoxComponent_ng_template_18_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ComboBoxComponent_ng_template_18_Conditional_3_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 20);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r1.noDataTemplate ? ctx_r1.noDataTemplate.templateRef : undefined));
  }
}
function ComboBoxComponent_ng_template_18_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.messageFor("noDataText"));
  }
}
function ComboBoxComponent_ng_template_18_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵconditionalCreate(1, ComboBoxComponent_ng_template_18_Conditional_3_Conditional_1_Template, 1, 3, null, 20);
    i0.ɵɵconditionalCreate(2, ComboBoxComponent_ng_template_18_Conditional_3_Conditional_2_Template, 2, 1, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-live", "polite");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.noDataTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.noDataTemplate ? 2 : -1);
  }
}
function ComboBoxComponent_ng_template_18_Conditional_4_ng_template_0_Template(rf, ctx) {}
function ComboBoxComponent_ng_template_18_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ComboBoxComponent_ng_template_18_Conditional_4_ng_template_0_Template, 0, 0, "ng-template", 20);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r1.footerTemplate.templateRef));
  }
}
function ComboBoxComponent_ng_template_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵconditionalCreate(0, ComboBoxComponent_ng_template_18_Conditional_0_Template, 1, 3, null, 20);
    i0.ɵɵelementStart(1, "kendo-list", 21, 4);
    i0.ɵɵlistener("pageChange", function ComboBoxComponent_ng_template_18_Template_kendo_list_pageChange_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.pageChange($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(3, ComboBoxComponent_ng_template_18_Conditional_3_Template, 3, 3, "div", 22);
    i0.ɵɵconditionalCreate(4, ComboBoxComponent_ng_template_18_Conditional_4_Template, 1, 3, null, 20);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.headerTemplate ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("size", ctx_r1.isAdaptive ? "large" : ctx_r1.size)("rounded", ctx_r1.rounded)("id", ctx_r1.listBoxId)("optionPrefix", ctx_r1.optionPrefix)("data", ctx_r1.data)("textField", ctx_r1.textField)("valueField", ctx_r1.valueField)("template", ctx_r1.template)("groupTemplate", ctx_r1.groupTemplate)("fixedGroupTemplate", ctx_r1.fixedGroupTemplate)("height", ctx_r1.listHeight)("show", ctx_r1.isOpen)("virtual", ctx_r1.virtual)("showStickyHeader", ctx_r1.showStickyHeader);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.data.length === 0 ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.footerTemplate ? 4 : -1);
  }
}
const _c18 = ["searchInput"];
function DropDownListComponent_Conditional_3_ng_template_0_Template(rf, ctx) {}
function DropDownListComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DropDownListComponent_Conditional_3_ng_template_0_Template, 0, 0, "ng-template", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction2(1, _c5, ctx_r0.valueTemplate.templateRef, ctx_r0.dataItem));
  }
}
function DropDownListComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate(ctx_r0.getText());
  }
}
function DropDownListComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 9);
  }
}
function DropDownListComponent_ng_template_8_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DropDownListComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DropDownListComponent_ng_template_8_ng_container_0_Template, 1, 0, "ng-container", 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const sharedPopupActionSheetTemplate_r2 = i0.ɵɵreference(15);
    i0.ɵɵproperty("ngTemplateOutlet", sharedPopupActionSheetTemplate_r2);
  }
}
function DropDownListComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-resize-sensor", 14);
    i0.ɵɵlistener("resize", function DropDownListComponent_Conditional_10_Template_kendo_resize_sensor_resize_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onResize());
    });
    i0.ɵɵelementEnd();
  }
}
function DropDownListComponent_ng_template_14_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵlistener("click", function DropDownListComponent_ng_template_14_Conditional_0_Template_div_click_0_listener($event) {
      return $event.stopImmediatePropagation();
    });
    i0.ɵɵelementStart(1, "span", 19);
    i0.ɵɵelement(2, "kendo-icon-wrapper", 20);
    i0.ɵɵelementStart(3, "input", 21, 4);
    i0.ɵɵtwoWayListener("ngModelChange", function DropDownListComponent_ng_template_14_Conditional_0_Template_input_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r0.filterText, $event) || (ctx_r0.filterText = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("keydown", function DropDownListComponent_ng_template_14_Conditional_0_Template_input_keydown_3_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const searchInput_r6 = i0.ɵɵreference(4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.keydown($event, searchInput_r6));
    })("input", function DropDownListComponent_ng_template_14_Conditional_0_Template_input_input_3_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleFilter($event));
    })("focus", function DropDownListComponent_ng_template_14_Conditional_0_Template_input_focus_3_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onFilterFocus());
    })("blur", function DropDownListComponent_ng_template_14_Conditional_0_Template_input_blur_3_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.blurFilterInput());
    })("click", function DropDownListComponent_ng_template_14_Conditional_0_Template_input_click_3_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleClick());
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.filterInputClasses);
    i0.ɵɵadvance();
    i0.ɵɵproperty("svgIcon", ctx_r0.searchIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("filterInput", ctx_r0.isFocused && !ctx_r0.touchEnabled)("dir", ctx_r0.direction);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.filterText);
    i0.ɵɵattribute("aria-controls", ctx_r0.listBoxId)("aria-label", ctx_r0.messageFor("filterInputLabel"));
  }
}
function DropDownListComponent_ng_template_14_Conditional_1_ng_template_0_Template(rf, ctx) {}
function DropDownListComponent_ng_template_14_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DropDownListComponent_ng_template_14_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r0.headerTemplate.templateRef));
  }
}
function DropDownListComponent_ng_template_14_Conditional_4_Conditional_1_ng_template_0_Template(rf, ctx) {}
function DropDownListComponent_ng_template_14_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DropDownListComponent_ng_template_14_Conditional_4_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r0.noDataTemplate ? ctx_r0.noDataTemplate.templateRef : undefined));
  }
}
function DropDownListComponent_ng_template_14_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.messageFor("noDataText"));
  }
}
function DropDownListComponent_ng_template_14_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵconditionalCreate(1, DropDownListComponent_ng_template_14_Conditional_4_Conditional_1_Template, 1, 3, null, 8);
    i0.ɵɵconditionalCreate(2, DropDownListComponent_ng_template_14_Conditional_4_Conditional_2_Template, 2, 1, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-live", "polite");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.noDataTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.noDataTemplate ? 2 : -1);
  }
}
function DropDownListComponent_ng_template_14_Conditional_5_ng_template_0_Template(rf, ctx) {}
function DropDownListComponent_ng_template_14_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DropDownListComponent_ng_template_14_Conditional_5_ng_template_0_Template, 0, 0, "ng-template", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r0.footerTemplate.templateRef));
  }
}
function DropDownListComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵconditionalCreate(0, DropDownListComponent_ng_template_14_Conditional_0_Template, 5, 7, "div", 15);
    i0.ɵɵconditionalCreate(1, DropDownListComponent_ng_template_14_Conditional_1_Template, 1, 3, null, 8);
    i0.ɵɵelementStart(2, "kendo-list", 16, 3);
    i0.ɵɵlistener("pageChange", function DropDownListComponent_ng_template_14_Template_kendo_list_pageChange_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.pageChange($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(4, DropDownListComponent_ng_template_14_Conditional_4_Template, 3, 3, "div", 17);
    i0.ɵɵconditionalCreate(5, DropDownListComponent_ng_template_14_Conditional_5_Template, 1, 3, null, 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.filterable && !ctx_r0.isActionSheetExpanded ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.headerTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.listBoxId)("size", ctx_r0.isAdaptive ? "large" : ctx_r0.size)("rounded", ctx_r0.rounded)("optionPrefix", ctx_r0.optionPrefix)("data", ctx_r0.data)("textField", ctx_r0.textField)("valueField", ctx_r0.valueField)("template", ctx_r0.itemTemplate)("groupTemplate", ctx_r0.groupTemplate)("fixedGroupTemplate", ctx_r0.fixedGroupTemplate)("height", ctx_r0.listHeight)("show", ctx_r0.isOpen)("virtual", ctx_r0.virtual)("ariaLive", ctx_r0.ariaLive)("showStickyHeader", ctx_r0.showStickyHeader)("defaultItem", ctx_r0.defaultItem);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.data.length === 0 ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.footerTemplate ? 5 : -1);
  }
}
const _c19 = ["*"];
const _c20 = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13) => ({
  "k-focus": a0,
  "k-disabled": a1,
  "k-chip-sm": a2,
  "k-chip-md": a3,
  "k-chip-lg": a4,
  "k-rounded-sm": a5,
  "k-rounded-md": a6,
  "k-rounded-lg": a7,
  "k-rounded-full": a8,
  "k-rounded-none": a9,
  "k-chip-solid": a10,
  "k-chip-flat": a11,
  "k-chip-outline": a12,
  "k-chip-base": a13
});
function TagListComponent_For_1_Conditional_2_Conditional_1_ng_template_0_Template(rf, ctx) {}
function TagListComponent_For_1_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TagListComponent_For_1_Conditional_2_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 6);
  }
  if (rf & 2) {
    const tag_r2 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction2(1, _c5, ctx_r2.groupTemplate.templateRef, tag_r2));
  }
}
function TagListComponent_For_1_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const tag_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵtextInterpolate2(" ", tag_r2.length, " ", tag_r2.length === 1 ? "item" : "items", " selected ");
  }
}
function TagListComponent_For_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵconditionalCreate(1, TagListComponent_For_1_Conditional_2_Conditional_1_Template, 1, 4, null, 6);
    i0.ɵɵconditionalCreate(2, TagListComponent_For_1_Conditional_2_Conditional_2_Template, 1, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.groupTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.groupTemplate ? 2 : -1);
  }
}
function TagListComponent_For_1_Conditional_3_Conditional_1_ng_template_0_Template(rf, ctx) {}
function TagListComponent_For_1_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TagListComponent_For_1_Conditional_3_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 6);
  }
  if (rf & 2) {
    const tag_r2 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction2(1, _c5, ctx_r2.template.templateRef, tag_r2));
  }
}
function TagListComponent_For_1_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    const tag_r2 = ctx_r3.$implicit;
    const ɵ$index_1_r5 = ctx_r3.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.tagProp(tag_r2, ctx_r2.textField, ɵ$index_1_r5), " ");
  }
}
function TagListComponent_For_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵconditionalCreate(1, TagListComponent_For_1_Conditional_3_Conditional_1_Template, 1, 4, null, 6);
    i0.ɵɵconditionalCreate(2, TagListComponent_For_1_Conditional_3_Conditional_2_Template, 1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.template ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r2.template ? 2 : -1);
  }
}
function TagListComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
    i0.ɵɵconditionalCreate(2, TagListComponent_For_1_Conditional_2_Template, 3, 2, "span", 2)(3, TagListComponent_For_1_Conditional_3_Template, 3, 2, "span", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 3)(5, "span", 4)(6, "kendo-icon-wrapper", 5);
    i0.ɵɵlistener("mousedown", function TagListComponent_For_1_Template_kendo_icon_wrapper_mousedown_6_listener($event) {
      const ctx_r5 = i0.ɵɵrestoreView(_r1);
      const tag_r2 = ctx_r5.$implicit;
      const ɵ$index_1_r5 = ctx_r5.$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.deleteTag($event, tag_r2, ɵ$index_1_r5));
    });
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const tag_r2 = ctx.$implicit;
    const ɵ$index_1_r5 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunctionV(7, _c20, [ɵ$index_1_r5 === ctx_r2.focused, ctx_r2.isTagDisabled(tag_r2, ɵ$index_1_r5), ctx_r2.size === "small", ctx_r2.size === "medium", ctx_r2.size === "large", ctx_r2.rounded === "small", ctx_r2.rounded === "medium", ctx_r2.rounded === "large", ctx_r2.rounded === "full", ctx_r2.rounded === "none", ctx_r2.fillMode === "solid", ctx_r2.fillMode === "flat", ctx_r2.fillMode === "outline", ctx_r2.fillMode]));
    i0.ɵɵattribute("id", ctx_r2.itemId(tag_r2, ɵ$index_1_r5))("aria-selected", true)("role", "option");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.isGroupTag(tag_r2) ? 2 : 3);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-hidden", ɵ$index_1_r5 !== ctx_r2.focused);
    i0.ɵɵadvance();
    i0.ɵɵproperty("svgIcon", ctx_r2.xCircleIcon);
  }
}
function MultiSelectComponent_Conditional_3_ng_template_1_Template(rf, ctx) {}
function MultiSelectComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtemplate(1, MultiSelectComponent_Conditional_3_ng_template_1_Template, 0, 0, "ng-template", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.prefixTemplate == null ? null : ctx_r1.prefixTemplate.templateRef);
  }
}
function MultiSelectComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-separator");
  }
}
function MultiSelectComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵlistener("mousedown", function MultiSelectComponent_Conditional_8_Template_span_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearAll($event));
    });
    i0.ɵɵelement(1, "kendo-icon-wrapper", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("visibility", ctx_r1.clearButtonVisibility);
    i0.ɵɵattribute("title", ctx_r1.messageFor("clearTitle"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("svgIcon", ctx_r1.xIcon);
  }
}
function MultiSelectComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 12);
  }
}
function MultiSelectComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-separator");
  }
}
function MultiSelectComponent_Conditional_11_ng_template_1_Template(rf, ctx) {}
function MultiSelectComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtemplate(1, MultiSelectComponent_Conditional_11_ng_template_1_Template, 0, 0, "ng-template", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.suffixTemplate == null ? null : ctx_r1.suffixTemplate.templateRef);
  }
}
function MultiSelectComponent_ng_template_12_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MultiSelectComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiSelectComponent_ng_template_12_ng_container_0_Template, 1, 0, "ng-container", 18);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const sharedPopupActionSheetTemplate_r4 = i0.ɵɵreference(19);
    i0.ɵɵproperty("ngTemplateOutlet", sharedPopupActionSheetTemplate_r4);
  }
}
function MultiSelectComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-resize-sensor", 19);
    i0.ɵɵlistener("resize", function MultiSelectComponent_Conditional_14_Template_kendo_resize_sensor_resize_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onResize());
    });
    i0.ɵɵelementEnd();
  }
}
function MultiSelectComponent_ng_template_18_Conditional_0_ng_template_0_Template(rf, ctx) {}
function MultiSelectComponent_ng_template_18_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiSelectComponent_ng_template_18_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 20);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r1.headerTemplate.templateRef));
  }
}
function MultiSelectComponent_ng_template_18_Conditional_3_Conditional_1_ng_template_0_Template(rf, ctx) {}
function MultiSelectComponent_ng_template_18_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiSelectComponent_ng_template_18_Conditional_3_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 20);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r1.noDataTemplate ? ctx_r1.noDataTemplate.templateRef : undefined));
  }
}
function MultiSelectComponent_ng_template_18_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.messageFor("noDataText"));
  }
}
function MultiSelectComponent_ng_template_18_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵconditionalCreate(1, MultiSelectComponent_ng_template_18_Conditional_3_Conditional_1_Template, 1, 3, null, 20);
    i0.ɵɵconditionalCreate(2, MultiSelectComponent_ng_template_18_Conditional_3_Conditional_2_Template, 2, 1, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-live", "polite");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.noDataTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.noDataTemplate ? 2 : -1);
  }
}
function MultiSelectComponent_ng_template_18_Conditional_4_ng_template_0_Template(rf, ctx) {}
function MultiSelectComponent_ng_template_18_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiSelectComponent_ng_template_18_Conditional_4_ng_template_0_Template, 0, 0, "ng-template", 20);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r1.footerTemplate.templateRef));
  }
}
function MultiSelectComponent_ng_template_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵconditionalCreate(0, MultiSelectComponent_ng_template_18_Conditional_0_Template, 1, 3, null, 20);
    i0.ɵɵelementStart(1, "kendo-list", 21, 3);
    i0.ɵɵlistener("pageChange", function MultiSelectComponent_ng_template_18_Template_kendo_list_pageChange_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.pageChange($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(3, MultiSelectComponent_ng_template_18_Conditional_3_Template, 3, 3, "div", 22);
    i0.ɵɵconditionalCreate(4, MultiSelectComponent_ng_template_18_Conditional_4_Template, 1, 3, null, 20);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.headerTemplate ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("size", ctx_r1.isAdaptive ? "large" : ctx_r1.size)("rounded", ctx_r1.rounded)("id", ctx_r1.listBoxId)("optionPrefix", ctx_r1.optionPrefix)("data", ctx_r1.data)("textField", ctx_r1.textField)("valueField", ctx_r1.valueField)("template", ctx_r1.template)("groupTemplate", ctx_r1.groupTemplate)("fixedGroupTemplate", ctx_r1.fixedGroupTemplate)("height", ctx_r1.listHeight)("show", ctx_r1.isOpen)("multipleSelection", true)("virtual", ctx_r1.virtual)("checkboxes", ctx_r1.checkboxes)("isMultiselect", true)("isActionSheetExpanded", ctx_r1.isActionSheetExpanded)("showStickyHeader", ctx_r1.showStickyHeader)("customItemTemplate", ctx_r1.customItemTemplate)("text", ctx_r1.text)("allowCustom", ctx_r1.allowCustom);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.data.length === 0 ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.footerTemplate ? 4 : -1);
  }
}
const _c21 = ["header"];
const _c22 = ["headerTable"];
const _c23 = ["columnHeader"];
const _c24 = (a0, a1, a2) => ({
  templateRef: a0,
  $implicit: a1,
  column: a2
});
const _c25 = (a0, a1, a2, a3) => ({
  templateRef: a0,
  $implicit: a1,
  dataItem: a2,
  column: a3
});
function MultiColumnComboBoxComponent_Conditional_2_ng_template_1_Template(rf, ctx) {}
function MultiColumnComboBoxComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtemplate(1, MultiColumnComboBoxComponent_Conditional_2_ng_template_1_Template, 0, 0, "ng-template", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.prefixTemplate == null ? null : ctx_r1.prefixTemplate.templateRef);
  }
}
function MultiColumnComboBoxComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-separator");
  }
}
function MultiColumnComboBoxComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵlistener("click", function MultiColumnComboBoxComponent_Conditional_5_Template_span_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearValue($event));
    });
    i0.ɵɵelement(1, "kendo-icon-wrapper", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("visibility", ctx_r1.clearButtonVisibility);
    i0.ɵɵproperty("kendoEventsOutsideAngular", i0.ɵɵpureFunction1(5, _c17, ctx_r1.preventEventDefault));
    i0.ɵɵattribute("title", ctx_r1.messageFor("clearTitle"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("svgIcon", ctx_r1.xIcon);
  }
}
function MultiColumnComboBoxComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 15);
  }
}
function MultiColumnComboBoxComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-separator");
  }
}
function MultiColumnComboBoxComponent_Conditional_8_ng_template_1_Template(rf, ctx) {}
function MultiColumnComboBoxComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtemplate(1, MultiColumnComboBoxComponent_Conditional_8_ng_template_1_Template, 0, 0, "ng-template", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.suffixTemplate == null ? null : ctx_r1.suffixTemplate.templateRef);
  }
}
function MultiColumnComboBoxComponent_ng_template_12_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MultiColumnComboBoxComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiColumnComboBoxComponent_ng_template_12_ng_container_0_Template, 1, 0, "ng-container", 23);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const sharedPopupActionSheetTemplate_r4 = i0.ɵɵreference(19);
    i0.ɵɵproperty("ngTemplateOutlet", sharedPopupActionSheetTemplate_r4);
  }
}
function MultiColumnComboBoxComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-resize-sensor", 24);
    i0.ɵɵlistener("resize", function MultiColumnComboBoxComponent_Conditional_14_Template_kendo_resize_sensor_resize_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onResize());
    });
    i0.ɵɵelementEnd();
  }
}
function MultiColumnComboBoxComponent_ng_template_18_Conditional_0_ng_template_0_Template(rf, ctx) {}
function MultiColumnComboBoxComponent_ng_template_18_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiColumnComboBoxComponent_ng_template_18_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 25);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r1.headerTemplate == null ? null : ctx_r1.headerTemplate.templateRef));
  }
}
function MultiColumnComboBoxComponent_ng_template_18_For_10_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "col");
  }
  if (rf & 2) {
    const column_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵstyleProp("width", column_r7.width, "px");
  }
}
function MultiColumnComboBoxComponent_ng_template_18_For_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, MultiColumnComboBoxComponent_ng_template_18_For_10_Conditional_0_Template, 1, 2, "col", 35);
  }
  if (rf & 2) {
    const column_r7 = ctx.$implicit;
    i0.ɵɵconditional(!column_r7.hidden && column_r7.matchesMedia ? 0 : -1);
  }
}
function MultiColumnComboBoxComponent_ng_template_18_For_14_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const column_r8 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵtextInterpolate1(" ", column_r8.title || column_r8.field, " ");
  }
}
function MultiColumnComboBoxComponent_ng_template_18_For_14_Conditional_0_Conditional_3_ng_template_0_Template(rf, ctx) {}
function MultiColumnComboBoxComponent_ng_template_18_For_14_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiColumnComboBoxComponent_ng_template_18_For_14_Conditional_0_Conditional_3_ng_template_0_Template, 0, 0, "ng-template", 25);
  }
  if (rf & 2) {
    const column_r8 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction3(1, _c24, column_r8.headerTemplate == null ? null : column_r8.headerTemplate.templateRef, column_r8, column_r8));
  }
}
function MultiColumnComboBoxComponent_ng_template_18_For_14_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 36, 9);
    i0.ɵɵconditionalCreate(2, MultiColumnComboBoxComponent_ng_template_18_For_14_Conditional_0_Conditional_2_Template, 1, 1);
    i0.ɵɵconditionalCreate(3, MultiColumnComboBoxComponent_ng_template_18_For_14_Conditional_0_Conditional_3_Template, 1, 5, null, 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngStyle", column_r8.headerStyle)("ngClass", column_r8.headerClass);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!column_r8.headerTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(column_r8.headerTemplate ? 3 : -1);
  }
}
function MultiColumnComboBoxComponent_ng_template_18_For_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, MultiColumnComboBoxComponent_ng_template_18_For_14_Conditional_0_Template, 4, 4, "th", 36);
  }
  if (rf & 2) {
    const column_r8 = ctx.$implicit;
    i0.ɵɵconditional(!column_r8.hidden && column_r8.matchesMedia ? 0 : -1);
  }
}
function MultiColumnComboBoxComponent_ng_template_18_ng_template_15_For_1_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const column_r9 = i0.ɵɵnextContext(2).$implicit;
    const dataItem_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.textFrom(dataItem_r10, column_r9.field), " ");
  }
}
function MultiColumnComboBoxComponent_ng_template_18_ng_template_15_For_1_Conditional_0_Conditional_2_ng_template_0_Template(rf, ctx) {}
function MultiColumnComboBoxComponent_ng_template_18_ng_template_15_For_1_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiColumnComboBoxComponent_ng_template_18_ng_template_15_For_1_Conditional_0_Conditional_2_ng_template_0_Template, 0, 0, "ng-template", 25);
  }
  if (rf & 2) {
    const column_r9 = i0.ɵɵnextContext(2).$implicit;
    const dataItem_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction4(1, _c25, column_r9.cellTemplate == null ? null : column_r9.cellTemplate.templateRef, dataItem_r10, dataItem_r10, column_r9));
  }
}
function MultiColumnComboBoxComponent_ng_template_18_ng_template_15_For_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 38);
    i0.ɵɵconditionalCreate(1, MultiColumnComboBoxComponent_ng_template_18_ng_template_15_For_1_Conditional_0_Conditional_1_Template, 1, 1);
    i0.ɵɵconditionalCreate(2, MultiColumnComboBoxComponent_ng_template_18_ng_template_15_For_1_Conditional_0_Conditional_2_Template, 1, 6, null, 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    const column_r9 = ctx_r10.$implicit;
    const ɵ$index_82_r12 = ctx_r10.$index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleProp("width", ctx_r1.getColumnWidth(ɵ$index_82_r12), "px")("max-width", ctx_r1.getColumnWidth(ɵ$index_82_r12), "px");
    i0.ɵɵproperty("ngClass", column_r9.class)("ngStyle", column_r9.style);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!column_r9.cellTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(column_r9.cellTemplate ? 2 : -1);
  }
}
function MultiColumnComboBoxComponent_ng_template_18_ng_template_15_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, MultiColumnComboBoxComponent_ng_template_18_ng_template_15_For_1_Conditional_0_Template, 3, 8, "span", 37);
  }
  if (rf & 2) {
    const column_r9 = ctx.$implicit;
    i0.ɵɵconditional(!column_r9.hidden && column_r9.matchesMedia ? 0 : -1);
  }
}
function MultiColumnComboBoxComponent_ng_template_18_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, MultiColumnComboBoxComponent_ng_template_18_ng_template_15_For_1_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIndex);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(ctx_r1.columns);
  }
}
function MultiColumnComboBoxComponent_ng_template_18_Conditional_19_Conditional_1_ng_template_0_Template(rf, ctx) {}
function MultiColumnComboBoxComponent_ng_template_18_Conditional_19_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiColumnComboBoxComponent_ng_template_18_Conditional_19_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 25);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r1.noDataTemplate == null ? null : ctx_r1.noDataTemplate.templateRef));
  }
}
function MultiColumnComboBoxComponent_ng_template_18_Conditional_19_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.messageFor("noDataText"));
  }
}
function MultiColumnComboBoxComponent_ng_template_18_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵconditionalCreate(1, MultiColumnComboBoxComponent_ng_template_18_Conditional_19_Conditional_1_Template, 1, 3, null, 25);
    i0.ɵɵconditionalCreate(2, MultiColumnComboBoxComponent_ng_template_18_Conditional_19_Conditional_2_Template, 2, 1, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-live", "polite");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.noDataTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.noDataTemplate ? 2 : -1);
  }
}
function MultiColumnComboBoxComponent_ng_template_18_Conditional_20_ng_template_5_Template(rf, ctx) {}
function MultiColumnComboBoxComponent_ng_template_18_Conditional_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34)(1, "table", 39)(2, "tfoot", 40)(3, "tr", 31)(4, "td", 41);
    i0.ɵɵtemplate(5, MultiColumnComboBoxComponent_ng_template_18_Conditional_20_ng_template_5_Template, 0, 0, "ng-template", 25);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r1.footerTemplate.templateRef));
  }
}
function MultiColumnComboBoxComponent_ng_template_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵconditionalCreate(0, MultiColumnComboBoxComponent_ng_template_18_Conditional_0_Template, 1, 3, null, 25);
    i0.ɵɵelementStart(1, "div", 26)(2, "div", 27, 4)(4, "div", 28, 5)(6, "table", 29, 6)(8, "colgroup");
    i0.ɵɵrepeaterCreate(9, MultiColumnComboBoxComponent_ng_template_18_For_10_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "thead", 30)(12, "tr", 31);
    i0.ɵɵrepeaterCreate(13, MultiColumnComboBoxComponent_ng_template_18_For_14_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵtemplate(15, MultiColumnComboBoxComponent_ng_template_18_ng_template_15_Template, 2, 0, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(17, "kendo-list", 32, 8);
    i0.ɵɵlistener("pageChange", function MultiColumnComboBoxComponent_ng_template_18_Template_kendo_list_pageChange_17_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.pageChange($event));
    })("listResize", function MultiColumnComboBoxComponent_ng_template_18_Template_kendo_list_listResize_17_listener() {
      i0.ɵɵrestoreView(_r6);
      const header_r13 = i0.ɵɵreference(3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.updateHeaderPadding(header_r13));
    })("popupListScroll", function MultiColumnComboBoxComponent_ng_template_18_Template_kendo_list_popupListScroll_17_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const headerWrap_r14 = i0.ɵɵreference(5);
      return i0.ɵɵresetView(headerWrap_r14.scrollLeft = $event.target.scrollLeft);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(19, MultiColumnComboBoxComponent_ng_template_18_Conditional_19_Template, 3, 3, "div", 33);
    i0.ɵɵconditionalCreate(20, MultiColumnComboBoxComponent_ng_template_18_Conditional_20_Template, 6, 3, "div", 34);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const rowTemplate_r15 = i0.ɵɵreference(16);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.headerTemplate ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.tableSizeClass);
    i0.ɵɵadvance(8);
    i0.ɵɵrepeater(ctx_r1.columns);
    i0.ɵɵadvance(4);
    i0.ɵɵrepeater(ctx_r1.columns);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("optionPrefix", ctx_r1.optionPrefix)("data", ctx_r1.data)("size", ctx_r1.isAdaptive ? "large" : ctx_r1.size)("textField", ctx_r1.textField)("valueField", ctx_r1.valueField)("template", i0.ɵɵpureFunction1(19, _c15, rowTemplate_r15))("groupTemplate", ctx_r1.groupTemplate)("fixedGroupTemplate", ctx_r1.fixedGroupTemplate)("height", ctx_r1.listHeight)("show", ctx_r1.isOpen)("id", ctx_r1.listBoxId)("virtual", ctx_r1.virtual)("type", "dropdowngrid")("rowWidth", ctx_r1.rowWidth)("showStickyHeader", ctx_r1.showStickyHeader);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.data.length === 0 ? 19 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.footerTemplate ? 20 : -1);
  }
}
const _c26 = ["treeview"];
const _c27 = ["filterInput"];
const _c28 = a0 => ({
  blur: a0
});
function DropDownTreeComponent_Conditional_2_Conditional_1_ng_template_0_Template(rf, ctx) {}
function DropDownTreeComponent_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DropDownTreeComponent_Conditional_2_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 13);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction2(1, _c5, ctx_r0.valueTemplate.templateRef, ctx_r0.dataItem));
  }
}
function DropDownTreeComponent_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.text || ctx_r0.placeholder, " ");
  }
}
function DropDownTreeComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵconditionalCreate(1, DropDownTreeComponent_Conditional_2_Conditional_1_Template, 1, 4, null, 13);
    i0.ɵɵconditionalCreate(2, DropDownTreeComponent_Conditional_2_Conditional_2_Template, 1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.valueTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.valueTemplate ? 2 : -1);
  }
}
function DropDownTreeComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵlistener("click", function DropDownTreeComponent_Conditional_3_Template_span_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.clearValue($event));
    });
    i0.ɵɵelement(1, "kendo-icon-wrapper", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("visibility", ctx_r0.clearButtonVisibility);
    i0.ɵɵattribute("title", ctx_r0.messageFor("clearTitle"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("svgIcon", ctx_r0.xIcon);
  }
}
function DropDownTreeComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 9);
  }
}
function DropDownTreeComponent_ng_template_7_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DropDownTreeComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DropDownTreeComponent_ng_template_7_ng_container_0_Template, 1, 0, "ng-container", 16);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const sharedPopupActionSheetTemplate_r3 = i0.ɵɵreference(13);
    i0.ɵɵproperty("ngTemplateOutlet", sharedPopupActionSheetTemplate_r3);
  }
}
function DropDownTreeComponent_ng_template_12_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 17)(1, "span", 20)(2, "span", 21);
    i0.ɵɵelement(3, "kendo-icon-wrapper", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 23, 3);
    i0.ɵɵlistener("input", function DropDownTreeComponent_ng_template_12_Conditional_0_Template_input_input_4_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleFilterInputChange($event.target));
    })("keydown.arrowdown", function DropDownTreeComponent_ng_template_12_Conditional_0_Template_input_keydown_arrowdown_4_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const filterInput_r5 = i0.ɵɵreference(5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleKeydown($event, filterInput_r5));
    })("keydown.alt.arrowup", function DropDownTreeComponent_ng_template_12_Conditional_0_Template_input_keydown_alt_arrowup_4_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const filterInput_r5 = i0.ɵɵreference(5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleKeydown($event, filterInput_r5));
    })("keydown.escape", function DropDownTreeComponent_ng_template_12_Conditional_0_Template_input_keydown_escape_4_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const filterInput_r5 = i0.ɵɵreference(5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleKeydown($event, filterInput_r5));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.filterInputClasses);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("svgIcon", ctx_r0.searchIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("filterInput", ctx_r0.filterable && !ctx_r0.touchEnabled)("value", ctx_r0.filter)("kendoEventsOutsideAngular", i0.ɵɵpureFunction1(7, _c28, ctx_r0.handleBlur))("scope", ctx_r0);
    i0.ɵɵattribute("aria-label", ctx_r0.messageFor("filterInputLabel"));
  }
}
function DropDownTreeComponent_ng_template_12_Conditional_1_ng_template_0_Template(rf, ctx) {}
function DropDownTreeComponent_ng_template_12_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DropDownTreeComponent_ng_template_12_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 13);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r0.headerTemplate == null ? null : ctx_r0.headerTemplate.templateRef));
  }
}
function DropDownTreeComponent_ng_template_12_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-treeview", 24, 4);
    i0.ɵɵtwoWayListener("selectedKeysChange", function DropDownTreeComponent_ng_template_12_Conditional_2_Template_kendo_treeview_selectedKeysChange_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r0.selectedKeys, $event) || (ctx_r0.selectedKeys = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("focusout", function DropDownTreeComponent_ng_template_12_Conditional_2_Template_kendo_treeview_focusout_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleBlur($event));
    })("keydown", function DropDownTreeComponent_ng_template_12_Conditional_2_Template_kendo_treeview_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleKeydown($event));
    })("selectionChange", function DropDownTreeComponent_ng_template_12_Conditional_2_Template_kendo_treeview_selectionChange_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onSelectionChange($event));
    })("expand", function DropDownTreeComponent_ng_template_12_Conditional_2_Template_kendo_treeview_expand_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.nodeExpand.emit($event));
    })("collapse", function DropDownTreeComponent_ng_template_12_Conditional_2_Template_kendo_treeview_collapse_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.nodeCollapse.emit($event));
    })("childrenLoaded", function DropDownTreeComponent_ng_template_12_Conditional_2_Template_kendo_treeview_childrenLoaded_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onChildrenLoaded());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("max-height", ctx_r0.listHeight, "px");
    i0.ɵɵproperty("size", ctx_r0.windowSize !== "large" ? "large" : ctx_r0.size)("nodes", ctx_r0.data)("animate", false);
    i0.ɵɵtwoWayProperty("selectedKeys", ctx_r0.selectedKeys);
    i0.ɵɵproperty("selectBy", ctx_r0.selectBy)("textField", ctx_r0.textField)("children", ctx_r0.children)("hasChildren", ctx_r0.hasChildren)("loadOnDemand", ctx_r0.loadOnDemand)("isExpanded", ctx_r0.isNodeExpanded)("isDisabled", ctx_r0.itemDisabled)("nodeTemplate", ctx_r0.nodeTemplate)("filter", ctx_r0.filter)("isVisible", ctx_r0.isNodeVisible);
    i0.ɵɵattribute("id", ctx_r0.treeViewId);
  }
}
function DropDownTreeComponent_ng_template_12_Conditional_3_ng_template_0_Template(rf, ctx) {}
function DropDownTreeComponent_ng_template_12_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DropDownTreeComponent_ng_template_12_Conditional_3_ng_template_0_Template, 0, 0, "ng-template", 13);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r0.footerTemplate == null ? null : ctx_r0.footerTemplate.templateRef));
  }
}
function DropDownTreeComponent_ng_template_12_Conditional_4_Conditional_1_ng_template_0_Template(rf, ctx) {}
function DropDownTreeComponent_ng_template_12_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DropDownTreeComponent_ng_template_12_Conditional_4_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 13);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r0.noDataTemplate == null ? null : ctx_r0.noDataTemplate.templateRef));
  }
}
function DropDownTreeComponent_ng_template_12_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.messageFor("noDataText"));
  }
}
function DropDownTreeComponent_ng_template_12_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵconditionalCreate(1, DropDownTreeComponent_ng_template_12_Conditional_4_Conditional_1_Template, 1, 3, null, 13);
    i0.ɵɵconditionalCreate(2, DropDownTreeComponent_ng_template_12_Conditional_4_Conditional_2_Template, 2, 1, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-live", "polite");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.noDataTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.noDataTemplate ? 2 : -1);
  }
}
function DropDownTreeComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, DropDownTreeComponent_ng_template_12_Conditional_0_Template, 6, 9, "span", 17);
    i0.ɵɵconditionalCreate(1, DropDownTreeComponent_ng_template_12_Conditional_1_Template, 1, 3, null, 13);
    i0.ɵɵconditionalCreate(2, DropDownTreeComponent_ng_template_12_Conditional_2_Template, 2, 17, "kendo-treeview", 18);
    i0.ɵɵconditionalCreate(3, DropDownTreeComponent_ng_template_12_Conditional_3_Template, 1, 3, null, 13);
    i0.ɵɵconditionalCreate(4, DropDownTreeComponent_ng_template_12_Conditional_4_Template, 3, 3, "div", 19);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.filterable && !ctx_r0.isActionSheetExpanded ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.headerTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.data.length !== 0 && !ctx_r0.allNodesHidden ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.footerTemplate ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.data.length === 0 || ctx_r0.allNodesHidden ? 4 : -1);
  }
}
function DropDownTreeComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-resize-sensor", 25);
    i0.ɵɵlistener("resize", function DropDownTreeComponent_Conditional_14_Template_kendo_resize_sensor_resize_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onResize());
    });
    i0.ɵɵelementEnd();
  }
}
const _c29 = ["checkAllInput"];
const _c30 = a0 => ({
  focusout: a0
});
function MultiSelectTreeComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.placeholder, " ");
  }
}
function MultiSelectTreeComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵlistener("click", function MultiSelectTreeComponent_Conditional_4_Template_span_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.clearAll($event));
    });
    i0.ɵɵelement(1, "kendo-icon-wrapper", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("title", ctx_r0.messageFor("clearTitle"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("svgIcon", ctx_r0.xIcon);
  }
}
function MultiSelectTreeComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 11);
  }
}
function MultiSelectTreeComponent_ng_template_6_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MultiSelectTreeComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiSelectTreeComponent_ng_template_6_ng_container_0_Template, 1, 0, "ng-container", 15);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const sharedPopupActionSheetTemplate_r3 = i0.ɵɵreference(12);
    i0.ɵɵproperty("ngTemplateOutlet", sharedPopupActionSheetTemplate_r3);
  }
}
function MultiSelectTreeComponent_ng_template_11_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "span", 21)(2, "span", 22);
    i0.ɵɵelement(3, "kendo-icon-wrapper", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 24, 4);
    i0.ɵɵlistener("input", function MultiSelectTreeComponent_ng_template_11_Conditional_0_Template_input_input_4_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleFilterInputChange($event.target));
    })("keydown", function MultiSelectTreeComponent_ng_template_11_Conditional_0_Template_input_keydown_4_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const filterInput_r6 = i0.ɵɵreference(5);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleKeydown($event, filterInput_r6));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.filterInputClasses);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("svgIcon", ctx_r0.searchIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("filterInput", ctx_r0.filterable && !ctx_r0.touchEnabled)("value", ctx_r0.filter)("kendoEventsOutsideAngular", i0.ɵɵpureFunction1(7, _c28, ctx_r0.handleBlur))("scope", ctx_r0);
    i0.ɵɵattribute("aria-label", ctx_r0.messageFor("filterInputLabel"));
  }
}
function MultiSelectTreeComponent_ng_template_11_Conditional_1_ng_template_0_Template(rf, ctx) {}
function MultiSelectTreeComponent_ng_template_11_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiSelectTreeComponent_ng_template_11_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 17);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r0.headerTemplate == null ? null : ctx_r0.headerTemplate.templateRef));
  }
}
function MultiSelectTreeComponent_ng_template_11_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "span", 25)(2, "input", 26, 5);
    i0.ɵɵlistener("checkedItemsChange", function MultiSelectTreeComponent_ng_template_11_Conditional_2_Template_input_checkedItemsChange_2_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleCheckedItemsChange($event));
    })("keydown", function MultiSelectTreeComponent_ng_template_11_Conditional_2_Template_input_keydown_2_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleKeydown($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "span", 27);
    i0.ɵɵlistener("click", function MultiSelectTreeComponent_ng_template_11_Conditional_2_Template_span_click_4_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.toggleCheckAll());
    })("mousedown", function MultiSelectTreeComponent_ng_template_11_Conditional_2_Template_span_mousedown_4_listener($event) {
      return $event.preventDefault();
    });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const treeview_r8 = i0.ɵɵreference(4);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checkAll", !ctx_r0.filterable && !ctx_r0.touchEnabled)("ngClass", ctx_r0.checkAllCheckboxClasses)("treeview", treeview_r8)("checkedItems", ctx_r0.checkedItems)("valueField", ctx_r0.valueField)("lastAction", ctx_r0.lastAction)("kendoEventsOutsideAngular", i0.ɵɵpureFunction1(9, _c28, ctx_r0.handleBlur))("scope", ctx_r0);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.messageFor("checkAllText"), " ");
  }
}
function MultiSelectTreeComponent_ng_template_11_Conditional_5_ng_template_0_Template(rf, ctx) {}
function MultiSelectTreeComponent_ng_template_11_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiSelectTreeComponent_ng_template_11_Conditional_5_ng_template_0_Template, 0, 0, "ng-template", 17);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r0.footerTemplate == null ? null : ctx_r0.footerTemplate.templateRef));
  }
}
function MultiSelectTreeComponent_ng_template_11_Conditional_6_Conditional_1_ng_template_0_Template(rf, ctx) {}
function MultiSelectTreeComponent_ng_template_11_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiSelectTreeComponent_ng_template_11_Conditional_6_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 17);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("templateContext", i0.ɵɵpureFunction1(1, _c15, ctx_r0.noDataTemplate == null ? null : ctx_r0.noDataTemplate.templateRef));
  }
}
function MultiSelectTreeComponent_ng_template_11_Conditional_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.messageFor("noDataText"));
  }
}
function MultiSelectTreeComponent_ng_template_11_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵconditionalCreate(1, MultiSelectTreeComponent_ng_template_11_Conditional_6_Conditional_1_Template, 1, 3, null, 17);
    i0.ɵɵconditionalCreate(2, MultiSelectTreeComponent_ng_template_11_Conditional_6_Conditional_2_Template, 2, 1, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-live", "polite");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.noDataTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.noDataTemplate ? 2 : -1);
  }
}
function MultiSelectTreeComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵconditionalCreate(0, MultiSelectTreeComponent_ng_template_11_Conditional_0_Template, 6, 9, "div", 16);
    i0.ɵɵconditionalCreate(1, MultiSelectTreeComponent_ng_template_11_Conditional_1_Template, 1, 3, null, 17);
    i0.ɵɵconditionalCreate(2, MultiSelectTreeComponent_ng_template_11_Conditional_2_Template, 6, 11, "div", 18);
    i0.ɵɵelementStart(3, "kendo-treeview", 19, 3);
    i0.ɵɵlistener("keydown", function MultiSelectTreeComponent_ng_template_11_Template_kendo_treeview_keydown_3_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.handleKeydown($event));
    })("nodeClick", function MultiSelectTreeComponent_ng_template_11_Template_kendo_treeview_nodeClick_3_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.handleNodeClick($event));
    })("expand", function MultiSelectTreeComponent_ng_template_11_Template_kendo_treeview_expand_3_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.nodeExpand.emit($event));
    })("collapse", function MultiSelectTreeComponent_ng_template_11_Template_kendo_treeview_collapse_3_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.nodeCollapse.emit($event));
    })("checkedItemsChange", function MultiSelectTreeComponent_ng_template_11_Template_kendo_treeview_checkedItemsChange_3_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.handleCheckedItemsChange($event));
    })("childrenLoaded", function MultiSelectTreeComponent_ng_template_11_Template_kendo_treeview_childrenLoaded_3_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onChildrenLoaded());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(5, MultiSelectTreeComponent_ng_template_11_Conditional_5_Template, 1, 3, null, 17);
    i0.ɵɵconditionalCreate(6, MultiSelectTreeComponent_ng_template_11_Conditional_6_Template, 3, 3, "div", 20);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.filterable && !ctx_r0.isActionSheetExpanded ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.headerTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.checkAll ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("max-height", ctx_r0.listHeight, "px");
    i0.ɵɵproperty("size", ctx_r0.windowSize !== "large" ? "large" : ctx_r0.size)("nodes", ctx_r0.data)("animate", false)("isHeterogeneous", ctx_r0.isHeterogeneous)("checkable", ctx_r0.checkableSettings)("checkedItems", ctx_r0.checkedItems)("valueField", ctx_r0.valueField)("textField", ctx_r0.textField)("children", ctx_r0.children)("hasChildren", ctx_r0.hasChildren)("isExpanded", ctx_r0.isNodeExpanded)("isDisabled", ctx_r0.itemDisabled)("nodeTemplate", ctx_r0.nodeTemplate)("loadOnDemand", ctx_r0.loadOnDemand)("filter", ctx_r0.filter)("isVisible", ctx_r0.isNodeVisible)("kendoEventsOutsideAngular", i0.ɵɵpureFunction1(26, _c30, ctx_r0.handleBlur))("scope", ctx_r0);
    i0.ɵɵattribute("id", ctx_r0.treeViewId);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.footerTemplate ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.data || (ctx_r0.data == null ? null : ctx_r0.data.length) === 0 || ctx_r0.allNodesHidden ? 6 : -1);
  }
}
function MultiSelectTreeComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-resize-sensor", 28);
    i0.ɵɵlistener("resize", function MultiSelectTreeComponent_Conditional_13_Template_kendo_resize_sensor_resize_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onResize());
    });
    i0.ɵɵelementEnd();
  }
}
export { PrefixTemplateDirective, SeparatorComponent, SuffixTemplateDirective, ToggleButtonTabStopDirective } from '@progress/kendo-angular-common';
import * as i7 from '@progress/kendo-angular-utils';
import { AdaptiveService } from '@progress/kendo-angular-utils';
import * as i8 from '@angular/forms';
import { NgControl, NG_VALUE_ACCESSOR, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { validatePackage } from '@progress/kendo-licensing';
import { getter as getter$1, touchEnabled, pointers } from '@progress/kendo-common';
import * as i1 from '@progress/kendo-angular-l10n';
import { ComponentMessages, LocalizationService, L10N_PREFIX } from '@progress/kendo-angular-l10n';
import { Subscription, merge, fromEvent, Subject, of, interval } from 'rxjs';
import { map, switchMap, take, auditTime, tap, filter, partition, throttleTime, catchError, skipWhile, concatMap, takeUntil, debounceTime } from 'rxjs/operators';
import * as i2 from '@progress/kendo-angular-popup';
import { PopupService } from '@progress/kendo-angular-popup';
import { NgStyle, NgClass, NgTemplateOutlet } from '@angular/common';
import { checkIcon, xIcon, chevronDownIcon, searchIcon, xCircleIcon } from '@progress/kendo-svg-icons';
import { IconComponent, IconWrapperComponent, IconsService } from '@progress/kendo-angular-icons';
import { ActionSheetComponent, ActionSheetTemplateDirective } from '@progress/kendo-angular-navigation';
import { TextBoxComponent, TextBoxPrefixTemplateDirective } from '@progress/kendo-angular-inputs';
import { ButtonComponent } from '@progress/kendo-angular-buttons';
import * as i1$1 from '@progress/kendo-angular-treeview';
import { TreeViewComponent, SelectDirective, DataBoundComponent, ExpandableComponent, FlatDataBindingDirective, HierarchyBindingDirective, ExpandDirective } from '@progress/kendo-angular-treeview';
import { DialogContainerService, DialogService, WindowService, WindowContainerService } from '@progress/kendo-angular-dialog';

/**
 * @hidden
 */
const packageMetadata = {
  name: '@progress/kendo-angular-dropdowns',
  productName: 'Kendo UI for Angular',
  productCode: 'KENDOUIANGULAR',
  productCodes: ['KENDOUIANGULAR'],
  publishDate: 1780593820,
  version: '24.1.0',
  licensingDocsUrl: 'https://www.telerik.com/kendo-angular-ui/my-license/'
};

/**
 * @hidden
 */
const isPresent = value => value !== null && value !== undefined;
/**
 * @hidden
 */
const isNumber = value => !isNaN(value);
/**
 * @hidden
 */
const combineStr = (begin, end) => {
  return begin.concat(end.substr(end.toLowerCase().indexOf(begin.toLowerCase()) + begin.length));
};
/**
 * @hidden
 */
const isWindowAvailable = () => typeof window !== 'undefined';
/**
 * @hidden
 */
const isArray = value => Array.isArray(value);
/**
 * @hidden
 */
const isObject = value => isPresent(value) && typeof value === 'object';
/**
 * @hidden
 */
const isEmptyString = value => typeof value === 'string' && value.length === 0;
/**
 * @hidden
 */
const resolveValuesInArray = (values, data = [], valueField) => values.map(value => {
  return data.find(item => getter(item, valueField) === value);
}).filter(value => value !== undefined);
/**
 * @hidden
 */
const validateComplexValues = (values, valueField) => isArray(values) && values.filter(item => {
  return isObject(item) && getter(item, valueField) !== undefined;
});
/**
 * @hidden
 */
const resolveAllValues = (value, data, valueField) => {
  const customValues = validateComplexValues(value, valueField) || [];
  const resolvedValues = resolveValuesInArray(value, data, valueField) || [];
  return resolvedValues.concat(customValues);
};
/**
 * @hidden
 */
const isObjectArray = values => {
  return isArray(values) && values.every(item => isObject(item));
};
/**
 * @hidden
 */
const selectedIndices = (values, data, valueField) => {
  const extractedValues = data.map(item => {
    return isPresent(item) && isPresent(getter(item, valueField)) ? getter(item, valueField) : item;
  });
  return values.reduce((arr, item) => {
    const value = isPresent(item) && isPresent(getter(item, valueField)) ? getter(item, valueField) : item;
    const index = extractedValues.indexOf(value);
    if (index !== -1) {
      arr.push(index);
    }
    return arr;
  }, []);
};
/**
 * @hidden
 */
const getter = (dataItem, field) => {
  if (!isPresent(dataItem)) {
    return null;
  }
  if (!isPresent(field) || !isObject(dataItem)) {
    return dataItem;
  }
  // creates a field accessor supporting nested fields processing
  const valueFrom = getter$1(field);
  return valueFrom(dataItem);
};
/**
 * @hidden
 */
const resolveValue = args => {
  let dataItem;
  if (isPresent(args.value)) {
    const data = [args.defaultItem, ...args.data];
    dataItem = data.find(element => getter(element, args.valueField) === args.value);
    return {
      dataItem: dataItem,
      focused: args.data.indexOf(dataItem),
      selected: args.data.indexOf(dataItem)
    };
  } else if (args.index) {
    return {
      dataItem: args.data[args.index],
      focused: args.index,
      selected: args.index
    };
  }
  return {
    dataItem: args.defaultItem,
    focused: -1,
    selected: -1
  };
};
/**
 * @hidden
 */
const sameCharsOnly = (word, character) => {
  for (let idx = 0; idx < word.length; idx++) {
    if (word.charAt(idx) !== character) {
      return false;
    }
  }
  return true;
};
/**
 * @hidden
 */
const shuffleData = (data, splitIndex, defaultItem) => {
  let result = data;
  if (defaultItem) {
    result = [defaultItem].concat(result);
  }
  return result.slice(splitIndex).concat(result.slice(0, splitIndex));
};
/**
 * @hidden
 */
const matchText = (text, word, ignoreCase) => {
  if (!isPresent(text)) {
    return false;
  }
  let temp = String(text);
  if (ignoreCase) {
    temp = temp.toLowerCase();
  }
  return temp.startsWith(word);
};
/**
 * @hidden
 */
const elementFromPoint = (x, y) => {
  if (!isDocumentAvailable()) {
    return;
  }
  return document.elementFromPoint(x, y);
};
/**
 * @hidden
 *
 * Checks whether the passed object has all of the listed properties.
 */
const hasProps = (obj, props) => {
  if (!isPresent(obj)) {
    return false;
  }
  return props.every(prop => obj.hasOwnProperty(prop));
};
/**
 * @hidden
 *
 * Checks whether an element is untouched by looking for the ng-untouched css class
 */
const isUntouched = element => element.className.includes('ng-untouched');
/**
 * @hidden
 */
const noop = _ => {};
/**
 * IE element `matches` polyfill.
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
 */
const matches = (element, selector) => {
  const matcher = element.matches || element.msMatchesSelector || element.webkitMatchesSelector;
  if (!matcher) {
    return false;
  }
  return matcher.call(element, selector);
};
/**
 * @hidden
 *
 * IE element `closest` polyfill.
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
 */
const closest = (element, selector) => {
  let parent = element;
  while (parent !== null && parent.nodeType === 1) {
    if (matches(parent, selector)) {
      return parent;
    }
    parent = parent.parentElement || parent.parentNode;
  }
  return null;
};
/**
 * @hidden
 *
 * Parses a provided value to its type 'number' representation.
 * If the parsed value (via Number(value)) is NaN, the provided default value is returned.
 * Uses 0 as default value if a second param is not provided.
 */
const parseNumber = (num, defaultValue = 0) => {
  const normalizedValue = Number(num);
  return isNaN(normalizedValue) ? defaultValue : normalizedValue;
};
/**
 * @hidden
 *
 * Checks whether the passed target element is inside the provided host or popupRef.
 */
const inDropDown = (host, target, popupRef) => {
  return host.nativeElement.contains(target) || popupRef && popupRef.popupElement.contains(target);
};
/**
 * @hidden
 *
 * Calculates the hierarchical level of an item, based on the provided index.
 * The result level is zero-based (starts from 0).
 */
const getHierarchicalItemLevel = index => {
  return (index || '').split('_').length - 1;
};
/**
 * @hidden
 *
 * Retrieves all descendant nodes' lookups which are currently registered in the provided lookup item as a flat array.
 */
const fetchDescendentNodes = (lookup, filterExpression) => {
  if (!isPresent(lookup) || lookup.children.length === 0) {
    return [];
  }
  let descendants = lookup.children;
  if (isPresent(filterExpression)) {
    descendants = descendants.filter(descendent => filterExpression(descendent.item));
  }
  descendants.forEach(child => descendants = descendants.concat(fetchDescendentNodes(child, filterExpression)));
  return descendants;
};
/**
 * @hidden
 *
 * Retrieves the correct value based on the item's level and the provided value field/s.
 * Used in the MultiSelectTree component.
 */
const valueFrom = ({
  dataItem,
  index,
  level
}, valueField) => {
  const fields = Array.isArray(valueField) ? valueField : [valueField];
  // either use the explicitly provided value level, or infer it from the item index
  const valueLevel = isPresent(level) ? level : getHierarchicalItemLevel(index);
  // fall-back to the last available one, if the current node is in a deeper level
  const normalizedLevel = Math.min(valueLevel, fields.length - 1);
  const field = fields[normalizedLevel];
  return getter$1(field)(dataItem);
};
/**
 * @hidden
 * Returns the size class based on the component and size input.
 */
const getSizeClass = (component, size) => {
  const SIZE_CLASSES = {
    'small': `k-${component}-sm`,
    'medium': `k-${component}-md`,
    'large': `k-${component}-lg`
  };
  return SIZE_CLASSES[size];
};
/**
 * @hidden
 * Returns the rounded class based on the rounded input.
 */
const getRoundedClass = rounded => {
  const ROUNDED_CLASSES = {
    'small': 'k-rounded-sm',
    'medium': 'k-rounded-md',
    'large': 'k-rounded-lg',
    'full': 'k-rounded-full',
    'none': 'k-rounded-none'
  };
  return ROUNDED_CLASSES[rounded];
};
/**
 * @hidden
 * Return the fillMode class based on the component and fillMode input.
 */
const getFillModeClass = (component, fillMode) => {
  const FILLMODE_CLASSES = {
    'solid': `k-${component}-solid`,
    'flat': `k-${component}-flat`,
    'outline': `k-${component}-outline`
  };
  return FILLMODE_CLASSES[fillMode];
};
/**
 * @hidden
 */
const filterAndMap = (arr, predicate, mapper) => arr.reduce((acc, curr) => predicate(curr) ? [...acc, mapper(curr)] : acc, []);
/**
 * @hidden
 *
 * Checks if input is Japanese IME
 */
const isJapanese = input => {
  const japaneseRegex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g;
  return japaneseRegex.test(input);
};
/**
 * @hidden
 */
const isLetter = text => {
  const isLetter = /[a-zA-Z]/;
  return isLetter.test(text) && text?.length === 1;
};
/**
 * @hidden
 */
const getTextField = (field, level) => {
  if (isArray(field)) {
    return field[level];
  }
  return field;
};
/**
 * @hidden
 */
const getSearchableItems = (treeViewId, element) => {
  const nodeSeletor = `kendo-treeview[id='${treeViewId}'] li.k-treeview-item`;
  const liElements = Array.from(element.querySelectorAll(nodeSeletor));
  return liElements.map(liElement => {
    return {
      text: liElement.innerText,
      index: liElement.getAttribute('data-treeindex')
    };
  });
};
/**
 * @hidden
 */
const isTruthy = value => !!value;
/**
 * @hidden
 */
const setListBoxAriaLabelledBy = (optionsList, element, renderer) => {
  const listBox = optionsList.wrapper.nativeElement.querySelector('kendo-list ul');
  const ariaLabel = element.nativeElement.getAttribute('aria-labelledby') || element.nativeElement.getAttribute('data-kendo-label-id');
  if (ariaLabel) {
    renderer.setAttribute(listBox, 'aria-labelledby', ariaLabel);
  }
};
/**
 * @hidden
 */
const setActionSheetTitle = (element, actionSheetTitle) => {
  const ariaLabel = element.nativeElement.getAttribute('aria-labelledby') || element.nativeElement.getAttribute('data-kendo-label-id');
  if (!actionSheetTitle && ariaLabel) {
    return document.getElementById(ariaLabel).innerText;
  }
  return actionSheetTitle;
};
/**
 * @hidden
 */
const animationDuration = 300;

/**
 * @hidden
 */
class SearchBarComponent {
  localization;
  injector;
  input;
  ngZone;
  direction;
  tagListId;
  set readonly(readonly) {
    this._readonly = readonly;
    if (this._readonly) {
      this.renderer.setAttribute(this.input.nativeElement, 'readonly', '');
    } else {
      this.renderer.removeAttribute(this.input.nativeElement, 'readonly');
    }
  }
  get readonly() {
    return this._readonly;
  }
  set disabled(disabled) {
    this._disabled = disabled;
    if (this._disabled) {
      this.renderer.setAttribute(this.input.nativeElement, 'disabled', '');
    } else {
      this.renderer.removeAttribute(this.input.nativeElement, 'disabled');
    }
  }
  get disabled() {
    return this._disabled;
  }
  set isRequired(isRequired) {
    this._isRequired = isRequired;
    if (this._isRequired) {
      this.renderer.setAttribute(this.input.nativeElement, 'required', '');
    } else {
      this.renderer.removeAttribute(this.input.nativeElement, 'required');
    }
  }
  get isRequired() {
    return this._isRequired;
  }
  set isSuggestable(isSuggestable) {
    this._isSuggestable = isSuggestable;
    this.setAriaAutocomplete();
  }
  get isSuggestable() {
    return this._isSuggestable;
  }
  set isFilterable(isFilterable) {
    this._isFilterable = isFilterable;
    this.setAriaAutocomplete();
  }
  get isFilterable() {
    return this._isFilterable;
  }
  get userInput() {
    return this._userInput;
  }
  set userInput(userInput) {
    this._userInput = userInput || "";
  }
  /**
   * @hidden
   */
  get formControl() {
    const ngControl = this.injector.get(NgControl, null);
    return ngControl?.control || null;
  }
  suggestedText;
  /**
   * @hidden
   */
  set inputAttributes(attributes) {
    if (isObjectPresent(this.parsedAttributes)) {
      removeHTMLAttributes(this.parsedAttributes, this.renderer, this.input.nativeElement);
    }
    this._inputAttributes = attributes;
    this.parsedAttributes = this.inputAttributes ? parseAttributes(this.inputAttributes, this.defaultAttributes) : this.inputAttributes;
    this.setInputAttributes();
  }
  get inputAttributes() {
    return this._inputAttributes;
  }
  id;
  activeDescendant;
  tabIndex;
  isLoading;
  ariaControls;
  ariaExpanded = null;
  get attrAriaInvalid() {
    return this.formControl?.invalid ? true : null;
  }
  set placeholder(text) {
    this._placeholder = text || '';
    this.setInputSize();
  }
  get placeholder() {
    return this._placeholder;
  }
  role = 'combobox';
  get dir() {
    return this.direction;
  }
  valueChange = new EventEmitter();
  onBlur = new EventEmitter();
  onFocus = new EventEmitter();
  onClick = new EventEmitter();
  onNavigate = new EventEmitter();
  get value() {
    return this.input.nativeElement.value;
  }
  _isRequired;
  _readonly;
  _disabled;
  _userInput = "";
  _previousValue = "";
  _placeholder = "";
  _isSuggestable = false;
  _isFilterable = false;
  renderer;
  subs = new Subscription();
  _inputAttributes;
  parsedAttributes = {};
  get defaultAttributes() {
    return {
      id: this.id,
      disabled: this.disabled ? '' : null,
      readonly: this.readonly ? '' : null,
      placeholder: this.placeholder,
      tabIndex: this.tabIndex,
      tabindex: this.tabIndex,
      dir: this.direction,
      required: this.isRequired ? '' : null,
      'aria-haspopup': 'listbox',
      'aria-expanded': this.ariaExpanded,
      'aria-controls': this.ariaControls,
      'aria-activedescendant': this.activeDescendant,
      'aria-busy': this.isLoading,
      'aria-invalid': this.formControl?.invalid
    };
  }
  get mutableAttributes() {
    return {
      autocomplete: 'off',
      role: this.role,
      'aria-describedby': this.tagListId
    };
  }
  constructor(localization, renderer, injector, input, ngZone) {
    this.localization = localization;
    this.injector = injector;
    this.input = input;
    this.ngZone = ngZone;
    this.direction = localization.rtl ? 'rtl' : 'ltr';
    this.renderer = renderer;
    this.renderer.addClass(this.input.nativeElement, 'k-input-inner');
    this.renderer.setAttribute(this.input.nativeElement, 'aria-haspopup', 'listbox');
    this.renderer.setAttribute(this.input.nativeElement, 'autocomplete', 'off');
  }
  ngOnInit() {
    this.subs.add(this.localization.changes.subscribe(({
      rtl
    }) => this.direction = rtl ? 'rtl' : 'ltr'));
  }
  ngOnChanges(changes) {
    if (!isDocumentAvailable()) {
      return;
    }
    let previousUserInput;
    if (this.input && (changes.userInput || changes.suggestedText)) {
      if (changes.userInput && changes.userInput.previousValue) {
        if (this._previousValue === changes.userInput.previousValue) {
          previousUserInput = this._previousValue;
        } else {
          previousUserInput = changes.userInput.currentValue || "";
        }
      } else {
        previousUserInput = this._previousValue;
      }
      const caretStart = this.input.nativeElement.selectionStart;
      const caretAtEnd = previousUserInput.length === caretStart;
      this.writeInputValue(this.suggestedText ? combineStr(this.userInput, this.suggestedText) : this.userInput);
      if (this.suggestedText) {
        this.setInputSelection(this.userInput.length, this.suggestedText.length);
      } else if (isSafari(navigator.userAgent) && !caretAtEnd) {
        this.setInputSelection(caretStart, this.userInput.length);
      } else if (caretAtEnd) {
        this.setInputSelection(this.userInput.length, this.userInput.length);
      } else {
        this.setInputSelection(caretStart, caretStart);
      }
      this._previousValue = this.userInput;
    }
  }
  ngAfterViewInit() {
    this.subs.add(this.renderer.listen(this.input.nativeElement, 'input', event => this.handleInput(event)));
    this.subs.add(this.renderer.listen(this.input.nativeElement, 'focus', event => this.handleFocus(event)));
    this.subs.add(this.renderer.listen(this.input.nativeElement, 'blur', event => this.handleBlur(event)));
    this.subs.add(this.ngZone.runOutsideAngular(() => this.renderer.listen(this.input.nativeElement, 'keydown', event => this.handleKeydown(event))));
  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
  writeInputValue(text) {
    if (isDocumentAvailable()) {
      this.renderer.setProperty(this.input.nativeElement, 'value', text);
    }
  }
  setInputSelection(start, end) {
    if (isDocumentAvailable() && this.input.nativeElement === document.activeElement) {
      try {
        this.input.nativeElement.setSelectionRange(start, end);
      } catch (_e) {
        //Make sure that the element is in the DOM before you invoke its methods
      }
    }
  }
  setAriaAutocomplete() {
    if (this.isFilterable) {
      this.renderer.setAttribute(this.input.nativeElement, 'aria-autocomplete', 'list');
    }
    if (this.isSuggestable) {
      this.renderer.setAttribute(this.input.nativeElement, 'aria-autocomplete', 'inline');
    }
    if (this.isFilterable && this.isSuggestable) {
      this.renderer.setAttribute(this.input.nativeElement, 'aria-autocomplete', 'both');
    }
    if (!this.isFilterable && !this.isSuggestable) {
      this.renderer.removeAttribute(this.input.nativeElement, 'aria-autocomplete');
    }
  }
  handleInput(event) {
    const target = event.target;
    const isBrowserSafari = isSafari(navigator.userAgent);
    const value = isBrowserSafari && isJapanese(target.value) ? event.data : target.value;
    if (value !== this.userInput) {
      this._previousValue = value;
      this.valueChange.emit(value);
    }
  }
  handleFocus(event) {
    this.onFocus.emit(event);
  }
  handleBlur(event) {
    this.onBlur.emit(event);
  }
  handleKeydown(event) {
    // on some keyboards arrow keys, PageUp/Down, and Home/End are mapped to Numpad keys
    const keyCode = normalizeKeys(event);
    const keys = [Keys.ArrowUp, Keys.ArrowDown, Keys.ArrowLeft, Keys.ArrowRight, Keys.Enter, Keys.Escape, Keys.Delete, Keys.Backspace, Keys.Home, Keys.End, Keys.PageDown, Keys.PageUp];
    if (keys.indexOf(keyCode) > -1) {
      this.ngZone.run(() => {
        this.onNavigate.emit(event);
      });
    }
  }
  focus() {
    if (isDocumentAvailable()) {
      this.input.nativeElement.focus();
    }
  }
  blur() {
    if (isDocumentAvailable()) {
      this.input.nativeElement.blur();
    }
  }
  setInputSize() {
    const lengthOf = x => x ? x.length : 0;
    const input = this.input.nativeElement;
    const placeholderLength = lengthOf(this.placeholder);
    const textLength = lengthOf(this.value);
    const size = Math.max(placeholderLength, textLength, 1);
    this.renderer.setAttribute(input, 'size', size.toString());
  }
  setInputAttributes() {
    const attributesToRender = Object.assign({}, this.mutableAttributes, this.parsedAttributes);
    setHTMLAttributes(attributesToRender, this.renderer, this.input.nativeElement, this.ngZone);
  }
  static ɵfac = function SearchBarComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SearchBarComponent)(i0.ɵɵdirectiveInject(i1.LocalizationService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SearchBarComponent,
    selectors: [["input", "kendoSearchbar", ""]],
    hostVars: 10,
    hostBindings: function SearchBarComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("id", ctx.id)("aria-activedescendant", ctx.activeDescendant)("tabindex", ctx.tabIndex)("aria-busy", ctx.isLoading)("aria-controls", ctx.ariaControls)("aria-expanded", ctx.ariaExpanded)("aria-invalid", ctx.attrAriaInvalid)("placeholder", ctx.placeholder)("role", ctx.role)("dir", ctx.dir);
      }
    },
    inputs: {
      tagListId: "tagListId",
      readonly: "readonly",
      disabled: "disabled",
      isRequired: "isRequired",
      isSuggestable: "isSuggestable",
      isFilterable: "isFilterable",
      userInput: "userInput",
      suggestedText: "suggestedText",
      inputAttributes: "inputAttributes",
      id: "id",
      activeDescendant: "activeDescendant",
      tabIndex: "tabIndex",
      isLoading: "isLoading",
      ariaControls: "ariaControls",
      ariaExpanded: "ariaExpanded",
      placeholder: "placeholder"
    },
    outputs: {
      valueChange: "valueChange",
      onBlur: "onBlur",
      onFocus: "onFocus",
      onClick: "onClick",
      onNavigate: "onNavigate"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    attrs: _c0,
    decls: 0,
    vars: 0,
    template: function SearchBarComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchBarComponent, [{
    type: Component,
    args: [{
      selector: 'input[kendoSearchbar]',
      template: ``,
      standalone: true
    }]
  }], () => [{
    type: i1.LocalizationService
  }, {
    type: i0.Renderer2
  }, {
    type: i0.Injector
  }, {
    type: i0.ElementRef
  }, {
    type: i0.NgZone
  }], {
    tagListId: [{
      type: Input
    }],
    readonly: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    isRequired: [{
      type: Input
    }],
    isSuggestable: [{
      type: Input
    }],
    isFilterable: [{
      type: Input
    }],
    userInput: [{
      type: Input
    }],
    suggestedText: [{
      type: Input
    }],
    inputAttributes: [{
      type: Input
    }],
    id: [{
      type: HostBinding,
      args: ['attr.id']
    }, {
      type: Input
    }],
    activeDescendant: [{
      type: HostBinding,
      args: ['attr.aria-activedescendant']
    }, {
      type: Input
    }],
    tabIndex: [{
      type: HostBinding,
      args: ['attr.tabindex']
    }, {
      type: Input
    }],
    isLoading: [{
      type: HostBinding,
      args: ['attr.aria-busy']
    }, {
      type: Input
    }],
    ariaControls: [{
      type: HostBinding,
      args: ['attr.aria-controls']
    }, {
      type: Input
    }],
    ariaExpanded: [{
      type: HostBinding,
      args: ['attr.aria-expanded']
    }, {
      type: Input
    }],
    attrAriaInvalid: [{
      type: HostBinding,
      args: ['attr.aria-invalid']
    }],
    placeholder: [{
      type: HostBinding,
      args: ['attr.placeholder']
    }, {
      type: Input
    }],
    role: [{
      type: HostBinding,
      args: ['attr.role']
    }],
    dir: [{
      type: HostBinding,
      args: ['attr.dir']
    }],
    valueChange: [{
      type: Output
    }],
    onBlur: [{
      type: Output
    }],
    onFocus: [{
      type: Output
    }],
    onClick: [{
      type: Output
    }],
    onNavigate: [{
      type: Output
    }]
  });
})();

/**
 * Renders the list item content. To define the item template, nest an `<ng-template>` tag
 * with the `kendo<ComponentName>ItemTemplate` directive inside the component tag. The template context is
 * set to the current component. To get a reference to the current data item, use the `let-dataItem` directive.
 *
 * - [Using `ItemTemplate` with the AutoComplete](https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/templates#item-template)
 * - [Using `ItemTemplate` with the ComboBox](https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox/templates#item-template)
 * - [Using `ItemTemplate` with the DropDownList](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/templates#item-template)
 * - [Using `ItemTemplate` with the MultiSelect](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/templates#item-template)
 *
 * @example
 * ```ts
 * _@Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-combobox [data]="listItems">
 *    <ng-template kendoComboBoxItemTemplate let-dataItem>
 *      <span>{{dataItem}} option</span>
 *    </ng-template>
 *  </kendo-combobox>
 * `
 * })
 * class AppComponent {
 *   public listItems: Array<string> = ["Item 1", "Item 2", "Item 3", "Item 4"];
 * }
 * ```
 */
class ItemTemplateDirective {
  templateRef;
  constructor(templateRef) {
    this.templateRef = templateRef;
  }
  static ɵfac = function ItemTemplateDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ItemTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ItemTemplateDirective,
    selectors: [["", "kendoDropDownListItemTemplate", ""], ["", "kendoComboBoxItemTemplate", ""], ["", "kendoAutoCompleteItemTemplate", ""], ["", "kendoMultiSelectItemTemplate", ""]]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItemTemplateDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoDropDownListItemTemplate],[kendoComboBoxItemTemplate],[kendoAutoCompleteItemTemplate],[kendoMultiSelectItemTemplate]',
      standalone: true
    }]
  }], () => [{
    type: i0.TemplateRef
  }], null);
})();

/**
 * Renders the header content of the list. To define the header template, nest an `<ng-template>` tag
 * with the `kendo<ComponentName>HeaderTemplate` directive inside the component tag.
 *
 * - [Using `HeaderTemplate` with the AutoComplete](https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/templates#header-template)
 * - [Using `HeaderTemplate` with the ComboBox](https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox/templates#header-template)
 * - [Using `HeaderTemplate` with the MultiColumnComboBox](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multicolumncombobox/templates#header-template)
 * - [Using `HeaderTemplate` with the DropDownList](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/templates#header-template)
 * - [Using `HeaderTemplate` with the DropDownTree](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdowntree/templates#header-template)
 * - [Using `HeaderTemplate` with the MultiSelect](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/templates#header-template)
 *
 * @example
 * ```ts
 * _@Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-combobox [data]="listItems">
 *    <ng-template kendoComboBoxHeaderTemplate>
 *      <h4>Header template</h4>
 *    </ng-template>
 *  </kendo-combobox>
 * `
 * })
 * class AppComponent {
 *   public listItems: Array<string> = ["Item 1", "Item 2", "Item 3", "Item 4"];
 * }
 * ```
 */
class HeaderTemplateDirective {
  templateRef;
  constructor(templateRef) {
    this.templateRef = templateRef;
  }
  static ɵfac = function HeaderTemplateDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HeaderTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: HeaderTemplateDirective,
    selectors: [["", "kendoDropDownListHeaderTemplate", ""], ["", "kendoComboBoxHeaderTemplate", ""], ["", "kendoDropDownTreeHeaderTemplate", ""], ["", "kendoMultiColumnComboBoxHeaderTemplate", ""], ["", "kendoAutoCompleteHeaderTemplate", ""], ["", "kendoMultiSelectHeaderTemplate", ""], ["", "kendoMultiSelectTreeHeaderTemplate", ""]]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderTemplateDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoDropDownListHeaderTemplate],[kendoComboBoxHeaderTemplate],[kendoDropDownTreeHeaderTemplate],[kendoMultiColumnComboBoxHeaderTemplate],[kendoAutoCompleteHeaderTemplate],[kendoMultiSelectHeaderTemplate],[kendoMultiSelectTreeHeaderTemplate]',
      standalone: true
    }]
  }], () => [{
    type: i0.TemplateRef
  }], null);
})();

/**
 * Renders the footer content of the list. To define the footer template, nest an `<ng-template>` tag
 * with the `kendo<ComponentName>FooterTemplate` directive inside the component tag.
 *
 * - [Using `FooterTemplate` with the AutoComplete](https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/templates#footer-template)
 * - [Using `FooterTemplate` with the ComboBox](https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox/templates#footer-template)
 * - [Using `FooterTemplate` with the MultiColumnComboBox](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multicolumncombobox/templates#footer-template)
 * - [Using `FooterTemplate` with the DropDownList](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/templates#footer-template)
 * - [Using `FooterTemplate` with the DropDownTree](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdowntree/templates#footer-template)
 * - [Using `FooterTemplate` with the MultiSelect](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/templates#footer-template)
 *
 * @example
 * ```ts
 * _@Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-combobox [data]="listItems">
 *    <ng-template kendoComboBoxFooterTemplate>
 *      <h4>Footer template</h4>
 *    </ng-template>
 *  </kendo-combobox>
 * `
 * })
 * class AppComponent {
 *   public listItems: Array<string> = ["Item 1", "Item 2", "Item 3", "Item 4"];
 * }
 * ```
 */
class FooterTemplateDirective {
  templateRef;
  constructor(templateRef) {
    this.templateRef = templateRef;
  }
  static ɵfac = function FooterTemplateDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FooterTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FooterTemplateDirective,
    selectors: [["", "kendoDropDownListFooterTemplate", ""], ["", "kendoComboBoxFooterTemplate", ""], ["", "kendoDropDownTreeFooterTemplate", ""], ["", "kendoMultiColumnComboBoxFooterTemplate", ""], ["", "kendoAutoCompleteFooterTemplate", ""], ["", "kendoMultiSelectFooterTemplate", ""], ["", "kendoMultiSelectTreeFooterTemplate", ""]]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FooterTemplateDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoDropDownListFooterTemplate],[kendoComboBoxFooterTemplate],[kendoDropDownTreeFooterTemplate],[kendoMultiColumnComboBoxFooterTemplate],[kendoAutoCompleteFooterTemplate],[kendoMultiSelectFooterTemplate],[kendoMultiSelectTreeFooterTemplate]',
      standalone: true
    }]
  }], () => [{
    type: i0.TemplateRef
  }], null);
})();

/**
 * Renders the group header content. To define the group template, nest an `<ng-template>` tag
 * with the `kendo<ComponentName>GroupTemplate` directive inside the component tag. The template context is
 * set to the current component. To get a reference to the current data item, use the `let-groupName` directive.
 *
 * - [Using `GroupTemplate` with the AutoComplete](https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/templates#group-header-template)
 * - [Using `GroupTemplate` with the ComboBox](https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox/templates#group-header-template)
 * - [Using `GroupTemplate` with the MultiColumnComboBox](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multicolumncombobox/templates#group-header-template)
 * - [Using `GroupTemplate` with the DropDownList](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/templates#group-header-template)
 * - [Using `GroupTemplate` with the MultiSelect](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/templates#group-header-template)
 *
 * @example
 * ```ts
 * import { groupBy } from '@progress/kendo-data-query';
 * _@Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-combobox [data]="groupedData" textField="name" valueField="name">
 *    <ng-template kendoComboBoxGroupTemplate let-groupName>
 *      <span>Food type: {{groupName}} option</span>
 *    </ng-template>
 *  </kendo-combobox>
 * `
 * })
 * class AppComponent {
 *   public data = [
 *       { name: "Pork", category: "Food", subcategory: "Meat" },
 *       { name: "Pepper", category: "Food", subcategory: "Vegetables" },
 *       { name: "Beef", category: "Food", subcategory: "Meat" }
 *   ];
 *   public groupedData = groupBy(this.data, [{field: "subcategory"}]);
 * }
 * ```
 */
class GroupTemplateDirective {
  templateRef;
  constructor(templateRef) {
    this.templateRef = templateRef;
  }
  static ɵfac = function GroupTemplateDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || GroupTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: GroupTemplateDirective,
    selectors: [["", "kendoDropDownListGroupTemplate", ""], ["", "kendoComboBoxGroupTemplate", ""], ["", "kendoMultiColumnComboBoxGroupTemplate", ""], ["", "kendoAutoCompleteGroupTemplate", ""], ["", "kendoMultiSelectGroupTemplate", ""]]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GroupTemplateDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoDropDownListGroupTemplate],[kendoComboBoxGroupTemplate],[kendoMultiColumnComboBoxGroupTemplate],[kendoAutoCompleteGroupTemplate],[kendoMultiSelectGroupTemplate]',
      standalone: true
    }]
  }], () => [{
    type: i0.TemplateRef
  }], null);
})();

/**
 * Renders the fixed group header content. To define the fixed group template, nest an `<ng-template>` tag
 * with the `kendo<ComponentName>FixedGroupTemplate` directive inside the component tag. The template context is
 * set to the current component. To get a reference to the current data item, use the `let-groupName` directive.
 *
 * - [Using `FixedGroupTemplate` with the AutoComplete](https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/templates#fixed-group-header-template)
 * - [Using `FixedGroupTemplate` with the ComboBox](https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox/templates#fixed-group-header-template)
 * - [Using `FixedGroupTemplate` with the MultiColumnComboBox](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multicolumncombobox/templates#fixed-group-header-template)
 * - [Using `FixedGroupTemplate` with the DropDownList](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/templates#fixed-group-header-template)
 * - [Using `FixedGroupTemplate` with the MultiSelect](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/templates#fixed-group-header-template)
 *
 * @example
 * ```ts
 * import { groupBy } from '@progress/kendo-data-query';
 * _@Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-combobox [data]="groupedData" textField="name" valueField="name">
 *    <ng-template kendoComboBoxFixedGroupTemplate let-groupName>
 *      <span>Food type: {{groupName}} option</span>
 *    </ng-template>
 *  </kendo-combobox>
 * `
 * })
 * class AppComponent {
 *   public data = [
 *       { name: "Pork", category: "Food", subcategory: "Meat" },
 *       { name: "Pepper", category: "Food", subcategory: "Vegetables" },
 *       { name: "Beef", category: "Food", subcategory: "Meat" }
 *   ];
 *   public groupedData = groupBy(this.data, [{field: "subcategory"}]);
 * }
 * ```
 */
class FixedGroupTemplateDirective {
  templateRef;
  constructor(templateRef) {
    this.templateRef = templateRef;
  }
  static ɵfac = function FixedGroupTemplateDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FixedGroupTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FixedGroupTemplateDirective,
    selectors: [["", "kendoDropDownListFixedGroupTemplate", ""], ["", "kendoComboBoxFixedGroupTemplate", ""], ["", "kendoMultiColumnComboBoxFixedGroupTemplate", ""], ["", "kendoAutoCompleteFixedGroupTemplate", ""], ["", "kendoMultiSelectFixedGroupTemplate", ""]]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FixedGroupTemplateDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoDropDownListFixedGroupTemplate],[kendoComboBoxFixedGroupTemplate],[kendoMultiColumnComboBoxFixedGroupTemplate],[kendoAutoCompleteFixedGroupTemplate],[kendoMultiSelectFixedGroupTemplate]',
      standalone: true
    }]
  }], () => [{
    type: i0.TemplateRef
  }], null);
})();

/**
 * @hidden
 */
class DataService {
  grouped = false;
  groupIndices = [];
  view;
  _data;
  _flatData;
  set data(data) {
    this._data = data;
    this.grouped = this.isGrouped(data);
    if (this.grouped) {
      this.groupIndices = this.getGroupIndices(data);
      this._flatData = this.flatten(data);
    }
  }
  get data() {
    if (this.grouped) {
      return this._flatData;
    }
    return this._data;
  }
  /**
   * @hidden
   * Used to get the actual items count, i.e. excluding the header items in case of grouping.
   */
  get itemsCount() {
    if (!isPresent(this.data) || this.data.length === 0) {
      return 0;
    }
    const items = this.grouped ? this._flatData.filter(item => !item.header) : this.data;
    return items.length;
  }
  /**
   * @hidden
   * Used to determine if the component received grouped data.
   */
  isGrouped(data) {
    // GroupResult { aggregates: AggregateResult, field: string, items: object[], value: any }
    // https://www.telerik.com/kendo-angular-ui/components/dataquery/api/GroupResult/
    return isPresent(data) && data.length !== 0 && isPresent(data[0]) && hasProps(data[0], ['aggregates', 'field', 'items', 'value']);
  }
  /**
   * @hidden
   * Used to calculate the last item index of each group.
   */
  getGroupIndices(data) {
    const groupIndices = [];
    for (let i = 0; i <= data.length - 1; i++) {
      groupIndices[i] = (groupIndices[i - 1] || 0) + data[i].items.length;
    }
    return groupIndices;
  }
  /**
   * @hidden
   * Used to get a flat array containing all items matching certain criteria.
   */
  filter(predicate) {
    let result = [];
    if (this.isGrouped(this.data)) {
      for (let i = 0; i <= this.groupIndices.length - 1; i++) {
        const matches = this.data[i].items.filter(predicate);
        if (matches) {
          result = result.concat(matches);
        }
      }
    } else {
      result = this.data.filter(predicate);
    }
    return result;
  }
  /**
   * @hidden
   * Used to get the index of a given data item.
   */
  indexOf(item, startFrom = 0) {
    let predicate = element => {
      return element === item;
    };
    if (this.grouped) {
      predicate = element => {
        return element.value === item;
      };
    }
    return this.findIndex(predicate, startFrom);
  }
  /**
   * @hidden
   * Used to get the index of a data item based on an expression.
   */
  findIndex(predicate, startFrom = 0) {
    let index = -1;
    if (this.grouped) {
      const data = this._flatData.filter(item => !item.header && item.offsetIndex >= startFrom);
      index = data.findIndex(predicate);
      index = data[index] ? data[index].offsetIndex : -1;
    } else {
      const data = this.data.slice(startFrom);
      const itemIndex = data.findIndex(predicate);
      index = itemIndex !== -1 ? itemIndex + startFrom : -1;
    }
    return index;
  }
  /**
   * @hidden
   * Used to get the closest group header prior to an item index.
   */
  closestGroup(index) {
    for (let i = index; i >= 0; i--) {
      if (this._flatData[i].header) {
        return this._flatData[i];
      }
    }
  }
  /**
   * @hidden
   * Used to get the first item matching the criteria.
   */
  find(predicate) {
    const index = this.findIndex(predicate);
    return this.itemAt(index);
  }
  /**
   * @hidden
   * Used to get the true index in a flattened data array.
   */
  flatIndex(index) {
    if (this.itemsCount === 0) {
      return -1;
    }
    if (this.grouped) {
      const match = this._flatData.find(item => !item.header && item.offsetIndex === index);
      if (match) {
        return match.index;
      }
    } else {
      return index;
    }
    return -1;
  }
  /**
   * @hidden
   * Used to get the item at the provided index.
   */
  itemAt(index) {
    let dataItem;
    if (this.itemsCount === 0) {
      return dataItem;
    }
    if (this.grouped) {
      const match = this._flatData.find(item => !item.header && item.offsetIndex === index);
      if (match) {
        dataItem = match.value;
      }
    } else {
      dataItem = this.data[index];
    }
    return dataItem;
  }
  /**
   * @hidden
   * Used to get the group at the provided index.
   */
  groupAt(index) {
    if (this.itemsCount === 0 || !this.isGrouped) {
      return;
    }
    return this._flatData.find(item => item.header && item.index === index);
  }
  /**
   * @hidden
   * Used to get all group items indices.
   */
  groupItemsIndices() {
    if (this.isGrouped) {
      return filterAndMap(this.data, item => item.header, mappedItem => mappedItem.index);
    }
    return [];
  }
  /**
   * @hidden
   * Used to get the field by which the data is grouped.
   */
  groupField() {
    if (this.itemsCount === 0 || !this.isGrouped) {
      return null;
    }
    return this._data[0].field;
  }
  /**
   * @hidden
   * Used to get the group to which a dataItem belongs.
   */
  itemGroup(item) {
    if (!item || this.itemsCount === 0 || !this.isGrouped) {
      return;
    }
    const fieldName = this.groupField();
    if (fieldName) {
      return getter(item, fieldName);
    }
  }
  flatten(data, group = undefined, offset = 0, groupIndex = 0) {
    let flat = [];
    if (isPresent(group)) {
      flat.push({
        header: true,
        groupIndex: groupIndex,
        index: groupIndex + offset,
        offsetIndex: groupIndex,
        value: group
      });
    }
    for (let i = 0; i < data.length; i++) {
      let result = [];
      if (data[i].items) {
        result = this.flatten(data[i].items, data[i].value, offset, i);
        offset = offset + data[i].items.length;
      } else {
        result.push({
          header: false,
          groupIndex: groupIndex,
          index: groupIndex + offset + i + 1,
          offsetIndex: offset + i,
          value: data[i]
        });
      }
      flat = flat.concat(result);
    }
    return flat;
  }
  static ɵfac = function DataService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DataService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DataService,
    factory: DataService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataService, [{
    type: Injectable
  }], null, null);
})();

/**
 * @hidden
 */
class DisabledItemsService {
  dataService;
  defaultItem;
  itemDisabled = null;
  constructor(dataService) {
    this.dataService = dataService;
  }
  isIndexDisabled(index) {
    if (this.itemDisabled) {
      const item = this.dataService.itemAt(index);
      if (isPresent(item)) {
        return this.itemDisabled({
          dataItem: item,
          index
        });
      } else if (isPresent(this.defaultItem)) {
        return this.itemDisabled({
          dataItem: this.defaultItem,
          index: -1
        });
      }
    }
  }
  isItemDisabled(item) {
    if (this.itemDisabled) {
      const index = this.dataService.indexOf(item);
      if (index !== -1) {
        return this.itemDisabled({
          dataItem: item,
          index
        });
      } else if (isPresent(this.defaultItem)) {
        return this.itemDisabled({
          dataItem: this.defaultItem,
          index: -1
        });
      }
    }
  }
  static ɵfac = function DisabledItemsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DisabledItemsService)(i0.ɵɵinject(DataService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DisabledItemsService,
    factory: DisabledItemsService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DisabledItemsService, [{
    type: Injectable
  }], () => [{
    type: DataService
  }], null);
})();

/**
 * @hidden
 */
class SelectionService {
  disabledItemsService;
  onSelect = new EventEmitter();
  onChange = new EventEmitter();
  onFocus = new EventEmitter();
  total = 0;
  lastClickedIndex;
  selectedIndices = [];
  focusedIndex;
  constructor(disabledItemsService) {
    this.disabledItemsService = disabledItemsService;
  }
  getTotal() {
    return this.total;
  }
  isSelected(index) {
    return isPresent(this.selectedIndices.find(current => current === index));
  }
  isFocused(index) {
    return index === this.focused;
  }
  focus(index) {
    if (this.isFocused(index)) {
      return;
    }
    this.focused = index;
    this.onFocus.emit(index);
  }
  select(index) {
    if (this.isSelected(index)) {
      return;
    }
    this.selectedIndices = [index];
    this.focused = index;
    this.onSelect.emit({
      indices: [index],
      newSelection: isPresent(index)
    });
  }
  add(index, preventClosingPopup) {
    if (this.isSelected(index)) {
      return;
    }
    this.selectedIndices.push(index);
    this.focused = index;
    this.onChange.emit({
      added: index,
      indices: this.selectedIndices.slice(),
      preventClosingPopup: preventClosingPopup
    });
  }
  indicesToBeRemoved = [];
  indicesToBeAdded = [];
  emitMultipleAddedRemoved() {
    this.onChange.emit({
      added: this.indicesToBeAdded,
      removed: this.indicesToBeRemoved,
      indices: this.selectedIndices.slice(),
      preventClosingPopup: true,
      isMultipleSelection: true
    });
    this.indicesToBeAdded = [];
    this.indicesToBeRemoved = [];
  }
  addMultiple(indices) {
    this.indicesToBeAdded = indices.slice();
    this.selectedIndices.push(...indices);
  }
  deselect(index, preventClosingPopup) {
    if (!this.isSelected(index)) {
      return;
    }
    const position = this.selectedIndices.indexOf(index);
    this.selectedIndices.splice(position, 1);
    this.focused = index;
    if (this.selected.length === 0) {
      this.lastClickedIndex = null;
    }
    this.onChange.emit({
      indices: this.selectedIndices.slice(),
      removed: index,
      preventClosingPopup: preventClosingPopup
    });
  }
  unselectMultiple(indices) {
    indices.forEach(index => {
      const position = this.selectedIndices.indexOf(index);
      this.selectedIndices.splice(position, 1);
    });
    this.indicesToBeRemoved = indices.slice();
  }
  change(index) {
    const newSelection = isPresent(index) && !this.isSelected(index);
    this.selectedIndices = [index];
    this.focused = index;
    this.onChange.emit({
      indices: [index],
      newSelection: newSelection
    });
  }
  resetSelection(index) {
    this.selectedIndices = index instanceof Array ? index : [index];
    this.focused = this.selectedIndices[this.selectedIndices.length - 1];
  }
  get selected() {
    return this.selectedIndices.slice();
  }
  get focused() {
    return this.focusedIndex;
  }
  set focused(index) {
    if (this.focusedIndex !== index) {
      this.focusedIndex = index;
      this.onFocus.emit(index);
    }
  }
  selectFromTo(from, to) {
    const addedIndices = [];
    for (let i = from; i <= to; i++) {
      if (!this.isSelected(i) && !this.disabledItemsService.isIndexDisabled(i)) {
        addedIndices.push(i);
      }
    }
    this.addMultiple(addedIndices);
  }
  unselectFromTo(from, to) {
    const indicesToBeUnselected = [];
    for (let i = from; i >= to; i--) {
      if (this.isSelected(i) && !this.disabledItemsService.isIndexDisabled(i)) {
        indicesToBeUnselected.push(i);
      }
    }
    this.unselectMultiple(indicesToBeUnselected);
  }
  unselectNotNeededIndices(startOfSelection, endOfSelection, totalItems) {
    const indicesToBeUnselected = [];
    for (let i = 0; i < startOfSelection; i++) {
      if (this.isSelected(i)) {
        indicesToBeUnselected.push(i);
      }
    }
    for (let i = endOfSelection + 1; i < totalItems; i++) {
      if (this.isSelected(i)) {
        indicesToBeUnselected.push(i);
      }
    }
    this.unselectMultiple(indicesToBeUnselected);
  }
  static ɵfac = function SelectionService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SelectionService)(i0.ɵɵinject(DisabledItemsService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SelectionService,
    factory: SelectionService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectionService, [{
    type: Injectable
  }], () => [{
    type: DisabledItemsService
  }], null);
})();

/**
 * @hidden
 */
var NavigationAction;
(function (NavigationAction) {
  NavigationAction[NavigationAction["Undefined"] = 0] = "Undefined";
  NavigationAction[NavigationAction["Open"] = 1] = "Open";
  NavigationAction[NavigationAction["Close"] = 2] = "Close";
  NavigationAction[NavigationAction["Enter"] = 3] = "Enter";
  NavigationAction[NavigationAction["Tab"] = 4] = "Tab";
  NavigationAction[NavigationAction["Esc"] = 5] = "Esc";
  NavigationAction[NavigationAction["Delete"] = 6] = "Delete";
  NavigationAction[NavigationAction["Backspace"] = 7] = "Backspace";
  NavigationAction[NavigationAction["Home"] = 8] = "Home";
  NavigationAction[NavigationAction["End"] = 9] = "End";
  NavigationAction[NavigationAction["Up"] = 10] = "Up";
  NavigationAction[NavigationAction["Down"] = 11] = "Down";
  NavigationAction[NavigationAction["Left"] = 12] = "Left";
  NavigationAction[NavigationAction["Right"] = 13] = "Right";
  NavigationAction[NavigationAction["PageDown"] = 14] = "PageDown";
  NavigationAction[NavigationAction["PageUp"] = 15] = "PageUp";
  NavigationAction[NavigationAction["SelectPrevious"] = 16] = "SelectPrevious";
  NavigationAction[NavigationAction["SelectNext"] = 17] = "SelectNext";
  NavigationAction[NavigationAction["SelectAll"] = 18] = "SelectAll";
  NavigationAction[NavigationAction["SelectAllToBeginning"] = 19] = "SelectAllToBeginning";
  NavigationAction[NavigationAction["SelectAllToEnd"] = 20] = "SelectAllToEnd";
})(NavigationAction || (NavigationAction = {}));
const MIN_INDEX = 0;
/**
 * @hidden
 */
class NavigationEvent {
  index;
  originalEvent;
  /**
   * The index of the item to which the user navigated.
   */
  constructor(index, originalEvent) {
    this.index = index;
    this.originalEvent = originalEvent;
  }
}
/**
 * @hidden
 */
class NavigationService {
  disabledItemsService;
  selectionService;
  open = new EventEmitter();
  close = new EventEmitter();
  enter = new EventEmitter();
  tab = new EventEmitter();
  esc = new EventEmitter();
  up = new EventEmitter();
  right = new EventEmitter();
  down = new EventEmitter();
  left = new EventEmitter();
  delete = new EventEmitter();
  backspace = new EventEmitter();
  home = new EventEmitter();
  end = new EventEmitter();
  pagedown = new EventEmitter();
  pageup = new EventEmitter();
  selectnext = new EventEmitter();
  selectprevious = new EventEmitter();
  selectall = new EventEmitter();
  selectalltobeginning = new EventEmitter();
  selectalltoend = new EventEmitter();
  constructor(disabledItemsService, selectionService) {
    this.disabledItemsService = disabledItemsService;
    this.selectionService = selectionService;
  }
  process(args) {
    // on some keyboards arrow keys, PageUp/Down, and Home/End are mapped to Numpad keys
    const keyCode = normalizeKeys(args.originalEvent);
    const altKey = args.originalEvent.altKey;
    const shiftKey = args.originalEvent.shiftKey;
    const ctrlKey = args.originalEvent.ctrlKey || args.originalEvent.metaKey;
    const openOnSpace = args.openOnSpace;
    const closeOnSpace = args.closeOnSpace;
    let index;
    let action = NavigationAction.Undefined;
    if (altKey && keyCode === Keys.ArrowDown) {
      action = NavigationAction.Open;
    } else if (openOnSpace && keyCode === Keys.Space) {
      action = NavigationAction.Open;
    } else if (altKey && keyCode === Keys.ArrowUp) {
      action = NavigationAction.Close;
    } else if (closeOnSpace && keyCode === Keys.Space) {
      action = NavigationAction.Close;
    } else if (shiftKey && keyCode === Keys.ArrowUp) {
      action = NavigationAction.SelectPrevious;
    } else if (shiftKey && keyCode === Keys.ArrowDown) {
      action = NavigationAction.SelectNext;
    } else if (ctrlKey && keyCode === Keys.KeyA) {
      action = NavigationAction.SelectAll;
    } else if (ctrlKey && shiftKey && keyCode === Keys.Home) {
      action = NavigationAction.SelectAllToBeginning;
    } else if (ctrlKey && shiftKey && keyCode === Keys.End) {
      action = NavigationAction.SelectAllToEnd;
    } else if (keyCode === Keys.Enter) {
      action = NavigationAction.Enter;
    } else if (keyCode === Keys.Escape) {
      action = NavigationAction.Esc;
    } else if (keyCode === Keys.Tab) {
      action = NavigationAction.Tab;
    } else if (keyCode === Keys.ArrowUp) {
      index = this.next({
        current: args.current,
        start: args.min,
        end: args.max,
        step: -1
      });
      action = NavigationAction.Up;
    } else if (keyCode === Keys.ArrowLeft) {
      index = this.next({
        current: args.current,
        start: args.min,
        end: args.max,
        step: -1
      });
      action = NavigationAction.Left;
    } else if (keyCode === Keys.ArrowDown) {
      index = this.next({
        current: args.current,
        start: args.min,
        end: args.max,
        step: 1
      });
      action = NavigationAction.Down;
    } else if (keyCode === Keys.ArrowRight) {
      index = this.next({
        current: args.current,
        start: args.min,
        end: args.max,
        step: 1
      });
      action = NavigationAction.Right;
    } else if (keyCode === Keys.Home) {
      index = this.isDisabled(MIN_INDEX) ? args.current : MIN_INDEX;
      action = NavigationAction.Home;
    } else if (keyCode === Keys.End) {
      index = this.isDisabled(args.max) ? args.current : args.max;
      action = NavigationAction.End;
    } else if (keyCode === Keys.Delete) {
      action = NavigationAction.Delete;
    } else if (keyCode === Keys.Backspace) {
      action = NavigationAction.Backspace;
    } else if (keyCode === Keys.PageDown) {
      action = NavigationAction.PageDown;
    } else if (keyCode === Keys.PageUp) {
      action = NavigationAction.PageUp;
    }
    const eventData = new NavigationEvent(index, args.originalEvent);
    if (action !== NavigationAction.Undefined) {
      this[NavigationAction[action].toLowerCase()].emit(eventData);
    }
    return action;
  }
  next(args) {
    const {
      current,
      start,
      end,
      step
    } = args;
    const nextIndex = !isPresent(current) ? start : this.clampIndex(current + step, start, end);
    const firstFocusableIndex = this.firstFocusableIndex(nextIndex, start, end, step);
    if (isPresent(firstFocusableIndex)) {
      return firstFocusableIndex;
    }
    if (this.selectionService.isSelected(current) && current >= start) {
      return current;
    }
    const inversedStep = -1 * step;
    return this.firstFocusableIndex(nextIndex, start, end, inversedStep);
  }
  clampIndex(index, min, max) {
    if (!isPresent(index) || index < min) {
      return min;
    }
    if (index > max) {
      return max;
    }
    return index;
  }
  firstFocusableIndex(startIndex, min, max, step) {
    while (min <= startIndex && startIndex <= max) {
      if (!this.isDisabled(startIndex)) {
        return startIndex;
      }
      startIndex += step;
    }
    return undefined;
  }
  isDisabled(index) {
    if (this.disabledItemsService) {
      return this.disabledItemsService.isIndexDisabled(index);
    }
  }
  static ɵfac = function NavigationService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NavigationService)(i0.ɵɵinject(DisabledItemsService), i0.ɵɵinject(SelectionService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: NavigationService,
    factory: NavigationService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationService, [{
    type: Injectable
  }], () => [{
    type: DisabledItemsService
  }, {
    type: SelectionService
  }], null);
})();

/**
 * Renders content when no data is available. To define the no-data template, nest a `<ng-template>` tag
 * with the `kendo<ComponentName>NoDataTemplate` directive inside the component tag.
 *
 * - [Using `NoDataTemplate` with the AutoComplete](https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/templates#no-data-template)
 * - [Using `NoDataTemplate` with the ComboBox](https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox/templates#no-data-template)
 * - [Using `NoDataTemplate` with the MultiColumnComboBox](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multicolumncombobox/templates#no-data-template)
 * - [Using `NoDataTemplate` with the DropDownList](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/templates#no-data-template)
 * - [Using `NoDataTemplate` with the DropDownTree](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdowntree/templates#no-data-template)
 * - [Using `NoDataTemplate` with the MultiSelect](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/templates#no-data-template)
 *
 * @example
 * ```ts
 * _@Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-combobox [data]="listItems">
 *    <ng-template kendoComboBoxNoDataTemplate>
 *      <h4>No data!</h4>
 *    </ng-template>
 *  </kendo-combobox>
 * `
 * })
 * class AppComponent {
 *   public listItems: Array<string> = [];
 * }
 * ```
 */
class NoDataTemplateDirective {
  templateRef;
  constructor(templateRef) {
    this.templateRef = templateRef;
  }
  static ɵfac = function NoDataTemplateDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NoDataTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: NoDataTemplateDirective,
    selectors: [["", "kendoDropDownListNoDataTemplate", ""], ["", "kendoDropDownTreeNoDataTemplate", ""], ["", "kendoComboBoxNoDataTemplate", ""], ["", "kendoMultiColumnComboBoxNoDataTemplate", ""], ["", "kendoAutoCompleteNoDataTemplate", ""], ["", "kendoMultiSelectNoDataTemplate", ""], ["", "kendoMultiSelectTreeNoDataTemplate", ""]]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NoDataTemplateDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoDropDownListNoDataTemplate],[kendoDropDownTreeNoDataTemplate],[kendoComboBoxNoDataTemplate],[kendoMultiColumnComboBoxNoDataTemplate],[kendoAutoCompleteNoDataTemplate],[kendoMultiSelectNoDataTemplate],[kendoMultiSelectTreeNoDataTemplate]',
      standalone: true
    }]
  }], () => [{
    type: i0.TemplateRef
  }], null);
})();

/**
 * @hidden
 */
class PreventableEvent {
  prevented = false;
  /**
   * Prevents the default action for a specified event.
   * In this way, the source component suppresses the built-in behavior that follows the event.
   */
  preventDefault() {
    this.prevented = true;
  }
  /**
   * If the event is prevented by any of its subscribers, returns `true`.
   *
   * @returns `true` if the default action was prevented. Otherwise, returns `false`.
   */
  isDefaultPrevented() {
    return this.prevented;
  }
}

/**
 * Defines the mandatory properties of the `kendoDropDownFilter` directive
 * so that `kendoDropDownFilter` can be used with any of the DropDowns components
 * which implement the `FilterableDropDownComponentBase` class.
 *
 * @hidden
 */
class FilterableComponent {
  /**
   * Sets the data of the component.
   */
  data;
  /**
   * Explicitly enables the emitting of the `filterChange` event.
   */
  filterable;
  /**
   * Hooks to the `filter` event.
   */
  filterChange;
  /**
   * Reads the data from the components with complex data.
   */
  textField;
  /**
   * Reads the data from the components with complex data which use `valueField` instead of
   * `textField`&mdash;for example, the AutoComplete.
   */
  valueField;
}

/**
 * @hidden
 */
class ListItemDirective {
  element;
  constructor(element) {
    this.element = element;
  }
  static ɵfac = function ListItemDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListItemDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ListItemDirective,
    selectors: [["li", "role", "option"], ["li", "role", "group"], ["li", "role", "presentation"]]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListItemDirective, [{
    type: Directive,
    args: [{
      selector: '"li[role=option], li[role=group], li[role=presentation]"',
      standalone: true
    }]
  }], () => [{
    type: i0.ElementRef
  }], null);
})();

/**
 * @hidden
 */
class SelectableDirective {
  index;
  checkboxes = {
    enabled: false
  };
  height;
  isMultiselect;
  multipleSelection = false;
  selectionService;
  constructor(selectionService) {
    this.selectionService = selectionService;
  }
  get focusedClassName() {
    return this.selectionService.isFocused(this.index);
  }
  get selectedClassName() {
    return !this.checkboxes.enabled && this.selectionService.isSelected(this.index);
  }
  onClick(event) {
    event.stopPropagation();
    this.selectionService.lastClickedIndex = this.index;
    if (this.checkboxes.enabled && !this.checkboxes.checkOnClick) {
      return;
    }
    if (this.multipleSelection) {
      if (this.selectionService.isSelected(this.index)) {
        this.selectionService.deselect(this.index);
      } else {
        this.selectionService.add(this.index);
      }
    } else {
      this.selectionService.change(this.index);
    }
  }
  static ɵfac = function SelectableDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SelectableDirective)(i0.ɵɵdirectiveInject(SelectionService));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: SelectableDirective,
    selectors: [["", "kendoDropDownsSelectable", ""]],
    hostVars: 9,
    hostBindings: function SelectableDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function SelectableDirective_click_HostBindingHandler($event) {
          return ctx.onClick($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("index", ctx.index);
        i0.ɵɵstyleProp("height", ctx.height, "px")("min-height", ctx.height, "px");
        i0.ɵɵclassProp("k-focus", ctx.focusedClassName)("k-selected", ctx.selectedClassName);
      }
    },
    inputs: {
      index: "index",
      checkboxes: "checkboxes",
      height: "height",
      isMultiselect: "isMultiselect",
      multipleSelection: "multipleSelection"
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectableDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoDropDownsSelectable]',
      standalone: true
    }]
  }], () => [{
    type: SelectionService
  }], {
    index: [{
      type: HostBinding,
      args: ['attr.index']
    }, {
      type: Input
    }],
    checkboxes: [{
      type: Input
    }],
    height: [{
      type: HostBinding,
      args: ['style.height.px']
    }, {
      type: HostBinding,
      args: ['style.minHeight.px']
    }, {
      type: Input
    }],
    isMultiselect: [{
      type: Input
    }],
    multipleSelection: [{
      type: Input
    }],
    focusedClassName: [{
      type: HostBinding,
      args: ['class.k-focus']
    }],
    selectedClassName: [{
      type: HostBinding,
      args: ['class.k-selected']
    }],
    onClick: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();

/**
 * Renders the content of the custom list item in the MultiSelect
 * ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/templates#rendering-custom-item-content)).
 * The template context is set to the current component.
 * To get a reference to the current text that is typed by the
 * user, use the `let-customItem` directive.
 *
 * The `CustomItemTemplate` directive can only be used with the MultiSelect component.
 *
 * @example
 * ```typescript
 * @Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-multiselect [data]="listItems" [allowCustom]="true">
 *    <ng-template kendoMultiSelectCustomItemTemplate let-customItem>
 *      <span>New Item: {{customItem}}</span>
 *    </ng-template>
 *  </kendo-multiselect>
 * `
 * })
 * class AppComponent {
 *   public listItems: Array<string> = ["Item 1", "Item 2", "Item 3", "Item 4"];
 * }
 * ```
 *
 */
class CustomItemTemplateDirective {
  templateRef;
  constructor(templateRef) {
    this.templateRef = templateRef;
  }
  static ɵfac = function CustomItemTemplateDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CustomItemTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CustomItemTemplateDirective,
    selectors: [["", "kendoMultiSelectCustomItemTemplate", ""]]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomItemTemplateDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoMultiSelectCustomItemTemplate]',
      standalone: true
    }]
  }], () => [{
    type: i0.TemplateRef
  }], null);
})();

/**
 * @hidden
 */
class ListComponent {
  dataService;
  wrapper;
  selectionService;
  disabledItemsService;
  cdr;
  zone;
  renderer;
  localization;
  selected = [];
  focused = -1;
  textField;
  valueField;
  height;
  template;
  groupTemplate;
  fixedGroupTemplate;
  show = true;
  id;
  optionPrefix;
  multipleSelection = false;
  virtual;
  type = 'list';
  checkboxes = {
    enabled: false
  };
  ariaLive;
  isMultiselect;
  isActionSheetExpanded;
  showStickyHeader;
  rowWidth;
  customItemTemplate;
  text;
  allowCustom;
  defaultItem;
  set data(data) {
    this._data = data[0]?.header ? data.slice(0) : data;
    if (this.dataService.grouped) {
      if (this.virtual) {
        const firstGroupItem = this.dataService.data.find(item => item.header && item.groupIndex === this.data[0].groupIndex);
        if (!this.data[0].header) {
          this._data = [firstGroupItem, ...this._data.slice(1)];
        }
      }
      this.groupedData = this._data.filter(item => item?.header);
      this.groupedData.forEach(group => {
        group.items = this._data.filter(item => !item.header && item.groupIndex === group.groupIndex);
      });
    }
  }
  get data() {
    return this._data;
  }
  set size(size) {
    if (this.type === 'list') {
      this.renderer.removeClass(this.wrapper.nativeElement, getSizeClass('list', this.size));
      if (size) {
        this.renderer.addClass(this.wrapper.nativeElement, getSizeClass('list', size));
      }
      this._size = size;
    }
  }
  get size() {
    return this._size;
  }
  groupedData;
  rounded = undefined;
  onClick = new EventEmitter();
  pageChange = new EventEmitter();
  listResize = new EventEmitter();
  popupListScroll = new EventEmitter();
  items;
  content;
  list;
  virtualContainer;
  currentGroup;
  startFrom = 0;
  lastLoaded = 0;
  lastScrollTop = 0;
  listContentClass;
  listClass;
  listItemClass;
  listVirtualClass;
  listGroupStickyHeaderClass;
  listGroupStickyHeaderTextClass;
  listGroupItemClass;
  listGroupItemTextClass;
  scrollToFocused = false;
  _data;
  scrollSubscription;
  selectSubscription;
  _size;
  get pageSize() {
    if (this.virtual.pageSize) {
      return this.virtual.pageSize;
    }
    const size = Math.round(this.height / this.virtual.itemHeight);
    return size;
  }
  get scrollHeight() {
    return this.virtual.total * this.virtual.itemHeight;
  }
  get overflowY() {
    if (isPresent(this.virtual)) {
      const overflow = this.hasVirtualScrollbar() ? 'scroll' : 'hidden';
      return overflow;
    }
  }
  /**
   * @hidden
   */
  get useCustomValueText() {
    const localizationMsg = this.localization.get('useCustomValueText');
    return replaceMessagePlaceholder(localizationMsg, 'customValue', this.text);
  }
  /**
   * @hidden
   */
  get checkboxClasses() {
    return `${this.size ? getSizeClass('checkbox', this.size) : ''} ${this.rounded ? getRoundedClass(this.rounded) : ''}`;
  }
  /* tslint:disable:member-ordering */
  constructor(dataService, wrapper, selectionService, disabledItemsService, cdr, zone, renderer, localization) {
    this.dataService = dataService;
    this.wrapper = wrapper;
    this.selectionService = selectionService;
    this.disabledItemsService = disabledItemsService;
    this.cdr = cdr;
    this.zone = zone;
    this.renderer = renderer;
    this.localization = localization;
    this.selectSubscription = merge(this.selectionService.onSelect.pipe(map(args => args.indices[0])), this.selectionService.onFocus).pipe(
    // handle only the very last onSelect/onFocus emission
    switchMap(event => this.zone.onStable.pipe(take(1), map(() => event)))).subscribe(this.scrollToItem.bind(this));
    this.prepareClasses();
  }
  ngOnChanges(changes) {
    if (isChanged('data', changes, false)) {
      if (this.lastLoaded <= 0) {
        this.lastLoaded = this.data.length - 1;
        this.scrollToFocused = !changes['data'].isFirstChange();
      }
      this.setOverflow();
    }
    if (isChanged('virtual', changes, false)) {
      this.setOverflow();
    }
    if (isChanged('type', changes, false)) {
      this.prepareClasses();
    }
  }
  ngAfterViewInit() {
    this.setComponentClasses();
    this.zone.runOutsideAngular(() => {
      this.scrollSubscription = fromEvent(this.content.nativeElement, "scroll").pipe(auditTime(100), tap(this.prefetchData.bind(this)), tap(this.findCurrentGroup.bind(this))).subscribe(() => {
        this.lastScrollTop = this.content.nativeElement.scrollTop;
      });
    });
    this.setOverflow();
  }
  ngAfterViewChecked() {
    if (this.virtual) {
      this.positionItems();
    }
    if (this.items && this.scrollToFocused) {
      this.scrollToFocused = false;
      const scrollTarget = this.items.length && this.selectionService.focused === -1 ? 0 : this.selectionService.focused;
      this.scrollToItem(scrollTarget);
    }
    if (this.dataService.grouped) {
      this.findCurrentGroup();
    }
  }
  ngOnDestroy() {
    this.selectSubscription.unsubscribe();
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }
  }
  onCheckedChange(e, index) {
    const isChecked = e.target['checked'];
    if (isChecked && !this.selectionService.isSelected(index)) {
      this.selectionService.add(index);
    }
    if (!isChecked && this.selectionService.isSelected(index)) {
      this.selectionService.deselect(index);
    }
  }
  prepareClasses() {
    if (this.type === 'list') {
      this.listContentClass = 'k-list-content';
      this.listClass = 'k-list-ul';
      this.listItemClass = 'k-list-item';
      this.listVirtualClass = 'k-virtual-list';
      this.listGroupStickyHeaderClass = 'k-list-group-sticky-header';
      this.listGroupStickyHeaderTextClass = 'k-list-header-text';
      this.listGroupItemClass = 'k-list-group-item';
      this.listGroupItemTextClass = 'k-list-item-text';
    } else {
      this.listContentClass = 'k-table-body k-table-scroller';
      this.listClass = 'k-table k-table-list';
      this.listItemClass = 'k-table-row';
      this.listVirtualClass = 'k-virtual-table';
      this.listGroupStickyHeaderClass = 'k-table-group-sticky-header';
      this.listGroupStickyHeaderTextClass = 'k-table-th';
      this.listGroupItemClass = 'k-table-group-row';
      this.listGroupItemTextClass = 'k-table-th';
    }
  }
  isChecked(index) {
    const normalizedIndex = this.virtual ? index + this.virtual.skip : index;
    return this.selectionService.isSelected(normalizedIndex);
  }
  firstVisibleItem() {
    const content = this.content.nativeElement;
    const rect = content.getBoundingClientRect();
    // IE9 hack
    const disabled = Array.prototype.slice.call(content.querySelectorAll(".k-disabled"));
    // This is a workaround for finding elements with pointer-events: none;
    disabled.forEach(el => this.renderer.setStyle(el, "pointer-events", "auto"));
    const item = document.elementFromPoint(rect.left + 1, rect.top + 1);
    disabled.forEach(el => this.renderer.setStyle(el, "pointer-events", "none"));
    // return the closest `li` item to cover the custom template scenario
    return closest(item, 'li');
  }
  findCurrentGroup() {
    if (!this.dataService.grouped) {
      this.currentGroup = undefined;
      return;
    }
    const item = this.firstVisibleItem();
    if (item) {
      let index;
      if (item.getAttribute("role") === "presentation") {
        index = parseInt(item.getAttribute("group-index"), 10);
        this.currentGroup = this.dataService.groupAt(index)?.value;
      } else {
        index = parseInt(item.getAttribute("index"), 10);
        this.currentGroup = this.dataService.itemGroup(this.dataService.itemAt(index));
      }
    }
    this.cdr.detectChanges();
  }
  prefetchData() {
    if (!this.virtual) {
      return;
    }
    const visibleItems = Math.trunc(this.content.nativeElement.clientHeight / this.virtual.itemHeight);
    const offsetY = this.content.nativeElement.scrollTop;
    const start = Math.trunc(offsetY / this.virtual.itemHeight);
    const down = offsetY > this.lastScrollTop;
    const nextPage = start + visibleItems >= this.lastLoaded && this.lastLoaded < this.virtual.total - 1;
    const leftOver = this.pageSize - (this.lastLoaded - this.startFrom);
    const prevPage = this.lastLoaded - this.pageSize + visibleItems >= start - leftOver;
    if (down && nextPage) {
      this.changePage(start);
    }
    if (!down && prevPage) {
      this.changePage(start - this.pageSize + visibleItems + 1);
    }
  }
  changePage(start) {
    this.zone.run(() => {
      let end = this.pageSize + start;
      if (end > this.virtual.total) {
        start--;
        end = this.virtual.total;
      }
      if (start < 0) {
        start = 0;
      }
      this.startFrom = start;
      this.lastLoaded = end;
      this.pageChange.emit({
        skip: start,
        take: this.pageSize
      });
    });
  }
  index(groupIndex, itemIndex) {
    return groupIndex > 0 ? this.dataService.groupIndices[groupIndex - 1] + itemIndex : itemIndex;
  }
  getText(dataItem) {
    return getter(dataItem, this.textField);
  }
  getValue(dataItem) {
    return getter(dataItem, this.valueField);
  }
  generateGroupId(dataItem) {
    return `${this.optionPrefix}-${dataItem.groupIndex}-${dataItem.value.toString().split(' ').join('')}`;
  }
  isDisabled(index) {
    if (isPresent(this.virtual) && !this.dataService.grouped) {
      index += this.virtual.skip;
    }
    return this.disabledItemsService.isIndexDisabled(index);
  }
  isAltRow(index) {
    return this.type === 'dropdowngrid' && index % 2 !== 0;
  }
  scrollToItem(index) {
    let flatIndex = index;
    if (this.dataService.grouped) {
      // takes into account the group header items
      flatIndex = this.dataService.flatIndex(index);
    }
    if (this.virtual && flatIndex > -1) {
      this.scrollToIndex(flatIndex);
      return;
    }
    const items = this.items.toArray();
    if (isPresent(items[flatIndex]) && flatIndex !== -1) {
      this.scroll(items[flatIndex].element);
    }
  }
  scrollWithOnePage(action) {
    const content = this.content.nativeElement;
    const contentOffsetHeight = content.clientHeight;
    if (action === NavigationAction.PageDown) {
      content.scrollTop += contentOffsetHeight;
    } else if (action === NavigationAction.PageUp) {
      content.scrollTop -= contentOffsetHeight;
    }
  }
  scrollToIndex(index) {
    const content = this.content.nativeElement;
    let contentScrollTop = content.scrollTop;
    const itemOffsetTop = index * this.virtual.itemHeight;
    const itemOffsetHeight = this.virtual.itemHeight;
    const contentOffsetHeight = content.clientHeight;
    const bottomDistance = itemOffsetTop + itemOffsetHeight;
    if (contentScrollTop > itemOffsetTop) {
      contentScrollTop = itemOffsetTop;
    } else if (bottomDistance > contentScrollTop + contentOffsetHeight) {
      contentScrollTop = bottomDistance - contentOffsetHeight;
    }
    content.scrollTop = contentScrollTop;
  }
  scroll(item) {
    if (!item) {
      return;
    }
    const nativeElement = item.nativeElement;
    const content = this.content.nativeElement;
    const itemOffsetTop = nativeElement.offsetTop;
    const itemOffsetHeight = nativeElement.offsetHeight;
    let contentScrollTop = content.scrollTop;
    const contentOffsetHeight = content.clientHeight;
    const bottomDistance = itemOffsetTop + itemOffsetHeight;
    if (contentScrollTop > itemOffsetTop) {
      contentScrollTop = itemOffsetTop;
    } else if (bottomDistance > contentScrollTop + contentOffsetHeight) {
      contentScrollTop = bottomDistance - contentOffsetHeight;
    }
    content.scrollTop = contentScrollTop;
  }
  /**
   * Indicates whether a scrollbar is currently rendered in the list.
   */
  hasScrollbar() {
    if (!(isPresent(this.items) && this.items.length && isPresent(this.list) && isPresent(this.content))) {
      return false;
    }
    const hasVirtualScroll = isPresent(this.virtual) && this.hasVirtualScrollbar();
    return hasVirtualScroll || this.list.nativeElement.scrollHeight > this.content.nativeElement.offsetHeight;
  }
  isItemSelected(index) {
    return this.selectionService.isSelected(index) || null;
  }
  get isDisabledDefaultItem() {
    return this.disabledItemsService.isItemDisabled(this.defaultItem);
  }
  getDefaultItemText() {
    return getter(this.defaultItem, this.textField);
  }
  /**
   * Sets the list's content overflow (hides/shows scrollbar)
   */
  setOverflow() {
    if (this.virtual) {
      const overflow = this.hasVirtualScrollbar() ? 'scroll' : 'hidden';
      this.renderer.setStyle(this.content.nativeElement, 'overflow-y', overflow);
    }
  }
  /**
   * Indicates whether the scrollbar should be visible in virtual mode.
   */
  hasVirtualScrollbar() {
    const contentOffsetHeight = this.content.nativeElement.offsetHeight;
    const virtualOffsetHeight = this.virtualContainer && this.virtualContainer.nativeElement.offsetHeight;
    return this.virtualContainer && virtualOffsetHeight > contentOffsetHeight;
  }
  positionItems() {
    this.items.forEach((item, index) => {
      const offsetY = (index + this.startFrom) * this.virtual.itemHeight;
      this.renderer.setStyle(item.element.nativeElement, "transform", `translateY(${offsetY}px`);
    });
  }
  setComponentClasses() {
    if (this.type === 'list') {
      this.renderer.addClass(this.wrapper.nativeElement, 'k-list');
      if (this.size) {
        this.renderer.addClass(this.wrapper.nativeElement, getSizeClass('list', this.size));
      }
    }
    if (this.type === 'dropdowngrid') {
      this.renderer.setStyle(this.wrapper.nativeElement, 'overflow-y', 'scroll');
    }
    if (isPresent(this.virtual)) {
      this.renderer.addClass(this.wrapper.nativeElement, this.listVirtualClass);
    }
  }
  static ɵfac = function ListComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ListComponent)(i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(SelectionService), i0.ɵɵdirectiveInject(DisabledItemsService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.LocalizationService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ListComponent,
    selectors: [["kendo-list"]],
    viewQuery: function ListComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c1, 7)(_c2, 5)(_c3, 5)(ListItemDirective, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.list = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.virtualContainer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.items = _t);
      }
    },
    inputs: {
      selected: "selected",
      focused: "focused",
      textField: "textField",
      valueField: "valueField",
      height: "height",
      template: "template",
      groupTemplate: "groupTemplate",
      fixedGroupTemplate: "fixedGroupTemplate",
      show: "show",
      id: "id",
      optionPrefix: "optionPrefix",
      multipleSelection: "multipleSelection",
      virtual: "virtual",
      type: "type",
      checkboxes: "checkboxes",
      ariaLive: "ariaLive",
      isMultiselect: "isMultiselect",
      isActionSheetExpanded: "isActionSheetExpanded",
      showStickyHeader: "showStickyHeader",
      rowWidth: "rowWidth",
      customItemTemplate: "customItemTemplate",
      text: "text",
      allowCustom: "allowCustom",
      defaultItem: "defaultItem",
      data: "data",
      size: "size",
      rounded: "rounded"
    },
    outputs: {
      onClick: "onClick",
      pageChange: "pageChange",
      listResize: "listResize",
      popupListScroll: "popupListScroll"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 9,
    vars: 16,
    consts: [["content", ""], ["list", ""], ["groupUl", ""], ["virtualContainer", ""], ["kendoDropDownsSelectable", "", 1, "k-list-optionlabel", 3, "ngClass", "index"], ["kendoDropDownsSelectable", "", 1, "k-list-custom-value", 3, "multipleSelection", "index"], [3, "class", "ngStyle"], ["unselectable", "on", 3, "scroll"], [3, "class"], ["role", "presentation", 1, "k-height-container"], [3, "templateContext"], [3, "ngStyle"], ["role", "option", "kendoDropDownsSelectable", "", 3, "checkboxes", "height", "index", "multipleSelection", "class", "ngClass", "width"], ["role", "option", "kendoDropDownsSelectable", "", 3, "checkboxes", "height", "index", "multipleSelection", "ngClass"], ["type", "checkbox", "role", "presentation", "tabindex", "-1", 1, "k-checkbox", 3, "ngClass", "checked"], [1, "k-list-item-text"], ["type", "checkbox", "role", "presentation", "tabindex", "-1", 1, "k-checkbox", 3, "change", "ngClass", "checked"], [3, "resize"], [1, "k-list-ul"], ["role", "presentation", 3, "class", "k-table-alt-row", "ngStyle", "width"], ["role", "option", "kendoDropDownsSelectable", "", 3, "height", "index", "multipleSelection", "class", "ngClass", "width"], ["role", "presentation", 3, "ngStyle"], ["role", "option", "kendoDropDownsSelectable", "", 3, "height", "index", "multipleSelection", "ngClass"]],
    template: function ListComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵconditionalCreate(0, ListComponent_Conditional_0_Template, 2, 5, "div", 4);
        i0.ɵɵconditionalCreate(1, ListComponent_Conditional_1_Template, 2, 8, "div", 4);
        i0.ɵɵconditionalCreate(2, ListComponent_Conditional_2_Template, 3, 3, "div", 5);
        i0.ɵɵconditionalCreate(3, ListComponent_Conditional_3_Template, 3, 9, "div", 6);
        i0.ɵɵelementStart(4, "div", 7, 0);
        i0.ɵɵlistener("scroll", function ListComponent_Template_div_scroll_4_listener($event) {
          return ctx.popupListScroll.emit($event);
        });
        i0.ɵɵconditionalCreate(6, ListComponent_Conditional_6_Template, 5, 8, "ul", 8);
        i0.ɵɵconditionalCreate(7, ListComponent_Conditional_7_Template, 4, 0, "ng-container");
        i0.ɵɵconditionalCreate(8, ListComponent_Conditional_8_Template, 4, 2, "div", 9);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵconditional(ctx.defaultItem && !ctx.template ? 0 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.defaultItem && ctx.template ? 1 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.allowCustom && ctx.text ? 2 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.dataService.grouped && ctx.showStickyHeader ? 3 : -1);
        i0.ɵɵadvance();
        i0.ɵɵclassMap(ctx.listContentClass);
        i0.ɵɵstyleProp("max-height", ctx.height, "px");
        i0.ɵɵattribute("role", ctx.dataService.grouped ? "listbox" : null)("id", ctx.dataService.grouped ? ctx.id : null)("aria-live", ctx.dataService.grouped ? ctx.ariaLive : null)("aria-multiselectable", ctx.dataService.grouped ? ctx.isMultiselect : null)("aria-hidden", ctx.dataService.grouped ? !ctx.show : null);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(!ctx.dataService.grouped ? 6 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.dataService.grouped ? 7 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.virtual ? 8 : -1);
      }
    },
    dependencies: [NgStyle, TemplateContextDirective, ListItemDirective, SelectableDirective, NgClass, ResizeSensorComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListComponent, [{
    type: Component,
    args: [{
      selector: 'kendo-list',
      template: `
    @if (defaultItem && !template) {
      <div
        class="k-list-optionlabel"
        [ngClass]="{ 'k-disabled': isDisabledDefaultItem }"
        kendoDropDownsSelectable
        [index]="-1">
        {{ getDefaultItemText() }}
      </div>
    }
    @if (defaultItem && template) {
      <div
        class="k-list-optionlabel"
        [ngClass]="{ 'k-disabled': isDisabledDefaultItem }"
        kendoDropDownsSelectable
        [index]="-1">
        <ng-template
            [templateContext]="{
                templateRef: template.templateRef,
                $implicit: defaultItem
            }">
        </ng-template>
      </div>
    }
    @if (allowCustom && text) {
      <div
        kendoDropDownsSelectable
        [multipleSelection]="true"
        [index]="-1"
        class="k-list-custom-value">
        @if (customItemTemplate) {
          <ng-template
            [templateContext]="{
                templateRef: customItemTemplate.templateRef,
                $implicit: text
            }">
          </ng-template>
        } @else {
          {{useCustomValueText}}
        }
      </div>
    }
    @if (dataService.grouped && showStickyHeader) {
      <div
        [class]="listGroupStickyHeaderClass"
        [ngStyle]="{
            'height.px': virtual?.itemHeight,
            'minHeight.px' : virtual?.itemHeight,
            'boxSizing' : virtual ? 'border-box' : 'inherit'}"
        >
        @if (fixedGroupTemplate) {
          <ng-template
            [templateContext]="{
                templateRef: fixedGroupTemplate.templateRef,
                $implicit: currentGroup
            }">
          </ng-template>
        }
        @if (!fixedGroupTemplate) {
          <span [class]="listGroupStickyHeaderTextClass">{{ currentGroup }}</span>
        }
      </div>
    }
    <div #content
      [class]="listContentClass"
      [style.maxHeight.px]="height"
      unselectable="on"
      (scroll)="popupListScroll.emit($event)"
      [attr.role]="dataService.grouped ? 'listbox' : null"
      [attr.id]="dataService.grouped ? id : null"
      [attr.aria-live]="dataService.grouped ? ariaLive : null"
      [attr.aria-multiselectable]="dataService.grouped ? isMultiselect : null"
      [attr.aria-hidden]="dataService.grouped ? !show : null"
      >
      @if (!dataService.grouped) {
        <ul #list
          [attr.role]="'listbox'"
          [class]="listClass"
          [attr.id]="id"
          [attr.aria-live]="ariaLive"
          [attr.aria-multiselectable]="isMultiselect"
          [attr.aria-hidden]="!show">
          @for (dataItem of data; track $index; let itemIndex = $index) {
            <li
              role="option"
              kendoDropDownsSelectable
              [checkboxes]="checkboxes"
              [height]="virtual?.itemHeight"
              [index]="itemIndex + startFrom"
              [multipleSelection]="multipleSelection"
              [attr.id]="optionPrefix + '-' + itemIndex"
              [attr.tabIndex]="-1"
              [attr.aria-selected]="isItemSelected(itemIndex)"
              [class]="listItemClass"
                    [ngClass]="{
                        'k-disabled': isDisabled(itemIndex),
                        'k-table-alt-row': isAltRow(itemIndex)
                    }"
              [style.width.px]="rowWidth ?? null"
              >
              @if (checkboxes.enabled) {
                <input
                  type="checkbox"
                  class="k-checkbox"
                  role="presentation"
                  tabindex="-1"
                  [ngClass]="checkboxClasses"
                  (change)="onCheckedChange($event, itemIndex + startFrom)"
                  [checked]="isChecked(itemIndex)"
                  />
              }
              @if (template) {
                <ng-template
                        [templateContext]="{
                            templateRef: template.templateRef,
                            $implicit: dataItem
                        }">
                </ng-template>
              }
              @if (!template) {
                <span class="k-list-item-text">{{ getText(dataItem) }}</span>
              }
            </li>
          }
          @if (!virtual) {
            <kendo-resize-sensor
              (resize)="listResize.emit()"
              >
            </kendo-resize-sensor>
          }
        </ul>
      }

      @if (dataService.grouped) {
        <ng-container #list>
          @for (dataItem of groupedData; track dataItem.groupIndex) {
            <ul
              #groupUl
              class="k-list-ul"
              [attr.role]="'group'"
              [attr.aria-labelledby]="generateGroupId(dataItem)"
              >
              @if (dataItem.header) {
                <li
                  role="presentation"
                  [class]="listGroupItemClass"
                  [class.k-table-alt-row]="isAltRow(dataItem.index - 1)"
                    [ngStyle]="{
                        'height.px': virtual?.itemHeight,
                        'minHeight.px' : virtual?.itemHeight,
                        'boxSizing' : virtual ? 'border-box' : 'inherit'}"
                  [attr.group-index]="dataItem.index"
                  [attr.id]="groupUl.getAttribute('aria-labelledby')"
                  [style.width.px]="rowWidth ?? null"
                  >
                  <span [class]="listGroupItemTextClass">
                    @if (groupTemplate) {
                      <ng-template
                            [templateContext]="{
                                templateRef: groupTemplate.templateRef,
                                $implicit: dataItem.value
                        }">
                      </ng-template>
                    }
                    @if (!groupTemplate) {
                      {{ dataItem.value }}
                    }
                  </span>
                </li>
              }
              @for (item of dataItem.items; track item.offsetIndex) {
                <li
                  role="option"
                  kendoDropDownsSelectable
                  [height]="virtual?.itemHeight"
                  [index]="item.offsetIndex"
                  [multipleSelection]="multipleSelection"
                  [attr.absolute-index]="item.index"
                  [attr.id]="optionPrefix + '-' + (item.index - 1 - item.groupIndex)"
                  [attr.tabIndex]="-1"
                  [attr.aria-selected]="isItemSelected(item.offsetIndex)"
                  [class]="listItemClass"
                    [ngClass]="{
                        'k-disabled': isDisabled(item.offsetIndex),
                        'k-table-alt-row': isAltRow(item.index - 1)
                    }"
                  [style.width.px]="rowWidth ?? null">
                  @if (template) {
                    <ng-template
                        [templateContext]="{
                            templateRef: template.templateRef,
                            $implicit: item.value
                        }">
                    </ng-template>
                  }
                  @if (!template) {
                    <span class="k-list-item-text">{{ getText(item.value) }}</span>
                  }
                </li>
              }
              @if (!virtual) {
                <kendo-resize-sensor
                  (resize)="listResize.emit()"
                  >
                </kendo-resize-sensor>
              }
            </ul>
          }
        </ng-container>
      }
      @if (virtual) {
        <div #virtualContainer class="k-height-container" role="presentation">
          <div [style.height.px]="scrollHeight">
            <kendo-resize-sensor (resize)="listResize.emit()"></kendo-resize-sensor>
          </div>
        </div>
      }
    </div>
    `,
      standalone: true,
      imports: [NgStyle, TemplateContextDirective, ListItemDirective, SelectableDirective, NgClass, ResizeSensorComponent]
    }]
  }], () => [{
    type: DataService
  }, {
    type: i0.ElementRef
  }, {
    type: SelectionService
  }, {
    type: DisabledItemsService
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i0.NgZone
  }, {
    type: i0.Renderer2
  }, {
    type: i1.LocalizationService
  }], {
    selected: [{
      type: Input
    }],
    focused: [{
      type: Input
    }],
    textField: [{
      type: Input
    }],
    valueField: [{
      type: Input
    }],
    height: [{
      type: Input
    }],
    template: [{
      type: Input
    }],
    groupTemplate: [{
      type: Input
    }],
    fixedGroupTemplate: [{
      type: Input
    }],
    show: [{
      type: Input
    }],
    id: [{
      type: Input
    }],
    optionPrefix: [{
      type: Input
    }],
    multipleSelection: [{
      type: Input
    }],
    virtual: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    checkboxes: [{
      type: Input
    }],
    ariaLive: [{
      type: Input
    }],
    isMultiselect: [{
      type: Input
    }],
    isActionSheetExpanded: [{
      type: Input
    }],
    showStickyHeader: [{
      type: Input
    }],
    rowWidth: [{
      type: Input
    }],
    customItemTemplate: [{
      type: Input
    }],
    text: [{
      type: Input
    }],
    allowCustom: [{
      type: Input
    }],
    defaultItem: [{
      type: Input
    }],
    data: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    rounded: [{
      type: Input
    }],
    onClick: [{
      type: Output
    }],
    pageChange: [{
      type: Output
    }],
    listResize: [{
      type: Output
    }],
    popupListScroll: [{
      type: Output
    }],
    items: [{
      type: ViewChildren,
      args: [ListItemDirective]
    }],
    content: [{
      type: ViewChild,
      args: ['content', {
        static: true
      }]
    }],
    list: [{
      type: ViewChild,
      args: ['list']
    }],
    virtualContainer: [{
      type: ViewChild,
      args: ['virtualContainer']
    }]
  });
})();

/**
 * @hidden
 */
const DEFAULTS = {
  pageSize: 50,
  itemHeight: 36
};
/**
 * @hidden
 */
const normalizeVirtualizationSettings = (settings, defaultOverrides) => {
  const defaults = Object.assign({}, DEFAULTS, defaultOverrides);
  if (settings === true) {
    return defaults;
  }
  if (!settings) {
    return null;
  }
  return {
    pageSize: DEFAULTS.pageSize,
    ...settings
  };
};

/**
 * @hidden
 */
class AdaptiveRendererComponent {
  localization;
  adaptiveService;
  title;
  subtitle;
  showTextInput;
  sharedPopupActionSheetTemplate;
  text;
  placeholder;
  searchBarValue;
  filterable;
  closePopup = new EventEmitter();
  textInputChange = new EventEmitter();
  navigate = new EventEmitter();
  onExpand = new EventEmitter();
  actionSheet;
  actionSheetSearchBar;
  constructor(localization, adaptiveService) {
    this.localization = localization;
    this.adaptiveService = adaptiveService;
  }
  animationDuration = animationDuration;
  checkIcon = checkIcon;
  expanded = false;
  messageFor(key) {
    return this.localization.get(key);
  }
  onValueChange(value) {
    this.searchBarValue = value;
    this.textInputChange.emit(value);
  }
  onOverlayClick() {
    if (this.expanded) {
      this.handleClose();
    }
  }
  handleExpand() {
    this.onExpand.emit();
    this.expanded = true;
  }
  handleClose() {
    this.closePopup.emit();
    this.expanded = false;
  }
  get windowSize() {
    return this.adaptiveService.size;
  }
  static ɵfac = function AdaptiveRendererComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AdaptiveRendererComponent)(i0.ɵɵdirectiveInject(i1.LocalizationService), i0.ɵɵdirectiveInject(i7.AdaptiveService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: AdaptiveRendererComponent,
    selectors: [["kendo-adaptive-renderer"]],
    viewQuery: function AdaptiveRendererComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(ActionSheetComponent, 5)(_c8, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.actionSheet = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.actionSheetSearchBar = _t.first);
      }
    },
    inputs: {
      title: "title",
      subtitle: "subtitle",
      showTextInput: "showTextInput",
      sharedPopupActionSheetTemplate: "sharedPopupActionSheetTemplate",
      text: "text",
      placeholder: "placeholder",
      searchBarValue: "searchBarValue",
      filterable: "filterable"
    },
    outputs: {
      closePopup: "closePopup",
      textInputChange: "textInputChange",
      navigate: "navigate",
      onExpand: "onExpand"
    },
    decls: 3,
    vars: 11,
    consts: [["actionSheet", ""], ["actionSheetSearchBar", ""], [3, "overlayClick", "keydown", "expand", "collapse", "animation", "initialFocus", "cssClass", "cssStyle"], ["kendoActionSheetTemplate", ""], [1, "k-text-center", "k-actionsheet-titlebar"], [1, "k-actionsheet-titlebar-group"], [1, "k-actionsheet-title"], [1, "k-text-center"], [1, "k-actionsheet-subtitle", "k-text-center"], [1, "k-actionsheet-actions"], ["kendoButton", "", "icon", "check", "type", "button", "fillMode", "flat", "themeColor", "primary", "size", "large", "innerCssClass", "k-button-icon", 3, "click", "svgIcon", "tabIndex"], [1, "k-actionsheet-titlebar-group", "k-actionsheet-filter"], [1, "k-actionsheet-content"], [1, "k-list-container"], [4, "ngTemplateOutlet"], ["size", "large", "autocomplete", "off", 1, "k-searchbox", 3, "valueChange", "value", "placeholder"], ["kendoTextBoxPrefixTemplate", ""], ["name", "search"]],
    template: function AdaptiveRendererComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "kendo-actionsheet", 2, 0);
        i0.ɵɵlistener("overlayClick", function AdaptiveRendererComponent_Template_kendo_actionsheet_overlayClick_0_listener() {
          return ctx.onOverlayClick();
        })("keydown", function AdaptiveRendererComponent_Template_kendo_actionsheet_keydown_0_listener($event) {
          return ctx.navigate.emit($event);
        })("expand", function AdaptiveRendererComponent_Template_kendo_actionsheet_expand_0_listener() {
          return ctx.handleExpand();
        })("collapse", function AdaptiveRendererComponent_Template_kendo_actionsheet_collapse_0_listener() {
          return ctx.closePopup.emit();
        });
        i0.ɵɵtemplate(2, AdaptiveRendererComponent_ng_template_2_Template, 11, 7, "ng-template", 3);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("animation", i0.ɵɵpureFunction1(4, _c9, ctx.animationDuration))("initialFocus", false)("cssClass", i0.ɵɵpureFunction2(6, _c10, ctx.windowSize === "small", ctx.windowSize === "medium"))("cssStyle", i0.ɵɵpureFunction1(9, _c11, ctx.windowSize === "small" ? "100vh" : "60vh"));
      }
    },
    dependencies: [ActionSheetComponent, ActionSheetTemplateDirective, ButtonComponent, TextBoxComponent, TextBoxPrefixTemplateDirective, IconComponent, NgTemplateOutlet],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AdaptiveRendererComponent, [{
    type: Component,
    args: [{
      selector: 'kendo-adaptive-renderer',
      template: `
        <kendo-actionsheet
          #actionSheet
          [animation]="{ duration: animationDuration }"
          [initialFocus]="false"
            [cssClass]="{
                'k-adaptive-actionsheet': true,
                'k-actionsheet-fullscreen': windowSize === 'small',
                'k-actionsheet-bottom': windowSize === 'medium'
            }"
            [cssStyle]="{
                height: windowSize === 'small' ? '100vh' : '60vh'
            }"
          (overlayClick)="onOverlayClick()"
          (keydown)="navigate.emit($event)"
          (expand)="handleExpand()"
          (collapse)="closePopup.emit()"
          >
          <ng-template kendoActionSheetTemplate>
            <div class="k-text-center k-actionsheet-titlebar">
              <div class="k-actionsheet-titlebar-group">
                <div class="k-actionsheet-title">
                  @if (title) {
                    <div class="k-text-center">{{ title }}</div>
                  }
                  @if (subtitle) {
                    <div class="k-actionsheet-subtitle k-text-center">{{ subtitle }}</div>
                  }
                </div>
                <div class="k-actionsheet-actions">
                  <button
                    kendoButton
                    icon="check"
                    type="button"
                    [attr.title]="messageFor('adaptiveCloseButtonTitle')"
                    [svgIcon]="checkIcon"
                    fillMode="flat"
                    themeColor="primary"
                    size="large"
                    [tabIndex]="-1"
                    innerCssClass="k-button-icon"
                    (click)="handleClose()"
                  ></button>
                </div>
              </div>
              @if (showTextInput) {
                <div class="k-actionsheet-titlebar-group k-actionsheet-filter">
                  <kendo-textbox
                    #actionSheetSearchBar
                    [value]="searchBarValue || ''"
                    size="large"
                    [placeholder]="filterable ? messageFor('filterInputPlaceholder') : placeholder"
                    class="k-searchbox"
                    autocomplete="off"
                    (valueChange)="onValueChange($event)"
                    >
                    @if (filterable) {
                      <ng-template kendoTextBoxPrefixTemplate>
                        <kendo-icon name="search"></kendo-icon>
                      </ng-template>
                    }
                  </kendo-textbox>
                </div>
              }
            </div>
            <div class="k-actionsheet-content">
              <div class="k-list-container">
                <ng-container *ngTemplateOutlet="sharedPopupActionSheetTemplate"></ng-container>
              </div>
            </div>
          </ng-template>
        </kendo-actionsheet>
        `,
      standalone: true,
      imports: [ActionSheetComponent, ActionSheetTemplateDirective, ButtonComponent, TextBoxComponent, TextBoxPrefixTemplateDirective, IconComponent, NgTemplateOutlet]
    }]
  }], () => [{
    type: i1.LocalizationService
  }, {
    type: i7.AdaptiveService
  }], {
    title: [{
      type: Input
    }],
    subtitle: [{
      type: Input
    }],
    showTextInput: [{
      type: Input
    }],
    sharedPopupActionSheetTemplate: [{
      type: Input
    }],
    text: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    searchBarValue: [{
      type: Input
    }],
    filterable: [{
      type: Input
    }],
    closePopup: [{
      type: Output
    }],
    textInputChange: [{
      type: Output
    }],
    navigate: [{
      type: Output
    }],
    onExpand: [{
      type: Output
    }],
    actionSheet: [{
      type: ViewChild,
      args: [ActionSheetComponent]
    }],
    actionSheetSearchBar: [{
      type: ViewChild,
      args: ['actionSheetSearchBar']
    }]
  });
})();

/**
 * @hidden
 */
class SharedDropDownEventsDirective {
  ngZone;
  renderer;
  cdr;
  hostElement;
  clearButtonClicked;
  isFocused;
  isFocusedChange = new EventEmitter();
  onFocus = new EventEmitter();
  handleBlur = new EventEmitter();
  subscriptions = new Subscription();
  constructor(ngZone, renderer, cdr) {
    this.ngZone = ngZone;
    this.renderer = renderer;
    this.cdr = cdr;
  }
  ngAfterViewInit() {
    const hostElement = this.hostElement.nativeElement;
    let cursorInsideWrapper = false;
    let tabbing = false;
    this.ngZone.runOutsideAngular(() => {
      // focusIn and focusOut are relative to the host element
      this.subscriptions.add(this.renderer.listen(hostElement, 'focusin', () => {
        this.cdr.detectChanges();
        if (!this.isFocused) {
          this.ngZone.run(() => {
            this.onFocus.emit();
            this.isFocused = true;
            this.isFocusedChange.emit(this.isFocused);
          });
        }
      }));
      this.subscriptions.add(this.renderer.listen(hostElement, 'focusout', args => {
        if (!this.isFocused) {
          return;
        }
        if (tabbing) {
          const closestTextbox = closest$1(args.relatedTarget, element => element === hostElement);
          if (!closestTextbox) {
            this.handleBlur.emit();
          }
          tabbing = false;
        } else if (!cursorInsideWrapper) {
          this.handleBlur.emit();
        }
      }));
      this.subscriptions.add(this.renderer.listen(hostElement, 'click', args => {
        if (!this.isFocused) {
          return;
        }
        const element = args.target;
        const adornmentContainer = element.closest('.k-input-prefix') || element.closest('.k-input-suffix');
        if (adornmentContainer) {
          const isFocusable = hasFocusableParent(element, adornmentContainer);
          if (!isFocusable) {
            this.handleBlur.emit();
          }
        }
      }));
      this.subscriptions.add(this.renderer.listen(hostElement, 'mouseenter', () => {
        cursorInsideWrapper = true;
      }));
      this.subscriptions.add(this.renderer.listen(hostElement, 'mouseleave', () => {
        cursorInsideWrapper = false;
      }));
      this.subscriptions.add(this.renderer.listen(hostElement, 'keydown', args => {
        if (args.code === Keys.Tab) {
          tabbing = true;
        } else {
          tabbing = false;
        }
      }));
    });
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  static ɵfac = function SharedDropDownEventsDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SharedDropDownEventsDirective)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: SharedDropDownEventsDirective,
    selectors: [["", "kendoDropDownSharedEvents", ""]],
    inputs: {
      hostElement: "hostElement",
      clearButtonClicked: "clearButtonClicked",
      isFocused: "isFocused"
    },
    outputs: {
      isFocusedChange: "isFocusedChange",
      onFocus: "onFocus",
      handleBlur: "handleBlur"
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SharedDropDownEventsDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoDropDownSharedEvents]',
      standalone: true
    }]
  }], () => [{
    type: i0.NgZone
  }, {
    type: i0.Renderer2
  }, {
    type: i0.ChangeDetectorRef
  }], {
    hostElement: [{
      type: Input
    }],
    clearButtonClicked: [{
      type: Input
    }],
    isFocused: [{
      type: Input
    }],
    isFocusedChange: [{
      type: Output
    }],
    onFocus: [{
      type: Output
    }],
    handleBlur: [{
      type: Output
    }]
  });
})();

/**
 * @hidden
 */
class Messages extends ComponentMessages {
  /**
   * The text displayed in the popup when there are no items.
   */
  noDataText;
  /**
   * The title of the clear button.
   */
  clearTitle;
  /**
   * The text displayed for the check-all checkbox.
   */
  checkAllText;
  /**
   * The text set as aria-label on the select button.
   */
  selectButtonText;
  /**
   * The text set as aria-label on the list filter input.
   */
  filterInputLabel;
  /**
   * The text set as aria-label on the popup containing the list of options when its role is `region`.
   */
  popupLabel;
  /**
   * The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode.
   */
  adaptiveCloseButtonTitle;
  /**
   * The text for the input's placeholder when filtering is enabled.
   */
  filterInputPlaceholder;
  /**
   * The text displayed when the user types a custom value that is not in the list of options.
   *
   * The text includes a localizable string and the custom value.
   * For example, when adding a custom value **Test**, the default text is **Use "Test"**.
   *
   * You can reorder the custom value and the localizable part by using a placeholder in `useCustomValueText`.
   * Use `{customValue}` to insert the value, for example, **Add: {customValue}**.
   */
  useCustomValueText;
  static ɵfac = /* @__PURE__ */(() => {
    let ɵMessages_BaseFactory;
    return function Messages_Factory(__ngFactoryType__) {
      return (ɵMessages_BaseFactory || (ɵMessages_BaseFactory = i0.ɵɵgetInheritedFactory(Messages)))(__ngFactoryType__ || Messages);
    };
  })();
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: Messages,
    inputs: {
      noDataText: "noDataText",
      clearTitle: "clearTitle",
      checkAllText: "checkAllText",
      selectButtonText: "selectButtonText",
      filterInputLabel: "filterInputLabel",
      popupLabel: "popupLabel",
      adaptiveCloseButtonTitle: "adaptiveCloseButtonTitle",
      filterInputPlaceholder: "filterInputPlaceholder",
      useCustomValueText: "useCustomValueText"
    },
    features: [i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Messages, [{
    type: Directive
  }], null, {
    noDataText: [{
      type: Input
    }],
    clearTitle: [{
      type: Input
    }],
    checkAllText: [{
      type: Input
    }],
    selectButtonText: [{
      type: Input
    }],
    filterInputLabel: [{
      type: Input
    }],
    popupLabel: [{
      type: Input
    }],
    adaptiveCloseButtonTitle: [{
      type: Input
    }],
    filterInputPlaceholder: [{
      type: Input
    }],
    useCustomValueText: [{
      type: Input
    }]
  });
})();

/**
 * @hidden
 */
class LocalizedMessagesDirective extends Messages {
  service;
  constructor(service) {
    super();
    this.service = service;
  }
  static ɵfac = function LocalizedMessagesDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LocalizedMessagesDirective)(i0.ɵɵdirectiveInject(i1.LocalizationService));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: LocalizedMessagesDirective,
    selectors: [["", "kendoDropDownListLocalizedMessages", ""], ["", "kendoDropDownTreeLocalizedMessages", ""], ["", "kendoComboBoxLocalizedMessages", ""], ["", "kendoMultiColumnComboBoxLocalizedMessages", ""], ["", "kendoAutoCompleteLocalizedMessages", ""], ["", "kendoMultiSelectLocalizedMessages", ""], ["", "kendoMultiSelectTreeLocalizedMessages", ""]],
    features: [i0.ɵɵProvidersFeature([{
      provide: Messages,
      useExisting: forwardRef(() => LocalizedMessagesDirective)
    }]), i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocalizedMessagesDirective, [{
    type: Directive,
    args: [{
      providers: [{
        provide: Messages,
        useExisting: forwardRef(() => LocalizedMessagesDirective)
      }],
      selector: `
    [kendoDropDownListLocalizedMessages],
    [kendoDropDownTreeLocalizedMessages],
    [kendoComboBoxLocalizedMessages],
    [kendoMultiColumnComboBoxLocalizedMessages],
    [kendoAutoCompleteLocalizedMessages],
    [kendoMultiSelectLocalizedMessages],
    [kendoMultiSelectTreeLocalizedMessages]
  `,
      standalone: true
    }]
  }], () => [{
    type: i1.LocalizationService
  }], null);
})();
const NO_VALUE = "";
/**
 * @hidden
 */
const AUTOCOMPLETE_VALUE_ACCESSOR = {
  multi: true,
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AutoCompleteComponent)
};
/**
 * Represents the [Kendo UI AutoComplete component for Angular](https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete).
 *
 * @example
 * ```html
 * <kendo-autocomplete
 *     [data]="['Item1', 'Item2', 'Item3']"
 *     placeholder="placeholder">
 * </kendo-autocomplete>
 * ```
 *
 * @remarks
 * Supported children components are: {@link CustomMessagesComponent}.
 */
class AutoCompleteComponent {
  localization;
  dataService;
  popupService;
  selectionService;
  navigationService;
  disabledItemsService;
  _zone;
  cdr;
  renderer;
  hostElement;
  injector;
  adaptiveService;
  /**
   * @hidden
   */
  animationDuration = animationDuration;
  /**
   * @hidden
   */
  xIcon = xIcon;
  /**
   * @hidden
   */
  adaptiveRendererComponent;
  /**
   * @hidden
   */
  get actionSheet() {
    return this.adaptiveRendererComponent?.actionSheet;
  }
  /**
   * @hidden
   */
  get actionSheetSearchBar() {
    return this.adaptiveRendererComponent?.actionSheetSearchBar;
  }
  get width() {
    let wrapperOffsetWidth = 0;
    if (isDocumentAvailable()) {
      wrapperOffsetWidth = this.wrapper.offsetWidth;
    }
    const width = this.popupSettings.width || wrapperOffsetWidth;
    const minWidth = isNaN(wrapperOffsetWidth) ? wrapperOffsetWidth : `${wrapperOffsetWidth}px`;
    const maxWidth = isNaN(width) ? width : `${width}px`;
    return {
      min: minWidth,
      max: maxWidth
    };
  }
  get height() {
    const popupHeight = this.popupSettings.height;
    return isPresent(popupHeight) ? `${popupHeight}px` : 'auto';
  }
  get listContainerClasses() {
    const containerClasses = ['k-list-container', 'k-autocomplete-popup'];
    if (!this.popupSettings.popupClass) {
      return containerClasses;
    }
    const parsedPopupClasses = parseCSSClassNames(this.popupSettings.popupClass);
    if (parsedPopupClasses?.length) {
      containerClasses.push(...parsedPopupClasses);
    }
    return containerClasses;
  }
  get suggestion() {
    if (!this.text || !this.suggestedText) {
      this.suggestedText = undefined;
      return;
    }
    const hasMatch = this.suggestedText.toLowerCase().startsWith(this.text.toLowerCase());
    const shouldSuggest = this.suggest && !this.backspacePressed;
    if (shouldSuggest && hasMatch) {
      return this.suggestedText;
    }
  }
  get appendTo() {
    const {
      appendTo
    } = this.popupSettings;
    if (!appendTo || appendTo === 'root') {
      return undefined;
    }
    return appendTo === 'component' ? this.container : appendTo;
  }
  /**
   * @hidden
   */
  get clearButtonVisibility() {
    if (touchEnabled) {
      return 'visible';
    }
  }
  /**
   * @hidden
   */
  get ariaControls() {
    return this.isOpen ? this.listBoxId : undefined;
  }
  /**
   * @hidden
   */
  get isControlRequired() {
    return isControlRequired(this.formControl);
  }
  /**
   * @hidden
   */
  dataItem;
  /**
   * Toggles the visibility of the popup or actionSheet.
   * If you use the `toggle` method to open or close the popup or actionSheet, the `open` and `close` events will not be fired.
   *
   * @param open - The state of the popup.
   */
  toggle(open) {
    Promise.resolve(null).then(() => {
      const shouldOpen = isPresent(open) ? open : !this._open;
      this._toggle(shouldOpen);
    });
  }
  /**
   * Returns the current open state. Returns `true` if the popup or actionSheet is open.
   */
  get isOpen() {
    return isTruthy(this._open || this.isActionSheetExpanded);
  }
  /**
   * @hidden
   */
  handleClick() {
    this.windowSize = this.adaptiveService.size;
    if (this.isAdaptive) {
      this.togglePopup(true);
    }
  }
  /**
   * @hidden
   */
  togglePopup(open) {
    const isDisabled = this.disabled || this.readonly;
    const sameState = this.isOpen === open;
    if (isDisabled || sameState) {
      return;
    }
    const isDefaultPrevented = this.triggerPopupEvents(open);
    if (!isDefaultPrevented) {
      this._toggle(open);
    }
  }
  get activeDescendant() {
    if (!this.isOpen || !isPresent(this.selectionService.focused) || this.selectionService.focused === -1) {
      return null;
    }
    return this.optionPrefix + "-" + this.selectionService.focused;
  }
  /**
   * Defines whether the first match from the suggestions list will be automatically focused.
   * By default, `highlightFirst` is set to `true`.
   *
   * @default true
   */
  highlightFirst = true;
  /**
   * Shows or hides the current group sticky header when using grouped data.
   * By default, the sticky header is displayed ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/grouping#sticky-header)).
   *
   * @default true
   */
  showStickyHeader = true;
  /**
   * @hidden
   */
  focusableId = `k-${guid()}`;
  /**
   * Sets the data of the AutoComplete.
   *
   * > The data has to be provided in an array-like list.
   */
  set data(data) {
    this.dataService.data = data || [];
    if (this.virtual) {
      this.virtual.skip = 0;
    }
    if (this.filterable) {
      this.selectionService.focused = this.isOpen && this.data.length && this.highlightFirst ? this.firstFocusableIndex(0) : -1;
    }
    if (this.suggest && this.dataService.itemsCount > 0) {
      this.suggestedText = getter(this.dataService.itemAt(0), this.valueField);
    }
  }
  get data() {
    const virtual = this.virtual;
    if (virtual) {
      const start = virtual.skip || 0;
      const end = start + virtual.pageSize;
      // Use length instead of itemsCount because of the grouping.
      virtual.total = this.dataService.data.length;
      return this.dataService.data.slice(start, end);
    }
    return this.dataService.data;
  }
  /**
   * Sets the value of the AutoComplete.
   */
  set value(newValue) {
    this.verifySettings(newValue);
    this._value = newValue || NO_VALUE;
    this.text = this.value;
    this.cdr.markForCheck();
  }
  get value() {
    return this._value || NO_VALUE;
  }
  /**
   * Specifies the `string` property of the data item that represents the item value.
   * If the data contains only primitive values, do not define it.
   *
   * > The `valueField` property can be set to point to a nested property value - e.g. `category.name`.
   */
  valueField;
  /**
   * Sets the placeholder of the AutoComplete.
   *
   * @default ""
   */
  placeholder = "";
  /**
   * Enables or disables the adaptive mode. By default, the adaptive rendering is disabled.
   *
   * @default 'none'
   */
  adaptiveMode = 'none';
  /**
   * Sets the title of the ActionSheet that renders instead of the Popup when using small screen devices.
   * By default, the ActionSheet title uses the text provided for the label of the AutoComplete.
   *
   * @default ''
   */
  adaptiveTitle = '';
  /**
   * Sets the subtitle of the ActionSheet that renders instead of the Popup when using small screen devices.
   * By default, the ActionSheet does not render a subtitle.
   */
  adaptiveSubtitle;
  /**
   * @hidden
   */
  get isAdaptiveModeEnabled() {
    return this.adaptiveMode === 'auto';
  }
  /**
   * Configures the popup of the AutoComplete.
   *
   * The available options are:
   * - `animate: Boolean`&mdash;Controls the popup animation. By default, the open and close animations are enabled.
   * - `width: Number | String`&mdash;Sets the width of the popup container. By default, the width of the host element is used. If set to `auto`, the component automatically adjusts the width of the popup and no item labels are wrapped. The `auto` mode is not supported when virtual scrolling is enabled.
   * - `height: Number`&mdash;Sets the height of the popup container.
   * - `popupClass: String`&mdash;Specifies a list of CSS classes that are used to style the popup.
   * - `appendTo: "root" | "component" | ViewContainerRef`&mdash;Specifies the component to which the popup will be appended.
   */
  set popupSettings(settings) {
    this._popupSettings = Object.assign({
      animate: true
    }, settings);
  }
  get popupSettings() {
    return this._popupSettings;
  }
  /**
  * Sets the height of the options list in the popup. By default, `listHeight` is 200px.
  *
  * > The `listHeight` property affects only the list of options and not the whole popup container.
  * > To set the height of the popup container, use `popupSettings.height`.
  *
  * When using `adaptiveMode` and the screen size is `small` or `medium`, the `listHeight` property is set to null.
  * @default 200
  */
  set listHeight(_listHeight) {
    this._listHeight = _listHeight;
  }
  get listHeight() {
    if (this.isAdaptive) {
      return;
    }
    return this._listHeight;
  }
  _listHeight = 200;
  /**
   * Sets and gets the loading state of the AutoComplete.
   *
   * @default false
   */
  loading;
  /**
   * @hidden
   *
   * If set to `true`, renders a button on hovering over the component.
   * Clicking this button resets the value of the component to `undefined` and triggers the `change` event.
   *
   * @default true
   */
  clearButton = true;
  /**
   * Enables the auto-completion of the text based on the first data item.
   *
   * @default false
   */
  suggest;
  /**
   * Sets the disabled state of the component. To learn how to disable the component in reactive forms, refer to the article on [Forms Support](https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/forms#managing-the-autocomplete-disabled-state-in-reactive-forms).
   *
   * @default false
   */
  disabled = false;
  /**
   * Defines a Boolean function that is executed for each data item in the component
   * ([see examples](https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/disabled-items)).
   * Determines whether the item will be disabled.
   */
  set itemDisabled(fn) {
    if (typeof fn !== 'function') {
      throw new Error(`itemDisabled must be a function, but received ${JSON.stringify(fn)}.`);
    }
    this.disabledItemsService.itemDisabled = fn;
  }
  /**
   * Sets the read-only state of the component.
   *
   * @default false
   */
  readonly = false;
  /**
   * Specifies the [`tabindex`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex) of the component.
   *
   * @default 0
   */
  tabindex = 0;
  /**
   * @hidden
   */
  set tabIndex(tabIndex) {
    this.tabindex = tabIndex;
  }
  get tabIndex() {
    return this.tabindex;
  }
  /**
   * Enables the [filtering](https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/filtering) functionality.
   * If set to `true`, the component emits the `filterChange` event.
   *
   * @default false
   */
  filterable = false;
  /**
   * Enables the [virtualization](https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/virtualization) functionality.
   *
   * @default false
   */
  set virtual(settings) {
    this._virtualSettings = normalizeVirtualizationSettings(settings);
  }
  get virtual() {
    return this._virtualSettings;
  }
  /**
   * Sets the size of the component. The default value is set by the Kendo theme.
   */
  set size(size) {
    this.renderer.removeClass(this.wrapper, getSizeClass('input', this.size));
    if (size) {
      this.renderer.addClass(this.wrapper, getSizeClass('input', size));
    }
    this._size = size;
  }
  get size() {
    return this._size;
  }
  /**
   * Sets the border radius of the component. The default value is set by the Kendo theme.
   */
  set rounded(rounded) {
    this.renderer.removeClass(this.wrapper, getRoundedClass(this.rounded));
    if (rounded) {
      this.renderer.addClass(this.wrapper, getRoundedClass(rounded));
    }
    this._rounded = rounded;
  }
  get rounded() {
    return this._rounded;
  }
  /**
   * Sets the fillMode of the component. The default value is set by the Kendo theme.
   */
  set fillMode(fillMode) {
    this.renderer.removeClass(this.wrapper, getFillModeClass('input', this.fillMode));
    if (fillMode) {
      this.renderer.addClass(this.wrapper, getFillModeClass('input', fillMode));
    }
    this._fillMode = fillMode;
  }
  get fillMode() {
    return this._fillMode;
  }
  /**
   * Sets the HTML attributes of the inner focusable input element. Attributes which are essential for certain component functionalities cannot be changed.
   *
   * @remarks
   * This property is related to accessibility.
   */
  inputAttributes;
  /**
   * Fires each time the value changes&mdash;
   * when the component is blurred or the value is cleared through the **Clear** button
   * ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/events).
   * When the value of the component is programmatically changed to `ngModel` or `formControl`
   * through its API or form binding, the `valueChange` event is not triggered because it
   * might cause a mix-up with the built-in `valueChange` mechanisms of the `ngModel` or `formControl` bindings.
   */
  valueChange = new EventEmitter();
  /**
   * Fires each time the user types in the input field.
   * You can filter the source based on the passed filtration value
   * ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/events)).
   */
  filterChange = new EventEmitter();
  /**
   * Fires each time the popup is about to open.
   * This event is preventable. If you cancel it, the popup remains closed.
   */
  open = new EventEmitter();
  /**
   * Fires after the popup opens.
   */
  opened = new EventEmitter();
  /**
   * Fires each time the popup is about to close.
   * This event is preventable. If you cancel it, the popup remains open.
   */
  close = new EventEmitter();
  /**
   * Fires after the popup closes.
   */
  closed = new EventEmitter();
  /**
   * Fires each time the user focuses the AutoComplete.
   */
  onFocus = new EventEmitter();
  /**
   * Fires each time the AutoComplete gets blurred.
   */
  onBlur = new EventEmitter();
  /**
   * Fires each time the user focuses the `input` element.
   */
  inputFocus = new EventEmitter();
  /**
   * Fires each time the `input` element gets blurred.
   */
  inputBlur = new EventEmitter();
  template;
  headerTemplate;
  footerTemplate;
  noDataTemplate;
  groupTemplate;
  fixedGroupTemplate;
  /**
   * @hidden
   */
  suffixTemplate;
  /**
   * @hidden
   */
  prefixTemplate;
  container;
  popupTemplate;
  searchbar;
  optionsList;
  widgetClasses = true;
  get isFocused() {
    return this._isFocused;
  }
  set isFocused(isFocused) {
    this.renderer[isFocused ? 'addClass' : 'removeClass'](this.wrapper, "k-focus");
    this._isFocused = isFocused;
  }
  get isDisabled() {
    return this.disabled;
  }
  get isLoading() {
    return this.loading;
  }
  get dir() {
    return this.direction;
  }
  text;
  listBoxId = `k-${guid()}`;
  optionPrefix = `k-${guid()}`;
  popupRef;
  /**
   * @hidden
   */
  windowSize = 'large';
  /**
   * @hidden
   */
  get isActionSheetExpanded() {
    return this.actionSheet?.expanded;
  }
  /**
   * @hidden
   */
  get isAdaptive() {
    return this.isAdaptiveModeEnabled && this.windowSize !== 'large';
  }
  /**
   * @hidden
   */
  get formControl() {
    const ngControl = this.injector.get(NgControl, null);
    return ngControl?.control || null;
  }
  onChangeCallback = noop;
  onTouchedCallback = noop;
  constructor(localization, dataService, popupService, selectionService, navigationService, disabledItemsService, _zone, cdr, renderer, hostElement, injector, adaptiveService) {
    this.localization = localization;
    this.dataService = dataService;
    this.popupService = popupService;
    this.selectionService = selectionService;
    this.navigationService = navigationService;
    this.disabledItemsService = disabledItemsService;
    this._zone = _zone;
    this.cdr = cdr;
    this.renderer = renderer;
    this.hostElement = hostElement;
    this.injector = injector;
    this.adaptiveService = adaptiveService;
    validatePackage(packageMetadata);
    this.direction = localization.rtl ? 'rtl' : 'ltr';
    this.wrapper = this.hostElement.nativeElement;
    this.data = [];
    this.subscribeEvents();
    this.subscribeTouchEvents();
    this.selectionService.resetSelection([-1]);
  }
  ngOnInit() {
    this.renderer.removeAttribute(this.wrapper, "tabindex");
    this.subs.add(this.localization.changes.subscribe(({
      rtl
    }) => {
      this.direction = rtl ? 'rtl' : 'ltr';
      this.cdr.detectChanges();
    }));
    this.setComponentClasses();
  }
  ngAfterViewInit() {
    this.windowSize = this.adaptiveService.size;
    this.cdr.detectChanges();
  }
  ngOnDestroy() {
    this.destroyPopup();
    this.subs.unsubscribe();
    if (this.touchstartDisposeHandler) {
      this.touchstartDisposeHandler();
    }
  }
  ngOnChanges(changes) {
    const virtual = this.virtual;
    const requestInitialData = virtual && changes['data'] && changes['data'].isFirstChange();
    if (requestInitialData) {
      this.pageChange({
        skip: 0,
        take: virtual.pageSize
      });
    }
  }
  /**
   * Resets the value of the AutoComplete.
   * If you use the `reset` method to clear the value of the component,
   * the model will not update automatically and the `valueChange` event will not be fired.
   */
  reset() {
    this.value = NO_VALUE;
  }
  /**
   * @hidden
   */
  messageFor(key) {
    return this.localization.get(key);
  }
  /**
   * @hidden
   */
  clearValue(event) {
    event.stopImmediatePropagation();
    this.focus();
    this.change(NO_VALUE);
    if (this.filterable) {
      this.filterChange.emit('');
    }
    this.selectionService.resetSelection([]);
  }
  /**
   * @hidden
   */
  writeValue(value) {
    this.value = value;
  }
  /**
   * @hidden
   */
  registerOnChange(fn) {
    this.onChangeCallback = fn;
  }
  /**
   * @hidden
   */
  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }
  /**
   * @hidden
   */
  setDisabledState(isDisabled) {
    this.cdr.markForCheck();
    this.disabled = isDisabled;
  }
  /**
   * Focuses a specific item of the AutoComplete based on a provided index.
   * If null or invalid index is provided the focus will be removed.
   */
  focusItemAt(index) {
    const isInRange = index >= 0 && index < this.data.length;
    if (isPresent(index) && isInRange && !this.disabledItemsService.isIndexDisabled(index)) {
      this.selectionService.focus(index);
    } else {
      this.selectionService.focus(-1);
    }
  }
  /**
   * Focuses the AutoComplete.
   */
  focus() {
    if (!this.disabled) {
      this.searchbar.focus();
    }
  }
  /**
   * Blurs the AutoComplete.
   */
  blur() {
    if (!this.disabled) {
      this.searchbar.blur();
    }
  }
  /**
   * @hidden
   */
  onResize() {
    const currentWindowSize = this.adaptiveService.size;
    if (this.isAdaptiveModeEnabled && this.windowSize !== currentWindowSize) {
      if (this.isOpen) {
        this.togglePopup(false);
      }
      this.windowSize = currentWindowSize;
      this.cdr.detectChanges();
    }
    if (this._open && !this.isActionSheetExpanded) {
      const popupWrapper = this.popupRef.popupElement;
      const {
        min,
        max
      } = this.width;
      popupWrapper.style.minWidth = min;
      popupWrapper.style.width = max;
    }
  }
  emitChange(value) {
    this.onChangeCallback(value);
    this.valueChange.emit(value);
  }
  verifySettings(newValue) {
    if (!isDevMode()) {
      return;
    }
    if (isPresent(newValue) && typeof newValue !== "string") {
      throw new Error("Expected value of type string. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/value-binding/");
    }
  }
  search(text, startFrom = 0) {
    const index = this.findIndex(text, startFrom);
    if (this.disabledItemsService.isIndexDisabled(index)) {
      if (index + 1 < this.dataService.itemsCount) {
        this.search(text, index + 1);
      } else {
        this.selectionService.focus(-1);
      }
    } else {
      this.selectionService.focus(index);
      if (this.suggest) {
        this.suggestedText = getter(this.dataService.itemAt(index), this.valueField);
      }
    }
  }
  navigate(index) {
    if (!this.isOpen) {
      return;
    }
    this.selectionService.focus(index);
  }
  /**
   * @hidden
   */
  handleNavigate(event) {
    const focused = isNaN(this.selectionService.focused) ? this.firstFocusableIndex(0) : this.selectionService.focused;
    if (this.disabled || this.readonly || isNaN(focused)) {
      return;
    }
    const action = this.navigationService.process({
      current: focused,
      max: this.dataService.itemsCount - 1,
      min: 0,
      originalEvent: event
    });
    if (action !== NavigationAction.Undefined && action !== NavigationAction.Backspace && action !== NavigationAction.Delete && action !== NavigationAction.Home && action !== NavigationAction.End && action !== NavigationAction.Left && action !== NavigationAction.Right && action !== NavigationAction.PageDown && action !== NavigationAction.PageUp && (action === NavigationAction.Enter && this.isOpen || action !== NavigationAction.Enter)) {
      event.preventDefault();
    }
    if (action === NavigationAction.Tab && this.isActionSheetExpanded) {
      event.stopImmediatePropagation();
      this.togglePopup(false);
    }
  }
  handleEnter(event) {
    const focused = this.selectionService.focused;
    let value;
    if (this.isOpen) {
      event.originalEvent.preventDefault();
    }
    if (focused >= 0) {
      value = getter(this.dataService.itemAt(focused), this.valueField);
    } else {
      const match = this.suggest && this.suggestedText && this.data.length && getter(this.dataService.itemAt(0), this.valueField).toLowerCase() === this.searchbar.value.toLowerCase();
      if (this.isOpen && match) {
        value = this.suggestedText;
      } else {
        value = this.searchbar.value;
      }
    }
    if (this.isActionSheetExpanded && focused >= 0) {
      this.togglePopup(false);
    }
    this.change(value);
  }
  handleEscape() {
    if (this.isOpen) {
      this.togglePopup(false);
    } else {
      this.value = '';
    }
    this.selectionService.focused = -1;
    this.suggestedText = null;
  }
  /**
   * @hidden
   */
  searchBarChange(text) {
    const currentTextLength = isPresent(this.text) ? this.text.length : 0;
    this.backspacePressed = Boolean(text.length < currentTextLength);
    this.text = text;
    this.togglePopup(text.length > 0);
    if (!this.highlightFirst) {
      this.selectionService.focused = -1;
    }
    if (this.filterable) {
      this.filterChange.emit(text);
    } else if (this.highlightFirst) {
      this.search(text);
    }
  }
  /**
   * @hidden
   */
  handleInputFocus() {
    this.handleFocus();
    if (hasObservers(this.inputFocus)) {
      this._zone.run(() => {
        this.inputFocus.emit();
      });
    }
  }
  /**
   * @hidden
   */
  handleFocus() {
    this._zone.run(() => {
      if (!this.isFocused && hasObservers(this.onFocus)) {
        this.onFocus.emit();
      }
      this.isFocused = true;
    });
  }
  /**
   * @hidden
   */
  handleBlur() {
    if (!this.isActionSheetExpanded) {
      this.blurComponent();
    }
  }
  /**
   * @hidden
   */
  handleInputBlur() {
    if (!this.isActionSheetExpanded) {
      const focused = this.filterable ? this.selectionService.focused : -1;
      this.searchbar.input.nativeElement.scrollLeft = 0; // Firefox doesn't auto-scroll to the left on blur like other browsers
      let dataItem;
      let text;
      if (focused !== -1) {
        dataItem = this.dataService.itemAt(focused);
        text = getter(dataItem, this.valueField) || "";
      } else {
        text = this.searchbar.value;
      }
      const exactMatch = text === this.searchbar.value;
      const insensitiveMatch = text.toLowerCase() === this.searchbar.value.toLowerCase();
      if (!exactMatch && insensitiveMatch) {
        this.selectionService.resetSelection([]);
      }
      const valueHasChanged = this.value !== this.text;
      const runInZone = hasObservers(this.inputBlur) || hasObservers(this.close) || isUntouched(this.wrapper) || valueHasChanged || this.formControl?.updateOn === 'blur';
      if (runInZone) {
        this._zone.run(() => {
          if (valueHasChanged) {
            this.change(this.searchbar.value);
          }
          this.inputBlur.emit();
          this.onTouchedCallback();
          this.togglePopup(false);
        });
      } else {
        this.togglePopup(false);
      }
    }
  }
  /**
   * @hidden
   */
  pageChange(event) {
    const virtual = this.virtual;
    virtual.skip = event.skip;
  }
  /**
   * @hidden
   */
  closeActionSheet() {
    this.blurComponent();
    this.closed.emit();
  }
  change(value) {
    this.togglePopup(false);
    this.valueChangeSubject.next(value);
  }
  popupMouseDownHandler = event => event.preventDefault();
  _popupSettings = {
    animate: true
  };
  _virtualSettings;
  _open = false;
  _value = "";
  suggestedText;
  backspacePressed;
  subs = new Subscription();
  valueChangeSubject = new Subject();
  touchstartDisposeHandler;
  wrapper;
  _isFocused = false;
  direction;
  _size = undefined;
  _rounded = undefined;
  _fillMode = undefined;
  subscribeEvents() {
    if (!isDocumentAvailable()) {
      return;
    }
    this.subs.add(this.valueChangeSubject.subscribe(value => {
      const hasChange = this.value !== value;
      if (this.isOpen) {
        const index = this.findIndex(value);
        this.selectionService.focused = index;
      }
      this.value = value;
      this.text = value;
      // emit change after assigning `this.value` => allows the user to modify the component value on `valueChange`
      if (hasChange) {
        this.emitChange(value);
      }
    }));
    this.subs.add(this.selectionService.onChange.subscribe(this.handleItemChange.bind(this)));
    this.subs.add(this.selectionService.onFocus.subscribe(this.handleItemFocus.bind(this)));
    this.subs.add(merge(this.navigationService.up, this.navigationService.down).subscribe(event => this.navigate(event.index)));
    this.subs.add(this.navigationService.close.subscribe(() => this.togglePopup(false)));
    this.subs.add(this.navigationService.open.subscribe(() => this.togglePopup(true)));
    this.subs.add(this.navigationService.enter.subscribe(this.handleEnter.bind(this)));
    this.subs.add(this.navigationService.esc.subscribe(this.handleEscape.bind(this)));
    this.subs.add(merge(this.navigationService.pagedown, this.navigationService.pageup).subscribe(event => {
      if (this.isOpen) {
        event.originalEvent.preventDefault();
        const code = normalizeKeys(event.originalEvent);
        this.optionsList.scrollWithOnePage(NavigationAction[code]);
      }
    }));
  }
  findIndex(value, startFrom = 0) {
    let index;
    if (value && value.length && this.dataService.itemsCount) {
      index = this.dataService.findIndex(this.findIndexPredicate(value), startFrom);
    } else {
      index = -1;
    }
    return index;
  }
  subscribeTouchEvents() {
    if (!isDocumentAvailable() || !touchEnabled) {
      return;
    }
    this._zone.runOutsideAngular(() =>
    // Roll up AutoComplete on iOS when tapped outside
    this.touchstartDisposeHandler = this.renderer.listen(document, 'touchstart', e => {
      const target = e.target;
      if (this.isFocused && !inDropDown(this.hostElement, target, this.popupRef)) {
        this._zone.run(() => this.blur());
      }
    }));
  }
  handleItemChange(event) {
    const index = event.indices.length ? event.indices[0] : undefined;
    this.selectionService.resetSelection([-1]);
    if (!isPresent(index)) {
      return;
    }
    const text = getter(this.dataService.itemAt(index), this.valueField);
    this.change(text);
  }
  handleItemFocus(_event) {
    const focused = this.selectionService.focused;
    const shouldSuggest = Boolean(this.suggest && this.data && this.data.length && focused >= 0);
    if (shouldSuggest) {
      this.suggestedText = getter(this.dataService.itemAt(focused), this.valueField);
    }
  }
  createPopup() {
    if (this.virtual) {
      this.virtual.skip = 0;
    }
    this.windowSize = this.adaptiveService.size;
    if (this.isAdaptive) {
      this.openActionSheet();
      return;
    }
    const horizontalAlign = this.direction === "rtl" ? "right" : "left";
    const anchorPosition = {
      horizontal: horizontalAlign,
      vertical: "bottom"
    };
    const popupPosition = {
      horizontal: horizontalAlign,
      vertical: "top"
    };
    const appendToComponent = typeof this.popupSettings.appendTo === 'string' && this.popupSettings.appendTo === 'component';
    this.popupRef = this.popupService.open({
      anchor: this.wrapper,
      animate: this.popupSettings.animate,
      appendTo: this.appendTo,
      content: this.popupTemplate,
      popupClass: this.listContainerClasses,
      positionMode: appendToComponent ? 'fixed' : 'absolute',
      popupAlign: popupPosition,
      anchorAlign: anchorPosition
    });
    const popupWrapper = this.popupRef.popupElement;
    const {
      min,
      max
    } = this.width;
    popupWrapper.addEventListener('mousedown', this.popupMouseDownHandler);
    popupWrapper.style.minWidth = min;
    popupWrapper.style.width = max;
    popupWrapper.style.height = this.height;
    popupWrapper.setAttribute('dir', this.direction);
    if (!this.appendTo) {
      this.renderer.setAttribute(popupWrapper, 'role', 'region');
      this.renderer.setAttribute(popupWrapper, 'aria-label', this.messageFor('popupLabel'));
    }
    this.subs.add(this.popupRef.popupOpen.subscribe(() => {
      this.cdr.detectChanges();
      if (!this.dataService.grouped) {
        setListBoxAriaLabelledBy(this.optionsList, this.searchbar.input, this.renderer);
      }
      this.optionsList.scrollToItem(this.selectionService.focused);
      this.selectionService.focus(this.selectionService.focused);
      this.opened.emit();
    }));
    this.subs.add(this.popupRef.popupClose.subscribe(() => {
      this.closed.emit();
    }));
    this.subs.add(this.popupRef.popupAnchorViewportLeave.subscribe(() => this.togglePopup(false)));
  }
  destroyPopup() {
    if (this.popupRef) {
      this.popupRef.popupElement.removeEventListener('mousedown', this.popupMouseDownHandler);
      this.popupRef.close();
      this.popupRef = null;
    }
  }
  _toggle(open) {
    this._open = open;
    this.destroyPopup();
    if (this.isActionSheetExpanded) {
      this.actionSheet.toggle(false);
      this.focus();
    }
    if (this._open) {
      this.createPopup();
    }
  }
  triggerPopupEvents(open) {
    const eventArgs = new PreventableEvent();
    if (open) {
      this.open.emit(eventArgs);
    } else {
      this.close.emit(eventArgs);
    }
    return eventArgs.isDefaultPrevented();
  }
  firstFocusableIndex(index) {
    const maxIndex = this.data.length - 1;
    if (this.disabledItemsService.isIndexDisabled(index)) {
      return index < maxIndex ? this.firstFocusableIndex(index + 1) : undefined;
    } else {
      return index;
    }
  }
  findIndexPredicate(text) {
    if (this.dataService.grouped) {
      return item => {
        let itemText = getter(item.value, this.valueField);
        itemText = !isPresent(itemText) ? "" : itemText.toString().toLowerCase();
        return itemText.startsWith(text.toLowerCase());
      };
    } else {
      return item => {
        let itemText = getter(item, this.valueField);
        itemText = !isPresent(itemText) ? "" : itemText.toString().toLowerCase();
        return itemText.startsWith(text.toLowerCase());
      };
    }
  }
  setComponentClasses() {
    if (this.size) {
      this.renderer.addClass(this.wrapper, getSizeClass('input', this.size));
    }
    if (this.rounded) {
      this.renderer.addClass(this.wrapper, getRoundedClass(this.rounded));
    }
    if (this.fillMode) {
      this.renderer.addClass(this.wrapper, getFillModeClass('input', this.fillMode));
    }
  }
  openActionSheet() {
    this.actionSheet.toggle(true);
    this.cdr.detectChanges();
    if (!this.dataService.grouped) {
      setListBoxAriaLabelledBy(this.optionsList, this.searchbar.input, this.renderer);
    }
    this.adaptiveTitle = setActionSheetTitle(this.searchbar.input, this.adaptiveTitle);
    this.cdr.detectChanges();
    this.opened.emit();
    // wait for the ActionSheet animation to complete to ensure the scroll calculation is accurate
    this.actionSheet.expand.pipe(take(1)).subscribe(() => {
      this.optionsList.scrollToItem(this.selectionService.focused);
    });
    this.selectionService.focus(this.selectionService.focused);
    this.actionSheetSearchBar.focus();
  }
  blurComponent() {
    this.isFocused = false;
    const valueHasChanged = this.value !== this.text;
    const runInZone = hasObservers(this.onBlur) || hasObservers(this.close) || isUntouched(this.wrapper) || valueHasChanged;
    if (runInZone) {
      this._zone.run(() => {
        if (valueHasChanged) {
          this.change(this.searchbar.value);
        }
        this.onBlur.emit();
        this.onTouchedCallback();
        this.togglePopup(false);
      });
    } else {
      this.togglePopup(false);
    }
  }
  static ɵfac = function AutoCompleteComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AutoCompleteComponent)(i0.ɵɵdirectiveInject(i1.LocalizationService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i2.PopupService), i0.ɵɵdirectiveInject(SelectionService), i0.ɵɵdirectiveInject(NavigationService), i0.ɵɵdirectiveInject(DisabledItemsService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i7.AdaptiveService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: AutoCompleteComponent,
    selectors: [["kendo-autocomplete"]],
    contentQueries: function AutoCompleteComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, ItemTemplateDirective, 5)(dirIndex, HeaderTemplateDirective, 5)(dirIndex, FooterTemplateDirective, 5)(dirIndex, NoDataTemplateDirective, 5)(dirIndex, GroupTemplateDirective, 5)(dirIndex, FixedGroupTemplateDirective, 5)(dirIndex, SuffixTemplateDirective, 5)(dirIndex, PrefixTemplateDirective, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.noDataTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.groupTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fixedGroupTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.suffixTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.prefixTemplate = _t.first);
      }
    },
    viewQuery: function AutoCompleteComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(AdaptiveRendererComponent, 5)(_c12, 7, ViewContainerRef)(_c13, 7)(SearchBarComponent, 7)(_c14, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.adaptiveRendererComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popupTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchbar = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.optionsList = _t.first);
      }
    },
    hostVars: 11,
    hostBindings: function AutoCompleteComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("dir", ctx.dir);
        i0.ɵɵclassProp("k-readonly", ctx.readonly)("k-autocomplete", ctx.widgetClasses)("k-input", ctx.widgetClasses)("k-disabled", ctx.isDisabled)("k-loading", ctx.isLoading);
      }
    },
    inputs: {
      highlightFirst: "highlightFirst",
      showStickyHeader: "showStickyHeader",
      focusableId: "focusableId",
      data: "data",
      value: "value",
      valueField: "valueField",
      placeholder: "placeholder",
      adaptiveMode: "adaptiveMode",
      adaptiveTitle: "adaptiveTitle",
      adaptiveSubtitle: "adaptiveSubtitle",
      popupSettings: "popupSettings",
      listHeight: "listHeight",
      loading: "loading",
      clearButton: "clearButton",
      suggest: "suggest",
      disabled: "disabled",
      itemDisabled: "itemDisabled",
      readonly: "readonly",
      tabindex: "tabindex",
      tabIndex: "tabIndex",
      filterable: "filterable",
      virtual: "virtual",
      size: "size",
      rounded: "rounded",
      fillMode: "fillMode",
      inputAttributes: "inputAttributes"
    },
    outputs: {
      valueChange: "valueChange",
      filterChange: "filterChange",
      open: "open",
      opened: "opened",
      close: "close",
      closed: "closed",
      onFocus: "focus",
      onBlur: "blur",
      inputFocus: "inputFocus",
      inputBlur: "inputBlur"
    },
    exportAs: ["kendoAutoComplete"],
    features: [i0.ɵɵProvidersFeature([AUTOCOMPLETE_VALUE_ACCESSOR, DataService, SelectionService, NavigationService, DisabledItemsService, LocalizationService, {
      provide: L10N_PREFIX,
      useValue: 'kendo.autocomplete'
    }, {
      provide: FilterableComponent,
      useExisting: forwardRef(() => AutoCompleteComponent)
    }, {
      provide: KendoInput,
      useExisting: forwardRef(() => AutoCompleteComponent)
    }, {
      provide: KENDO_WEBMCP_HOST,
      useExisting: forwardRef(() => AutoCompleteComponent)
    }]), i0.ɵɵNgOnChangesFeature],
    decls: 17,
    vars: 30,
    consts: () => {
      let i18n_0;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text displayed in the popup when there are no items
         * @meaning kendo.autocomplete.noDataText
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_0 = goog.getMsg("NO DATA FOUND");
        i18n_0 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_0;
      } else {
        i18n_0 = $localize`:kendo.autocomplete.noDataText|The text displayed in the popup when there are no items:NO DATA FOUND`;
      }
      let i18n_1;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the clear button
         * @meaning kendo.autocomplete.clearTitle
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_1 = goog.getMsg("clear");
        i18n_1 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_1;
      } else {
        i18n_1 = $localize`:kendo.autocomplete.clearTitle|The title of the clear button:clear`;
      }
      let i18n_2;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The label of the popup element that contains the list of options when its role is 'region'
         * @meaning kendo.autocomplete.popupLabel
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_2 = goog.getMsg("Options list");
        i18n_2 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_2;
      } else {
        i18n_2 = $localize`:kendo.autocomplete.popupLabel|The label of the popup element that contains the list of options when its role is 'region':Options list`;
      }
      let i18n_3;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode
         * @meaning kendo.autocomplete.adaptiveCloseButtonTitle
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_3 = goog.getMsg("Close");
        i18n_3 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_3;
      } else {
        i18n_3 = $localize`:kendo.autocomplete.adaptiveCloseButtonTitle|The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode:Close`;
      }
      return [["popupTemplate", ""], ["container", ""], ["sharedPopupActionSheetTemplate", ""], ["optionsList", ""], ["kendoAutoCompleteLocalizedMessages", "", "noDataText", i18n_0, "clearTitle", i18n_1, "popupLabel", i18n_2, "adaptiveCloseButtonTitle", i18n_3], ["kendoDropDownSharedEvents", "", 3, "isFocusedChange", "handleBlur", "onFocus", "hostElement", "isFocused"], [1, "k-input-prefix", "k-input-prefix-horizontal"], ["kendoSearchbar", "", 3, "onNavigate", "valueChange", "onBlur", "onFocus", "click", "ariaExpanded", "isSuggestable", "isFilterable", "isLoading", "ariaControls", "id", "activeDescendant", "userInput", "suggestedText", "disabled", "readonly", "tabIndex", "isRequired", "placeholder", "inputAttributes"], ["role", "button", "tabindex", "-1", 1, "k-clear-value", 3, "visibility"], [1, "k-icon", "k-i-loading", "k-input-loading-icon"], [1, "k-input-suffix", "k-input-suffix-horizontal"], [3, "closePopup", "textInputChange", "navigate", "sharedPopupActionSheetTemplate", "title", "showTextInput", "subtitle", "placeholder", "searchBarValue"], [3, "ngTemplateOutlet"], ["role", "button", "tabindex", "-1", 1, "k-clear-value", 3, "click", "mousedown"], ["name", "x", 3, "svgIcon"], [4, "ngTemplateOutlet"], [3, "resize"], [3, "templateContext"], [3, "pageChange", "size", "rounded", "id", "optionPrefix", "data", "textField", "valueField", "template", "groupTemplate", "fixedGroupTemplate", "height", "show", "virtual", "showStickyHeader"], [1, "k-no-data"]];
    },
    template: function AutoCompleteComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementContainer(0, 4);
        i0.ɵɵelementContainerStart(1, 5);
        i0.ɵɵtwoWayListener("isFocusedChange", function AutoCompleteComponent_Template_ng_container_isFocusedChange_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          i0.ɵɵtwoWayBindingSet(ctx.isFocused, $event) || (ctx.isFocused = $event);
          return i0.ɵɵresetView($event);
        });
        i0.ɵɵlistener("handleBlur", function AutoCompleteComponent_Template_ng_container_handleBlur_1_listener() {
          return ctx.handleBlur();
        })("onFocus", function AutoCompleteComponent_Template_ng_container_onFocus_1_listener() {
          return ctx.handleFocus();
        });
        i0.ɵɵconditionalCreate(2, AutoCompleteComponent_Conditional_2_Template, 2, 1, "span", 6);
        i0.ɵɵconditionalCreate(3, AutoCompleteComponent_Conditional_3_Template, 1, 0, "kendo-separator");
        i0.ɵɵelementStart(4, "input", 7);
        i0.ɵɵlistener("onNavigate", function AutoCompleteComponent_Template_input_onNavigate_4_listener($event) {
          return ctx.handleNavigate($event);
        })("valueChange", function AutoCompleteComponent_Template_input_valueChange_4_listener($event) {
          return ctx.searchBarChange($event);
        })("onBlur", function AutoCompleteComponent_Template_input_onBlur_4_listener() {
          return ctx.handleInputBlur();
        })("onFocus", function AutoCompleteComponent_Template_input_onFocus_4_listener() {
          return ctx.handleInputFocus();
        })("click", function AutoCompleteComponent_Template_input_click_4_listener() {
          return ctx.handleClick();
        });
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(5, AutoCompleteComponent_Conditional_5_Template, 2, 4, "span", 8);
        i0.ɵɵconditionalCreate(6, AutoCompleteComponent_Conditional_6_Template, 1, 0, "span", 9);
        i0.ɵɵconditionalCreate(7, AutoCompleteComponent_Conditional_7_Template, 1, 0, "kendo-separator");
        i0.ɵɵconditionalCreate(8, AutoCompleteComponent_Conditional_8_Template, 2, 1, "span", 10);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵtemplate(9, AutoCompleteComponent_ng_template_9_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementContainer(11, null, 1);
        i0.ɵɵconditionalCreate(13, AutoCompleteComponent_Conditional_13_Template, 1, 0, "kendo-resize-sensor");
        i0.ɵɵelementStart(14, "kendo-adaptive-renderer", 11);
        i0.ɵɵlistener("closePopup", function AutoCompleteComponent_Template_kendo_adaptive_renderer_closePopup_14_listener() {
          return ctx.closeActionSheet();
        })("textInputChange", function AutoCompleteComponent_Template_kendo_adaptive_renderer_textInputChange_14_listener($event) {
          return ctx.searchBarChange($event);
        })("navigate", function AutoCompleteComponent_Template_kendo_adaptive_renderer_navigate_14_listener($event) {
          return ctx.handleNavigate($event);
        });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(15, AutoCompleteComponent_ng_template_15_Template, 5, 17, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const sharedPopupActionSheetTemplate_r4 = i0.ɵɵreference(16);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hostElement", ctx.hostElement);
        i0.ɵɵtwoWayProperty("isFocused", ctx.isFocused);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.prefixTemplate ? 2 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.prefixTemplate && ctx.prefixTemplate.showSeparator ? 3 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ariaExpanded", ctx.isOpen)("isSuggestable", ctx.suggest)("isFilterable", ctx.filterable)("isLoading", ctx.isLoading)("ariaControls", ctx.ariaControls)("id", ctx.focusableId)("activeDescendant", ctx.activeDescendant)("userInput", ctx.text)("suggestedText", ctx.suggestion)("disabled", ctx.disabled)("readonly", ctx.readonly || ctx.isAdaptive)("tabIndex", ctx.tabIndex)("isRequired", ctx.isControlRequired)("placeholder", ctx.placeholder)("inputAttributes", ctx.inputAttributes);
        i0.ɵɵadvance();
        i0.ɵɵconditional(!ctx.loading && !ctx.readonly && ctx.clearButton && (ctx.text == null ? null : ctx.text.length) ? 5 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.loading ? 6 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.suffixTemplate && ctx.suffixTemplate.showSeparator ? 7 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.suffixTemplate ? 8 : -1);
        i0.ɵɵadvance(5);
        i0.ɵɵconditional(ctx.isOpen || ctx.isAdaptiveModeEnabled ? 13 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("sharedPopupActionSheetTemplate", sharedPopupActionSheetTemplate_r4)("title", ctx.adaptiveTitle)("showTextInput", true)("subtitle", ctx.adaptiveSubtitle)("placeholder", ctx.placeholder)("searchBarValue", ctx.text);
      }
    },
    dependencies: [LocalizedMessagesDirective, SharedDropDownEventsDirective, NgTemplateOutlet, SeparatorComponent, SearchBarComponent, IconWrapperComponent, ResizeSensorComponent, AdaptiveRendererComponent, TemplateContextDirective, ListComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AutoCompleteComponent, [{
    type: Component,
    args: [{
      exportAs: 'kendoAutoComplete',
      providers: [AUTOCOMPLETE_VALUE_ACCESSOR, DataService, SelectionService, NavigationService, DisabledItemsService, LocalizationService, {
        provide: L10N_PREFIX,
        useValue: 'kendo.autocomplete'
      }, {
        provide: FilterableComponent,
        useExisting: forwardRef(() => AutoCompleteComponent)
      }, {
        provide: KendoInput,
        useExisting: forwardRef(() => AutoCompleteComponent)
      }, {
        provide: KENDO_WEBMCP_HOST,
        useExisting: forwardRef(() => AutoCompleteComponent)
      }],
      selector: 'kendo-autocomplete',
      template: `
        <ng-container kendoAutoCompleteLocalizedMessages
          i18n-noDataText="kendo.autocomplete.noDataText|The text displayed in the popup when there are no items"
          noDataText="NO DATA FOUND"

          i18n-clearTitle="kendo.autocomplete.clearTitle|The title of the clear button"
          clearTitle="clear"

          i18n-popupLabel="kendo.autocomplete.popupLabel|The label of the popup element that contains the list of options when its role is 'region'"
          popupLabel="Options list"

          i18n-adaptiveCloseButtonTitle="kendo.autocomplete.adaptiveCloseButtonTitle|The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode"
          adaptiveCloseButtonTitle="Close"
          >
        </ng-container>

        <ng-container
          kendoDropDownSharedEvents
          [hostElement]="hostElement"
          [(isFocused)]="isFocused"
          (handleBlur)="handleBlur()"
          (onFocus)="handleFocus()"
          >
          @if (prefixTemplate) {
            <span class="k-input-prefix k-input-prefix-horizontal">
              <ng-template [ngTemplateOutlet]="prefixTemplate?.templateRef">
              </ng-template>
            </span>
          }
          @if (prefixTemplate && prefixTemplate.showSeparator) {
            <kendo-separator></kendo-separator>
          }
          <input
            kendoSearchbar
            [ariaExpanded]="isOpen"
            [isSuggestable]="suggest"
            [isFilterable]="filterable"
            [isLoading]="isLoading"
            [ariaControls]="ariaControls"
            [id]="focusableId"
            [activeDescendant]="activeDescendant"
            [userInput]="text"
            [suggestedText]="suggestion"
            [disabled]="disabled"
            [readonly]="readonly || this.isAdaptive"
            [tabIndex]="tabIndex"
            [isRequired]="isControlRequired"
            [placeholder]="placeholder"
            [inputAttributes]="inputAttributes"
            (onNavigate)="handleNavigate($event)"
            (valueChange)="searchBarChange($event)"
            (onBlur)="handleInputBlur()"
            (onFocus)="handleInputFocus()"
            (click)="handleClick()"
            />
          @if (!loading && !readonly && (clearButton && text?.length)) {
            <span
              class="k-clear-value"
              [style.visibility]="clearButtonVisibility"
              [attr.title]="messageFor('clearTitle')"
              role="button"
              tabindex="-1"
              (click)="clearValue($event)"
              (mousedown)="$event.preventDefault()"
              >
              <kendo-icon-wrapper
                name="x"
                [svgIcon]="xIcon"
                >
              </kendo-icon-wrapper>
            </span>
          }
          @if (loading) {
            <span class="k-icon k-i-loading k-input-loading-icon"></span>
          }
          @if (suffixTemplate && suffixTemplate.showSeparator) {
            <kendo-separator></kendo-separator>
          }
          @if (suffixTemplate) {
            <span class="k-input-suffix k-input-suffix-horizontal">
              <ng-template [ngTemplateOutlet]="suffixTemplate?.templateRef">
              </ng-template>
            </span>
          }
        </ng-container>

        <ng-template #popupTemplate>
          <ng-container *ngTemplateOutlet="sharedPopupActionSheetTemplate"></ng-container>
        </ng-template>
        <ng-container #container></ng-container>
        @if (isOpen || isAdaptiveModeEnabled) {
          <kendo-resize-sensor (resize)="onResize()"></kendo-resize-sensor>
        }

        <kendo-adaptive-renderer
          [sharedPopupActionSheetTemplate]="sharedPopupActionSheetTemplate"
          [title]="adaptiveTitle"
          [showTextInput]="true"
          [subtitle]="adaptiveSubtitle"
          (closePopup)="closeActionSheet()"
          (textInputChange)="searchBarChange($event)"
          (navigate)="handleNavigate($event)"
          [placeholder]="placeholder"
          [searchBarValue]="text">
        </kendo-adaptive-renderer>

        <ng-template #sharedPopupActionSheetTemplate>
          <!--header template-->
          @if (headerTemplate) {
            <ng-template
                [templateContext]="{
                    templateRef: headerTemplate.templateRef
                }">
            </ng-template>
          }
          <!--list-->
          <kendo-list
            #optionsList
            [size]="isAdaptive ? 'large' : size"
            [rounded]="rounded"
            [id]="listBoxId"
            [optionPrefix]="optionPrefix"
            [data]="data"
            [textField]="valueField"
            [valueField]="valueField"
            [template]="template"
            [groupTemplate]="groupTemplate"
            [fixedGroupTemplate]="fixedGroupTemplate"
            [height]="listHeight"
            [show]="isOpen"
            [virtual]="virtual"
            [showStickyHeader]="showStickyHeader"
            (pageChange)="pageChange($event)"
            >
          </kendo-list>
          <!--no-data template-->
          @if (data.length === 0) {
            <div class="k-no-data" [attr.aria-live]="'polite'">
              @if (noDataTemplate) {
                <ng-template
                    [templateContext]="{
                        templateRef: noDataTemplate?.templateRef
                    }">
                </ng-template>
              }
              @if (!noDataTemplate) {
                <div>{{ messageFor('noDataText') }}</div>
              }
            </div>
          }
          <!--footer template-->
          @if (footerTemplate) {
            <ng-template
                [templateContext]="{
                    templateRef: footerTemplate.templateRef
                }">
            </ng-template>
          }
        </ng-template>
        `,
      standalone: true,
      imports: [LocalizedMessagesDirective, SharedDropDownEventsDirective, NgTemplateOutlet, SeparatorComponent, SearchBarComponent, IconWrapperComponent, ResizeSensorComponent, AdaptiveRendererComponent, TemplateContextDirective, ListComponent]
    }]
  }], () => [{
    type: i1.LocalizationService
  }, {
    type: DataService
  }, {
    type: i2.PopupService
  }, {
    type: SelectionService
  }, {
    type: NavigationService
  }, {
    type: DisabledItemsService
  }, {
    type: i0.NgZone
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i0.Renderer2
  }, {
    type: i0.ElementRef
  }, {
    type: i0.Injector
  }, {
    type: i7.AdaptiveService
  }], {
    adaptiveRendererComponent: [{
      type: ViewChild,
      args: [AdaptiveRendererComponent]
    }],
    highlightFirst: [{
      type: Input
    }],
    showStickyHeader: [{
      type: Input
    }],
    focusableId: [{
      type: Input
    }],
    data: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    valueField: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    adaptiveMode: [{
      type: Input
    }],
    adaptiveTitle: [{
      type: Input
    }],
    adaptiveSubtitle: [{
      type: Input
    }],
    popupSettings: [{
      type: Input
    }],
    listHeight: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    clearButton: [{
      type: Input
    }],
    suggest: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    itemDisabled: [{
      type: Input
    }],
    readonly: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['class.k-readonly']
    }],
    tabindex: [{
      type: Input
    }],
    tabIndex: [{
      type: Input,
      args: ["tabIndex"]
    }],
    filterable: [{
      type: Input
    }],
    virtual: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    rounded: [{
      type: Input
    }],
    fillMode: [{
      type: Input
    }],
    inputAttributes: [{
      type: Input
    }],
    valueChange: [{
      type: Output
    }],
    filterChange: [{
      type: Output
    }],
    open: [{
      type: Output
    }],
    opened: [{
      type: Output
    }],
    close: [{
      type: Output
    }],
    closed: [{
      type: Output
    }],
    onFocus: [{
      type: Output,
      args: ['focus']
    }],
    onBlur: [{
      type: Output,
      args: ['blur']
    }],
    inputFocus: [{
      type: Output
    }],
    inputBlur: [{
      type: Output
    }],
    template: [{
      type: ContentChild,
      args: [ItemTemplateDirective, {
        static: false
      }]
    }],
    headerTemplate: [{
      type: ContentChild,
      args: [HeaderTemplateDirective, {
        static: false
      }]
    }],
    footerTemplate: [{
      type: ContentChild,
      args: [FooterTemplateDirective, {
        static: false
      }]
    }],
    noDataTemplate: [{
      type: ContentChild,
      args: [NoDataTemplateDirective, {
        static: false
      }]
    }],
    groupTemplate: [{
      type: ContentChild,
      args: [GroupTemplateDirective, {
        static: false
      }]
    }],
    fixedGroupTemplate: [{
      type: ContentChild,
      args: [FixedGroupTemplateDirective, {
        static: false
      }]
    }],
    suffixTemplate: [{
      type: ContentChild,
      args: [SuffixTemplateDirective]
    }],
    prefixTemplate: [{
      type: ContentChild,
      args: [PrefixTemplateDirective]
    }],
    container: [{
      type: ViewChild,
      args: ['container', {
        read: ViewContainerRef,
        static: true
      }]
    }],
    popupTemplate: [{
      type: ViewChild,
      args: ['popupTemplate', {
        static: true
      }]
    }],
    searchbar: [{
      type: ViewChild,
      args: [SearchBarComponent, {
        static: true
      }]
    }],
    optionsList: [{
      type: ViewChild,
      args: ['optionsList', {
        static: false
      }]
    }],
    widgetClasses: [{
      type: HostBinding,
      args: ['class.k-autocomplete']
    }, {
      type: HostBinding,
      args: ['class.k-input']
    }],
    isDisabled: [{
      type: HostBinding,
      args: ['class.k-disabled']
    }],
    isLoading: [{
      type: HostBinding,
      args: ['class.k-loading']
    }],
    dir: [{
      type: HostBinding,
      args: ['attr.dir']
    }]
  });
})();

/**
 * @hidden
 */
const MultiselectMessages = {
  'array': 'Expected values of array type. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/value-binding',
  'object': 'Expected values of Object type. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/value-binding/#object-values',
  'primitive': 'Expected values of primitive type. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/value-binding/#primitive-values',
  'textAndValue': 'Expected textField and valueField options to be set. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/data-binding/#arrays-of-complex-data'
};
/**
 * @hidden
 */
const MultiSelectTreeMessages = {
  'array': 'Expected values of array type. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselecttree/value-binding',
  'primitive': 'Expected values of primitive type. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselecttree/value-binding/#primitive-values',
  'object': 'Expected values of type Object. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselecttree/value-binding/#object-values',
  'dataItems': 'Expected dataItems of type Object[] to be set. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/api/MultiSelectTreeComponent/#dataitems',
  'dataItemsLength': 'Expected dataItems length to match the number of provided values. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/api/MultiSelectTreeComponent/#dataitems',
  'textAndValue': 'Expected textField and valueField options to be set. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselecttree/value-binding',
  'valueDepth': 'Expected valueDepth of type number[] to be set. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/api/MultiSelectTreeComponent/#valuedepth',
  'valueDepthLength': 'Expected valueDepth length to match the number of provided values. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/api/MultiSelectTreeComponent/#valuedepth'
};
/**
 * @hidden
 */
const ComboBoxMessages = {
  'object': 'Expected value of type Object. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox/value-binding/#object-values',
  'primitive': 'Expected value of primitive type. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox/value-binding/#primitive-values',
  'textAndValue': 'Expected textField and valueField options to be set. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox/data-binding/#arrays-of-complex-data',
  'noItemHeight': 'Expected virtual.itemHeight of type number.'
};
/**
 * @hidden
 */
const MultiColumnComboBoxMessages = {
  'data': 'Provided data must consist only of objects. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/multicolumncombobox/data-binding/',
  'textAndValue': 'Expected textField and valueField options to be set. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/multicolumncombobox/data-binding/#fields-configuration'
};
/**
 * @hidden
 */
const DropDownListMessages = {
  'defaultItem': 'defaultItem and data items must be of same type. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/api/DropDownListComponent/#defaultitem',
  'object': 'Expected value of type Object. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/value-binding/#object-values',
  'primitive': 'Expected value of primitive type. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/value-binding/#primitive-values',
  'textAndValue': 'Expected textField and valueField options to be set. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/data-binding/#arrays-of-complex-data'
};
/**
 * @hidden
 */
const DropDownTreeMessages = {
  'primitive': 'Expected value of primitive type. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdowntree/value-binding/#primitive-values',
  'object': 'Expected value of type Object. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdowntree/value-binding/#object-values',
  'dataItem': 'Expected dataItem of type Object to be set. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/api/DropDownTreeComponent/#dataitem',
  'textAndValue': 'Expected textField and valueField options to be set. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdowntree/value-binding',
  'valueDepth': 'Expected valueDepth to be set. See https://www.telerik.com/kendo-angular-ui/components/dropdowns/api/DropDownTreeComponent/#valuedepth'
};

/**
 * @hidden
 */
const COMBOBOX_VALUE_ACCESSOR = {
  multi: true,
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ComboBoxComponent)
};
/**
 * Represents the [Kendo UI ComboBox component for Angular](https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox).
 * @example
 * ```html
 * <kendo-combobox [data]="listItems"> </kendo-combobox>
 * ```
 * @remarks
 * Supported children components are: {@link CustomMessagesComponent}.
 */
class ComboBoxComponent extends MultiTabStop {
  wrapper;
  localization;
  popupService;
  selectionService;
  navigationService;
  disabledItemsService;
  dataService;
  zone;
  cdr;
  renderer;
  injector;
  hostElement;
  adaptiveService;
  /**
   * @hidden
   */
  icon;
  /**
   * @hidden
   */
  svgIcon;
  /**
   * Sets the HTML attributes of the inner focusable input element. Attributes essential for certain component functionalities cannot be changed.
   *
   * @remarks
   * This property is related to accessibility.
   */
  inputAttributes;
  /**
   * @hidden
   */
  animationDuration = animationDuration;
  /**
   * @hidden
   */
  xIcon = xIcon;
  /**
   * @hidden
   */
  adaptiveRendererComponent;
  /**
   * @hidden
   */
  get actionSheet() {
    return this.adaptiveRendererComponent?.actionSheet;
  }
  /**
   * @hidden
   */
  get actionSheetSearchBar() {
    return this.adaptiveRendererComponent?.actionSheetSearchBar;
  }
  /**
   * @hidden
   */
  chevronDownIcon = chevronDownIcon;
  set text(text) {
    this._text = isPresent(text) ? text.toString() : "";
  }
  get text() {
    return this._text;
  }
  /**
   * @hidden
   */
  get ariaControls() {
    return this.isOpen ? this.listBoxId : undefined;
  }
  /**
   * @hidden
   */
  get isControlRequired() {
    return isControlRequired(this.formControl);
  }
  /**
   * @hidden
   */
  togglePopup(open) {
    const isDisabled = this.disabled || this.readonly;
    const sameState = this.isOpen === open;
    if (isDisabled || sameState) {
      return;
    }
    const isDefaultPrevented = this.triggerPopupEvents(open);
    if (!isDefaultPrevented) {
      this._toggle(open);
    }
  }
  get activeDescendant() {
    if (!this.isOpen || !isPresent(this.selectionService.focused) || this.selectionService.focused === -1) {
      return null;
    }
    return this.optionPrefix + "-" + this.selectionService.focused;
  }
  get appendTo() {
    const {
      appendTo
    } = this.popupSettings;
    if (!appendTo || appendTo === 'root') {
      return undefined;
    }
    return appendTo === 'component' ? this.container : appendTo;
  }
  dataItem;
  selected = [];
  /**
   * Shows or hides the current group sticky header when using grouped data.
   * By default the sticky header is displayed ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/grouping#sticky-header)).
   * @default true
   */
  showStickyHeader = true;
  /**
   * @hidden
   */
  focusableId = `k-${guid()}`;
  /**
   * Specifies whether the ComboBox allows user-defined values that are not present in the dataset
   * ([more information and examples](https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox/custom-values)).
   * Defaults to `false`.
   *
   * The feature is not available when using adaptive mode.
   * @default false
   */
  allowCustom = false;
  /**
   * Sets the data of the ComboBox.
   * The data must be provided in an array-like list.
   */
  set data(data) {
    this.dataService.data = data || [];
    if (this.virtual) {
      this.virtual.skip = 0;
    }
    this.setState();
    if (this._filtering) {
      const queryAndDataPresent = this.text.length > 0 && this.dataService.itemsCount > 0;
      const index = queryAndDataPresent ? this.firstFocusableIndex(0) : -1;
      this.selectionService.focused = index;
    }
    if (this.suggest && this.dataService.itemsCount && this.text) {
      this.suggestedText = getter(this.dataService.itemAt(0), this.textField);
    }
  }
  get data() {
    const virtual = this.virtual;
    if (virtual) {
      const start = virtual.skip || 0;
      const end = start + virtual.pageSize;
      // Use length instead of itemsCount because of the grouping.
      virtual.total = this.dataService.data.length;
      return this.dataService.data.slice(start, end);
    }
    return this.dataService.data;
  }
  /**
   * Sets the value of the ComboBox. The value can be a primitive (string, number) or a complex object. Use the `valuePrimitive` property to define the type.
   *
   * All selected values not present in the dataset are custom values. When the `Enter` key is pressed or the component loses focus, custom values are dismissed unless `allowCustom` is set to `true`.
   */
  set value(newValue) {
    this._value = newValue;
    this.setState();
    this.cdr.markForCheck();
  }
  get value() {
    return this._value;
  }
  /**
   * Sets the data item field that represents the item text. If the data contains only primitive values, do not define this property.
   *
   * The `textField` property can be set to a nested property value, for example, `category.name`.
   */
  textField;
  /**
   * Sets the data item field that represents the item value.
   * If the data contains only primitive values, do not define it.
   *
   * > The `valueField` property can be set to point to a nested property value - e.g. `category.id`.
   */
  valueField;
  /**
   * Specifies the type of the selected value. If set to `true`, the selected value must be a primitive type.
   * ([more information and example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox/value-binding#primitive-values-from-object-fields))
   */
  set valuePrimitive(isPrimitive) {
    this._valuePrimitive = isPrimitive;
  }
  get valuePrimitive() {
    if (!isPresent(this._valuePrimitive)) {
      return !isPresent(this.valueField);
    }
    return this._valuePrimitive;
  }
  /**
   * A user-defined callback which returns normalized custom values.
   * Typically used when the data items are different from type `string`.
   * @param { Any } value - The custom value defined by the user.
   * @returns { Any }
   *
   * @example
   * ```ts
   * import { map } from 'rxjs/operators';
   *
   * _@Component({
   * selector: 'my-app',
   * template: `
   *   <kendo-combobox
   *       [allowCustom]="true"
   *       [data]="listItems"
   *       textField="text"
   *       valueField="value"
   *       [valueNormalizer]="valueNormalizer"
   *       (valueChange)="onValueChange($event)"
   *   >
   *   </kendo-combobox>
   * `
   * })
   *
   * class AppComponent {
   *   public listItems: Array<{ text: string, value: number }> = [
   *       { text: "Small", value: 1 },
   *       { text: "Medium", value: 2 },
   *       { text: "Large", value: 3 }
   *   ];
   *
   *   public onValueChange(value) {
   *       console.log("valueChange : ", value);
   *   }
   *
   *   public valueNormalizer = (text$: Observable<string>) => text$.pipe(map((text: string) => {
   *      return { ProductID: null, ProductName: text };
   *   }));
   *
   * }
   * ```
   */
  valueNormalizer = text => text.pipe(map(userInput => userInput));
  /**
   * The hint that is displayed when the component is empty.
   * @default ''
   */
  placeholder = "";
  /**
   * Enables or disables the adaptive mode. By default, adaptive rendering is disabled.
   * @default 'none'
   */
  adaptiveMode = 'none';
  /**
   * Sets the title of the ActionSheet that is rendered instead of the Popup when using small screen devices.
   * By default, the ActionSheet title uses the text provided for the label of the ComboBox.
   * @default ''
   */
  adaptiveTitle = '';
  /**
   * Sets the subtitle of the ActionSheet that is rendered instead of the Popup when using small screen devices. By default, the ActionSheet does not render a subtitle.
   */
  adaptiveSubtitle;
  /**
   * @hidden
   */
  get isAdaptiveModeEnabled() {
    return this.adaptiveMode === 'auto';
  }
  /**
   * Configures the popup of the ComboBox.
   */
  set popupSettings(settings) {
    this._popupSettings = Object.assign({
      animate: true
    }, settings);
  }
  get popupSettings() {
    return this._popupSettings;
  }
  /**
   * Sets the height of the options list in the popup. By default, `listHeight` is 200px.
   *
   * > The `listHeight` property affects only the list of options and not the whole popup container.
   * > To set the height of the popup container, use `popupSettings.height`.
   *
   * When using `adaptiveMode` and the screen size is `small` or `medium` the `listHeight` property is set to null.
   */
  set listHeight(_listHeight) {
    this._listHeight = _listHeight;
  }
  get listHeight() {
    if (this.isAdaptive) {
      return;
    }
    return this._listHeight;
  }
  _listHeight = 200;
  /**
   * Sets and gets the loading state of the ComboBox.
   */
  loading;
  /**
   * Enables the auto-completion of the text based on the first data item.
   * @default false
   */
  suggest = false;
  /**
   * If set to `true`, renders a button on hovering over the component.
   * Clicking this button resets the value of the component to `undefined` and triggers the `change` event.
   * @default true
   */
  clearButton = true;
  /**
   * Sets the disabled state of the component. To learn how to disable the component in reactive forms, refer to the articles on [ComboBox Forms Support](https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox/forms#managing-the-combobox-disabled-state-in-reactive-forms) and [MultiColumnComboBox Forms Support](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multicolumncombobox/forms#managing-the-multicolumncombobox-disabled-state-in-reactive-forms).
   */
  disabled = false;
  /**
   * Defines a Boolean function that is executed for each data item in the component ([see examples](https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox/disabled-items)). Determines whether the item is disabled.
   */
  set itemDisabled(fn) {
    if (typeof fn !== 'function') {
      throw new Error(`itemDisabled must be a function, but received ${JSON.stringify(fn)}.`);
    }
    this.disabledItemsService.itemDisabled = fn;
  }
  /**
   * Sets the read-only state of the component.
   * @default false
   */
  readonly = false;
  /**
   * Specifies the [`tabindex`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex) of the component.
   *
   * @default 0
   */
  tabindex = 0;
  /**
   * @hidden
   */
  set tabIndex(tabIndex) {
    this.tabindex = tabIndex;
  }
  get tabIndex() {
    return this.tabindex;
  }
  /**
   * Enables the [filtering](https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox/filtering) functionality.
   * If set to `true`, the component emits the `filterChange` event.
   */
  filterable = false;
  /**
   * Enables the [virtualization](https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox/virtualization) functionality.
   */
  set virtual(settings) {
    this._virtualSettings = normalizeVirtualizationSettings(settings, {
      itemHeight: this.defaultVirtualItemHeight,
      pageSize: this.defaultVirtualPageSize
    });
  }
  get virtual() {
    return this._virtualSettings;
  }
  /**
   * Sets the size of the component. The default value is set by the Kendo theme.
   */
  set size(size) {
    this.renderer.removeClass(this.wrapper.nativeElement, getSizeClass('input', this.size));
    if (size) {
      this.renderer.addClass(this.wrapper.nativeElement, getSizeClass('input', size));
    }
    this._size = size;
  }
  get size() {
    return this._size;
  }
  /**
   * Sets the border radius of the component. The default value is set by the Kendo theme.
   */
  set rounded(rounded) {
    this.renderer.removeClass(this.wrapper.nativeElement, getRoundedClass(this.rounded));
    if (rounded) {
      this.renderer.addClass(this.wrapper.nativeElement, getRoundedClass(rounded));
    }
    this._rounded = rounded;
  }
  get rounded() {
    return this._rounded;
  }
  /**
   * Sets the fillMode of the component. The default value is set by the Kendo theme.
   */
  set fillMode(fillMode) {
    this.renderer.removeClass(this.wrapper.nativeElement, getFillModeClass('input', this.fillMode));
    if (fillMode) {
      this.renderer.addClass(this.wrapper.nativeElement, getFillModeClass('input', fillMode));
    }
    this._fillMode = fillMode;
  }
  get fillMode() {
    return this._fillMode;
  }
  /**
   * Fires each time the value is changed&mdash;
   * when the component is blurred or the value is cleared through the **Clear** button
   * ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox/events)).
   * When the value of the component is programmatically changed to `ngModel` or `formControl`
   * through its API or form binding, the `valueChange` event is not triggered because it
   * might cause a mix-up with the built-in `valueChange` mechanisms of the `ngModel` or `formControl` bindings.
   */
  valueChange = new EventEmitter();
  /**
   * Fires each time an item selection is changed ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox/events)).
   */
  selectionChange = new EventEmitter();
  /**
   * Fires each time the user types in the input field. You can filter the source based on the passed filtration value ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/combobox/events)).
   */
  filterChange = new EventEmitter();
  /**
   * Fires each time the popup is about to open. This event is preventable. If you cancel it, the popup remains closed.
   */
  open = new EventEmitter();
  /**
   * Fires after the popup has been opened.
   */
  opened = new EventEmitter();
  /**
   * Fires each time the popup is about to close. This event is preventable. If you cancel it, the popup remains open.
   */
  close = new EventEmitter();
  /**
   * Fires after the popup has been closed.
   */
  closed = new EventEmitter();
  /**
   * Fires each time the user focuses the ComboBox.
   */
  onFocus = new EventEmitter();
  /**
   * Fires each time the ComboBox gets blurred.
   */
  onBlur = new EventEmitter();
  /**
   * Fires each time the user focuses the `input` element.
   */
  inputFocus = new EventEmitter();
  /**
   * Fires each time the `input` element gets blurred.
   */
  inputBlur = new EventEmitter();
  /**
   * @hidden
   */
  escape = new EventEmitter();
  template;
  headerTemplate;
  footerTemplate;
  noDataTemplate;
  groupTemplate;
  fixedGroupTemplate;
  /**
   * @hidden
   */
  suffixTemplate;
  /**
   * @hidden
   */
  prefixTemplate;
  container;
  popupTemplate;
  searchbar;
  optionsList;
  select;
  widgetClasses = true;
  get isDisabled() {
    return this.disabled;
  }
  get isLoading() {
    return this.loading;
  }
  get dir() {
    return this.direction;
  }
  _isFocused = false;
  get isFocused() {
    return this._isFocused;
  }
  set isFocused(value) {
    this.renderer[value ? 'addClass' : 'removeClass'](this.wrapper.nativeElement, "k-focus");
    this._isFocused = value;
  }
  get clearButtonVisibility() {
    if (touchEnabled) {
      return 'visible';
    }
  }
  /**
   * @hidden
   */
  get formControl() {
    const ngControl = this.injector.get(NgControl, null);
    return ngControl?.control || null;
  }
  /**
   * @hidden
   */
  windowSize = 'large';
  /**
   * @hidden
   */
  get isActionSheetExpanded() {
    return this.actionSheet?.expanded;
  }
  /**
   * @hidden
   */
  get isAdaptive() {
    return this.isAdaptiveModeEnabled && this.windowSize !== 'large';
  }
  listBoxId = `k-${guid()}`;
  optionPrefix = `k-${guid()}`;
  popupRef;
  get popupWidth() {
    let wrapperOffsetWidth = 0;
    if (isDocumentAvailable()) {
      wrapperOffsetWidth = this.wrapper.nativeElement.offsetWidth;
    }
    const width = this.popupSettings.width || wrapperOffsetWidth;
    const minWidth = isNaN(wrapperOffsetWidth) ? wrapperOffsetWidth : `${wrapperOffsetWidth}px`;
    const maxWidth = isNaN(width) ? width : `${width}px`;
    return {
      min: minWidth,
      max: maxWidth
    };
  }
  get popupHeight() {
    const popupHeight = this.popupSettings.height;
    return isPresent(popupHeight) ? `${popupHeight}px` : 'auto';
  }
  onChangeCallback = _ => {};
  onTouchedCallback = _ => {};
  /**
   * Used for the default virtualization settings config.
   */
  defaultVirtualItemHeight = 28;
  /**
   * Used for the default virtualization settings config.
   */
  defaultVirtualPageSize = 50;
  valueSubscription;
  _filtering = false;
  _text = '';
  filterText = '';
  _open = false;
  _value;
  _valuePrimitive;
  _previousDataItem;
  suggestedText;
  backspacePressed;
  _popupSettings = {
    animate: true
  };
  _virtualSettings;
  popupMouseDownHandler = event => event.preventDefault();
  customValueSubject = new Subject();
  valueSubject = new Subject();
  clearValueSubject = new Subject();
  direction;
  subs = new Subscription();
  touchstartDisposeHandler;
  selectClickDisposeHandler;
  _size = undefined;
  _rounded = undefined;
  _fillMode = undefined;
  constructor(wrapper, localization, popupService, selectionService, navigationService, disabledItemsService, dataService, zone, cdr, renderer, injector, hostElement, adaptiveService) {
    super();
    this.wrapper = wrapper;
    this.localization = localization;
    this.popupService = popupService;
    this.selectionService = selectionService;
    this.navigationService = navigationService;
    this.disabledItemsService = disabledItemsService;
    this.dataService = dataService;
    this.zone = zone;
    this.cdr = cdr;
    this.renderer = renderer;
    this.injector = injector;
    this.hostElement = hostElement;
    this.adaptiveService = adaptiveService;
    validatePackage(packageMetadata);
    this.direction = localization.rtl ? 'rtl' : 'ltr';
    this.data = [];
  }
  ngOnInit() {
    this.renderer.removeAttribute(this.wrapper.nativeElement, 'tabindex');
    this.attachStreams();
    this.createValueStream();
    this.subscribeTouchEvents();
    this.attachSelectClickHandler();
    this.setComponentClasses();
  }
  ngAfterViewInit() {
    this.windowSize = this.adaptiveService.size;
    this.cdr.detectChanges();
  }
  createValueStream() {
    const valueStream = this.valueSubject.pipe(filter(candidate => {
      const current = getter(this.value, this.valueField);
      const newValue = getter(candidate, this.valueField);
      let newText = getter(candidate, this.textField);
      if (!isPresent(this.value) && !isPresent(newValue)) {
        return false;
      }
      if (isPresent(newText)) {
        newText = newText.toString();
      }
      if (current === newValue && this.text === newText) {
        this.clearFilter();
        return false;
      } else {
        return true;
      }
    }), map(candidate => {
      const newValue = getter(candidate, this.valueField);
      const newText = getter(candidate, this.textField);
      return {
        dataItem: candidate,
        text: newText,
        value: this.valuePrimitive ? newValue : candidate
      };
    }));
    const customValueStreams = partition(() => this.allowCustom)(this.customValueSubject.pipe(throttleTime(300)));
    const allowCustomValueStream = customValueStreams[0].pipe(tap(() => {
      this.loading = true;
      this.disabled = true;
      this.cdr.detectChanges();
    }), filter(() => {
      const hasChange = this.text !== getter(this.value, this.valueField);
      this.loading = hasChange;
      this.disabled = hasChange;
      if (!hasChange) {
        this.clearFilter();
      }
      return hasChange;
    }), this.valueNormalizer, map(normalizedValue => {
      return {
        custom: true,
        dataItem: normalizedValue,
        text: this.text,
        value: normalizedValue
      };
    }));
    const disableCustomValueStream = customValueStreams[1].pipe(map(() => {
      return {
        custom: true,
        dataItem: undefined,
        text: undefined,
        value: undefined
      };
    }));
    const clearValueStream = this.clearValueSubject.pipe(map(() => ({
      dataItem: undefined,
      text: undefined,
      value: undefined
    })));
    if (this.valueSubscription) {
      this.valueSubscription.unsubscribe();
    }
    const merged = merge(valueStream, allowCustomValueStream, disableCustomValueStream, clearValueStream);
    this.valueSubscription = merged.pipe(catchError(() => {
      const selectionChanged = getter(this.dataItem, this.valueField) !== undefined;
      this.dataItem = undefined;
      this.value = undefined;
      this.text = undefined;
      this.loading = false;
      this.disabled = false;
      if (selectionChanged) {
        this.selectionChange.emit(undefined);
      }
      this.emitValueChange();
      this.createValueStream();
      return of(null);
    })).subscribe(state => {
      const selectionChanged = getter(this.dataItem, this.valueField) !== getter(state.dataItem, this.valueField);
      this.dataItem = state.dataItem;
      this.value = state.value;
      this.text = state.text;
      this.loading = false;
      this.disabled = false;
      this.clearFilter();
      if (state.custom) {
        this.selectionService.focused = -1;
      }
      if (selectionChanged) {
        const selectionArgs = state.custom ? undefined : this.dataItem;
        this.selectionChange.emit(selectionArgs);
      }
      this.emitValueChange();
    });
  }
  attachStreams() {
    if (!isDocumentAvailable()) {
      return;
    }
    this.subs.add(this.localization.changes.subscribe(({
      rtl
    }) => {
      this.direction = rtl ? 'rtl' : 'ltr';
      this.cdr.detectChanges();
    }));
    this.subs.add(merge(this.navigationService.up, this.navigationService.down, this.navigationService.home, this.navigationService.end).pipe(filter(event => isPresent(event.index))).subscribe(event => this.navigate(event.index)));
    this.subs.add(this.navigationService.open.subscribe(this.handleNavigationOpen.bind(this)));
    this.subs.add(this.navigationService.close.subscribe(() => this.togglePopup(false)));
    this.subs.add(merge(this.navigationService.pagedown, this.navigationService.pageup).subscribe(event => {
      if (this.isOpen) {
        event.originalEvent.preventDefault();
        const code = normalizeKeys(event.originalEvent);
        this.optionsList.scrollWithOnePage(NavigationAction[code]);
      }
    }));
    this.subs.add(this.navigationService.esc.subscribe(this.handleEscape.bind(this)));
    this.subs.add(this.navigationService.enter.pipe(tap(event => {
      if (this.isOpen) {
        event.originalEvent.preventDefault();
      }
    })).subscribe(this.handleEnter.bind(this)));
    this.subs.add(merge(this.selectionService.onChange, this.selectionService.onSelect.pipe(filter(() => !this.isOpen))).pipe(tap(() => {
      this._filtering = false;
      this.togglePopup(false);
    }), map(event => this.dataService.itemAt(event.indices[0]))).subscribe(dataItem => {
      this.change(dataItem);
    }));
    this.subs.add(this.selectionService.onSelect.pipe(filter(() => this.isOpen), tap(() => this._filtering = false), map(event => this.dataService.itemAt(event.indices[0]))).subscribe(dataItem => {
      const selectionChanged = getter(dataItem, this.valueField) !== getter(this.dataItem, this.valueField);
      this.updateState({
        dataItem
      });
      if (selectionChanged) {
        this.selectionChange.emit(dataItem);
      }
    }));
  }
  ngOnDestroy() {
    this.destroyPopup();
    this.subs.unsubscribe();
    if (isPresent(this.valueSubscription)) {
      this.valueSubscription.unsubscribe();
    }
    if (this.touchstartDisposeHandler) {
      this.touchstartDisposeHandler();
    }
    if (this.selectClickDisposeHandler) {
      this.selectClickDisposeHandler();
    }
  }
  ngOnChanges(changes) {
    const virtual = this.virtual;
    const requestInitialData = virtual && changes['data'] && changes['data'].isFirstChange();
    if (requestInitialData) {
      this.pageChange({
        skip: 0,
        take: virtual.pageSize
      });
    }
    if (isChanged('valueNormalizer', changes)) {
      this.createValueStream();
    }
    if (anyChanged(['textField', 'valueField', 'valuePrimitive'], changes, false)) {
      this.setState();
    }
  }
  ngAfterContentChecked() {
    this.verifySettings();
  }
  /**
   * Focuses a specific item of the ComboBox based on a provided index.
   * If null or invalid index is provided the focus will be removed.
   */
  focusItemAt(index) {
    const isInRange = index >= 0 && index < this.data.length;
    if (isPresent(index) && isInRange && !this.disabledItemsService.isIndexDisabled(index)) {
      this.selectionService.focus(index);
    } else {
      this.selectionService.focus(-1);
    }
  }
  /**
   * Focuses the ComboBox.
   */
  focus() {
    if (!this.disabled) {
      this.searchbar.focus();
    }
  }
  /**
   * Blurs the ComboBox.
   */
  blur() {
    if (!this.disabled) {
      this.searchbar.blur();
    }
  }
  /**
   * Toggles the visibility of the popup or actionSheet. If you use the `toggle` method to open or close the popup or actionSheet,
   * the `open` and `close` events will not be fired.
   *
   * @param open - The state of the popup.
   */
  toggle(open) {
    Promise.resolve(null).then(() => {
      const shouldOpen = isPresent(open) ? open : !this._open;
      this._toggle(shouldOpen);
      this.cdr.markForCheck();
    });
  }
  /**
   * Returns the current open state. Returns `true` if the popup or actionSheet is open.
   */
  get isOpen() {
    return isTruthy(this._open || this.isActionSheetExpanded);
  }
  /**
   * @hidden
   */
  handleClick() {
    this.windowSize = this.adaptiveService.size;
    if (this.isAdaptive) {
      this.togglePopup(true);
    }
  }
  /**
   * Resets the value of the ComboBox.
   * If you use the `reset` method to clear the value of the component,
   * the model will not update automatically and the `selectionChange` and `valueChange` events will not be fired.
   */
  reset() {
    this.value = undefined;
    this.clearState();
    this.resetSelection();
  }
  /**
   * @hidden
   *
   * Used by the TextBoxContainer to determine if the floating label
   * should be rendered in the input when the component is not focused.
   */
  isEmpty() {
    const textEmpty = !isPresent(this.text) || isEmptyString(this.text);
    const valueEmpty = !isPresent(this.value) || isEmptyString(this.value);
    return textEmpty && valueEmpty;
  }
  /**
   * @hidden
   */
  messageFor(key) {
    return this.localization.get(key);
  }
  /**
   * @hidden
   */
  clearValue(event) {
    event?.stopImmediatePropagation();
    if (event) {
      this.focus();
    }
    this._previousDataItem = undefined;
    this.selectionService.resetSelection([]);
    this.clearValueSubject.next(undefined);
    this._filtering = false;
  }
  /**
   * @hidden
   */
  writeValue(value) {
    this.value = value === null ? undefined : value;
  }
  /**
   * @hidden
   */
  registerOnChange(fn) {
    this.onChangeCallback = fn;
  }
  /**
   * @hidden
   */
  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }
  /**
   * @hidden
   */
  setDisabledState(isDisabled) {
    this.cdr.markForCheck();
    this.disabled = isDisabled;
  }
  /**
   * @hidden
   */
  get selectButtonClasses() {
    return `${this.size ? getSizeClass('button', this.size) : ''} ${this.fillMode ? 'k-button-' + this.fillMode : ''}`;
  }
  /**
   * @hidden
   */
  onResize() {
    const currentWindowSize = this.adaptiveService.size;
    if (this.isAdaptiveModeEnabled && this.windowSize !== currentWindowSize) {
      if (this.isOpen) {
        this.togglePopup(false);
      }
      this.windowSize = currentWindowSize;
      this.cdr.detectChanges();
    }
    if (this.isOpen && !this.isActionSheetExpanded) {
      const popupWrapper = this.popupRef.popupElement;
      const {
        min,
        max
      } = this.popupWidth;
      popupWrapper.style.minWidth = min;
      popupWrapper.style.width = max;
    }
  }
  verifySettings() {
    if (!isDevMode()) {
      return;
    }
    if (this.valuePrimitive === true && isPresent(this.value) && typeof this.value === "object") {
      throw new Error(ComboBoxMessages.primitive);
    }
    if (this.valuePrimitive === false && isPresent(this.value) && typeof this.value !== "object") {
      throw new Error(ComboBoxMessages.object);
    }
    const valueOrText = !isPresent(this.valueField) !== !isPresent(this.textField);
    if (valueOrText) {
      throw new Error(ComboBoxMessages.textAndValue);
    }
    if (this.virtual && isNaN(this.virtual.itemHeight)) {
      throw new Error(ComboBoxMessages.noItemHeight);
    }
  }
  setState() {
    // Filtering in process, do nothing.
    if (this._filtering) {
      return;
    }
    const value = this.value;
    const valueField = this.valueField;
    const resolved = this.findDataItem({
      valueField,
      value
    });
    if (isPresent(resolved.index) && resolved.index !== -1) {
      this.updateState({
        dataItem: resolved.dataItem,
        confirm: true
      });
      this.resetSelection(resolved.index);
    } else if (isPresent(value) && this.allowCustom) {
      this.updateState({
        dataItem: value
      });
      this.resetSelection(-1);
    } else if (this._previousDataItem && this.value) {
      this.updateState({
        dataItem: this._previousDataItem
      });
      this.resetSelection();
    } else {
      this.clearState();
      this.resetSelection(-1);
    }
  }
  updateState({
    dataItem,
    confirm = false
  }) {
    this.dataItem = dataItem;
    this.text = getter(dataItem, this.textField);
    if (confirm) {
      this._previousDataItem = dataItem;
    }
  }
  clearState() {
    this.text = undefined;
    this.dataItem = undefined;
  }
  resetSelection(index) {
    const clear = !isPresent(index) || index < 0;
    this.selectionService.resetSelection(clear ? [] : [index]);
    this.selectionService.focused = index;
  }
  firstFocusableIndex(index) {
    const maxIndex = this.data.length - 1;
    if (this.disabledItemsService.isIndexDisabled(index)) {
      return index < maxIndex ? this.firstFocusableIndex(index + 1) : undefined;
    } else {
      return index;
    }
  }
  findIndexPredicate(text) {
    if (this.dataService.grouped) {
      return item => {
        let itemText = getter(item.value, this.textField);
        itemText = !isPresent(itemText) ? "" : itemText.toString().toLowerCase();
        return itemText.startsWith(text.toLowerCase());
      };
    } else {
      return item => {
        let itemText = getter(item, this.textField);
        itemText = !isPresent(itemText) ? "" : itemText.toString().toLowerCase();
        return itemText.startsWith(text.toLowerCase());
      };
    }
  }
  findDataItem({
    valueField,
    value
  }) {
    const result = {
      dataItem: null,
      index: -1
    };
    const comparer = element => {
      const dataItem = this.dataService.grouped ? element.value : element;
      return getter(dataItem, valueField) === getter(value, valueField);
    };
    const index = this.dataService.findIndex(comparer);
    result.dataItem = this.dataService.itemAt(index);
    result.index = index;
    return result;
  }
  search(text, startFrom = 0) {
    const index = this.findIndex(text, startFrom);
    if (this.disabledItemsService.isIndexDisabled(index)) {
      if (index + 1 < this.dataService.itemsCount) {
        this.search(text, index + 1);
      } else {
        this.selectionService.focus(-1);
      }
    } else {
      this.selectionService.focus(index);
      if (this.suggest) {
        this.suggestedText = getter(this.dataService.itemAt(index), this.textField);
      }
    }
  }
  /**
   * @hidden
   */
  getSuggestion() {
    const hasSelected = !!this.selectionService.selected.length;
    const shouldSuggest = this.suggest && !this.backspacePressed && this.suggestedText && this.text;
    if (!hasSelected && shouldSuggest && this.suggestedText.toLowerCase().startsWith(this.text.toLowerCase())) {
      return this.suggestedText;
    } else {
      this.suggestedText = undefined;
    }
  }
  navigate(index) {
    if (this.dataService.itemsCount === 0) {
      return;
    }
    this.text = getter(this.dataService.itemAt(index), this.textField);
    this.selectionService.select(index);
  }
  /**
   * @hidden
   */
  handleNavigate(event) {
    const hasSelected = isPresent(this.selectionService.selected[0]);
    const focused = isNaN(this.selectionService.focused) ? this.firstFocusableIndex(0) : this.selectionService.focused;
    let offset = 0;
    if (this.disabled || this.readonly) {
      return;
    }
    // on some keyboards, Home and End keys are mapped to Numpad keys
    const code = normalizeKeys(event);
    const isHomeKey = code === Keys.Home;
    const isEndKey = code === Keys.End;
    if (isHomeKey || isEndKey) {
      return;
    }
    if (!hasSelected) {
      if (code === Keys.ArrowDown) {
        offset = -1;
      } else if (code === Keys.ArrowUp) {
        offset = 1;
      }
    }
    const action = this.navigationService.process({
      current: offset + focused,
      max: this.dataService.itemsCount - 1,
      min: 0,
      originalEvent: event
    });
    if (action !== NavigationAction.Undefined && action !== NavigationAction.Left && action !== NavigationAction.Right && action !== NavigationAction.Backspace && action !== NavigationAction.Delete && action !== NavigationAction.PageDown && action !== NavigationAction.PageUp && (action === NavigationAction.Enter && this.isOpen || action !== NavigationAction.Enter)) {
      event.preventDefault();
    }
    if (action === NavigationAction.Tab && this.isActionSheetExpanded) {
      event.stopImmediatePropagation();
      this.togglePopup(false);
    }
  }
  handleEnter() {
    const text = this.text;
    const focused = this.selectionService.focused;
    const hasFocused = isPresent(focused) && focused !== -1;
    const previousText = getter(this._previousDataItem, this.textField) || "";
    const focusedItemText = getter(this.dataService.itemAt(focused), this.textField);
    const textHasChanged = text !== previousText;
    this.togglePopup(false);
    this._filtering = false;
    if (this.allowCustom && textHasChanged) {
      if (text === focusedItemText || this.useSuggestion()) {
        this.selectionService.change(focused);
      } else {
        this.change(text, true);
      }
    }
    if (!this.allowCustom) {
      if (hasFocused) {
        this.selectionService.change(focused);
      } else if (textHasChanged) {
        this.change(text, true);
      }
    }
  }
  /**
   * @hidden
   */
  handleFocus() {
    this.zone.run(() => {
      if (!this.isFocused && hasObservers(this.onFocus)) {
        this.onFocus.emit();
      }
      this.isFocused = true;
    });
  }
  /**
   * @hidden
   */
  handleBlur() {
    if (!this.isActionSheetExpanded) {
      this.blurComponent();
    }
  }
  /**
   * @hidden
   */
  handleInputBlur() {
    if (!this.isActionSheetExpanded) {
      this._filtering = false;
      this.searchbar.input.nativeElement.scrollLeft = 0; // Firefox doesn't auto-scroll to the left on blur like other browsers
      const unresolvedSelection = getter(this.dataItem, this.valueField) !== getter(this.value, this.valueField);
      const currentText = this.searchbar.value;
      const textHasChanged = currentText !== (getter(this.dataItem, this.textField) ?? '').toString().replace(/\r?\n|\r/g, '');
      const valueHasChanged = unresolvedSelection || textHasChanged;
      const runInZone = valueHasChanged || hasObservers(this.onBlur) || hasObservers(this.close) || isUntouched(this.wrapper.nativeElement) || this.formControl?.updateOn === 'blur';
      if (runInZone) {
        this.zone.run(() => {
          if (valueHasChanged) {
            const lowerCaseMatch = isPresent(this.focusedItemText) && this.focusedItemText.toLowerCase() === currentText.toLowerCase();
            if (lowerCaseMatch || unresolvedSelection) {
              this.selectionService.change(this.selectionService.focused);
            } else {
              this.change(currentText, true);
            }
          }
          this.inputBlur.emit();
          this.onTouchedCallback();
          this.togglePopup(false);
        });
      } else {
        this.togglePopup(false);
      }
    }
  }
  /**
   * @hidden
   */
  handleEscape() {
    this.isOpen ? this.togglePopup(false) : this.clearValue();
    // clear the focus only if the focused item is not selected
    const hasSelected = this.selectionService.selected.length > 0;
    if (!hasSelected) {
      this.suggestedText = null;
      this.selectionService.focused = -1;
    }
    hasObservers(this.escape) && this.escape.emit();
  }
  /**
   * @hidden
   */
  handleNavigationOpen() {
    this.restoreItemFocus();
    this.togglePopup(true);
  }
  /**
   * @hidden
   */
  searchBarChange(text) {
    const currentTextLength = this.text ? this.text.length : 0;
    this.backspacePressed = Boolean(text.length < currentTextLength);
    this.text = text;
    // Reset the selection prior to filter. If a match is present, it will be resolved. If a match is not present, it is not needed.
    this.selectionService.resetSelection([]);
    this.togglePopup(true);
    this._filtering = true;
    if (this.filterable && this.filterText !== text) {
      this.filterText = text;
      this.filterChange.emit(text);
    } else {
      this.search(text);
    }
  }
  /**
   * @hidden
   */
  handleInputFocus() {
    this.handleFocus();
    if (hasObservers(this.inputFocus)) {
      this.zone.run(() => this.inputFocus.emit());
    }
  }
  /**
   * @hidden
   */
  pageChange(event) {
    const virtual = this.virtual;
    virtual.skip = event.skip;
  }
  /**
   * @hidden
   */
  closeActionSheet() {
    this.blurComponent();
    this.closed.emit();
  }
  change(candidate, isCustom = false) {
    if (isCustom) {
      this.customValueSubject.next(candidate);
    } else {
      this.valueSubject.next(candidate);
      if (this.isActionSheetExpanded) {
        this.togglePopup(false);
      }
    }
  }
  emitValueChange() {
    this.onChangeCallback(this.value);
    this.valueChange.emit(this.value);
    this._previousDataItem = this.dataItem;
  }
  /**
   * @hidden
   */
  selectClick() {
    if (!touchEnabled) {
      this.searchbar.focus();
      this.isFocused = true;
    }
    if (!this.isOpen) {
      this.restoreItemFocus();
    }
    this.togglePopup(!this.isOpen);
  }
  get listContainerClasses() {
    const containerClasses = ['k-list-container', 'k-combobox-popup'];
    if (!this.popupSettings.popupClass) {
      return containerClasses;
    }
    const parsedPopupClasses = parseCSSClassNames(this.popupSettings.popupClass);
    if (parsedPopupClasses?.length) {
      containerClasses.push(...parsedPopupClasses);
    }
    return containerClasses;
  }
  /**
   * @hidden
   */
  preventEventDefault(event) {
    event.preventDefault();
  }
  get focusedItemText() {
    const focused = this.selectionService.focused;
    if (!isPresent(focused) || focused === -1) {
      return null;
    }
    const itemText = getter(this.dataService.itemAt(focused), this.textField);
    return !isPresent(itemText) ? "" : itemText.toString();
  }
  /**
   * Focuses the first match when there's text in the input field, but no focused item.
   */
  restoreItemFocus() {
    const hasFocus = isPresent(this.selectionService.focused) && this.selectionService.focused > -1;
    if (!hasFocus && this.text && this.dataService.itemsCount) {
      if (this.filterable) {
        this.selectionService.focused = this.firstFocusableIndex(0);
      } else {
        this.search(this.text);
      }
    }
  }
  useSuggestion() {
    if (!(this.suggest && isPresent(this.searchbar.value))) {
      return false;
    }
    const focusedDataItem = this.dataService.itemAt(this.selectionService.focused);
    const focusedItemText = getter(focusedDataItem, this.textField);
    if (!isPresent(focusedItemText)) {
      return false;
    }
    return this.searchbar.value.toLowerCase() === focusedItemText.toLowerCase();
  }
  destroyPopup() {
    if (this.popupRef) {
      this.popupRef.popupElement.removeEventListener('mousedown', this.popupMouseDownHandler);
      this.popupRef.close();
      this.popupRef = null;
    }
  }
  createPopup() {
    if (this.virtual) {
      this.virtual.skip = 0;
    }
    this.windowSize = this.adaptiveService.size;
    if (this.isAdaptive) {
      this.openActionSheet();
      return;
    }
    const horizontalAlign = this.direction === "rtl" ? "right" : "left";
    const anchorPosition = {
      horizontal: horizontalAlign,
      vertical: "bottom"
    };
    const popupPosition = {
      horizontal: horizontalAlign,
      vertical: "top"
    };
    const appendToComponent = typeof this.popupSettings.appendTo === 'string' && this.popupSettings.appendTo === 'component';
    this.popupRef = this.popupService.open({
      anchor: this.wrapper,
      animate: this.popupSettings.animate,
      appendTo: this.appendTo,
      content: this.popupTemplate,
      popupClass: this.listContainerClasses,
      positionMode: appendToComponent ? 'fixed' : 'absolute',
      anchorAlign: anchorPosition,
      popupAlign: popupPosition
    });
    const popupWrapper = this.popupRef.popupElement;
    const {
      min,
      max
    } = this.popupWidth;
    popupWrapper.addEventListener('mousedown', this.popupMouseDownHandler);
    popupWrapper.style.minWidth = min;
    popupWrapper.style.width = max;
    popupWrapper.style.height = this.popupHeight;
    popupWrapper.setAttribute('dir', this.direction);
    if (!this.appendTo) {
      this.renderer.setAttribute(popupWrapper, 'role', 'region');
      this.renderer.setAttribute(popupWrapper, 'aria-label', this.messageFor('popupLabel'));
    }
    this.popupRef.popupOpen.subscribe(() => {
      this.cdr.detectChanges();
      if (!this.dataService.grouped) {
        setListBoxAriaLabelledBy(this.optionsList, this.searchbar.input, this.renderer);
      }
      this.optionsList.scrollToItem(this.selectionService.focused);
      this.selectionService.focus(this.selectionService.focused);
      this.opened.emit();
    });
    this.popupRef.popupClose.subscribe(() => {
      this.closed.emit();
    });
    this.popupRef.popupAnchorViewportLeave.subscribe(() => this.togglePopup(false));
  }
  _toggle(open) {
    this._open = open;
    this.destroyPopup();
    if (this.isActionSheetExpanded) {
      this.actionSheet.toggle(false);
      this.focus();
    }
    if (this._open) {
      this.windowSize = this.adaptiveService.size;
      this.createPopup();
    }
  }
  triggerPopupEvents(open) {
    const eventArgs = new PreventableEvent();
    if (open) {
      this.open.emit(eventArgs);
    } else {
      this.close.emit(eventArgs);
    }
    return eventArgs.isDefaultPrevented();
  }
  clearFilter() {
    if (!(this.filterable && this.filterText)) {
      return;
    }
    this.filterText = '';
    this.filterChange.emit(this.filterText);
  }
  subscribeTouchEvents() {
    if (!isDocumentAvailable() || !touchEnabled) {
      return;
    }
    this.zone.runOutsideAngular(() =>
    // Roll up ComboBox on iOS when tapped outside
    this.touchstartDisposeHandler = this.renderer.listen(document, 'touchstart', e => {
      const target = e.target;
      const isInDropDown = inDropDown(this.wrapper, target, this.popupRef);
      if (this.isFocused && !isInDropDown) {
        // Close popup and mobile keyboard if searchbar is focused
        this.zone.run(() => this.blur());
      } else if (this.isOpen && !isInDropDown) {
        // Close popup if the popup is opened via the select click
        this.zone.run(() => this.togglePopup(false));
      }
    }));
  }
  attachSelectClickHandler() {
    const selectElement = this.select.nativeElement;
    const event = pointers ? 'pointerdown' : 'click';
    this.selectClickDisposeHandler = this.renderer.listen(selectElement, event, this.selectClick.bind(this));
  }
  setComponentClasses() {
    if (this.size) {
      this.renderer.addClass(this.wrapper.nativeElement, getSizeClass('input', this.size));
    }
    if (this.rounded) {
      this.renderer.addClass(this.wrapper.nativeElement, getRoundedClass(this.rounded));
    }
    if (this.fillMode) {
      this.renderer.addClass(this.wrapper.nativeElement, getFillModeClass('input', this.fillMode));
    }
  }
  findIndex(value, startFrom = 0) {
    let index;
    if (value && value.length && this.dataService.itemsCount) {
      index = this.dataService.findIndex(this.findIndexPredicate(value), startFrom);
    } else {
      index = -1;
    }
    return index;
  }
  openActionSheet() {
    this.windowSize = this.adaptiveService.size;
    this.actionSheet.toggle(true);
    this.cdr.detectChanges();
    if (!this.dataService.grouped) {
      setListBoxAriaLabelledBy(this.optionsList, this.searchbar.input, this.renderer);
    }
    this.adaptiveTitle = setActionSheetTitle(this.searchbar.input, this.adaptiveTitle);
    this.cdr.detectChanges();
    this.opened.emit();
    // wait for the ActionSheet animation to complete to ensure the scroll calculation is accurate
    this.actionSheet.expand.pipe(take(1)).subscribe(() => {
      this.optionsList.scrollToItem(this.selectionService.focused);
    });
    this.selectionService.focus(this.selectionService.focused);
    this.actionSheetSearchBar.focus();
  }
  blurComponent() {
    this._filtering = false;
    this.searchbar.input.nativeElement.scrollLeft = 0; // Firefox doesn't auto-scroll to the left on blur like other browsers
    this.isFocused = false;
    const unresolvedSelection = getter(this.dataItem, this.valueField) !== getter(this.value, this.valueField);
    const currentText = this.searchbar.value;
    const textHasChanged = currentText !== (getter(this.dataItem, this.textField) ?? '').toString().replace(/\r?\n|\r/g, '');
    const valueHasChanged = unresolvedSelection || textHasChanged;
    const runInZone = valueHasChanged || hasObservers(this.onBlur) || hasObservers(this.close) || isUntouched(this.wrapper.nativeElement);
    if (runInZone) {
      this.zone.run(() => {
        if (valueHasChanged) {
          const lowerCaseMatch = isPresent(this.focusedItemText) && this.focusedItemText.toLowerCase() === currentText.toLowerCase();
          if (lowerCaseMatch || unresolvedSelection) {
            this.selectionService.change(this.selectionService.focused);
          } else {
            this.change(currentText, true);
          }
        }
        this.onBlur.emit();
        this.onTouchedCallback();
        this.togglePopup(false);
      });
    } else {
      this.togglePopup(false);
    }
  }
  static ɵfac = function ComboBoxComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ComboBoxComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.LocalizationService), i0.ɵɵdirectiveInject(i2.PopupService), i0.ɵɵdirectiveInject(SelectionService), i0.ɵɵdirectiveInject(NavigationService), i0.ɵɵdirectiveInject(DisabledItemsService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i7.AdaptiveService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ComboBoxComponent,
    selectors: [["kendo-combobox"]],
    contentQueries: function ComboBoxComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, ItemTemplateDirective, 5)(dirIndex, HeaderTemplateDirective, 5)(dirIndex, FooterTemplateDirective, 5)(dirIndex, NoDataTemplateDirective, 5)(dirIndex, GroupTemplateDirective, 5)(dirIndex, FixedGroupTemplateDirective, 5)(dirIndex, SuffixTemplateDirective, 5)(dirIndex, PrefixTemplateDirective, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.noDataTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.groupTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fixedGroupTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.suffixTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.prefixTemplate = _t.first);
      }
    },
    viewQuery: function ComboBoxComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(AdaptiveRendererComponent, 5)(_c12, 7, ViewContainerRef)(_c13, 7)(SearchBarComponent, 7)(_c14, 5)(_c16, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.adaptiveRendererComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popupTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchbar = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.optionsList = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.select = _t.first);
      }
    },
    hostVars: 11,
    hostBindings: function ComboBoxComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("dir", ctx.dir);
        i0.ɵɵclassProp("k-readonly", ctx.readonly)("k-combobox", ctx.widgetClasses)("k-input", ctx.widgetClasses)("k-disabled", ctx.isDisabled)("k-loading", ctx.isLoading);
      }
    },
    inputs: {
      icon: "icon",
      svgIcon: "svgIcon",
      inputAttributes: "inputAttributes",
      showStickyHeader: "showStickyHeader",
      focusableId: "focusableId",
      allowCustom: "allowCustom",
      data: "data",
      value: "value",
      textField: "textField",
      valueField: "valueField",
      valuePrimitive: "valuePrimitive",
      valueNormalizer: "valueNormalizer",
      placeholder: "placeholder",
      adaptiveMode: "adaptiveMode",
      adaptiveTitle: "adaptiveTitle",
      adaptiveSubtitle: "adaptiveSubtitle",
      popupSettings: "popupSettings",
      listHeight: "listHeight",
      loading: "loading",
      suggest: "suggest",
      clearButton: "clearButton",
      disabled: "disabled",
      itemDisabled: "itemDisabled",
      readonly: "readonly",
      tabindex: "tabindex",
      tabIndex: "tabIndex",
      filterable: "filterable",
      virtual: "virtual",
      size: "size",
      rounded: "rounded",
      fillMode: "fillMode"
    },
    outputs: {
      valueChange: "valueChange",
      selectionChange: "selectionChange",
      filterChange: "filterChange",
      open: "open",
      opened: "opened",
      close: "close",
      closed: "closed",
      onFocus: "focus",
      onBlur: "blur",
      inputFocus: "inputFocus",
      inputBlur: "inputBlur",
      escape: "escape"
    },
    exportAs: ["kendoComboBox"],
    features: [i0.ɵɵProvidersFeature([COMBOBOX_VALUE_ACCESSOR, DataService, SelectionService, NavigationService, DisabledItemsService, LocalizationService, {
      provide: L10N_PREFIX,
      useValue: 'kendo.combobox'
    }, {
      provide: FilterableComponent,
      useExisting: forwardRef(() => ComboBoxComponent)
    }, {
      provide: KendoInput,
      useExisting: forwardRef(() => ComboBoxComponent)
    }, {
      provide: MultiTabStop,
      useExisting: forwardRef(() => ComboBoxComponent)
    }, {
      provide: KENDO_WEBMCP_HOST,
      useExisting: forwardRef(() => ComboBoxComponent)
    }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
    decls: 20,
    vars: 38,
    consts: () => {
      let i18n_4;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text displayed in the popup when there are no items
         * @meaning kendo.combobox.noDataText
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_4 = goog.getMsg("NO DATA FOUND");
        i18n_4 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_4;
      } else {
        i18n_4 = $localize`:kendo.combobox.noDataText|The text displayed in the popup when there are no items:NO DATA FOUND`;
      }
      let i18n_5;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the clear button
         * @meaning kendo.combobox.clearTitle
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_5 = goog.getMsg("clear");
        i18n_5 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_5;
      } else {
        i18n_5 = $localize`:kendo.combobox.clearTitle|The title of the clear button:clear`;
      }
      let i18n_6;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text set as aria-label on the select button
         * @meaning kendo.combobox.selectButtonText
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_6 = goog.getMsg("Select");
        i18n_6 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_6;
      } else {
        i18n_6 = $localize`:kendo.combobox.selectButtonText|The text set as aria-label on the select button:Select`;
      }
      let i18n_7;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The label of the popup element that contains the list of options when its role is 'region'
         * @meaning kendo.combobox.popupLabel
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_7 = goog.getMsg("Options list");
        i18n_7 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_7;
      } else {
        i18n_7 = $localize`:kendo.combobox.popupLabel|The label of the popup element that contains the list of options when its role is 'region':Options list`;
      }
      let i18n_8;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode
         * @meaning kendo.combobox.adaptiveCloseButtonTitle
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_8 = goog.getMsg("Close");
        i18n_8 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_8;
      } else {
        i18n_8 = $localize`:kendo.combobox.adaptiveCloseButtonTitle|The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode:Close`;
      }
      return [["select", ""], ["popupTemplate", ""], ["container", ""], ["sharedPopupActionSheetTemplate", ""], ["optionsList", ""], ["kendoComboBoxLocalizedMessages", "", "noDataText", i18n_4, "clearTitle", i18n_5, "selectButtonText", i18n_6, "popupLabel", i18n_7, "adaptiveCloseButtonTitle", i18n_8], ["kendoDropDownSharedEvents", "", 3, "isFocusedChange", "handleBlur", "onFocus", "hostElement", "isFocused"], [1, "k-input-prefix", "k-input-prefix-horizontal"], ["kendoSearchbar", "", 3, "onNavigate", "valueChange", "onBlur", "onFocus", "click", "ariaExpanded", "ariaControls", "id", "isLoading", "isSuggestable", "isFilterable", "activeDescendant", "userInput", "suggestedText", "disabled", "readonly", "tabIndex", "isRequired", "placeholder", "inputAttributes"], ["aria-hidden", "true", 1, "k-clear-value", 3, "visibility", "kendoEventsOutsideAngular"], [1, "k-i-loading", "k-input-loading-icon", "k-icon"], [1, "k-input-suffix", "k-input-suffix-horizontal"], ["tabindex", "-1", "unselectable", "on", "type", "button", 1, "k-input-button", "k-button", "k-icon-button", 3, "keydown.enter", "ngClass", "kendoEventsOutsideAngular"], ["innerCssClass", "k-button-icon", 3, "name", "svgIcon"], [3, "closePopup", "textInputChange", "navigate", "sharedPopupActionSheetTemplate", "title", "showTextInput", "subtitle", "placeholder", "searchBarValue"], [3, "ngTemplateOutlet"], ["aria-hidden", "true", 1, "k-clear-value", 3, "click", "kendoEventsOutsideAngular"], ["name", "x", 3, "svgIcon"], [4, "ngTemplateOutlet"], [3, "resize"], [3, "templateContext"], [3, "pageChange", "size", "rounded", "id", "optionPrefix", "data", "textField", "valueField", "template", "groupTemplate", "fixedGroupTemplate", "height", "show", "virtual", "showStickyHeader"], [1, "k-no-data"]];
    },
    template: function ComboBoxComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementContainer(0, 5);
        i0.ɵɵelementContainerStart(1, 6);
        i0.ɵɵtwoWayListener("isFocusedChange", function ComboBoxComponent_Template_ng_container_isFocusedChange_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          i0.ɵɵtwoWayBindingSet(ctx.isFocused, $event) || (ctx.isFocused = $event);
          return i0.ɵɵresetView($event);
        });
        i0.ɵɵlistener("handleBlur", function ComboBoxComponent_Template_ng_container_handleBlur_1_listener() {
          return ctx.handleBlur();
        })("onFocus", function ComboBoxComponent_Template_ng_container_onFocus_1_listener() {
          return ctx.handleFocus();
        });
        i0.ɵɵconditionalCreate(2, ComboBoxComponent_Conditional_2_Template, 2, 1, "span", 7);
        i0.ɵɵconditionalCreate(3, ComboBoxComponent_Conditional_3_Template, 1, 0, "kendo-separator");
        i0.ɵɵelementStart(4, "input", 8);
        i0.ɵɵlistener("onNavigate", function ComboBoxComponent_Template_input_onNavigate_4_listener($event) {
          return ctx.handleNavigate($event);
        })("valueChange", function ComboBoxComponent_Template_input_valueChange_4_listener($event) {
          return ctx.searchBarChange($event);
        })("onBlur", function ComboBoxComponent_Template_input_onBlur_4_listener() {
          return ctx.handleInputBlur();
        })("onFocus", function ComboBoxComponent_Template_input_onFocus_4_listener() {
          return ctx.handleInputFocus();
        })("click", function ComboBoxComponent_Template_input_click_4_listener() {
          return ctx.handleClick();
        });
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(5, ComboBoxComponent_Conditional_5_Template, 2, 7, "span", 9);
        i0.ɵɵconditionalCreate(6, ComboBoxComponent_Conditional_6_Template, 1, 0, "span", 10);
        i0.ɵɵconditionalCreate(7, ComboBoxComponent_Conditional_7_Template, 1, 0, "kendo-separator");
        i0.ɵɵconditionalCreate(8, ComboBoxComponent_Conditional_8_Template, 2, 1, "span", 11);
        i0.ɵɵelementStart(9, "button", 12, 0);
        i0.ɵɵlistener("keydown.enter", function ComboBoxComponent_Template_button_keydown_enter_9_listener($event) {
          return $event.stopImmediatePropagation();
        });
        i0.ɵɵelement(11, "kendo-icon-wrapper", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerEnd();
        i0.ɵɵtemplate(12, ComboBoxComponent_ng_template_12_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵconditionalCreate(14, ComboBoxComponent_Conditional_14_Template, 1, 0, "kendo-resize-sensor");
        i0.ɵɵelementContainer(15, null, 2);
        i0.ɵɵelementStart(17, "kendo-adaptive-renderer", 14);
        i0.ɵɵlistener("closePopup", function ComboBoxComponent_Template_kendo_adaptive_renderer_closePopup_17_listener() {
          return ctx.closeActionSheet();
        })("textInputChange", function ComboBoxComponent_Template_kendo_adaptive_renderer_textInputChange_17_listener($event) {
          return ctx.searchBarChange($event);
        })("navigate", function ComboBoxComponent_Template_kendo_adaptive_renderer_navigate_17_listener($event) {
          return ctx.handleNavigate($event);
        });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(18, ComboBoxComponent_ng_template_18_Template, 5, 17, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const sharedPopupActionSheetTemplate_r4 = i0.ɵɵreference(19);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hostElement", ctx.hostElement);
        i0.ɵɵtwoWayProperty("isFocused", ctx.isFocused);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.prefixTemplate ? 2 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.prefixTemplate && ctx.prefixTemplate.showSeparator ? 3 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ariaExpanded", ctx.isOpen)("ariaControls", ctx.ariaControls)("id", ctx.focusableId)("isLoading", ctx.loading)("isSuggestable", ctx.suggest)("isFilterable", ctx.filterable)("activeDescendant", ctx.activeDescendant)("userInput", ctx.text)("suggestedText", ctx.getSuggestion())("disabled", ctx.disabled)("readonly", ctx.readonly || ctx.isAdaptive)("tabIndex", ctx.tabIndex)("isRequired", ctx.isControlRequired)("placeholder", ctx.placeholder)("inputAttributes", ctx.inputAttributes);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.clearButton && !ctx.loading && !ctx.disabled && !ctx.readonly && (ctx.text == null ? null : ctx.text.length) ? 5 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.loading ? 6 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.suffixTemplate && ctx.suffixTemplate.showSeparator ? 7 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.suffixTemplate ? 8 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", ctx.selectButtonClasses)("kendoEventsOutsideAngular", i0.ɵɵpureFunction1(36, _c17, ctx.preventEventDefault));
        i0.ɵɵattribute("aria-label", ctx.messageFor("selectButtonText"))("disabled", ctx.disabled ? "" : null);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("name", ctx.icon || "chevron-down")("svgIcon", ctx.svgIcon || ctx.chevronDownIcon);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.isOpen || ctx.isAdaptiveModeEnabled ? 14 : -1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("sharedPopupActionSheetTemplate", sharedPopupActionSheetTemplate_r4)("title", ctx.adaptiveTitle)("showTextInput", true)("subtitle", ctx.adaptiveSubtitle)("placeholder", ctx.placeholder)("searchBarValue", ctx.text);
      }
    },
    dependencies: [LocalizedMessagesDirective, SharedDropDownEventsDirective, NgTemplateOutlet, SeparatorComponent, SearchBarComponent, EventsOutsideAngularDirective, IconWrapperComponent, NgClass, ResizeSensorComponent, AdaptiveRendererComponent, TemplateContextDirective, ListComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComboBoxComponent, [{
    type: Component,
    args: [{
      exportAs: 'kendoComboBox',
      providers: [COMBOBOX_VALUE_ACCESSOR, DataService, SelectionService, NavigationService, DisabledItemsService, LocalizationService, {
        provide: L10N_PREFIX,
        useValue: 'kendo.combobox'
      }, {
        provide: FilterableComponent,
        useExisting: forwardRef(() => ComboBoxComponent)
      }, {
        provide: KendoInput,
        useExisting: forwardRef(() => ComboBoxComponent)
      }, {
        provide: MultiTabStop,
        useExisting: forwardRef(() => ComboBoxComponent)
      }, {
        provide: KENDO_WEBMCP_HOST,
        useExisting: forwardRef(() => ComboBoxComponent)
      }],
      selector: 'kendo-combobox',
      template: `
        <ng-container kendoComboBoxLocalizedMessages
          i18n-noDataText="kendo.combobox.noDataText|The text displayed in the popup when there are no items"
          noDataText="NO DATA FOUND"

          i18n-clearTitle="kendo.combobox.clearTitle|The title of the clear button"
          clearTitle="clear"

          i18n-selectButtonText="kendo.combobox.selectButtonText|The text set as aria-label on the select button"
          selectButtonText="Select"

          i18n-popupLabel="kendo.combobox.popupLabel|The label of the popup element that contains the list of options when its role is 'region'"
          popupLabel="Options list"

          i18n-adaptiveCloseButtonTitle="kendo.combobox.adaptiveCloseButtonTitle|The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode"
          adaptiveCloseButtonTitle="Close"
          >
        </ng-container>

        <ng-container
          kendoDropDownSharedEvents
          [hostElement]="hostElement"
          [(isFocused)]="isFocused"
          (handleBlur)="handleBlur()"
          (onFocus)="handleFocus()"
          >
          @if (prefixTemplate) {
            <span class="k-input-prefix k-input-prefix-horizontal">
              <ng-template [ngTemplateOutlet]="prefixTemplate?.templateRef">
              </ng-template>
            </span>
          }
          @if (prefixTemplate && prefixTemplate.showSeparator) {
            <kendo-separator></kendo-separator>
          }
          <input
            kendoSearchbar
            [ariaExpanded]="isOpen"
            [ariaControls]="ariaControls"
            [id]="focusableId"
            [isLoading]="loading"
            [isSuggestable]="suggest"
            [isFilterable]="filterable"
            [activeDescendant]="activeDescendant"
            [userInput]="text"
            [suggestedText]="getSuggestion()"
            [disabled]="disabled"
            [readonly]="readonly || isAdaptive"
            [tabIndex]="tabIndex"
            [isRequired]="isControlRequired"
            [placeholder]="placeholder"
            [inputAttributes]="inputAttributes"
            (onNavigate)="handleNavigate($event)"
            (valueChange)="searchBarChange($event)"
            (onBlur)="handleInputBlur()"
            (onFocus)="handleInputFocus()"
            (click)="handleClick()"
            />
          @if (clearButton && !loading && !disabled && !readonly && text?.length) {
            <span
              class="k-clear-value"
              [style.visibility]="clearButtonVisibility"
              aria-hidden="true"
              [attr.title]="messageFor('clearTitle')"
              (click)="clearValue($event)"
                [kendoEventsOutsideAngular]="{
                    mousedown: preventEventDefault
                }"
              >
              <kendo-icon-wrapper
                name="x"
                [svgIcon]="xIcon"
                >
              </kendo-icon-wrapper>
            </span>
          }
          @if (loading) {
            <span class="k-i-loading k-input-loading-icon k-icon"></span>
          }
          @if (suffixTemplate && suffixTemplate.showSeparator) {
            <kendo-separator></kendo-separator>
          }
          @if (suffixTemplate) {
            <span class="k-input-suffix k-input-suffix-horizontal">
              <ng-template [ngTemplateOutlet]="suffixTemplate?.templateRef">
              </ng-template>
            </span>
          }
          <button
            #select
            tabindex="-1"
            unselectable="on"
            type="button"
            class="k-input-button k-button k-icon-button"
            [ngClass]="selectButtonClasses"
            [attr.aria-label]="messageFor('selectButtonText')"
            [attr.disabled]="disabled ? '' : null"
            (keydown.enter)="$event.stopImmediatePropagation();"
                [kendoEventsOutsideAngular]="{
                    mousedown: preventEventDefault
                }"
            >
            <kendo-icon-wrapper
              [name]="icon || 'chevron-down'"
              innerCssClass="k-button-icon"
              [svgIcon]="svgIcon || chevronDownIcon"
              >
            </kendo-icon-wrapper>
          </button>
        </ng-container>

        <ng-template #popupTemplate>
          <ng-container *ngTemplateOutlet="sharedPopupActionSheetTemplate"></ng-container>
        </ng-template>
        @if (isOpen || isAdaptiveModeEnabled) {
          <kendo-resize-sensor (resize)="onResize()"></kendo-resize-sensor>
        }
        <ng-container #container></ng-container>

        <kendo-adaptive-renderer
          [sharedPopupActionSheetTemplate]="sharedPopupActionSheetTemplate"
          [title]="adaptiveTitle"
          [showTextInput]="true"
          [subtitle]="adaptiveSubtitle"
          (closePopup)="closeActionSheet()"
          (textInputChange)="searchBarChange($event)"
          (navigate)="handleNavigate($event)"
          [placeholder]="placeholder"
          [searchBarValue]="text"
          >
        </kendo-adaptive-renderer>
        <ng-template #sharedPopupActionSheetTemplate>
          <!--header template-->
          @if (headerTemplate) {
            <ng-template
                [templateContext]="{
                    templateRef: headerTemplate.templateRef
                }">
            </ng-template>
          }
          <!--list-->
          <kendo-list
            #optionsList
            [size]="isAdaptive ? 'large' : size"
            [rounded]="rounded"
            [id]="listBoxId"
            [optionPrefix]="optionPrefix"
            [data]="data"
            [textField]="textField"
            [valueField]="valueField"
            [template]="template"
            [groupTemplate]="groupTemplate"
            [fixedGroupTemplate]="fixedGroupTemplate"
            [height]="listHeight"
            [show]="isOpen"
            [virtual]="virtual"
            [showStickyHeader]="showStickyHeader"
            (pageChange)="pageChange($event)"
            >
          </kendo-list>
          <!--no-data template-->
          @if (data.length === 0) {
            <div class="k-no-data" [attr.aria-live]="'polite'">
              @if (noDataTemplate) {
                <ng-template
                    [templateContext]="{
                        templateRef: noDataTemplate ? noDataTemplate.templateRef : undefined
                    }">
                </ng-template>
              }
              @if (!noDataTemplate) {
                <div>{{ messageFor('noDataText') }}</div>
              }
            </div>
          }
          <!--footer template-->
          @if (footerTemplate) {
            <ng-template
                [templateContext]="{
                    templateRef: footerTemplate.templateRef
                }">
            </ng-template>
          }
        </ng-template>
        `,
      standalone: true,
      imports: [LocalizedMessagesDirective, SharedDropDownEventsDirective, NgTemplateOutlet, SeparatorComponent, SearchBarComponent, EventsOutsideAngularDirective, IconWrapperComponent, NgClass, ResizeSensorComponent, AdaptiveRendererComponent, TemplateContextDirective, ListComponent]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i1.LocalizationService
  }, {
    type: i2.PopupService
  }, {
    type: SelectionService
  }, {
    type: NavigationService
  }, {
    type: DisabledItemsService
  }, {
    type: DataService
  }, {
    type: i0.NgZone
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i0.Renderer2
  }, {
    type: i0.Injector
  }, {
    type: i0.ElementRef
  }, {
    type: i7.AdaptiveService
  }], {
    icon: [{
      type: Input
    }],
    svgIcon: [{
      type: Input
    }],
    inputAttributes: [{
      type: Input
    }],
    adaptiveRendererComponent: [{
      type: ViewChild,
      args: [AdaptiveRendererComponent]
    }],
    showStickyHeader: [{
      type: Input
    }],
    focusableId: [{
      type: Input
    }],
    allowCustom: [{
      type: Input
    }],
    data: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    textField: [{
      type: Input
    }],
    valueField: [{
      type: Input
    }],
    valuePrimitive: [{
      type: Input
    }],
    valueNormalizer: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    adaptiveMode: [{
      type: Input
    }],
    adaptiveTitle: [{
      type: Input
    }],
    adaptiveSubtitle: [{
      type: Input
    }],
    popupSettings: [{
      type: Input
    }],
    listHeight: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    suggest: [{
      type: Input
    }],
    clearButton: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    itemDisabled: [{
      type: Input
    }],
    readonly: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['class.k-readonly']
    }],
    tabindex: [{
      type: Input
    }],
    tabIndex: [{
      type: Input,
      args: ["tabIndex"]
    }],
    filterable: [{
      type: Input
    }],
    virtual: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    rounded: [{
      type: Input
    }],
    fillMode: [{
      type: Input
    }],
    valueChange: [{
      type: Output
    }],
    selectionChange: [{
      type: Output
    }],
    filterChange: [{
      type: Output
    }],
    open: [{
      type: Output
    }],
    opened: [{
      type: Output
    }],
    close: [{
      type: Output
    }],
    closed: [{
      type: Output
    }],
    onFocus: [{
      type: Output,
      args: ['focus']
    }],
    onBlur: [{
      type: Output,
      args: ['blur']
    }],
    inputFocus: [{
      type: Output
    }],
    inputBlur: [{
      type: Output
    }],
    escape: [{
      type: Output
    }],
    template: [{
      type: ContentChild,
      args: [ItemTemplateDirective, {
        static: false
      }]
    }],
    headerTemplate: [{
      type: ContentChild,
      args: [HeaderTemplateDirective, {
        static: false
      }]
    }],
    footerTemplate: [{
      type: ContentChild,
      args: [FooterTemplateDirective, {
        static: false
      }]
    }],
    noDataTemplate: [{
      type: ContentChild,
      args: [NoDataTemplateDirective, {
        static: false
      }]
    }],
    groupTemplate: [{
      type: ContentChild,
      args: [GroupTemplateDirective, {
        static: false
      }]
    }],
    fixedGroupTemplate: [{
      type: ContentChild,
      args: [FixedGroupTemplateDirective, {
        static: false
      }]
    }],
    suffixTemplate: [{
      type: ContentChild,
      args: [SuffixTemplateDirective]
    }],
    prefixTemplate: [{
      type: ContentChild,
      args: [PrefixTemplateDirective]
    }],
    container: [{
      type: ViewChild,
      args: ['container', {
        read: ViewContainerRef,
        static: true
      }]
    }],
    popupTemplate: [{
      type: ViewChild,
      args: ['popupTemplate', {
        static: true
      }]
    }],
    searchbar: [{
      type: ViewChild,
      args: [SearchBarComponent, {
        static: true
      }]
    }],
    optionsList: [{
      type: ViewChild,
      args: ['optionsList', {
        static: false
      }]
    }],
    select: [{
      type: ViewChild,
      args: ['select', {
        static: true
      }]
    }],
    widgetClasses: [{
      type: HostBinding,
      args: ['class.k-combobox']
    }, {
      type: HostBinding,
      args: ['class.k-input']
    }],
    isDisabled: [{
      type: HostBinding,
      args: ['class.k-disabled']
    }],
    isLoading: [{
      type: HostBinding,
      args: ['class.k-loading']
    }],
    dir: [{
      type: HostBinding,
      args: ['attr.dir']
    }]
  });
})();

/**
 * Renders the selected value of the dropdown. To define the header template, nest an `<ng-template>` tag
 * with the `kendo<ComponentName>ValueTemplate` directive inside the component tag.
 *
 * The template context is set to the current component.
 * To get a reference to the current data item, use the `let-dataItem` directive.
 *
 * > The `ValueTemplate` directive can only be used with the DropDownList and DropDownTree components.
 *
 * - [Using `ValueTemplate` with the DropDownList](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/templates#value-template)
 * - [Using `ValueTemplate` with the DropDownTree](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdowntree/templates#value-template)
 *
 * @example
 * ```ts
 * _@Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-dropdownlist [data]="listItems">
 *    <ng-template kendoDropDownListValueTemplate let-dataItem>
 *      <span>{{dataItem}} option</span>
 *    </ng-template>
 *  </kendo-dropdownlist>
 * `
 * })
 * class AppComponent {
 *   public listItems: Array<string> = ["Item 1", "Item 2", "Item 3", "Item 4"];
 * }
 * ```
 */
class ValueTemplateDirective {
  templateRef;
  constructor(templateRef) {
    this.templateRef = templateRef;
  }
  static ɵfac = function ValueTemplateDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ValueTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ValueTemplateDirective,
    selectors: [["", "kendoDropDownListValueTemplate", ""], ["", "kendoDropDownTreeValueTemplate", ""]]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValueTemplateDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoDropDownListValueTemplate],[kendoDropDownTreeValueTemplate]',
      standalone: true
    }]
  }], () => [{
    type: i0.TemplateRef
  }], null);
})();

/**
 * @hidden
 */
class FilterInputDirective {
  element;
  zone;
  focused;
  constructor(element, zone) {
    this.element = element;
    this.zone = zone;
  }
  ngOnChanges() {
    if (this.focused) {
      this.nextTick(() => this.element.nativeElement.focus());
    }
  }
  nextTick(fn) {
    this.zone.runOutsideAngular(() => setTimeout(fn));
  }
  static ɵfac = function FilterInputDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FilterInputDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FilterInputDirective,
    selectors: [["", "filterInput", ""]],
    inputs: {
      focused: [0, "filterInput", "focused"]
    },
    features: [i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterInputDirective, [{
    type: Directive,
    args: [{
      selector: '[filterInput]',
      standalone: true
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.NgZone
  }], {
    focused: [{
      type: Input,
      args: ['filterInput']
    }]
  });
})();

/**
 * @hidden
 */
const DROPDOWNLIST_VALUE_ACCESSOR = {
  multi: true,
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DropDownListComponent)
};
/**
 * Represents the Kendo UI for Angular [DropDownList](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist) component.
 *
 * @example
 * ```html
 * <kendo-dropdownlist [data]="["Item 1", "Item 2", "Item 3"]"></kendo-dropdownlist>
 * ```
 * @remarks
 * Supported children components are: {@link CustomMessagesComponent}.
 */
class DropDownListComponent {
  wrapper;
  localization;
  popupService;
  selectionService;
  navigationService;
  disabledItemsService;
  dataService;
  _zone;
  renderer;
  cdr;
  injector;
  adaptiveService;
  /**
   * @hidden
   */
  touchEnabled = touchEnabled;
  /**
   * @hidden
   */
  animationDuration = animationDuration;
  /**
   * @hidden
   */
  xIcon = xIcon;
  /**
   * @hidden
   */
  searchIcon = searchIcon;
  /**
   * @hidden
   */
  chevronDownSVGIcon = chevronDownIcon;
  /**
   * @hidden
   */
  customIconClass;
  /**
   * @hidden
   */
  adaptiveRenderer;
  /**
   * @hidden
   */
  searchInput;
  /**
   * @hidden
   */
  get actionSheet() {
    return this.adaptiveRenderer?.actionSheet;
  }
  /**
   * @hidden
   */
  get actionSheetSearchBar() {
    return this.adaptiveRenderer?.actionSheetSearchBar;
  }
  get width() {
    const wrapperWidth = isDocumentAvailable() ? this.wrapper.nativeElement.offsetWidth : 0;
    const width = this.popupSettings.width || wrapperWidth;
    const minWidth = isNaN(wrapperWidth) ? wrapperWidth : `${wrapperWidth}px`;
    const maxWidth = isNaN(width) ? width : `${width}px`;
    return {
      min: minWidth,
      max: maxWidth
    };
  }
  get height() {
    const popupHeight = this.popupSettings.height;
    return isPresent(popupHeight) ? `${popupHeight}px` : 'auto';
  }
  get widgetTabIndex() {
    if (this.disabled) {
      return undefined;
    }
    const providedTabIndex = Number(this.tabIndex);
    const defaultTabIndex = 0;
    return !isNaN(providedTabIndex) ? providedTabIndex : defaultTabIndex;
  }
  get ariaActivedescendant() {
    if (!isPresent(this.dataItem) || !this.isOpen) {
      return;
    }
    return this.optionPrefix + "-" + this.selectionService.focused;
  }
  get appendTo() {
    const {
      appendTo
    } = this.popupSettings;
    if (!appendTo || appendTo === 'root') {
      return undefined;
    }
    return appendTo === 'component' ? this.container : appendTo;
  }
  /**
   * @hidden
   */
  onFilterChange(text) {
    if (this.filterable) {
      this.filterChange.emit(text);
    }
  }
  /**
   * @hidden
   */
  get ariaLive() {
    return this.filterable ? 'polite' : 'off';
  }
  /**
   * Shows or hides the current group sticky header when using grouped data.
   * The sticky header displays by default. [see example.](https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/grouping#sticky-header)
   */
  showStickyHeader = true;
  /**
   * @hidden
   */
  icon;
  /**
   * @hidden
   */
  svgIcon;
  /**
   * Sets and gets the loading state of the `DropDownListComponent`.
   */
  loading;
  /**
   * Sets the data of the `DropDownListComponent`.
   *
   * The data must be an array-like list.
   */
  set data(data) {
    this.dataService.data = data || [];
    if (this.virtual) {
      this.virtual.skip = 0;
    }
    this.setState();
  }
  get data() {
    const virtual = this.virtual;
    if (virtual) {
      const start = virtual.skip || 0;
      const end = start + virtual.pageSize;
      // Use length instead of itemsCount because of the grouping.
      virtual.total = this.dataService.data.length;
      return this.dataService.data.slice(start, end);
    }
    return this.dataService.data;
  }
  /**
   * Sets the value of the `DropDownListComponent`.
   * The value can be a primitive (string, number) or a complex object.
   * Use the `valuePrimitive` option to define the type.
   *
   * All selected values not present in the source are ignored.
   */
  set value(newValue) {
    if (!isPresent(newValue)) {
      this._previousDataItem = undefined;
    }
    this._value = newValue;
    this.setState();
    this.cdr.markForCheck();
  }
  get value() {
    return this._value;
  }
  /**
   * Sets the data item field that represents the item text.
   * If the data contains only primitive values, do not define this property.
   *
   * The `textField` property can point to a nested property value, for example, `category.name`.
   */
  textField;
  /**
   * Sets the data item field that represents the item value.
   * If the data contains only primitive values, do not define this property.
   *
   * The `valueField` property can point to a nested property value, for example, `category.id`.
   */
  valueField;
  /**
   * Enables or disables the adaptive mode. The adaptive rendering is disabled by default.
   */
  adaptiveMode = 'none';
  /**
   * Sets the title of the ActionSheet rendered instead of the Popup on small screens.
   * By default, the ActionSheet title uses the label text of the `DropDownListComponent`.
   */
  adaptiveTitle = '';
  /**
   * Sets the subtitle of the ActionSheet rendered instead of the Popup on small screens.
   * By default, the ActionSheet does not render a subtitle.
   */
  adaptiveSubtitle = '';
  /**
   * @hidden
   */
  get isAdaptiveModeEnabled() {
    return this.adaptiveMode === 'auto';
  }
  /**
  * @hidden
  */
  windowSize = 'large';
  /**
   * @hidden
   */
  get isActionSheetExpanded() {
    return this.actionSheet?.expanded;
  }
  /**
   * @hidden
   */
  get isAdaptive() {
    return this.isAdaptiveModeEnabled && this.windowSize !== 'large';
  }
  /**
   * Configures the popup of the `DropDownListComponent`.
   *
   * The available options are:
   * - `animate: Boolean`&mdash;Controls the popup animation. The open and close animations are enabled by default.
   * - `width: Number | String`&mdash;Sets the width of the popup container. By default, the width of the host element is used. If set to `auto`, the component automatically adjusts the width of the popup and no item labels are wrapped. The `auto` mode is not supported when virtual scrolling is enabled.
   * - `height: Number`&mdash;Sets the height of the popup container.
   * - `popupClass: String`&mdash;Specifies a list of CSS classes used to style the popup.
   * - `appendTo: "root" | "component" | ViewContainerRef`&mdash;Specifies the component to which the popup will be appended.
   */
  set popupSettings(settings) {
    this._popupSettings = Object.assign({
      animate: true
    }, settings);
  }
  get popupSettings() {
    return this._popupSettings;
  }
  /**
   * Sets the height of the options list in the popup.
   *
   * The `listHeight` property affects only the list of options, not the whole popup container.
   * To set the height of the popup container, use `popupSettings.height`.
   *
   * When using `adaptiveMode` and the screen size is `small` or `medium`, the `listHeight` property is set to null.
   *
   * @default 200
   */
  set listHeight(_listHeight) {
    this._listHeight = _listHeight;
  }
  get listHeight() {
    if (this.isAdaptive) {
      return;
    }
    return this._listHeight;
  }
  _listHeight = 200;
  /**
   * Sets the text of the default empty item. The value type must match the data type.
   */
  defaultItem;
  /**
   * Sets the disabled state of the component. To disable the component in reactive forms, see [Forms Support](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/forms#managing-the-dropdownlist-disabled-state-in-reactive-forms).
   */
  disabled;
  /**
   * Defines a Boolean function executed for each data item in the component. Determines whether the item is disabled. [See examples.](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/disabled-items)
   */
  set itemDisabled(fn) {
    if (typeof fn !== 'function') {
      throw new Error(`itemDisabled must be a function, but received ${JSON.stringify(fn)}.`);
    }
    this.disabledItemsService.itemDisabled = fn;
  }
  /**
   * Sets the read-only state of the component.
   *
   * @default false
   */
  readonly = false;
  /**
   * Enables the [filtering](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/filtering) functionality of the `DropDownListComponent`.
   */
  filterable = false;
  /**
   * Enables the [virtualization](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/virtualization) functionality.
   */
  set virtual(settings) {
    this._virtualSettings = normalizeVirtualizationSettings(settings);
  }
  get virtual() {
    return this._virtualSettings;
  }
  /**
   * Enables a case-insensitive search. Use this option when filtration is disabled.
   */
  ignoreCase = true;
  /**
   * Sets the delay before an item search is performed. Use this option when filtration is disabled.
   */
  delay = 500;
  /**
   * Specifies the type of the selected value. If set to `true`, the selected value must be a primitive value.
   * * [More information and example.](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/value-binding#primitive-values-from-object-fields)
   */
  set valuePrimitive(isPrimitive) {
    this._valuePrimitive = isPrimitive;
  }
  get valuePrimitive() {
    if (!isPresent(this._valuePrimitive)) {
      return !isPresent(this.valueField);
    }
    return this._valuePrimitive;
  }
  /**
   * Specifies the [`tabindex`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex) of the component.
   *
   * @default 0
   */
  tabindex = 0;
  /**
   * @hidden
   */
  set tabIndex(tabIndex) {
    this.tabindex = tabIndex;
  }
  get tabIndex() {
    return this.tabindex;
  }
  /**
   * Sets the size of the component. The default value is set by the Kendo theme.
   */
  set size(size) {
    this.renderer.removeClass(this.wrapper.nativeElement, getSizeClass('picker', this.size));
    if (size) {
      this.renderer.addClass(this.wrapper.nativeElement, getSizeClass('picker', size));
    }
    this._size = size;
  }
  get size() {
    return this._size;
  }
  /**
   * Sets the border radius of the component. The default value is set by the Kendo theme.
   */
  set rounded(rounded) {
    this.renderer.removeClass(this.wrapper.nativeElement, getRoundedClass(this.rounded));
    if (rounded) {
      this.renderer.addClass(this.wrapper.nativeElement, getRoundedClass(rounded));
    }
    this._rounded = rounded;
  }
  get rounded() {
    return this._rounded;
  }
  /**
   * Sets the fillMode of the component. The default value is set by the Kendo theme.
   */
  set fillMode(fillMode) {
    this.renderer.removeClass(this.wrapper.nativeElement, getFillModeClass('picker', this.fillMode));
    if (fillMode) {
      this.renderer.addClass(this.wrapper.nativeElement, getFillModeClass('picker', fillMode));
    }
    this._fillMode = fillMode;
  }
  get fillMode() {
    return this._fillMode;
  }
  /**
   * Toggles the left and right arrow keys navigation functionality.
   * @hidden
   */
  leftRightArrowsNavigation = true;
  /**
   * Fires each time the value changes. [See example.](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/events).
   */
  valueChange = new EventEmitter();
  /**
   ** Fires each time the user types in the input field. You can filter the source based on the filtration value. When the value is programmatically changed, the `valueChange` event is not triggered. [See example.](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/events).
   */
  filterChange = new EventEmitter();
  /**
   * Fires each time the item selection changes. [see example.](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/events).
   */
  selectionChange = new EventEmitter();
  /**
   * Fires each time the popup is about to open. This event is preventable. If you cancel it, the popup remains closed. [see example.](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/open-state#preventing-opening-and-closing)
   */
  open = new EventEmitter();
  /**
   * Fires after the popup has been opened.
   */
  opened = new EventEmitter();
  /**
   * Fires each time the popup is about to close. This event is preventable. If you cancel it, the popup remains open. [see example.](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdownlist/open-state#preventing-opening-and-closing)
   */
  close = new EventEmitter();
  /**
   * Fires after the popup has been closed.
   */
  closed = new EventEmitter();
  /**
   * Fires each time the user focuses the `DropDownListComponent`.
   */
  onFocus = new EventEmitter();
  /**
   * Fires each time the `DropDownListComponent` gets blurred.
   */
  onBlur = new EventEmitter();
  itemTemplate;
  groupTemplate;
  fixedGroupTemplate;
  valueTemplate;
  headerTemplate;
  footerTemplate;
  noDataTemplate;
  container;
  popupTemplate;
  optionsList;
  /**
   * @hidden
   */
  blurComponent(event) {
    if (event.target !== this.wrapper.nativeElement) {
      return;
    }
    event.stopImmediatePropagation();
    this.hostElementBlurred.emit();
  }
  /**
   * @hidden
   */
  blurFilterInput() {
    this.filterBlurred.emit();
  }
  /**
   * @hidden
   */
  focusComponent(event) {
    if (event.target !== this.wrapper.nativeElement) {
      return;
    }
    event.stopImmediatePropagation();
    this.hostElementFocused.emit();
    if (!this.isFocused) {
      this.isFocused = true;
      if (hasObservers(this.onFocus)) {
        this._zone.run(() => {
          this.onFocus.emit();
        });
      }
    }
  }
  /**
   * @hidden
   */
  onResize() {
    const currentWindowSize = this.adaptiveService.size;
    if (this.isAdaptiveModeEnabled && this.windowSize !== currentWindowSize) {
      if (this.isOpen) {
        this.togglePopup(false);
      }
      this.windowSize = currentWindowSize;
    }
    if (this.isOpen && !this.isActionSheetExpanded) {
      const popupWrapper = this.popupRef.popupElement;
      const {
        min,
        max
      } = this.width;
      popupWrapper.style.minWidth = min;
      popupWrapper.style.width = max;
    }
  }
  hostClasses = true;
  get isDisabledClass() {
    return this.disabled || null;
  }
  get isLoading() {
    return this.loading;
  }
  /**
   * @hidden
   */
  focusableId = `k-${guid()}`;
  get dir() {
    return this.direction;
  }
  get hostTabIndex() {
    return this.widgetTabIndex;
  }
  get readonlyClass() {
    return this.readonly;
  }
  get readonlyAttr() {
    return this.readonly ? '' : null;
  }
  get isBusy() {
    return this.isLoading;
  }
  role = 'combobox';
  haspopup = 'listbox';
  get hostAriaInvalid() {
    return this.formControl?.invalid ? true : null;
  }
  /**
   * @hidden
   */
  keydown(event, input) {
    if (input) {
      event.stopPropagation();
    }
    const firstIndex = isPresent(this.defaultItem) ? -1 : 0;
    const focused = isNaN(this.selectionService.focused) ? this.firstFocusableIndex(firstIndex) : this.selectionService.focused;
    let offset = 0;
    if (this.disabled || this.readonly) {
      return;
    }
    // on some keyboards, Home and End keys are mapped to Numpad keys
    const code = normalizeKeys(event);
    const isHomeKey = code === Keys.Home;
    const isEndKey = code === Keys.End;
    const isHomeEnd = isHomeKey || isEndKey;
    const isFilterFocused = this.filterable && this.isFocused && this.isOpen;
    if (isFilterFocused && isHomeEnd) {
      return;
    }
    const hasSelected = isPresent(this.selectionService.selected[0]);
    const focusedItemNotSelected = isPresent(this.selectionService.focused) && !this.selectionService.isSelected(this.selectionService.focused);
    if (!hasSelected || focusedItemNotSelected) {
      if (code === Keys.ArrowDown || code === Keys.ArrowRight && this.leftRightArrowsNavigation) {
        offset = -1;
      } else if (code === Keys.ArrowUp || code === Keys.ArrowLeft && this.leftRightArrowsNavigation) {
        offset = 1;
      }
    }
    const eventData = event;
    const action = this.navigationService.process({
      current: focused + offset,
      max: this.dataService.itemsCount - 1,
      min: this.defaultItem ? -1 : 0,
      originalEvent: eventData,
      openOnSpace: !this.isOpen,
      closeOnSpace: this.isOpen && !input && !(event.target instanceof HTMLInputElement)
    });
    const leftRightKeys = action === NavigationAction.Left || action === NavigationAction.Right && this.leftRightArrowsNavigation;
    if (action !== NavigationAction.Undefined && action !== NavigationAction.Tab && action !== NavigationAction.Backspace && action !== NavigationAction.Delete && action !== NavigationAction.PageDown && action !== NavigationAction.PageUp && action !== NavigationAction.SelectAll && !(leftRightKeys && this.filterable) && action !== NavigationAction.Enter //enter when popup is opened is handled before `handleEnter`
    ) {
      eventData.preventDefault();
    }
    if (action === NavigationAction.Tab && this.isActionSheetExpanded) {
      this.togglePopup(false);
    }
  }
  /**
   * @hidden
   */
  keypress(event) {
    if (this.disabled || this.readonly || this.filterable) {
      return;
    }
    this.onKeyPress(event);
  }
  /**
   * @hidden
   */
  click() {
    if (!this.isActionSheetExpanded) {
      this.focus();
      this.togglePopup(!this.isOpen);
    }
  }
  groupIndices = [];
  optionPrefix = `k-${guid()}`;
  valueLabelId;
  filterText = '';
  listBoxId = `k-${guid()}`;
  subs = new Subscription();
  _isFocused = false;
  set isFocused(isFocused) {
    this.renderer[isFocused ? 'addClass' : 'removeClass'](this.wrapper.nativeElement, 'k-focus');
    this._isFocused = isFocused;
  }
  get isFocused() {
    return this._isFocused;
  }
  direction;
  dataItem;
  popupRef;
  onTouchedCallback = _ => {};
  onChangeCallback = _ => {};
  popupMouseDownHandler;
  word = "";
  last = "";
  typingTimeout;
  filterFocused = new EventEmitter();
  filterBlurred = new EventEmitter();
  hostElementFocused = new EventEmitter();
  hostElementBlurred = new EventEmitter();
  touchstartDisposeHandler;
  _value;
  _open = false;
  _previousDataItem;
  _valuePrimitive;
  text;
  _popupSettings = {
    animate: true
  };
  _virtualSettings;
  _size = undefined;
  _rounded = undefined;
  _fillMode = undefined;
  constructor(wrapper, localization, popupService, selectionService, navigationService, disabledItemsService, dataService, _zone, renderer, cdr, injector, adaptiveService) {
    this.wrapper = wrapper;
    this.localization = localization;
    this.popupService = popupService;
    this.selectionService = selectionService;
    this.navigationService = navigationService;
    this.disabledItemsService = disabledItemsService;
    this.dataService = dataService;
    this._zone = _zone;
    this.renderer = renderer;
    this.cdr = cdr;
    this.injector = injector;
    this.adaptiveService = adaptiveService;
    validatePackage(packageMetadata);
    this.direction = localization.rtl ? 'rtl' : 'ltr';
    this.data = [];
    this.subscribeEvents();
    this.subscribeTouchEvents();
    this.subscribeFocusEvents();
    this.popupMouseDownHandler = this.onMouseDown.bind(this);
  }
  ngOnInit() {
    this.renderer.removeAttribute(this.wrapper.nativeElement, "tabindex");
    this.renderer.setAttribute(this.wrapper.nativeElement, 'aria-expanded', 'false');
    if (this.ariaActivedescendant) {
      this.renderer.setAttribute(this.wrapper.nativeElement, 'aria-activedescendant', this.ariaActivedescendant);
    }
    this.subs.add(this.localization.changes.subscribe(({
      rtl
    }) => {
      this.direction = rtl ? 'rtl' : 'ltr';
      this.cdr.detectChanges();
    }));
    this.assignAriaDescribedBy();
    this.setComponentClasses();
  }
  ngAfterViewInit() {
    this.windowSize = this.adaptiveService.size;
  }
  /**
   * @hidden
   * Used by the TextBoxContainer to determine if the component is empty.
   */
  isEmpty() {
    const value = this.value;
    return !(value === 0 || value === false || value || this.defaultItem);
  }
  /**
   * @hidden
   */
  onFilterFocus() {
    this.filterFocused.emit();
  }
  /**
   * @hidden
   */
  ngOnDestroy() {
    this.destroyPopup();
    this.subs.unsubscribe();
    this.unSubscribeFocusEvents();
    if (this.touchstartDisposeHandler) {
      this.touchstartDisposeHandler();
    }
  }
  /**
   * @hidden
   */
  ngOnChanges(changes) {
    const virtual = this.virtual;
    const requestInitialData = virtual && changes['data'] && changes['data'].isFirstChange();
    if (requestInitialData) {
      this.pageChange({
        skip: 0,
        take: virtual.pageSize
      });
    }
    if (isChanged('defaultItem', changes, false)) {
      this.disabledItemsService.defaultItem = this.defaultItem;
    }
    if (anyChanged(['textField', 'valueField', 'valuePrimitive', 'defaultItem', 'itemDisabled'], changes, false)) {
      this.setState();
    }
  }
  /**
   * @hidden
   */
  ngAfterContentChecked() {
    this.verifySettings();
  }
  /**
   * @hidden
   */
  get formControl() {
    const ngControl = this.injector.get(NgControl, null);
    return ngControl?.control || null;
  }
  /**
   * Focuses a specific item of the `DropDownListComponent` based on the provided index. If there is a default item, it is positioned at index `-1`. If `null` or an invalid index is provided, the focus is removed.
   */
  focusItemAt(index) {
    const minIndex = isPresent(this.defaultItem) ? -1 : 0;
    const isInRange = minIndex <= index && index < this.data.length;
    if (isPresent(index) && isInRange && !this.disabledItemsService.isIndexDisabled(index)) {
      this.selectionService.focus(index);
    } else {
      this.selectionService.focus(null);
    }
  }
  /**
   * Focuses the `DropDownListComponent`.
   */
  focus() {
    if (!this.disabled) {
      this.wrapper.nativeElement.focus();
    }
  }
  /**
   * Blurs the `DropDownListComponent`.
   */
  blur() {
    if (!this.disabled) {
      this.wrapper.nativeElement.blur();
      this.cdr.detectChanges();
    }
  }
  /**
   * Toggles the visibility of the Popup or ActionSheet. If you use the `toggle` method to open or close the Popup, the `open` and `close` events are not fired.
   *
   * @param open - The state of the popup.
   */
  toggle(open) {
    // The Promise is required to open the popup on load.
    // Otherwise, the "Expression has changed..." type error will be thrown.
    Promise.resolve(null).then(() => {
      const shouldOpen = isPresent(open) ? open : !this._open;
      this._toggle(shouldOpen);
    });
  }
  _toggle(open) {
    this._open = open;
    this.destroyPopup();
    if (this.isActionSheetExpanded) {
      this.closeActionSheet();
    }
    if (this._open) {
      this.createPopup();
    }
  }
  triggerPopupEvents(open) {
    const eventArgs = new PreventableEvent();
    if (open) {
      this.open.emit(eventArgs);
    } else {
      this.close.emit(eventArgs);
    }
    return eventArgs.isDefaultPrevented();
  }
  /**
   * @hidden
   */
  togglePopup(open) {
    const isDisabled = this.disabled || this.readonly;
    const sameState = this.isOpen === open;
    if (isDisabled || sameState) {
      return;
    }
    const isDefaultPrevented = this.triggerPopupEvents(open);
    if (!isDefaultPrevented) {
      if (!open && this.filterable && this.isFocused) {
        this.focus();
      }
      this._toggle(open);
    }
  }
  /**
   * Returns the current open state. Returns `true` if the popup or actionSheet is open.
   */
  get isOpen() {
    return isTruthy(this._open || this.isActionSheetExpanded);
  }
  /**
   * Resets the value of the `DropDownListComponent`. If you use the `reset` method to clear the value, the model does not update automatically and the `selectionChange` and `valueChange` events are not fired.
   */
  reset() {
    this.value = undefined;
  }
  /**
   * @hidden
   */
  messageFor(key) {
    return this.localization.get(key);
  }
  /**
   * @hidden
   */
  writeValue(value) {
    this.value = value === null ? undefined : value;
  }
  /**
   * @hidden
   */
  registerOnChange(fn) {
    this.onChangeCallback = fn;
  }
  /**
   * @hidden
   */
  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }
  /**
   * @hidden
   */
  setDisabledState(isDisabled) {
    this.cdr.markForCheck();
    this.disabled = isDisabled;
  }
  /**
   * @hidden
   */
  get selectButtonClasses() {
    return `${this.size ? getSizeClass('button', this.size) : ''} ${this.fillMode ? 'k-button-' + this.fillMode : ''}`;
  }
  /**
   * @hidden
   */
  get filterInputClasses() {
    return `${this.size ? getSizeClass('input', this.size) : ''} ${this.fillMode ? 'k-input-' + this.fillMode : ''} ${this.rounded ? getRoundedClass(this.rounded) : ''}`;
  }
  /**
   * @hidden
   */
  get listContainerClasses() {
    const containerClasses = ['k-list-container', 'k-dropdownlist-popup'];
    if (!this.popupSettings.popupClass) {
      return containerClasses;
    }
    const parsedPopupClasses = parseCSSClassNames(this.popupSettings.popupClass);
    if (parsedPopupClasses?.length) {
      containerClasses.push(...parsedPopupClasses);
    }
    return containerClasses;
  }
  /**
   * @hidden
   */
  getText() {
    return this.text;
  }
  createPopup() {
    if (this.virtual) {
      this.virtual.skip = 0;
    }
    this.windowSize = this.adaptiveService.size;
    if (this.isAdaptive) {
      this.openActionSheet();
      return;
    }
    const horizontalAlign = this.direction === "rtl" ? "right" : "left";
    const anchorPosition = {
      horizontal: horizontalAlign,
      vertical: "bottom"
    };
    const popupPosition = {
      horizontal: horizontalAlign,
      vertical: "top"
    };
    const appendToComponent = typeof this.popupSettings.appendTo === 'string' && this.popupSettings.appendTo === 'component';
    this.popupRef = this.popupService.open({
      anchor: this.wrapper,
      anchorAlign: anchorPosition,
      animate: this.popupSettings.animate,
      appendTo: this.appendTo,
      content: this.popupTemplate,
      popupAlign: popupPosition,
      popupClass: this.listContainerClasses,
      positionMode: appendToComponent ? 'fixed' : 'absolute'
    });
    this.renderer.setAttribute(this.wrapper.nativeElement, 'aria-expanded', 'true');
    this.renderer.setAttribute(this.wrapper.nativeElement, 'aria-controls', this.listBoxId);
    const popupWrapper = this.popupRef.popupElement;
    const {
      min,
      max
    } = this.width;
    popupWrapper.addEventListener('mousedown', this.popupMouseDownHandler);
    popupWrapper.style.minWidth = min;
    popupWrapper.style.width = max;
    popupWrapper.style.height = this.height;
    popupWrapper.setAttribute('dir', this.direction);
    if (!this.appendTo) {
      this.renderer.setAttribute(popupWrapper, 'role', 'region');
      this.renderer.setAttribute(popupWrapper, 'aria-label', this.messageFor('popupLabel'));
    }
    this.subs.add(this.popupRef.popupOpen.subscribe(() => {
      this.cdr.detectChanges();
      if (!this.dataService.grouped) {
        setListBoxAriaLabelledBy(this.optionsList, this.wrapper, this.renderer);
      }
      this.setAriaactivedescendant();
      this.optionsList.scrollToItem(this.selectionService.focused);
      this.selectionService.focus(this.selectionService.focused);
      this.opened.emit();
    }));
    this.subs.add(this.popupRef.popupClose.subscribe(() => {
      this.closed.emit();
    }));
    if (!this.filterable) {
      this.subs.add(this.popupRef.popupAnchorViewportLeave.subscribe(() => this.togglePopup(false)));
    }
  }
  destroyPopup() {
    if (this.popupRef) {
      this.renderer.setAttribute(this.wrapper.nativeElement, 'aria-expanded', 'false');
      this.renderer.removeAttribute(this.wrapper.nativeElement, 'aria-controls');
      this.renderer.removeAttribute(this.wrapper.nativeElement, 'aria-activedescendant');
      this.popupRef.popupElement.removeEventListener('mousedown', this.popupMouseDownHandler);
      this.popupRef.close();
      this.popupRef = null;
    }
  }
  updateState({
    dataItem,
    confirm = false
  }) {
    this.dataItem = dataItem;
    this.text = getter(dataItem, this.textField);
    if (confirm) {
      this._previousDataItem = dataItem;
    }
  }
  clearState() {
    this.text = undefined;
    this.dataItem = undefined;
  }
  resetSelection(index) {
    const clear = !isPresent(index);
    this.selectionService.resetSelection(clear ? [] : [index]);
    this.selectionService.focused = clear ? this.firstFocusableIndex(0) : index;
  }
  onSelectionChange({
    dataItem
  }) {
    this.updateState({
      dataItem
    });
    this.selectionChange.emit(dataItem);
    // reassigning the value label ID as aria-deascibedby forces firefox/nvda, forefox/jaws to read
    // the new value when the popup is closed and the value is changed with the arrow keys (up/down)
    this.assignAriaDescribedBy();
    this.setAriaactivedescendant();
  }
  subscribeEvents() {
    if (!isDocumentAvailable()) {
      return;
    }
    // Item selection when the popup is open.
    this.subs.add(this.selectionService.onSelect.pipe(filter(() => this.isOpen), map(this.itemFromEvent.bind(this))).subscribe(this.onSelectionChange.bind(this)));
    // Item selection when the popup is closed | clicked | enter, and so on.
    this.subs.add(merge(this.selectionService.onSelect.pipe(filter(() => !this.isOpen)), this.selectionService.onChange).pipe(map(this.itemFromEvent.bind(this)), tap(() => this.togglePopup(false))).subscribe(({
      dataItem,
      value: newValue,
      newSelection
    }) => {
      if (newSelection) {
        this.onSelectionChange({
          dataItem
        });
      }
      const shouldUsePrevious = !isPresent(dataItem) && this._previousDataItem;
      const shouldUseNewValue = newValue !== getter(this.value, this.valueField);
      if (shouldUsePrevious) {
        this.updateState({
          dataItem: this._previousDataItem
        });
        this.resetSelection();
      } else if (shouldUseNewValue) {
        this.value = this.valuePrimitive ? newValue : dataItem;
        this._previousDataItem = dataItem;
        this.emitChange(this.value);
      }
      this.clearFilter();
    }));
    this.subs.add(merge(this.navigationService.up, this.navigationService.down, this.navigationService.left.pipe(filter(() => this.leftRightArrowsNavigation), skipWhile(() => this.filterable)), this.navigationService.right.pipe(filter(() => this.leftRightArrowsNavigation), skipWhile(() => this.filterable)), this.navigationService.home, this.navigationService.end).pipe(filter(event => !isNaN(event.index))).subscribe(event => this.selectionService.select(event.index)));
    this.subs.add(merge(this.navigationService.pagedown, this.navigationService.pageup).subscribe(event => {
      if (this.isOpen) {
        event.originalEvent.preventDefault();
        const code = normalizeKeys(event.originalEvent);
        this.optionsList.scrollWithOnePage(NavigationAction[code]);
      }
    }));
    this.subs.add(this.navigationService.open.subscribe(() => this.togglePopup(true)));
    this.subs.add(this.navigationService.close.subscribe(() => {
      this.togglePopup(false);
      this.focus();
    }));
    this.subs.add(this.navigationService.enter.pipe(tap(event => event.originalEvent.preventDefault())).subscribe(this.handleEnter.bind(this)));
    this.subs.add(this.navigationService.esc.subscribe(this.handleEscape.bind(this)));
    this.subs.add(this.filterBlurred.pipe(concatMap(() => interval(10).pipe(take(1), takeUntil(this.hostElementFocused)))).subscribe(() => {
      this.hostElementBlurred.emit();
    }));
    this._zone.runOutsideAngular(() => {
      this.subs.add(merge(this.hostElementBlurred.pipe(concatMap(() => interval(10).pipe(take(1), takeUntil(this.filterFocused)))), this.navigationService.tab).pipe(tap(event => event instanceof NavigationEvent && this.focus()), filter(() => this.isFocused), filter(() => {
        const isBrowserSafari = isDocumentAvailable() && isSafari(navigator.userAgent);
        if (!isBrowserSafari) {
          return true;
        }
        const hasFocusedKendoButton = this.popupRef?.popupElement.querySelector('.k-button.k-focus');
        const shouldNotBlur = this.searchInput && hasFocusedKendoButton && hasObservers(this.filterChange);
        if (shouldNotBlur) {
          this.searchInput.nativeElement.focus();
          this.isFocused = true;
        }
        return !shouldNotBlur;
      })).subscribe(() => this.componentBlur()));
    });
  }
  setAriaactivedescendant() {
    if (this.ariaActivedescendant) {
      this.renderer.setAttribute(this.wrapper.nativeElement, 'aria-activedescendant', this.ariaActivedescendant);
      if (this.searchInput) {
        this.renderer.setAttribute(this.searchInput.nativeElement, 'aria-activedescendant', this.ariaActivedescendant);
      }
    }
  }
  subscribeTouchEvents() {
    if (!isDocumentAvailable() || !this.touchEnabled) {
      return;
    }
    this._zone.runOutsideAngular(() =>
    // Roll up DropDownList on iOS when tapped outside
    this.touchstartDisposeHandler = this.renderer.listen(document, 'touchstart', e => {
      const target = e.target;
      if (this.isFocused && !inDropDown(this.wrapper, target, this.popupRef)) {
        this._zone.run(() => {
          if (this.filterFocused) {
            // Close popup if filter is focused
            this.togglePopup(false);
          }
          this.blur();
        });
      }
    }));
  }
  subscribeFocusEvents() {
    if (isDocumentAvailable()) {
      this.focusComponent = this.focusComponent.bind(this);
      this.blurComponent = this.blurComponent.bind(this);
      this._zone.runOutsideAngular(() => {
        const useCapture = true;
        document.addEventListener('focus', this.focusComponent, useCapture);
        document.addEventListener('blur', this.blurComponent, useCapture);
      });
    }
  }
  unSubscribeFocusEvents() {
    if (isDocumentAvailable()) {
      const useCapture = true;
      document.removeEventListener('focus', this.focusComponent, useCapture);
      document.removeEventListener('blur', this.blurComponent, useCapture);
    }
  }
  itemFromEvent(event) {
    const index = event.indices[0];
    let dataItem = this.dataService.itemAt(index);
    dataItem = isPresent(dataItem) ? dataItem : this.currentOrDefault(index);
    const value = getter(dataItem, this.valueField);
    const newSelection = event.newSelection;
    return {
      dataItem,
      index,
      newSelection,
      value
    };
  }
  currentOrDefault(selectedIndex) {
    const defaultItemIndex = -1;
    if (isPresent(this.dataItem) && selectedIndex !== defaultItemIndex) {
      return this.dataItem;
    } else {
      return this.defaultItem;
    }
  }
  firstFocusableIndex(index) {
    const maxIndex = this.dataService.itemsCount - 1;
    if (this.disabledItemsService.isIndexDisabled(index)) {
      return index < maxIndex ? this.firstFocusableIndex(index + 1) : undefined;
    } else {
      return index;
    }
  }
  handleEnter() {
    if (this.isOpen) {
      this.selectionService.change(this.selectionService.focused);
      this.focus();
    } else {
      this.togglePopup(true);
    }
  }
  handleEscape() {
    if (isPresent(this.selectionService.selected[0])) {
      this.selectionService.change(this.selectionService.selected[0]);
    } else {
      this.togglePopup(false);
      this.clearFilter();
    }
    this.focus();
  }
  clearFilter() {
    if (!(this.filterable && this.filterText)) {
      return;
    }
    this.filterText = "";
    this.cdr.markForCheck();
    this.filterChange.emit(this.filterText);
  }
  verifySettings() {
    if (!isDevMode()) {
      return;
    }
    if (this.defaultItem && this.valueField && typeof this.defaultItem !== "object") {
      throw new Error(DropDownListMessages.defaultItem);
    }
    if (this.valuePrimitive === true && isPresent(this.value) && typeof this.value === "object") {
      throw new Error(DropDownListMessages.primitive);
    }
    if (this.valuePrimitive === false && isPresent(this.value) && typeof this.value !== "object") {
      throw new Error(DropDownListMessages.object);
    }
    const valueOrText = !isPresent(this.valueField) !== !isPresent(this.textField);
    if (valueOrText) {
      throw new Error(DropDownListMessages.textAndValue);
    }
  }
  componentBlur() {
    if (!this.isActionSheetExpanded) {
      this.isFocused = false;
      const selectionPresent = isPresent(this.selectionService.selected[0]);
      const valueHasChanged = selectionPresent && getter(this.value, this.valueField) !== getter(this.dataService.itemAt(this.selectionService.selected[0]), this.valueField);
      if (valueHasChanged || hasObservers(this.close) || hasObservers(this.onBlur) || hasObservers(this.filterChange) || isUntouched(this.wrapper.nativeElement) || this.formControl?.updateOn === 'blur') {
        this._zone.run(() => {
          if (valueHasChanged) {
            this.selectionService.change(this.selectionService.selected[0]);
          }
          this.togglePopup(false);
          this.clearFilter();
          this.onBlur.emit();
          this.onTouchedCallback();
        });
      } else {
        this.togglePopup(false);
        //this is needed for Ang 18 not to throw ng0100 error when closing the popup
        //the component could be refactored using kendoDropDownSharedEvents directive
        //once we are able to debug against Angular 18
        this.cdr.markForCheck();
      }
    }
  }
  /**
   * @hidden
   */
  onMouseDown(event) {
    const tagName = event.target.tagName.toLowerCase();
    if (tagName !== "input") {
      event.preventDefault();
    }
  }
  onKeyPress(event) {
    if (event.which === 0 || event.code === Keys.Enter || event.code === Keys.NumpadEnter || event.key.length > 1) {
      return;
    }
    let character = event.key;
    if (this.ignoreCase) {
      character = character.toLowerCase();
    }
    if (character === " ") {
      event.preventDefault();
    }
    this.word += character;
    this.last = character;
    this.search();
  }
  search() {
    clearTimeout(this.typingTimeout);
    if (!this.filterable) {
      this.typingTimeout = setTimeout(() => {
        this.word = "";
      }, this.delay);
      this.selectNext();
    }
  }
  selectNext() {
    let data = this.dataService.filter(item => isPresent(item) && !item.header && !this.disabledItemsService.isItemDisabled(item)).map(item => {
      if (this.dataService.grouped) {
        return {
          item: item.value,
          itemIndex: item.offsetIndex
        };
      }
      return {
        item: item,
        itemIndex: this.dataService.indexOf(item)
      };
    });
    const isInLoop = sameCharsOnly(this.word, this.last);
    let dataLength = data.length;
    const hasSelected = !isNaN(this.selectionService.selected[0]);
    let startIndex = !hasSelected ? 0 : this.selectionService.selected[0];
    let text, index, defaultItem;
    if (this.defaultItem && !this.disabledItemsService.isItemDisabled(this.defaultItem)) {
      defaultItem = {
        item: this.defaultItem,
        itemIndex: -1
      };
      dataLength += 1;
      startIndex += 1;
    }
    startIndex += isInLoop && hasSelected ? 1 : 0;
    data = shuffleData(data, startIndex, defaultItem);
    index = 0;
    for (; index < dataLength; index++) {
      text = getter(data[index].item, this.textField);
      const loopMatch = Boolean(isInLoop && matchText(text, this.last, this.ignoreCase));
      const nextMatch = Boolean(matchText(text, this.word, this.ignoreCase));
      if (loopMatch || nextMatch) {
        index = data[index].itemIndex;
        break;
      }
    }
    if (index !== dataLength) {
      this.navigate(index);
    }
  }
  emitChange(value) {
    this.onChangeCallback(value);
    this.valueChange.emit(value);
  }
  navigate(index) {
    this.selectionService.select(index);
  }
  findDataItem({
    valueField,
    value
  }) {
    const result = {
      dataItem: null,
      index: -1
    };
    const prop = dataItem => getter(dataItem, valueField);
    let comparer;
    if (this.dataService.grouped) {
      comparer = element => {
        return prop(element.value) === prop(value);
      };
    } else {
      comparer = element => {
        return prop(element) === prop(value);
      };
    }
    const index = this.dataService.findIndex(comparer);
    result.dataItem = this.dataService.itemAt(index);
    result.index = index;
    return result;
  }
  setState() {
    const value = this.value;
    const valueField = this.valueField;
    const textField = this.textField;
    const primitive = this.valuePrimitive;
    if (this.defaultItem) {
      const defaultValue = getter(this.defaultItem, valueField);
      const currentValue = getter(value, valueField);
      if (!isPresent(value) || currentValue === defaultValue) {
        this.updateState({
          dataItem: this.defaultItem,
          confirm: true
        });
        this.resetSelection(-1);
        if (this.filterable && this.filterText && this.dataService.itemsCount) {
          this.selectionService.focused = this.firstFocusableIndex(0);
        }
        return;
      }
    }
    const resolved = this.findDataItem({
      valueField,
      value
    });
    // The data and value are of same shape,
    // for example, value: 'foo', data: ['foo', 'bar']
    // or value: { value: 1, text: 'foo' }, data: [{ value: 1, text: 'foo' }].
    const ofSameType = !(primitive && textField);
    if (resolved.dataItem) {
      this.updateState({
        dataItem: resolved.dataItem,
        confirm: true
      });
      this.resetSelection(resolved.index);
    } else if (isPresent(value) && ofSameType) {
      this.updateState({
        dataItem: value
      });
      this.resetSelection();
    } else if (this._previousDataItem) {
      this.updateState({
        dataItem: this._previousDataItem
      });
      this.resetSelection();
    } else {
      this.clearState();
      this.resetSelection();
    }
  }
  /**
   * @hidden
   */
  handleFilter(event) {
    this.filterChange.emit(event.target.value);
  }
  /**
   * @hidden
   */
  handleClick() {
    this.windowSize = this.adaptiveService.size;
    if (this.isAdaptive) {
      this.togglePopup(true);
    }
  }
  /**
   * @hidden
   */
  pageChange(event) {
    const virtual = this.virtual;
    virtual.skip = event.skip;
  }
  assignAriaDescribedBy() {
    const currentValue = this.wrapper.nativeElement.getAttribute('aria-describedby') || '';
    const trimmed = currentValue.replace(this.valueLabelId, '').trim();
    // reset the value label ID to force readers to read the new value
    this.valueLabelId = `k-${guid()}`;
    // add to the current value - don't replace it
    const newValue = `${this.valueLabelId} ${trimmed}`.trim();
    this.renderer.setAttribute(this.wrapper.nativeElement, 'aria-describedby', newValue);
  }
  setComponentClasses() {
    if (this.size) {
      this.renderer.addClass(this.wrapper.nativeElement, getSizeClass('picker', this.size));
    }
    if (this.rounded) {
      this.renderer.addClass(this.wrapper.nativeElement, getRoundedClass(this.rounded));
    }
    if (this.fillMode) {
      this.renderer.addClass(this.wrapper.nativeElement, getFillModeClass('picker', this.fillMode));
    }
  }
  closeActionSheet() {
    this.actionSheet.toggle(false);
    this.renderer.setAttribute(this.wrapper.nativeElement, 'aria-expanded', 'false');
    this.renderer.removeAttribute(this.wrapper.nativeElement, 'aria-controls');
    if (this.filterable) {
      this.adaptiveRenderer.searchBarValue = '';
      this.filterChange.emit('');
    }
    this.closed.emit();
  }
  openActionSheet() {
    this.actionSheet.toggle(true);
    this.cdr.detectChanges();
    this.renderer.setAttribute(this.wrapper.nativeElement, 'aria-expanded', 'true');
    this.renderer.setAttribute(this.wrapper.nativeElement, 'aria-controls', this.listBoxId);
    if (!this.dataService.grouped) {
      setListBoxAriaLabelledBy(this.optionsList, this.wrapper, this.renderer);
    }
    this.setAriaactivedescendant();
    this.adaptiveTitle = setActionSheetTitle(this.wrapper, this.adaptiveTitle);
    this.cdr.detectChanges();
    // wait for the ActionSheet animation to complete to ensure the scroll calculation is accurate
    this.actionSheet.expand.pipe(take(1)).subscribe(() => {
      this.optionsList.scrollToItem(this.selectionService.focused);
    });
    this.selectionService.focus(this.selectionService.focused);
    this.opened.emit();
  }
  static ɵfac = function DropDownListComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropDownListComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.LocalizationService), i0.ɵɵdirectiveInject(i2.PopupService), i0.ɵɵdirectiveInject(SelectionService), i0.ɵɵdirectiveInject(NavigationService), i0.ɵɵdirectiveInject(DisabledItemsService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i7.AdaptiveService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DropDownListComponent,
    selectors: [["kendo-dropdownlist"]],
    contentQueries: function DropDownListComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, ItemTemplateDirective, 5)(dirIndex, GroupTemplateDirective, 5)(dirIndex, FixedGroupTemplateDirective, 5)(dirIndex, ValueTemplateDirective, 5)(dirIndex, HeaderTemplateDirective, 5)(dirIndex, FooterTemplateDirective, 5)(dirIndex, NoDataTemplateDirective, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.groupTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fixedGroupTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.valueTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.noDataTemplate = _t.first);
      }
    },
    viewQuery: function DropDownListComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(AdaptiveRendererComponent, 5)(_c18, 5)(_c12, 7, ViewContainerRef)(_c13, 7)(_c14, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.adaptiveRenderer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchInput = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popupTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.optionsList = _t.first);
      }
    },
    hostVars: 19,
    hostBindings: function DropDownListComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("keydown", function DropDownListComponent_keydown_HostBindingHandler($event) {
          return ctx.keydown($event);
        })("keypress", function DropDownListComponent_keypress_HostBindingHandler($event) {
          return ctx.keypress($event);
        })("click", function DropDownListComponent_click_HostBindingHandler() {
          return ctx.click();
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("aria-disabled", ctx.isDisabledClass)("id", ctx.focusableId)("dir", ctx.dir)("tabindex", ctx.hostTabIndex)("readonly", ctx.readonlyAttr)("aria-busy", ctx.isBusy)("role", ctx.role)("aria-haspopup", ctx.haspopup)("aria-invalid", ctx.hostAriaInvalid);
        i0.ɵɵclassProp("k-readonly", ctx.readonly)("k-dropdownlist", ctx.hostClasses)("k-picker", ctx.hostClasses)("k-disabled", ctx.isDisabledClass)("k-loading", ctx.isLoading);
      }
    },
    inputs: {
      customIconClass: "customIconClass",
      showStickyHeader: "showStickyHeader",
      icon: "icon",
      svgIcon: "svgIcon",
      loading: "loading",
      data: "data",
      value: "value",
      textField: "textField",
      valueField: "valueField",
      adaptiveMode: "adaptiveMode",
      adaptiveTitle: "adaptiveTitle",
      adaptiveSubtitle: "adaptiveSubtitle",
      popupSettings: "popupSettings",
      listHeight: "listHeight",
      defaultItem: "defaultItem",
      disabled: "disabled",
      itemDisabled: "itemDisabled",
      readonly: "readonly",
      filterable: "filterable",
      virtual: "virtual",
      ignoreCase: "ignoreCase",
      delay: "delay",
      valuePrimitive: "valuePrimitive",
      tabindex: "tabindex",
      tabIndex: "tabIndex",
      size: "size",
      rounded: "rounded",
      fillMode: "fillMode",
      leftRightArrowsNavigation: "leftRightArrowsNavigation",
      focusableId: [0, "id", "focusableId"]
    },
    outputs: {
      valueChange: "valueChange",
      filterChange: "filterChange",
      selectionChange: "selectionChange",
      open: "open",
      opened: "opened",
      close: "close",
      closed: "closed",
      onFocus: "focus",
      onBlur: "blur"
    },
    exportAs: ["kendoDropDownList"],
    features: [i0.ɵɵProvidersFeature([DROPDOWNLIST_VALUE_ACCESSOR, DataService, SelectionService, NavigationService, DisabledItemsService, LocalizationService, {
      provide: L10N_PREFIX,
      useValue: 'kendo.dropdownlist'
    }, {
      provide: FilterableComponent,
      useExisting: forwardRef(() => DropDownListComponent)
    }, {
      provide: KendoInput,
      useExisting: forwardRef(() => DropDownListComponent)
    }, {
      provide: KENDO_WEBMCP_HOST,
      useExisting: forwardRef(() => DropDownListComponent)
    }]), i0.ɵɵNgOnChangesFeature],
    decls: 16,
    vars: 19,
    consts: () => {
      let i18n_9;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text displayed in the popup when there are no items
         * @meaning kendo.dropdownlist.noDataText
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_9 = goog.getMsg("NO DATA FOUND");
        i18n_9 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_9;
      } else {
        i18n_9 = $localize`:kendo.dropdownlist.noDataText|The text displayed in the popup when there are no items:NO DATA FOUND`;
      }
      let i18n_10;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text set as aria-label on the select button
         * @meaning kendo.dropdownlist.selectButtonText
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_10 = goog.getMsg("Select");
        i18n_10 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_10;
      } else {
        i18n_10 = $localize`:kendo.dropdownlist.selectButtonText|The text set as aria-label on the select button:Select`;
      }
      let i18n_11;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text set as aria-label on the filter input
         * @meaning kendo.dropdownlist.filterInputLabel
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_11 = goog.getMsg("Filter");
        i18n_11 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_11;
      } else {
        i18n_11 = $localize`:kendo.dropdownlist.filterInputLabel|The text set as aria-label on the filter input:Filter`;
      }
      let i18n_12;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The label of the popup element that contains the list of options when its role is 'region'
         * @meaning kendo.dropdownlist.popupLabel
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_12 = goog.getMsg("Options list");
        i18n_12 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_12;
      } else {
        i18n_12 = $localize`:kendo.dropdownlist.popupLabel|The label of the popup element that contains the list of options when its role is 'region':Options list`;
      }
      let i18n_13;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode
         * @meaning kendo.dropdownlist.adaptiveCloseButtonTitle
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_13 = goog.getMsg("Close");
        i18n_13 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_13;
      } else {
        i18n_13 = $localize`:kendo.dropdownlist.adaptiveCloseButtonTitle|The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode:Close`;
      }
      return [["popupTemplate", ""], ["container", ""], ["sharedPopupActionSheetTemplate", ""], ["optionsList", ""], ["searchInput", ""], ["kendoDropDownListLocalizedMessages", "", "noDataText", i18n_9, "selectButtonText", i18n_10, "filterInputLabel", i18n_11, "popupLabel", i18n_12, "adaptiveCloseButtonTitle", i18n_13, "filterInputPlaceholder", "Filter"], ["unselectable", "on", 1, "k-input-inner", 3, "click", "id"], [1, "k-input-value-text"], [3, "templateContext"], [1, "k-i-loading", "k-input-loading-icon", "k-icon"], ["tabindex", "-1", "unselectable", "on", "type", "button", 1, "k-input-button", "k-button", "k-icon-button", 3, "ngClass", "kendoEventsOutsideAngular"], ["unselectable", "on", "innerCssClass", "k-button-icon", 3, "name", "customFontClass", "svgIcon"], [3, "closePopup", "textInputChange", "sharedPopupActionSheetTemplate", "title", "showTextInput", "subtitle", "filterable"], [4, "ngTemplateOutlet"], [3, "resize"], [1, "k-list-filter"], [3, "pageChange", "id", "size", "rounded", "optionPrefix", "data", "textField", "valueField", "template", "groupTemplate", "fixedGroupTemplate", "height", "show", "virtual", "ariaLive", "showStickyHeader", "defaultItem"], [1, "k-no-data"], [1, "k-list-filter", 3, "click"], [1, "k-searchbox", "k-input", 3, "ngClass"], ["innerCssClass", "k-input-icon", "name", "search", 1, "k-icon", 3, "svgIcon"], ["role", "searchbox", "aria-autocomplete", "list", "aria-haspopup", "listbox", "tabindex", "-1", 1, "k-input-inner", 3, "ngModelChange", "keydown", "input", "focus", "blur", "click", "filterInput", "dir", "ngModel"]];
    },
    template: function DropDownListComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementContainer(0, 5);
        i0.ɵɵelementStart(1, "span", 6);
        i0.ɵɵlistener("click", function DropDownListComponent_Template_span_click_1_listener($event) {
          return $event.preventDefault();
        });
        i0.ɵɵelementStart(2, "span", 7);
        i0.ɵɵconditionalCreate(3, DropDownListComponent_Conditional_3_Template, 1, 4, null, 8);
        i0.ɵɵconditionalCreate(4, DropDownListComponent_Conditional_4_Template, 1, 1);
        i0.ɵɵelementEnd()();
        i0.ɵɵconditionalCreate(5, DropDownListComponent_Conditional_5_Template, 1, 0, "span", 9);
        i0.ɵɵelementStart(6, "button", 10);
        i0.ɵɵelement(7, "kendo-icon-wrapper", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, DropDownListComponent_ng_template_8_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵconditionalCreate(10, DropDownListComponent_Conditional_10_Template, 1, 0, "kendo-resize-sensor");
        i0.ɵɵelementContainer(11, null, 1);
        i0.ɵɵelementStart(13, "kendo-adaptive-renderer", 12);
        i0.ɵɵlistener("closePopup", function DropDownListComponent_Template_kendo_adaptive_renderer_closePopup_13_listener() {
          return ctx.togglePopup(false);
        })("textInputChange", function DropDownListComponent_Template_kendo_adaptive_renderer_textInputChange_13_listener($event) {
          return ctx.onFilterChange($event);
        });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(14, DropDownListComponent_ng_template_14_Template, 6, 20, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const sharedPopupActionSheetTemplate_r2 = i0.ɵɵreference(15);
        i0.ɵɵadvance();
        i0.ɵɵproperty("id", ctx.valueLabelId);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.valueTemplate ? 3 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(!ctx.valueTemplate ? 4 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.loading ? 5 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", ctx.selectButtonClasses)("kendoEventsOutsideAngular", i0.ɵɵpureFunction1(17, _c17, ctx.onMouseDown));
        i0.ɵɵattribute("aria-label", ctx.messageFor("selectButtonText"))("disabled", ctx.disabled ? "" : null);
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", ctx.icon || "chevron-down")("customFontClass", ctx.customIconClass)("svgIcon", ctx.svgIcon || ctx.chevronDownSVGIcon);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.isOpen || ctx.isAdaptiveModeEnabled ? 10 : -1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("sharedPopupActionSheetTemplate", sharedPopupActionSheetTemplate_r2)("title", ctx.adaptiveTitle)("showTextInput", ctx.filterable)("subtitle", ctx.adaptiveSubtitle)("filterable", ctx.filterable);
      }
    },
    dependencies: [LocalizedMessagesDirective, TemplateContextDirective, NgClass, EventsOutsideAngularDirective, IconWrapperComponent, NgTemplateOutlet, ResizeSensorComponent, AdaptiveRendererComponent, ReactiveFormsModule, i8.DefaultValueAccessor, i8.NgControlStatus, FilterInputDirective, FormsModule, i8.NgModel, ListComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropDownListComponent, [{
    type: Component,
    args: [{
      exportAs: 'kendoDropDownList',
      providers: [DROPDOWNLIST_VALUE_ACCESSOR, DataService, SelectionService, NavigationService, DisabledItemsService, LocalizationService, {
        provide: L10N_PREFIX,
        useValue: 'kendo.dropdownlist'
      }, {
        provide: FilterableComponent,
        useExisting: forwardRef(() => DropDownListComponent)
      }, {
        provide: KendoInput,
        useExisting: forwardRef(() => DropDownListComponent)
      }, {
        provide: KENDO_WEBMCP_HOST,
        useExisting: forwardRef(() => DropDownListComponent)
      }],
      selector: 'kendo-dropdownlist',
      template: `
        <ng-container kendoDropDownListLocalizedMessages
          i18n-noDataText="kendo.dropdownlist.noDataText|The text displayed in the popup when there are no items"
          noDataText="NO DATA FOUND"

          i18n-selectButtonText="kendo.dropdownlist.selectButtonText|The text set as aria-label on the select button"
          selectButtonText="Select"

          i18n-filterInputLabel="kendo.dropdownlist.filterInputLabel|The text set as aria-label on the filter input"
          filterInputLabel="Filter"

          i18n-popupLabel="kendo.dropdownlist.popupLabel|The label of the popup element that contains the list of options when its role is 'region'"
          popupLabel="Options list"

          i18n-adaptiveCloseButtonTitle="kendo.dropdownlist.adaptiveCloseButtonTitle|The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode"
          adaptiveCloseButtonTitle="Close"

          i18n-filterPlaceholder="kendo.dropdownlist.filterPlaceholder|The text for the input's placeholder when filtering is enabled"
          filterInputPlaceholder="Filter"
          >
        </ng-container>
        <span class="k-input-inner" unselectable="on" [id]="valueLabelId" (click)="$event.preventDefault()">
          <span class="k-input-value-text">
            @if (valueTemplate) {
              <ng-template
                    [templateContext]="{
                        templateRef: valueTemplate.templateRef,
                        $implicit: dataItem
                    }">
              </ng-template>
            }
            @if (!valueTemplate) {{{ getText() }}}
          </span>
        </span>
        @if (loading) {
          <span class="k-i-loading k-input-loading-icon k-icon"></span>
        }
        <button
          tabindex="-1"
          unselectable="on"
          type="button"
          class="k-input-button k-button k-icon-button"
          [ngClass]="selectButtonClasses"
          [attr.aria-label]="messageFor('selectButtonText')"
          [attr.disabled]="disabled ? '' : null"
            [kendoEventsOutsideAngular]="{
                mousedown: onMouseDown
            }"
          >
          <kendo-icon-wrapper
            unselectable="on"
            [name]="icon || 'chevron-down'"
            innerCssClass="k-button-icon"
            [customFontClass]="customIconClass"
            [svgIcon]="svgIcon || chevronDownSVGIcon">
          </kendo-icon-wrapper>
        </button>
        <ng-template #popupTemplate>
          <ng-container *ngTemplateOutlet="sharedPopupActionSheetTemplate"></ng-container>
        </ng-template>
        @if (isOpen || isAdaptiveModeEnabled) {
          <kendo-resize-sensor (resize)="onResize()"></kendo-resize-sensor>
        }
        <ng-container #container></ng-container>

        <kendo-adaptive-renderer
          [sharedPopupActionSheetTemplate]="sharedPopupActionSheetTemplate"
          [title]="adaptiveTitle"
          [showTextInput]="filterable"
          [subtitle]="adaptiveSubtitle"
          (closePopup)="togglePopup(false)"
          (textInputChange)="onFilterChange($event)"
          [filterable]="filterable">
        </kendo-adaptive-renderer>

        <ng-template #sharedPopupActionSheetTemplate>
          <!--filterable-->
          @if (filterable && !isActionSheetExpanded) {
            <div class="k-list-filter" (click)="$event.stopImmediatePropagation()">
              <span
                class="k-searchbox k-input"
                [ngClass]="filterInputClasses">
                <kendo-icon-wrapper
                  class="k-icon"
                  innerCssClass="k-input-icon"
                  name="search"
                  [svgIcon]="searchIcon">
                </kendo-icon-wrapper>
                <input
                  #searchInput
                  role="searchbox"
                  aria-autocomplete="list"
                  aria-haspopup="listbox"
                  [attr.aria-controls]="listBoxId"
                  tabindex="-1"
                  [filterInput]="isFocused && !touchEnabled"
                  [attr.aria-label]="messageFor('filterInputLabel')"
                  [dir]="direction"
                  [(ngModel)]="filterText"
                  class="k-input-inner"
                  (keydown)="keydown($event, searchInput)"
                  (input)="handleFilter($event)"
                  (focus)="onFilterFocus()"
                  (blur)="blurFilterInput()"
                  (click)="handleClick()" />
              </span>
            </div>
          }
          <!--header template-->
          @if (headerTemplate) {
            <ng-template
                [templateContext]="{
                    templateRef: headerTemplate.templateRef
                }">
            </ng-template>
          }
          <!--list-->
          <kendo-list
            #optionsList
            [id]="listBoxId"
            [size]="isAdaptive ? 'large' : size"
            [rounded]="rounded"
            [optionPrefix]="optionPrefix"
            [data]="data"
            [textField]="textField"
            [valueField]="valueField"
            [template]="itemTemplate"
            [groupTemplate]="groupTemplate"
            [fixedGroupTemplate]="fixedGroupTemplate"
            [height]="listHeight"
            [show]="isOpen"
            [virtual]="virtual"
            [ariaLive]="ariaLive"
            [showStickyHeader]="showStickyHeader"
            (pageChange)="pageChange($event)"
            [defaultItem]="defaultItem">
          </kendo-list>
          <!--no-data template-->
          @if (data.length === 0) {
            <div class="k-no-data" [attr.aria-live]="'polite'">
              @if (noDataTemplate) {
                <ng-template
                    [templateContext]="{
                        templateRef: noDataTemplate ? noDataTemplate.templateRef : undefined
                    }">
                </ng-template>
              }
              @if (!noDataTemplate) {
                <div>{{ messageFor('noDataText') }}</div>
              }
            </div>
          }
          <!--footer template-->
          @if (footerTemplate) {
            <ng-template
                [templateContext]="{
                    templateRef: footerTemplate.templateRef
                }">
            </ng-template>
          }
        </ng-template>
        `,
      standalone: true,
      imports: [LocalizedMessagesDirective, TemplateContextDirective, NgClass, EventsOutsideAngularDirective, IconWrapperComponent, NgTemplateOutlet, ResizeSensorComponent, AdaptiveRendererComponent, ReactiveFormsModule, FilterInputDirective, FormsModule, ListComponent]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i1.LocalizationService
  }, {
    type: i2.PopupService
  }, {
    type: SelectionService
  }, {
    type: NavigationService
  }, {
    type: DisabledItemsService
  }, {
    type: DataService
  }, {
    type: i0.NgZone
  }, {
    type: i0.Renderer2
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i0.Injector
  }, {
    type: i7.AdaptiveService
  }], {
    customIconClass: [{
      type: Input
    }],
    adaptiveRenderer: [{
      type: ViewChild,
      args: [AdaptiveRendererComponent]
    }],
    searchInput: [{
      type: ViewChild,
      args: ['searchInput']
    }],
    showStickyHeader: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    svgIcon: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    data: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    textField: [{
      type: Input
    }],
    valueField: [{
      type: Input
    }],
    adaptiveMode: [{
      type: Input
    }],
    adaptiveTitle: [{
      type: Input
    }],
    adaptiveSubtitle: [{
      type: Input
    }],
    popupSettings: [{
      type: Input
    }],
    listHeight: [{
      type: Input
    }],
    defaultItem: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    itemDisabled: [{
      type: Input
    }],
    readonly: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['class.k-readonly']
    }],
    filterable: [{
      type: Input
    }],
    virtual: [{
      type: Input
    }],
    ignoreCase: [{
      type: Input
    }],
    delay: [{
      type: Input
    }],
    valuePrimitive: [{
      type: Input
    }],
    tabindex: [{
      type: Input
    }],
    tabIndex: [{
      type: Input,
      args: ["tabIndex"]
    }],
    size: [{
      type: Input
    }],
    rounded: [{
      type: Input
    }],
    fillMode: [{
      type: Input
    }],
    leftRightArrowsNavigation: [{
      type: Input
    }],
    valueChange: [{
      type: Output
    }],
    filterChange: [{
      type: Output
    }],
    selectionChange: [{
      type: Output
    }],
    open: [{
      type: Output
    }],
    opened: [{
      type: Output
    }],
    close: [{
      type: Output
    }],
    closed: [{
      type: Output
    }],
    onFocus: [{
      type: Output,
      args: ['focus']
    }],
    onBlur: [{
      type: Output,
      args: ['blur']
    }],
    itemTemplate: [{
      type: ContentChild,
      args: [ItemTemplateDirective, {
        static: false
      }]
    }],
    groupTemplate: [{
      type: ContentChild,
      args: [GroupTemplateDirective, {
        static: false
      }]
    }],
    fixedGroupTemplate: [{
      type: ContentChild,
      args: [FixedGroupTemplateDirective, {
        static: false
      }]
    }],
    valueTemplate: [{
      type: ContentChild,
      args: [ValueTemplateDirective, {
        static: false
      }]
    }],
    headerTemplate: [{
      type: ContentChild,
      args: [HeaderTemplateDirective, {
        static: false
      }]
    }],
    footerTemplate: [{
      type: ContentChild,
      args: [FooterTemplateDirective, {
        static: false
      }]
    }],
    noDataTemplate: [{
      type: ContentChild,
      args: [NoDataTemplateDirective, {
        static: false
      }]
    }],
    container: [{
      type: ViewChild,
      args: ['container', {
        read: ViewContainerRef,
        static: true
      }]
    }],
    popupTemplate: [{
      type: ViewChild,
      args: ['popupTemplate', {
        static: true
      }]
    }],
    optionsList: [{
      type: ViewChild,
      args: ['optionsList', {
        static: false
      }]
    }],
    hostClasses: [{
      type: HostBinding,
      args: ['class.k-dropdownlist']
    }, {
      type: HostBinding,
      args: ['class.k-picker']
    }],
    isDisabledClass: [{
      type: HostBinding,
      args: ['class.k-disabled']
    }, {
      type: HostBinding,
      args: ['attr.aria-disabled']
    }],
    isLoading: [{
      type: HostBinding,
      args: ['class.k-loading']
    }],
    focusableId: [{
      type: Input,
      args: ['id']
    }, {
      type: HostBinding,
      args: ['attr.id']
    }],
    dir: [{
      type: HostBinding,
      args: ['attr.dir']
    }],
    hostTabIndex: [{
      type: HostBinding,
      args: ['attr.tabindex']
    }],
    readonlyClass: [{
      type: HostBinding,
      args: ['attr.readonly']
    }],
    readonlyAttr: [{
      type: HostBinding,
      args: ['attr.readonly']
    }],
    isBusy: [{
      type: HostBinding,
      args: ['attr.aria-busy']
    }],
    role: [{
      type: HostBinding,
      args: ['attr.role']
    }],
    haspopup: [{
      type: HostBinding,
      args: ['attr.aria-haspopup']
    }],
    hostAriaInvalid: [{
      type: HostBinding,
      args: ['attr.aria-invalid']
    }],
    keydown: [{
      type: HostListener,
      args: ['keydown', ['$event']]
    }],
    keypress: [{
      type: HostListener,
      args: ['keypress', ['$event']]
    }],
    click: [{
      type: HostListener,
      args: ['click']
    }]
  });
})();

/**
 * Renders the selected tag value of the MultiSelect
 * ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/templates#tag-template)).
 * The template context is set to the current component.
 * To get a reference to the current data item, use the `let-dataItem` directive.
 *
 * > The `TagTemplate` directive can only be used with the MultiSelect and MultiSelectTree components.
 *
 * @example
 * ```ts
 * _@Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-multiselect [data]="items">
 *    <ng-template kendoMultiSelectTagTemplate let-dataItem>
 *      <span>{{dataItem}} option</span>
 *    </ng-template>
 *  </kendo-multiselect>
 * `
 * })
 * class AppComponent {
 *   public items: Array<string> = ["Item 1", "Item 2", "Item 3", "Item 4"];
 * }
 * ```
 */
class TagTemplateDirective {
  templateRef;
  constructor(templateRef) {
    this.templateRef = templateRef;
  }
  static ɵfac = function TagTemplateDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TagTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TagTemplateDirective,
    selectors: [["", "kendoMultiSelectTagTemplate", ""], ["", "kendoMultiSelectTreeTagTemplate", ""]]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TagTemplateDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoMultiSelectTagTemplate],[kendoMultiSelectTreeTagTemplate]',
      standalone: true
    }]
  }], () => [{
    type: i0.TemplateRef
  }], null);
})();

/**
 * Renders the grouped tag values in the MultiSelect
 * ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/summary-tag-mode)).
 * The template context is set to the current component.
 * To get a reference to the current grouped
 * data items collection, use the `let-dataItems` directive.
 *
 * > The `GroupTagTemplate` directive can only be used with the MultiSelect and MultiSelectTree components.
 *
 * @example
 * ```ts
 * _@Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-multiselect kendoMultiSelectSummaryTag [data]="items">
 *    <ng-template kendoMultiSelectGroupTagTemplate let-dataItems>
 *      <span>{{dataItems.length}} item(s) selected</span>
 *    </ng-template>
 *  </kendo-multiselect>
 * `
 * })
 * class AppComponent {
 *   public items: Array<string> = ["Item 1", "Item 2", "Item 3", "Item 4"];
 * }
 * ```
 */
class GroupTagTemplateDirective {
  templateRef;
  constructor(templateRef) {
    this.templateRef = templateRef;
  }
  static ɵfac = function GroupTagTemplateDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || GroupTagTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: GroupTagTemplateDirective,
    selectors: [["", "kendoMultiSelectGroupTagTemplate", ""], ["", "kendoMultiSelectTreeGroupTagTemplate", ""]]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GroupTagTemplateDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoMultiSelectGroupTagTemplate],[kendoMultiSelectTreeGroupTagTemplate]',
      standalone: true
    }]
  }], () => [{
    type: i0.TemplateRef
  }], null);
})();

/**
 * Arguments for the `removeTag` event. The `removeTag` event fires when a tag is about
 * to the removed. If you cancel the event, the removal is prevented.
 */
class RemoveTagEvent extends PreventableEvent {
  /**
   * The data item or an array of data items that will be removed.
   */
  dataItem;
  /**
   * Constructs the event arguments for the `remove` event.
   * @param dataItem - The data item or an array of data items that will be removed.
   */
  constructor(dataItem) {
    super();
    this.dataItem = dataItem;
  }
}

/**
 * @hidden
 */
const normalizeCheckboxesSettings = settings => {
  if (isObject(settings)) {
    const defaultSettings = {
      enabled: true,
      checkOnClick: true
    };
    return Object.assign({}, defaultSettings, settings);
  }
  return {
    enabled: Boolean(settings),
    checkOnClick: true
  };
};

/**
 * @hidden
 */
class TagListComponent {
  renderer;
  hostElement;
  /**
   * @hidden
   */
  xCircleIcon = xCircleIcon;
  tags;
  textField;
  valueField;
  valueDepth;
  focused;
  template;
  groupTemplate;
  disabled;
  tagPrefix;
  id;
  set size(size) {
    this.renderer.removeClass(this.hostElement.nativeElement, getSizeClass('chip-list', this.size));
    if (size) {
      this.renderer.addClass(this.hostElement.nativeElement, getSizeClass('chip-list', size));
    }
    this._size = size;
  }
  get size() {
    return this._size;
  }
  rounded;
  fillMode;
  /**
   * A collection with the disabled tags' indices.
   */
  disabledIndices = new Set();
  removeTag = new EventEmitter();
  hostClass = true;
  get hostId() {
    return this.id;
  }
  taglistRole = 'listbox';
  multiselectable = true;
  _size;
  constructor(renderer, hostElement) {
    this.renderer = renderer;
    this.hostElement = hostElement;
  }
  tagProp(tag, prop, index) {
    const propField = prop && this.getPropField(tag, prop, index);
    return getter(tag, propField);
  }
  isTagDisabled(tag, positionIndex) {
    if (this.isGroupTag(tag)) {
      /** The `positionIndex` is used to determine after how many single tags is the group tag displayed =>
       * => it is used to increment the indices inside the group tag so that we determine the actual position index
       * of each group tag item as they appear in the `value` (important to check against `disabledIndices`)
       * e.g. `disabledIndices = [0, 1]` && `tags = ['Small', ['Medium', 'Large']]` => without the incrementation with
       * `positionIndex`, the group tag would yield [0, 1] as indices, while it should yield [1, 2]
       */
      return tag.every((_tag, index) => this.disabledIndices.has(index + positionIndex));
    }
    return this.disabledIndices.has(positionIndex);
  }
  deleteTag(event, tag, index) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!this.disabled && event.which === 1) {
      this.removeTag.emit({
        tag,
        index
      });
    }
  }
  itemId(tag, index) {
    if (tag) {
      //because of custom values
      return this.tagPrefix + "-" + index;
    }
  }
  isGroupTag(tag) {
    return tag instanceof Array;
  }
  tagAriaHidden(index) {
    return isPresent(this.focused) && this.focused !== index;
  }
  getPropField(tag, prop, index) {
    // Needed for MultiSelectTree value binding (Heterogeneous Data)
    const fieldsCount = prop.length - 1;
    if (typeof prop === 'string') {
      return prop;
    } else if (this.valueDepth) {
      const depth = this.valueDepth[index];
      return fieldsCount < depth ? prop[fieldsCount] : prop[depth];
    } else {
      return prop.find(item => item in tag);
    }
  }
  static ɵfac = function TagListComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TagListComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TagListComponent,
    selectors: [["kendo-taglist"]],
    hostVars: 5,
    hostBindings: function TagListComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("id", ctx.hostId)("role", ctx.taglistRole)("aria-multiselectable", ctx.multiselectable);
        i0.ɵɵclassProp("k-chip-list", ctx.hostClass);
      }
    },
    inputs: {
      tags: "tags",
      textField: "textField",
      valueField: "valueField",
      valueDepth: "valueDepth",
      focused: "focused",
      template: "template",
      groupTemplate: "groupTemplate",
      disabled: "disabled",
      tagPrefix: "tagPrefix",
      id: "id",
      size: "size",
      rounded: "rounded",
      fillMode: "fillMode",
      disabledIndices: "disabledIndices"
    },
    outputs: {
      removeTag: "removeTag"
    },
    ngContentSelectors: _c19,
    decls: 3,
    vars: 0,
    consts: [[1, "k-chip", 3, "ngClass"], [1, "k-chip-content"], [1, "k-chip-label", "k-text-ellipsis"], [1, "k-chip-actions"], ["aria-label", "delete", 1, "k-chip-action", "k-chip-remove-action"], ["name", "x-circle", 3, "mousedown", "svgIcon"], [3, "templateContext"]],
    template: function TagListComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵrepeaterCreate(0, TagListComponent_For_1_Template, 7, 22, "div", 0, i0.ɵɵrepeaterTrackByIndex);
        i0.ɵɵprojection(2);
      }
      if (rf & 2) {
        i0.ɵɵrepeater(ctx.tags);
      }
    },
    dependencies: [NgClass, TemplateContextDirective, IconWrapperComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TagListComponent, [{
    type: Component,
    args: [{
      selector: 'kendo-taglist',
      template: `
        @for (tag of tags; track $index; let index = $index) {
          <div
            [attr.id]="itemId(tag, index)"
            [attr.aria-selected]="true"
            [attr.role]="'option'"
            class="k-chip"
            [ngClass]="{
                'k-focus': index === focused,
                'k-disabled': isTagDisabled(tag, index),
                'k-chip-sm': size === 'small',
                'k-chip-md': size === 'medium',
                'k-chip-lg': size === 'large',
                'k-rounded-sm': rounded === 'small',
                'k-rounded-md': rounded === 'medium',
                'k-rounded-lg': rounded === 'large',
                'k-rounded-full': rounded === 'full',
                'k-rounded-none': rounded === 'none',
                'k-chip-solid': fillMode === 'solid',
                'k-chip-flat': fillMode === 'flat',
                'k-chip-outline': fillMode === 'outline',
                'k-chip-base': fillMode
            }"
            >
            <span class="k-chip-content">
              @if (isGroupTag(tag)) {
                <span class="k-chip-label k-text-ellipsis">
                  @if (groupTemplate) {
                    <ng-template
                            [templateContext]="{
                            templateRef: groupTemplate.templateRef,
                            $implicit: tag
                        }">
                    </ng-template>
                  }
                  @if (!groupTemplate) {
                    {{ tag.length }} {{ tag.length === 1 ? 'item' : 'items' }} selected
                  }
                </span>
              } @else {
                <span class="k-chip-label k-text-ellipsis">
                  @if (template) {
                    <ng-template
                            [templateContext]="{
                            templateRef: template.templateRef,
                            $implicit: tag
                        }">
                    </ng-template>
                  }
                  @if (!template) {
                    {{ tagProp(tag, textField, index) }}
                  }
                </span>
              }
            </span>
            <span class="k-chip-actions">
              <span aria-label="delete" [attr.aria-hidden]="index !== focused" class="k-chip-action k-chip-remove-action">
                <kendo-icon-wrapper
                  (mousedown)="deleteTag($event, tag, index)"
                  name="x-circle"
                  [svgIcon]="xCircleIcon"
                  >
                </kendo-icon-wrapper>
              </span>
            </span>
          </div>
        }
        <ng-content></ng-content>
        `,
      standalone: true,
      imports: [NgClass, TemplateContextDirective, IconWrapperComponent]
    }]
  }], () => [{
    type: i0.Renderer2
  }, {
    type: i0.ElementRef
  }], {
    tags: [{
      type: Input
    }],
    textField: [{
      type: Input
    }],
    valueField: [{
      type: Input
    }],
    valueDepth: [{
      type: Input
    }],
    focused: [{
      type: Input
    }],
    template: [{
      type: Input
    }],
    groupTemplate: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    tagPrefix: [{
      type: Input
    }],
    id: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    rounded: [{
      type: Input
    }],
    fillMode: [{
      type: Input
    }],
    disabledIndices: [{
      type: Input
    }],
    removeTag: [{
      type: Output
    }],
    hostClass: [{
      type: HostBinding,
      args: ['class.k-chip-list']
    }],
    hostId: [{
      type: HostBinding,
      args: ['attr.id']
    }],
    taglistRole: [{
      type: HostBinding,
      args: ['attr.role']
    }],
    multiselectable: [{
      type: HostBinding,
      args: ['attr.aria-multiselectable']
    }]
  });
})();
const MULTISELECT_VALUE_ACCESSOR = {
  multi: true,
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MultiSelectComponent)
};
/**
 * Represents the [Kendo UI MultiSelect component for Angular](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect).
 *
 * Use the `MultiSelectComponent` to show a dropdown list where users can select multiple items.
 * [See example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect).
 *
 * @example
 * ```typescript
 * @Component({
 *   selector: 'my-app',
 *   template: `
 *     <kendo-multiselect
 *       [data]="listItems"
 *       textField="name"
 *       valueField="id"
 *       placeholder="Select items...">
 *     </kendo-multiselect>
 *   `
 * })
 * export class AppComponent {
 *   public listItems = [
 *     { id: 1, name: "Item 1" },
 *     { id: 2, name: "Item 2" },
 *     { id: 3, name: "Item 3" }
 *   ];
 * }
 * ```
 * @remarks
 * Supported children components are: {@link CustomMessagesComponent}.
 */
class MultiSelectComponent {
  wrapper;
  localization;
  popupService;
  dataService;
  selectionService;
  navigationService;
  disabledItemsService;
  cdr;
  differs;
  renderer;
  _zone;
  injector;
  adaptiveService;
  /**
   * @hidden
   */
  animationDuration = animationDuration;
  /**
   * @hidden
   */
  xIcon = xIcon;
  listBoxId = `k-${guid()}`;
  tagListId = `k-${guid()}`;
  tagPrefix = "tag-" + guid();
  optionPrefix = "option-" + guid();
  popupRef;
  text;
  tags;
  focusedTagIndex = undefined;
  /**
   * @hidden
   */
  adaptiveRendererComponent;
  /**
   * @hidden
   */
  get actionSheet() {
    return this.adaptiveRendererComponent?.actionSheet;
  }
  /**
   * @hidden
   */
  get actionSheetSearchBar() {
    return this.adaptiveRendererComponent?.actionSheetSearchBar;
  }
  /**
   * @hidden
   */
  get ariaControls() {
    return this.isOpen ? this.listBoxId : undefined;
  }
  /**
   * @hidden
   */
  get isControlRequired() {
    return isControlRequired(this.formControl);
  }
  /**
   * @hidden
   */
  get formControl() {
    const ngControl = this.injector.get(NgControl, null);
    return ngControl?.control || null;
  }
  /**
   * Focuses a specific item in the MultiSelect based on the provided index.
   * Sets the index to `-1` to focus the custom item if available.
   * Pass `null` or an invalid index to remove focus.
   */
  focusItemAt(index) {
    const minIndex = this.allowCustom ? -1 : 0;
    const isInRange = minIndex <= 0 && index < this.data.length;
    if (isPresent(index) && isInRange && !this.disabledItemsService.isIndexDisabled(index)) {
      this.selectionService.focus(index);
    } else {
      this.selectionService.focus(null);
    }
  }
  /**
   * Focuses the MultiSelect input element.
   */
  focus() {
    if (!this.disabled) {
      this.searchbar.focus();
    }
  }
  /**
   * @hidden
   */
  handleInputFocus() {
    this.handleFocus();
    if (hasObservers(this.inputFocus)) {
      this._zone.run(() => {
        this.inputFocus.emit();
      });
    }
  }
  /**
   * Removes focus from the MultiSelect input element.
   */
  blur() {
    if (!this.disabled) {
      this.searchbar.blur();
    }
  }
  /**
   * @hidden
   */
  handleFocus() {
    this._zone.run(() => {
      if (!this.isFocused && hasObservers(this.onFocus)) {
        this.onFocus.emit();
      }
      this.isFocused = true;
    });
  }
  /**
   * @hidden
   */
  handleBlur() {
    if (!this.isActionSheetExpanded) {
      this.blurComponent();
    }
  }
  /**
   * @hidden
   */
  handleInputBlur() {
    if (!this.isActionSheetExpanded) {
      if (!this.isFocused) {
        return;
      }
      if (hasObservers(this.inputBlur) || hasObservers(this.filterChange) || hasObservers(this.close) || isUntouched(this.wrapper.nativeElement) || this.formControl?.updateOn === 'blur') {
        this._zone.run(() => {
          this.closePopup();
          if (!(this.isOpen && this.allowCustom)) {
            this.clearFilter();
          }
          this.inputBlur.emit();
          this.onTouchedCallback();
        });
      } else {
        if (!this.allowCustom) {
          this.clearFilter();
        }
        this.closePopup();
      }
    }
  }
  /**
   * @hidden
   */
  onMouseDown(event) {
    event.preventDefault();
  }
  /**
   * @hidden
   */
  onResize() {
    const currentWindowSize = this.adaptiveService.size;
    if (this.isAdaptiveModeEnabled && this.windowSize !== currentWindowSize) {
      if (this.isOpen) {
        this.togglePopup(false);
      }
      this.windowSize = currentWindowSize;
      this.cdr.detectChanges();
    }
    if (this.isOpen && !this.isActionSheetExpanded) {
      const popupWrapper = this.popupRef.popupElement;
      const {
        min,
        max
      } = this.width;
      popupWrapper.style.minWidth = min;
      popupWrapper.style.width = max;
    }
  }
  get appendTo() {
    const {
      appendTo
    } = this.popupSettings;
    if (!appendTo || appendTo === 'root') {
      return undefined;
    }
    return appendTo === 'component' ? this.container : appendTo;
  }
  /**
   * Shows or hides the current group sticky header when using grouped data.
   * By default the sticky header is displayed ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/grouping#sticky-header)).
   */
  showStickyHeader = true;
  /**
   * @hidden
   */
  focusableId = `k-${guid()}`;
  /**
   * Controls whether the options list closes after item selection finishes ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/open-state#keeping-the-options-list-open-while-on-focus)).
   * Set to `false` to keep the list open while the component has focus.
   *
   * @default true
   */
  autoClose = true;
  /**
   * Controls the loading state of the MultiSelect.
   * Set to `true` to display the loading indicator.
   */
  loading;
  /**
   * Sets the data source for the MultiSelect.
   * Provide the data as an array of items.
   */
  set data(data) {
    this.dataService.data = data || [];
    if (this.virtual) {
      this.virtual.skip = 0;
    }
    if (this.initialized) {
      this.setState(this.value);
    }
  }
  get data() {
    const virtual = this.virtual;
    if (virtual) {
      const start = virtual.skip || 0;
      const end = start + virtual.pageSize;
      //Use length instead of itemsCount because of grouping
      virtual.total = this.dataService.data.length;
      return this.dataService.data.slice(start, end);
    }
    return this.dataService.data;
  }
  /**
   * Sets the selected values of the MultiSelect.
   * Accepts primitive values (strings, numbers) or complex objects.
   * Use the `valuePrimitive` property to define the value type.
   * > The component ignores selected values that don't exist in the data source.
   */
  set value(values) {
    this._value = values ? values : [];
    if (!this.differ && this.value) {
      this.differ = this.differs.find(this.value).create();
    }
    this.valueChangeDetected = true;
    if (this.initialized) {
      this.setState(this.value);
    }
  }
  get value() {
    return this._value;
  }
  /**
   * Sets the field name that contains the item value in the data objects.
   * Skip this property when your data contains only primitive values.
   * Supports nested property paths like `category.id`.
   */
  valueField;
  /**
   * Sets the field name that contains the item text in the data objects.
   * Skip this property when your data contains only primitive values.
   * Supports nested property paths like `category.name`.
   */
  textField;
  /**
   * Sets the [`tabindex`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex) attribute of the component.
   *
   * @default 0
   */
  tabindex = 0;
  /**
   * @hidden
   */
  set tabIndex(tabIndex) {
    this.tabindex = tabIndex;
  }
  get tabIndex() {
    return this.tabindex;
  }
  /**
   * Sets the size of the component. The default value is set by the Kendo theme.
   */
  set size(size) {
    this.renderer.removeClass(this.wrapper.nativeElement, getSizeClass('input', this.size));
    if (size) {
      this.renderer.addClass(this.wrapper.nativeElement, getSizeClass('input', size));
    }
    this._size = size;
  }
  get size() {
    return this._size;
  }
  /**
   * Sets the border radius of the component. The default value is set by the Kendo theme.
   */
  set rounded(rounded) {
    this.renderer.removeClass(this.wrapper.nativeElement, getRoundedClass(this.rounded));
    if (rounded) {
      this.renderer.addClass(this.wrapper.nativeElement, getRoundedClass(rounded));
    }
    this._rounded = rounded;
  }
  get rounded() {
    return this._rounded;
  }
  /**
   * Sets the fill mode of the component. The default value is set by the Kendo theme.
   */
  set fillMode(fillMode) {
    this.renderer.removeClass(this.wrapper.nativeElement, getFillModeClass('input', this.fillMode));
    if (fillMode) {
      this.renderer.addClass(this.wrapper.nativeElement, getFillModeClass('input', fillMode));
    }
    this._fillMode = fillMode;
  }
  get fillMode() {
    return this._fillMode;
  }
  /**
   * Sets the placeholder text for the MultiSelect input.
   * When the values are selected, it disappears.
   */
  set placeholder(text) {
    this._placeholder = text || '';
  }
  get placeholder() {
    return this.selectedDataItems.length ? '' : this._placeholder;
  }
  /**
   * Controls the adaptive mode behavior of the component.
   * Set to `auto` to enable adaptive rendering on small screens.
   *
   * @default "none"
   */
  adaptiveMode = 'none';
  /**
   * Sets the title text for the ActionSheet in adaptive mode.
   * Uses the component's label text by default.
   */
  adaptiveTitle = '';
  /**
   * Sets the subtitle text for the ActionSheet in adaptive mode.
   * No subtitle appears by default.
   */
  adaptiveSubtitle;
  /**
   * @hidden
   */
  get isAdaptiveModeEnabled() {
    return this.adaptiveMode === 'auto';
  }
  /**
   * Controls the disabled state of the component.
   * When true, sets the component to disabled.
   * To learn how to disable the component in reactive forms, refer to the article on [Forms Support](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/forms#managing-the-multiselect-disabled-state-in-reactive-forms).
   *
   * @default false
   */
  disabled = false;
  /**
   * Determines wether the item will be disabled. The function is executed for each data item.
   * The function receives the item as an argument and should return `true` if the item is disabled.
   */
  set itemDisabled(fn) {
    if (typeof fn !== 'function') {
      throw new Error(`itemDisabled must be a function, but received ${JSON.stringify(fn)}.`);
    }
    this.disabledItemsService.itemDisabled = fn;
  }
  /**
   * Controls whether checkboxes appear before each item in the popup list.
   * Pass `true` to enable checkboxes or an object to configure checkbox settings.
   *
   * @default false
   */
  set checkboxes(settings) {
    this._checkboxes = normalizeCheckboxesSettings(settings);
  }
  get checkboxes() {
    return this._checkboxes;
  }
  /**
   * Controls the read-only state of the component.
   * When true, the component does not allow user input or selection changes.
   *
   * @default false
   */
  readonly = false;
  /**
   * Enables the filtering functionality of the MultiSelect.
   * Set to `true` to allow users to filter the data by typing.
   *
   * @default false
   */
  filterable = false;
  /**
   * Enables virtualization to improve performance with large datasets.
   * Pass `true` for default settings or an object to configure virtualization.
   */
  set virtual(settings) {
    this._virtualSettings = normalizeVirtualizationSettings(settings);
  }
  get virtual() {
    return this._virtualSettings;
  }
  /**
   * Configures the popup appearance and behavior.
   * Set properties like `animate`, `width`, `height`, `popupClass`, and `appendTo`.
   */
  set popupSettings(settings) {
    this._popupSettings = Object.assign({
      animate: true
    }, settings);
  }
  get popupSettings() {
    return this._popupSettings;
  }
  /**
   * Sets the height of the options list in the popup.
   * This affects only the list height, not the entire popup container.
   *
   * @default 200
   */
  set listHeight(_listHeight) {
    this._listHeight = _listHeight;
  }
  get listHeight() {
    if (this.isAdaptive) {
      return;
    }
    return this._listHeight;
  }
  _listHeight = 200;
  /**
   * Controls the type of selected values.
   * Set to `true` for primitive values or `false` for object references.
   * When undefined, the component determines the type based on `valueField`.
   */
  set valuePrimitive(isPrimitive) {
    this._valuePrimitive = isPrimitive;
  }
  get valuePrimitive() {
    if (!isPresent(this._valuePrimitive)) {
      return !isPresent(this.valueField);
    }
    return this._valuePrimitive;
  }
  /**
   * Controls whether a clear button appears when items are selected.
   * Set to `true` to show the button that clears all selections.
   *
   * @default true
   */
  clearButton = true;
  /**
   * Sets a function that transforms selected data items into display tags.
   * Use this to customize how selected items appear as tags.
   *
   * @default (tags) => tags || []
   */
  tagMapper = tags => tags || [];
  /**
   * Allows users to add custom values not present in the data source.
   * Set to `true` to enable custom value input.
   * This feature is not available in adaptive mode.
   *
   * @default false
   */
  allowCustom = false;
  /**
   * Sets a function that normalizes custom user input into data items.
   * Use this when your data items differ from simple strings.
   */
  valueNormalizer = text => text.pipe(map(userInput => {
    const comparer = item => typeof item === 'string' && userInput.toLowerCase() === item.toLowerCase();
    const matchingValue = this.value.find(comparer);
    if (matchingValue) {
      return matchingValue;
    }
    const matchingItem = this.dataService.find(comparer);
    return matchingItem ? matchingItem : userInput;
  }));
  /**
   * Sets HTML attributes for the inner input element.
   * You cannot change attributes essential for component functionality.
   *
   * @remarks
   * This property is related to accessibility.
   */
  inputAttributes;
  /**
   * Fires when the user types in the input field.
   * Use this event to filter the data source based on user input.
   */
  filterChange = new EventEmitter();
  /**
   * Fires when the value changes through user interaction or the Clear button.
   * This event does not fire when you change the value programmatically.
   */
  valueChange = new EventEmitter();
  /**
   * Fires before the popup opens.
   * You can prevent the popup from opening by calling `preventDefault()` on the event.
   */
  open = new EventEmitter();
  /**
   * Fires after the popup opens completely.
   */
  opened = new EventEmitter();
  /**
   * Fires before the popup closes.
   * You can prevent the popup from closing by calling `preventDefault()` on the event.
   */
  close = new EventEmitter();
  /**
   * Fires after the popup closes completely.
   */
  closed = new EventEmitter();
  /**
   * Fires when the user focuses the MultiSelect component.
   */
  onFocus = new EventEmitter();
  /**
   * Fires when the MultiSelect component loses focus.
   */
  onBlur = new EventEmitter();
  /**
   * Fires when the user focuses the input element inside the MultiSelect.
   */
  inputFocus = new EventEmitter();
  /**
   * Fires when the input element inside the MultiSelect loses focus.
   */
  inputBlur = new EventEmitter();
  /**
   * Fires before a tag gets removed from the selection.
   * You can prevent tag removal by calling `preventDefault()` on the event.
   */
  removeTag = new EventEmitter();
  container;
  searchbar;
  tagList;
  popupTemplate;
  optionsList;
  template;
  customItemTemplate;
  groupTemplate;
  fixedGroupTemplate;
  headerTemplate;
  footerTemplate;
  tagTemplate;
  groupTagTemplate;
  noDataTemplate;
  /**
   * @hidden
   */
  suffixTemplate;
  /**
   * @hidden
   */
  prefixTemplate;
  get dir() {
    return this.direction;
  }
  get disabledClass() {
    return this.disabled;
  }
  get isLoading() {
    return this.loading;
  }
  /**
   * @hidden
   */
  windowSize = 'large';
  /**
   * @hidden
   */
  get isActionSheetExpanded() {
    return this.actionSheet?.expanded;
  }
  /**
   * @hidden
   */
  get isAdaptive() {
    return this.isAdaptiveModeEnabled && this.windowSize !== 'large';
  }
  /**
   * @hidden
   */
  applyValue() {
    if (!this.isActionSheetExpanded) {
      return;
    }
    const isValueChanged = !(this.value.every(i => this._valueHolder.find(item => i === item)) && this._valueHolder.length === this.value.length);
    if (isValueChanged) {
      this.value = this._valueHolder;
      this._valueHolder = [];
      this.emitValueChange();
    }
    this.clearFilter();
    this.togglePopup(false);
    if (this.allowCustom && this.isCustomValueSelected) {
      this.isCustomValueSelected = false;
    }
  }
  disabledIndices;
  initialized = false;
  _size;
  _rounded;
  _fillMode;
  _valueHolder = [];
  isCustomValueSelected = false;
  constructor(wrapper, localization, popupService, dataService, selectionService, navigationService, disabledItemsService, cdr, differs, renderer, _zone, injector, adaptiveService) {
    this.wrapper = wrapper;
    this.localization = localization;
    this.popupService = popupService;
    this.dataService = dataService;
    this.selectionService = selectionService;
    this.navigationService = navigationService;
    this.disabledItemsService = disabledItemsService;
    this.cdr = cdr;
    this.differs = differs;
    this.renderer = renderer;
    this._zone = _zone;
    this.injector = injector;
    this.adaptiveService = adaptiveService;
    validatePackage(packageMetadata);
    this.popupMouseDownHandler = this.onMouseDown.bind(this);
    this.data = [];
    this.direction = this.localization.rtl ? 'rtl' : 'ltr';
    this.subscribeEvents();
    this.subscribeTouchEvents();
  }
  get listContainerClasses() {
    const containerClasses = ['k-list-container', 'k-multiselect-popup'];
    if (!this.popupSettings.popupClass) {
      return containerClasses;
    }
    const parsedPopupClasses = parseCSSClassNames(this.popupSettings.popupClass);
    if (parsedPopupClasses?.length) {
      containerClasses.push(...parsedPopupClasses);
    }
    return containerClasses;
  }
  /**
   * @hidden
   */
  get customItemSizeClass() {
    const currentSize = this.isAdaptive ? 'large' : this.size;
    return `${currentSize ? getSizeClass('list', currentSize) : ''}`;
  }
  get width() {
    let wrapperOffsetWidth = 0;
    if (isDocumentAvailable()) {
      wrapperOffsetWidth = this.wrapper.nativeElement.offsetWidth;
    }
    const width = this.popupSettings.width || wrapperOffsetWidth;
    const minWidth = isNaN(wrapperOffsetWidth) ? wrapperOffsetWidth : `${wrapperOffsetWidth}px`;
    const maxWidth = isNaN(width) ? width : `${width}px`;
    return {
      min: minWidth,
      max: maxWidth
    };
  }
  get height() {
    const popupHeight = this.popupSettings.height;
    return isPresent(popupHeight) ? `${popupHeight}px` : 'auto';
  }
  get activeDescendant() {
    const focusedTagIndex = this.focusedTagIndex;
    const focusedListIndex = this.selectionService.focused;
    let prefix;
    let focusedIndex;
    if (isPresent(focusedTagIndex) && !this.isOpen) {
      focusedIndex = focusedTagIndex;
      prefix = this.tagPrefix;
    } else if (isPresent(focusedListIndex) && focusedListIndex !== -1 && this.isOpen) {
      focusedIndex = focusedListIndex;
      prefix = this.optionPrefix;
    } else {
      return null;
    }
    return prefix + "-" + focusedIndex;
  }
  get clearButtonVisibility() {
    if (touchEnabled) {
      return 'visible';
    }
  }
  /**
   * @hidden
   */
  verifySettings() {
    if (!isDevMode() || this.value.length === 0) {
      return;
    }
    if (!isArray(this.value)) {
      throw new Error(MultiselectMessages.array);
    }
    if (this.valuePrimitive === true && isObjectArray(this.value)) {
      throw new Error(MultiselectMessages.primitive);
    }
    if (this.valuePrimitive === false && !isObjectArray(this.value)) {
      throw new Error(MultiselectMessages.object);
    }
    const valueOrText = !isPresent(this.valueField) !== !isPresent(this.textField);
    if (valueOrText) {
      throw new Error(MultiselectMessages.textAndValue);
    }
  }
  /**
   * @hidden
   */
  change(event) {
    if (event.isMultipleSelection) {
      // Existing items.
      if (isPresent(event.added) && event.added.length > 0) {
        event.added.forEach(itemIndex => {
          const dataItem = this.dataService.itemAt(itemIndex);
          const newItem = this.valuePrimitive && isPresent(dataItem) && isPresent(getter(dataItem, this.valueField)) ? getter(dataItem, this.valueField) : dataItem;
          if (isPresent(newItem)) {
            if (!this.isAdaptive || !this.isActionSheetExpanded) {
              this.value = [...this.value, newItem];
            } else {
              this._valueHolder = [...this._valueHolder, newItem];
            }
          }
        });
      }
      if (isPresent(event.removed) && event.removed.length > 0) {
        event.removed.forEach(itemIndex => {
          const dataItem = this.dataService.itemAt(itemIndex);
          const filter = item => getter(item, this.valueField) !== getter(dataItem, this.valueField);
          if (!this.isAdaptive || !this.isActionSheetExpanded) {
            this.value = this.value.filter(filter);
          } else {
            this._valueHolder = this._valueHolder.filter(filter);
          }
        });
        this.cdr.detectChanges();
      }
    } else {
      const isCustomItem = (isPresent(event.added) || isPresent(event.removed)) && (event.added === -1 || event.removed === -1);
      if (isCustomItem) {
        this.addCustomValue(this.text);
        return; // The change is emited asynchronosly.
      }
      // Existing items.
      if (isPresent(event.added)) {
        const dataItem = this.dataService.itemAt(event.added);
        const newItem = this.valuePrimitive && isPresent(dataItem) && isPresent(getter(dataItem, this.valueField)) ? getter(dataItem, this.valueField) : dataItem;
        if (!this.isAdaptive || !this.isActionSheetExpanded) {
          this.value = [...this.value, newItem];
        } else {
          this._valueHolder = [...this._valueHolder, newItem];
        }
      }
      if (isPresent(event.removed)) {
        const dataItem = this.dataService.itemAt(event.removed);
        const filter = item => getter(item, this.valueField) !== getter(dataItem, this.valueField);
        if (!this.isAdaptive || !this.isActionSheetExpanded) {
          this.value = this.value.filter(filter);
        } else {
          this._valueHolder = this._valueHolder.filter(filter);
        }
        this.selectionService.focused = event.removed;
        this.cdr.detectChanges();
      }
    }
    if (!this.isAdaptive || !this.isActionSheetExpanded) {
      this.emitValueChange();
    }
  }
  /**
   * @hidden
   */
  setState(value) {
    const data = this.getDataItems();
    const selection = selectedIndices(this.value, data, this.valueField);
    this.selectionService.resetSelection(selection);
    if (this.disabledItemsService.isIndexDisabled(this.selectionService.focused)) {
      this.selectionService.focused = this.firstFocusableIndex(0);
    }
    if (this.isOpen && this.selectionService.focused === undefined) {
      if (this.dataService.itemsCount > 0) {
        this.selectionService.focused = this.firstFocusableIndex(0);
        if (this.allowCustom) {
          this.selectionService.focused = 0;
        }
      } else if (this.allowCustom) {
        this.selectionService.focused = -1;
      }
    }
    if (this.valuePrimitive && !this.valueField) {
      this.selectedDataItems = value.slice();
    }
    if (isObjectArray(value) || this.valuePrimitive && this.valueField) {
      this.selectedDataItems = resolveAllValues(value, data, this.valueField);
    }
    if (this.selectedDataItems.length < value.length) {
      this.selectedDataItems = value.map(current => {
        const dataItem = this.selectedDataItems.find(item => getter(item, this.valueField) === getter(current, this.valueField));
        return isPresent(dataItem) ? dataItem : this.resolveDataItemFromTags(current);
      }).filter(dataItem => isPresent(dataItem));
    }
    this.tags = this.tagMapper(this.selectedDataItems.slice(0));
    this.disabledIndices = this.disabledItemsMapper();
    this.cdr.markForCheck();
  }
  /**
   * @hidden
   */
  handleFilter(text) {
    if (this.isActionSheetExpanded && this.allowCustom && this.isCustomValueSelected) {
      this.addCustomValue(this.text);
      this.addCustomValue(text);
    }
    this.text = text;
    if (text && !this.isOpen) {
      this.openPopup();
    }
    if (this.filterable) {
      this.filterChange.emit(text);
    } else {
      this.searchTextAndFocus(text);
    }
    this.searchbar.setInputSize();
  }
  /**
   * @hidden
   */
  pageChange(event) {
    const virtual = this.virtual;
    virtual.skip = event.skip;
  }
  /**
   * @hidden
   */
  clearFilter() {
    if (this.filterable && this.text) {
      this.filterChange.emit("");
    }
    this.text = "";
    /* Clearing the value from the input as the setInputSize calculation will be incorrect otherwise.
     Calling cdr.detectChanges to clear the input value as a result of property binding
     causes JAWS to read outdated tag values in IE upon tag selection for some reason. */
    this.searchbar.input.nativeElement.value = "";
    this.searchbar.setInputSize();
  }
  /**
   * @hidden
   */
  handleNavigate(event) {
    const code = normalizeKeys(event);
    const navigateInput = this.text && code !== Keys.ArrowDown && code !== Keys.ArrowUp;
    const selectValue = this.text && code === Keys.Enter || code === Keys.Escape;
    const deleteTag = !this.text && code === Keys.Backspace && this.tags.length > 0;
    if (code === Keys.Backspace && this.isActionSheetExpanded) {
      return;
    }
    if (deleteTag) {
      this.handleBackspace();
      return;
    }
    if (this.disabled || navigateInput && !selectValue) {
      return;
    }
    const eventData = event;
    const focused = isNaN(this.selectionService.focused) ? -1 : this.selectionService.focused;
    const action = this.navigationService.process({
      current: focused,
      max: this.dataService.itemsCount - 1,
      min: this.allowCustom && this.text ? -1 : 0,
      open: this.isOpen,
      originalEvent: eventData
    });
    if (action !== NavigationAction.Undefined && (action === NavigationAction.Enter && this.isOpen || action !== NavigationAction.Enter) && !this.isActionSheetExpanded && action === NavigationAction.Tab) {
      event.preventDefault();
    }
  }
  /**
   * @hidden
   */
  handleRemoveTag({
    tag
  }) {
    const eventArgs = new RemoveTagEvent(tag);
    if (this.disabled || this.readonly) {
      return;
    }
    this.focus();
    this.removeTag.emit(eventArgs);
    if (eventArgs.isDefaultPrevented()) {
      return;
    }
    if (tag instanceof Array) {
      this.removeGroupTag(tag);
    } else {
      this.removeSingleTag(tag);
    }
    this.cdr.detectChanges();
  }
  /**
   * @hidden
   */
  clearAll(event) {
    event?.stopImmediatePropagation();
    event?.preventDefault();
    this.focus();
    this.clearFilter();
    this.selectionService.lastClickedIndex = null;
    const selected = this.selectionService.selected;
    if (this.isAdaptive && this.isActionSheetExpanded) {
      this._valueHolder = this._valueHolder.filter((_item, index) => this.disabledItemsService.isIndexDisabled(selected[index]));
      const selection = selectedIndices(this._valueHolder, this.getDataItems(), this.valueField);
      this.selectionService.resetSelection(selection);
    } else {
      this.value = this.value.filter((_item, index) => this.disabledItemsService.isIndexDisabled(selected[index]));
      this.emitValueChange();
    }
  }
  /**
   * @hidden
   */
  addCustomValue(text) {
    this.customValueSubject.next(text);
  }
  ngAfterContentChecked() {
    this.verifySettings();
  }
  ngDoCheck() {
    const valueChanges = this.differ && this.differ.diff(this.value);
    if (valueChanges && !this.valueChangeDetected) {
      this.setState(this.value);
    }
    this.valueChangeDetected = false;
  }
  ngOnInit() {
    this.renderer.addClass(this.wrapper.nativeElement, 'k-multiselect');
    this.renderer.addClass(this.wrapper.nativeElement, 'k-input');
    this.renderer.removeAttribute(this.wrapper.nativeElement, "tabindex");
    this.createCustomValueStream();
    this.subs.add(this.localization.changes.subscribe(({
      rtl
    }) => {
      this.direction = rtl ? 'rtl' : 'ltr';
      this.cdr.markForCheck();
    }));
    this.setState(this.value);
    this.setComponentClasses();
    this.initialized = true;
  }
  ngOnChanges(changes) {
    const virtual = this.virtual;
    const requestInitialData = virtual && changes.data && changes.data.isFirstChange();
    if (requestInitialData) {
      this.pageChange({
        skip: 0,
        take: virtual.pageSize
      });
    }
    if (isChanged('valueNormalizer', changes)) {
      this.createCustomValueStream();
    }
    if (anyChanged(['textField', 'valueField', 'valuePrimitive'], changes)) {
      this.setState(this.value);
    }
  }
  ngAfterViewInit() {
    this.windowSize = this.adaptiveService.size;
    this.cdr.detectChanges();
    this.searchbar.setInputSize();
    this.subs.add(this.renderer.listen(this.wrapper.nativeElement, 'mousedown', this.handleMousedown.bind(this)));
    this.subs.add(this.renderer.listen(this.wrapper.nativeElement, 'keydown', this.handleKeydown.bind(this)));
    this._zone.onStable.pipe(take(1)).subscribe(() => {
      const ariaLabel = this.searchbar.input.nativeElement.getAttribute('aria-labelledby') || this.searchbar.input.nativeElement.getAttribute('data-kendo-label-id');
      if (ariaLabel) {
        this.renderer.setAttribute(this.tagList.hostElement.nativeElement, 'aria-labelledby', ariaLabel);
      }
    });
  }
  ngOnDestroy() {
    this._toggle(false);
    this.unsubscribeEvents();
  }
  /**
   * Toggles the visibility of the popup or actionSheet
   * ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/open-state#setting-the-initially-opened-component)).
   * If you use the `toggle` method to open or close the popup or actionSheet, the respective `open` and `close` events will not be fired.
   *
   * @param open - The state of the popup.
   */
  toggle(open) {
    // The Promise is required for opening the popup on load.
    // Otherwise, the "Expression has changed..." type error will be thrown.
    Promise.resolve(null).then(() => {
      const shouldOpen = isPresent(open) ? open : !this._open;
      this._toggle(shouldOpen);
      this.cdr.markForCheck();
    });
  }
  /**
   * Returns the current open state. Returns `true` if the popup or actionSheet is open.
   */
  get isOpen() {
    return isTruthy(this._open || this.isActionSheetExpanded);
  }
  /**
   * Resets the MultiSelect by clearing the text and value.
   * This method does not trigger the `selectionChange` and `valueChange` events.
   */
  reset() {
    this.text = "";
    this.value = [];
  }
  /**
   * @hidden
   */
  messageFor(key) {
    return this.localization.get(key);
  }
  // NG MODEL BINDINGS
  /**
   * @hidden
   */
  writeValue(value) {
    this.value = value || [];
  }
  /**
   * @hidden
   */
  registerOnChange(fn) {
    this.onChangeCallback = fn;
  }
  /**
   * @hidden
   */
  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }
  /**
   * @hidden
   */
  setDisabledState(isDisabled) {
    this.cdr.markForCheck();
    this.disabled = isDisabled;
  }
  /**
   * @hidden
   */
  onTagMapperChange() {
    this.tags = this.tagMapper(this.selectedDataItems.slice(0));
    this.cdr.markForCheck();
  }
  /**
   * @hidden
   */
  handleClick() {
    this.windowSize = this.adaptiveService.size;
    if (this.isAdaptive) {
      this.togglePopup(true);
    }
  }
  onChangeCallback = _ => {};
  onTouchedCallback = _ => {};
  _placeholder = '';
  _open = false;
  _value = [];
  _popupSettings = {
    animate: true
  };
  _virtualSettings;
  _valuePrimitive;
  _checkboxes = {
    enabled: false
  };
  _isFocused = false;
  set isFocused(isFocused) {
    this.renderer[isFocused ? 'addClass' : 'removeClass'](this.wrapper.nativeElement, 'k-focus');
    this._isFocused = isFocused;
  }
  get isFocused() {
    return this._isFocused;
  }
  selectedDataItems = [];
  popupMouseDownHandler;
  isOpenPrevented = false;
  customValueSubject = new Subject();
  customValueSubscription;
  subs = new Subscription();
  touchstartDisposeHandler;
  direction;
  differ;
  valueChangeDetected;
  subscribeEvents() {
    if (!isDocumentAvailable()) {
      return;
    }
    const isOpen = () => this.isOpen;
    const isClosed = () => !this.isOpen;
    const isTagFocused = () => !this.isOpen && this.focusedTagIndex !== undefined;
    [this.selectionService.onChange.subscribe(this.handleItemChange.bind(this)), this.navigationService.esc.subscribe(() => {
      if (this.isOpen) {
        this.closePopup();
      } else if (this.isFocused && this.selectedDataItems.length > 0) {
        this.clearAll();
      }
    }), this.navigationService.enter.pipe(filter(isOpen)).subscribe(this.handleEnter.bind(this)), this.navigationService.open.subscribe(this.openPopup.bind(this)), this.navigationService.close.subscribe(this.handleClose.bind(this)), this.navigationService.up.pipe(filter(isOpen)).subscribe(event => this.handleUp(event.index)), this.navigationService.home.pipe(filter(() => isClosed)).subscribe(this.handleHome.bind(this)), this.navigationService.end.pipe(filter(() => isClosed)).subscribe(this.handleEnd.bind(this)), this.navigationService.backspace.pipe(filter(isTagFocused)).subscribe(this.handleBackspace.bind(this)), this.navigationService.delete.pipe(filter(isTagFocused)).subscribe(this.handleDelete.bind(this)), this.navigationService.left.subscribe(this.direction === 'rtl' ? this.handleRightKey.bind(this) : this.handleLeftKey.bind(this)), this.navigationService.right.subscribe(this.direction === 'rtl' ? this.handleLeftKey.bind(this) : this.handleRightKey.bind(this)), this.navigationService.down.subscribe(event => this.handleDownKey(event.index)), this.navigationService.selectprevious.pipe(filter(isOpen)).subscribe(event => this.handleSelectUpDown(event)), this.navigationService.selectnext.pipe(filter(isOpen)).subscribe(event => this.handleSelectUpDown(event)), this.navigationService.selectalltobeginning.pipe(filter(isOpen)).subscribe(() => this.handleSelectAllToBeginning()), this.navigationService.selectalltoend.pipe(filter(isOpen)).subscribe(() => this.handleSelectAllToEnd()), merge(this.navigationService.pagedown, this.navigationService.pageup).subscribe(event => {
      if (this.isOpen) {
        event.originalEvent.preventDefault();
        const code = normalizeKeys(event.originalEvent);
        this.optionsList.scrollWithOnePage(NavigationAction[code]);
      }
    })].forEach(s => this.subs.add(s));
  }
  subscribeTouchEvents() {
    if (!isDocumentAvailable() || !touchEnabled) {
      return;
    }
    this._zone.runOutsideAngular(() =>
    // Roll up MultiSelect on iOS when tapped outside
    this.touchstartDisposeHandler = this.renderer.listen(document, 'touchstart', e => {
      const target = e.target;
      if ((this.isFocused || this.isOpen) && !inDropDown(this.wrapper, target, this.popupRef)) {
        this._zone.run(() => {
          this.blur();
          if (this.isOpen) {
            this.togglePopup(false);
          }
        });
      }
    }));
  }
  unsubscribeEvents() {
    if (!isDocumentAvailable()) {
      return;
    }
    this.subs.unsubscribe();
    if (this.customValueSubscription) {
      this.customValueSubscription.unsubscribe();
    }
    if (this.touchstartDisposeHandler) {
      this.touchstartDisposeHandler();
    }
  }
  getDataItems() {
    const data = this.dataService.data;
    if (this.dataService.grouped) {
      return data.filter(item => !item.header).map(item => item.value);
    }
    return data;
  }
  removeGroupTag(dataItems) {
    const data = this.getDataItems();
    const dataItemValues = new Set(dataItems.map(item => getter(item, this.valueField)));
    this.value = this.value.filter(value => {
      const index = selectedIndices([value], data, this.valueField)[0];
      const isDataItemDisabled = this.disabledItemsService.isIndexDisabled(index);
      return !dataItemValues.has(getter(value, this.valueField)) || isDataItemDisabled;
    });
    this.emitValueChange();
  }
  removeSingleTag(dataItem) {
    const data = this.getDataItems();
    const index = selectedIndices([dataItem], data, this.valueField)[0];
    if (this.disabledItemsService.isIndexDisabled(index)) {
      return;
    }
    if (isNumber(index)) {
      this.selectionService.deselect(index);
      this.selectionService.focused = index;
      this.togglePopup(false);
    } else {
      // the deleted item is not present in the source
      const filter = item => getter(item, this.valueField) !== getter(dataItem, this.valueField);
      this.value = this.value.filter(filter);
      this.emitValueChange();
    }
  }
  /**
   * @hidden
   *
   * Determines which of the provided tags should be disabled and stores their position indices
   */
  disabledItemsMapper() {
    const {
      selected
    } = this.selectionService;
    return new Set(this.selectedDataItems.reduce((indices, _item, index) => {
      if (this.disabledItemsService.isIndexDisabled(selected[index])) {
        indices.push(index);
      }
      return indices;
    }, []));
  }
  createCustomValueStream() {
    if (this.customValueSubscription) {
      this.customValueSubscription.unsubscribe();
    }
    this.customValueSubscription = this.customValueSubject.pipe(tap(() => {
      this.loading = true;
      this.disabled = true;
      this.cdr.detectChanges();
    }), this.valueNormalizer, catchError(() => {
      this.loading = false;
      this.disabled = false;
      if (this.autoClose) {
        this.togglePopup(false);
      }
      if (this.autoClose || !this.filterable) {
        this.clearFilter();
      }
      this.nextTick(() => {
        this.searchbar.focus();
      });
      this.createCustomValueStream();
      return of(null);
    })).subscribe(normalizedValue => {
      this.loading = false;
      this.disabled = false;
      if (isPresent(normalizedValue)) {
        // if valueNormalizer returns `null` or `undefined` custom value is discarded
        const newValue = this.valuePrimitive ? getter(normalizedValue, this.valueField) : normalizedValue;
        const itemIndex = this.dataService.indexOf(newValue);
        const customItem = itemIndex === -1;
        if (this.value.indexOf(newValue) === -1) {
          !this.isActionSheetExpanded && (this.tags = this.tagMapper([...this.selectedDataItems, normalizedValue]));
          if (!customItem) {
            this.selectionService.add(itemIndex);
          } else if (this.isActionSheetExpanded) {
            const isValueInHolder = this._valueHolder.some(item => getter(item, this.valueField) === newValue);
            if (isValueInHolder) {
              this._valueHolder = this._valueHolder.filter(item => getter(item, this.valueField) !== newValue);
              this.isCustomValueSelected = false;
            } else {
              this._valueHolder = [...this._valueHolder, newValue];
              this.isCustomValueSelected = true;
            }
          } else {
            this.value = [...this.value, newValue];
          }
        } else if (!customItem && this.selectionService.isSelected(itemIndex)) {
          this.selectionService.deselect(itemIndex);
          this.selectionService.focused = itemIndex;
        } else if (this.isActionSheetExpanded) {
          this._valueHolder = this._valueHolder.filter(item => getter(item, this.valueField) !== newValue);
          this.isCustomValueSelected = false;
        } else {
          this.value = this.value.filter(item => getter(item, this.valueField) !== newValue);
        }
        !this.isActionSheetExpanded && this.emitValueChange();
      }
      if (this.autoClose) {
        this.togglePopup(false);
      }
      if ((this.autoClose || !this.filterable) && !this.isActionSheetExpanded) {
        this.clearFilter();
      }
      if (!this.isActionSheetExpanded) {
        this.nextTick(() => {
          this.searchbar.focus();
        });
      }
    });
  }
  handleItemChange(event) {
    this.change(event);
    if (this.autoClose && !event.preventClosingPopup && !this.isActionSheetExpanded) {
      this.togglePopup(false);
    }
    if ((this.autoClose || !this.filterable) && !this.isActionSheetExpanded) {
      this.clearFilter();
    }
  }
  handleMousedown(event) {
    if (event.target.closest('.k-input-prefix') || event.target.closest('.k-input-suffix')) {
      return;
    }
    if (!this.isActionSheetExpanded) {
      const inputElement = this.searchbar.input.nativeElement;
      if (event.button === 0) {
        if (this.isFocused && (this.isOpen || this.isOpenPrevented) && event.target === inputElement) {
          return;
        }
        if (!touchEnabled || touchEnabled && event.target.tagName !== 'SPAN') {
          this.searchbar.focus();
        }
        // The check is needed otherwise when appended to the component, the popup reopens on click
        // https://github.com/telerik/kendo-angular/issues/3738
        if (this.popupRef && this.popupRef.popupElement.contains(event.target)) {
          return;
        }
        event.preventDefault();
        this.togglePopup(!this.isOpen);
      }
    }
  }
  handleKeydown(event) {
    const code = normalizeKeys(event);
    if (this.isFocused && this.isOpen && (event.ctrlKey || event.metaKey) && code === Keys.KeyA) {
      event.preventDefault();
      this.handleSelectAll();
    }
  }
  handleEnter(event) {
    const service = this.selectionService;
    const focusedIndex = this.selectionService.focused;
    this.selectionService.lastClickedIndex = focusedIndex;
    if (this.isOpen) {
      event.originalEvent.preventDefault();
    }
    if (focusedIndex === -1) {
      if (this.allowCustom && this.text) {
        this.addCustomValue(this.text);
      }
      return; // Clear filter & close are done at customValueSubscription due to race conditions.
    }
    if (service.isSelected(focusedIndex)) {
      service.deselect(focusedIndex);
      service.focused = focusedIndex;
    } else {
      service.add(focusedIndex);
    }
    if (this.autoClose && !this.isActionSheetExpanded) {
      this.togglePopup(false);
    }
    if (this.autoClose || !this.filterable) {
      this.clearFilter();
    }
  }
  handleClose() {
    this.closePopup();
    this.searchbar.focus();
  }
  handleEnd() {
    this.focusedTagIndex = this.tags.length - 1;
  }
  handleHome() {
    this.focusedTagIndex = 0;
  }
  sortSelectionAscending() {
    return this.selectionService.selected.sort((a, b) => a - b);
  }
  handleSelectAll() {
    const selectedItemsCount = this.selectionService.selected.length;
    const dataItemsCount = this.dataService.data.length;
    const dataItemsWithoutHeadersCount = this.dataService.data.filter(i => !i.header).length;
    if (!this.dataService.grouped && selectedItemsCount === dataItemsCount || this.dataService.grouped && selectedItemsCount === dataItemsWithoutHeadersCount) {
      this.clearAll();
    } else {
      this.selectionService.selectFromTo(0, dataItemsCount - 1);
      this.selectionService.emitMultipleAddedRemoved();
    }
  }
  handleSelectAllToBeginning() {
    const selectedItemsCount = this.selectionService.selected.length;
    const dataItemsCount = this.dataService.data.length;
    const focusedItem = this.selectionService.focused;
    const largestIndex = this.sortSelectionAscending()[selectedItemsCount - 1];
    if (selectedItemsCount !== dataItemsCount) {
      this.selectionService.unselectFromTo(largestIndex, focusedItem + 1);
      this.selectionService.selectFromTo(0, focusedItem);
    }
    this.nextTick(() => this.selectionService.focus(0));
    this.selectionService.emitMultipleAddedRemoved();
  }
  handleSelectAllToEnd() {
    const selectedItemsCount = this.selectionService.selected.length;
    const dataItemsCount = this.dataService.data.length;
    const focusedItem = this.selectionService.focused;
    if (selectedItemsCount !== dataItemsCount) {
      this.selectionService.unselectFromTo(focusedItem - 1, 0);
      this.selectionService.selectFromTo(focusedItem, dataItemsCount - 1);
    }
    if (this.dataService.grouped) {
      const lastItemIndex = this.dataService.groupIndices[this.dataService.groupIndices.length - 1] - 1;
      this.nextTick(() => this.selectionService.focus(lastItemIndex));
    } else {
      this.nextTick(() => this.selectionService.focus(dataItemsCount - 1));
    }
    this.selectionService.emitMultipleAddedRemoved();
  }
  handleSelectUpDown(event) {
    const focusedIndex = this.selectionService.focused;
    if (!isPresent(focusedIndex)) {
      return;
    }
    let indexToSelect;
    if (event.originalEvent.key === 'ArrowUp') {
      indexToSelect = focusedIndex > 0 ? focusedIndex - 1 : focusedIndex;
    } else {
      indexToSelect = focusedIndex < this.dataService.data.length - 1 ? focusedIndex + 1 : focusedIndex;
    }
    if (!isPresent(this.selectionService.lastClickedIndex)) {
      this.selectionService.lastClickedIndex = focusedIndex;
    }
    this.selectRangeFromTo(indexToSelect);
  }
  /**
   * Selects all items between the focused item and the last clicked item (index). Also removes all other selected items.
   */
  selectRangeFromTo(indexToSelect) {
    const lastClickedIndex = this.selectionService.lastClickedIndex;
    if (lastClickedIndex > indexToSelect) {
      this.selectionService.unselectNotNeededIndices(indexToSelect, lastClickedIndex, this.dataService.data.length);
      this.selectionService.selectFromTo(indexToSelect, this.selectionService.lastClickedIndex);
      this.selectionService.emitMultipleAddedRemoved();
    } else {
      this.selectionService.unselectNotNeededIndices(lastClickedIndex, indexToSelect, this.dataService.data.length);
      this.selectionService.selectFromTo(lastClickedIndex, indexToSelect);
      this.selectionService.emitMultipleAddedRemoved();
    }
    this.nextTick(() => this.selectionService.focus(indexToSelect));
  }
  handleUp(index) {
    this.selectionService.focused = index;
  }
  handleBackspace() {
    if (this.focusedTagIndex !== undefined) {
      this.handleDelete();
    } else {
      this.handleRemoveTag({
        tag: this.tags[this.tags.length - 1]
      });
      this.searchbar.focus();
    }
  }
  handleDelete() {
    this.handleRemoveTag({
      tag: this.tags[this.focusedTagIndex]
    });
    if (this.focusedTagIndex === this.tags.length) {
      this.focusedTagIndex = undefined;
    }
  }
  handleLeftKey() {
    if (this.focusedTagIndex === undefined || this.focusedTagIndex < 0) {
      this.focusedTagIndex = this.tags.length - 1;
    } else if (this.focusedTagIndex !== 0) {
      this.focusedTagIndex--;
    }
  }
  handleDownKey(index) {
    if (this.isOpen) {
      this.selectionService.focused = index || this.firstFocusableIndex(0);
    } else {
      this.openPopup();
    }
  }
  handleRightKey() {
    const last = this.tags.length - 1;
    if (this.focusedTagIndex === last) {
      this.focusedTagIndex = undefined;
    } else if (this.focusedTagIndex < last) {
      this.focusedTagIndex++;
    }
  }
  findIndex(text, startsFrom = 0) {
    let itemText;
    text = text.toLowerCase();
    const index = this.dataService.findIndex(item => {
      if (this.dataService.grouped) {
        itemText = getter(item.value, this.textField);
      } else {
        itemText = getter(item, this.textField);
      }
      itemText = !isPresent(itemText) ? "" : itemText.toString().toLowerCase();
      return text && itemText.startsWith(text);
    }, startsFrom);
    if (this.disabledItemsService.isIndexDisabled(index)) {
      return index + 1 > this.dataService.itemsCount ? -1 : this.findIndex(text, index + 1);
    } else {
      return index;
    }
  }
  searchTextAndFocus(text) {
    const index = this.findIndex(text);
    this.selectionService.focused = index;
  }
  closePopup() {
    this.togglePopup(false);
    this.focusedTagIndex = undefined;
  }
  openPopup() {
    this.togglePopup(true);
    this.focusedTagIndex = undefined;
  }
  /**
   * @hidden
   */
  togglePopup(open) {
    const isDisabled = this.disabled || this.readonly;
    const sameState = this.isOpen === open;
    if (isDisabled || sameState) {
      return;
    }
    const isDefaultPrevented = this.triggerPopupEvents(open);
    if (open) {
      this.isOpenPrevented = isDefaultPrevented;
    }
    if (!isDefaultPrevented) {
      this._toggle(open);
    }
  }
  triggerPopupEvents(open) {
    const eventArgs = new PreventableEvent();
    if (open) {
      this.open.emit(eventArgs);
    } else {
      this.close.emit(eventArgs);
    }
    return eventArgs.isDefaultPrevented();
  }
  _toggle(open) {
    this._open = open;
    this.destroyPopup();
    if (this.isActionSheetExpanded) {
      this.actionSheet.toggle(false);
      this.closed.emit();
      this.isFocused = false;
    }
    if (this._open) {
      this.createPopup();
    }
  }
  destroyPopup() {
    if (this.popupRef) {
      this.popupRef.popupElement.removeEventListener('mousedown', this.popupMouseDownHandler);
      this.popupRef.close();
      this.popupRef = null;
    }
  }
  createPopup() {
    if (this.virtual) {
      this.virtual.skip = 0;
    }
    this.windowSize = this.adaptiveService.size;
    if (this.isAdaptive) {
      this.openActionSheet();
      return;
    }
    const horizontalAlign = this.direction === "rtl" ? "right" : "left";
    const anchorPosition = {
      horizontal: horizontalAlign,
      vertical: "bottom"
    };
    const popupPosition = {
      horizontal: horizontalAlign,
      vertical: "top"
    };
    const appendToComponent = typeof this.popupSettings.appendTo === 'string' && this.popupSettings.appendTo === 'component';
    this.popupRef = this.popupService.open({
      anchor: this.wrapper,
      anchorAlign: anchorPosition,
      animate: this.popupSettings.animate,
      appendTo: this.appendTo,
      content: this.popupTemplate,
      popupAlign: popupPosition,
      popupClass: this.listContainerClasses,
      positionMode: appendToComponent ? 'fixed' : 'absolute'
    });
    const popupWrapper = this.popupRef.popupElement;
    const {
      min,
      max
    } = this.width;
    if (!this.appendTo) {
      this.renderer.setAttribute(popupWrapper, 'role', 'region');
      this.renderer.setAttribute(popupWrapper, 'aria-label', this.messageFor('popupLabel'));
    }
    // pointerdown causes issues with some ios versions; use mousedown instead - https://github.com/telerik/kendo-angular/issues/4912
    popupWrapper.addEventListener('mousedown', this.popupMouseDownHandler);
    popupWrapper.style.minWidth = min;
    popupWrapper.style.width = max;
    popupWrapper.style.height = this.height;
    popupWrapper.setAttribute("dir", this.direction);
    this.popupRef.popupOpen.subscribe(() => {
      this.cdr.detectChanges();
      if (!this.dataService.grouped) {
        setListBoxAriaLabelledBy(this.optionsList, this.searchbar.input, this.renderer);
      }
      this.optionsList.scrollToItem(this.selectionService.focused);
      this.selectionService.focus(this.selectionService.focused);
      this.opened.emit();
    });
    this.popupRef.popupClose.subscribe(() => {
      this.closed.emit();
    });
    this.popupRef.popupAnchorViewportLeave.subscribe(() => {
      this.togglePopup(false);
    });
  }
  emitValueChange() {
    this.onChangeCallback(this.value);
    this.valueChange.emit(this.value);
  }
  resolveDataItemFromTags(value) {
    if (!(this.tags && this.tags.length && isPresent(value))) {
      return undefined;
    }
    // Flattening the tags array in case of a summary tag occurrence.
    const tags = this.tags.reduce((acc, tag) => {
      const items = isArray(tag) ? tag : [tag];
      acc.push(...items);
      return acc;
    }, []);
    return tags.find(tag => getter(tag, this.valueField) === getter(value, this.valueField));
  }
  firstFocusableIndex(index) {
    const maxIndex = this.dataService.itemsCount;
    if (this.disabledItemsService.isIndexDisabled(index)) {
      const nextIndex = index + 1;
      return nextIndex < maxIndex ? this.firstFocusableIndex(nextIndex) : undefined;
    } else {
      return index;
    }
  }
  nextTick(f) {
    this._zone.runOutsideAngular(() => {
      // Use `setTimeout` instead of a resolved promise
      // because the latter does not wait long enough.
      setTimeout(() => this._zone.run(f));
    });
  }
  setComponentClasses() {
    if (this.size) {
      this.renderer.addClass(this.wrapper.nativeElement, getSizeClass('input', this.size));
    }
    if (this.rounded) {
      this.renderer.addClass(this.wrapper.nativeElement, getRoundedClass(this.rounded));
    }
    if (this.fillMode) {
      this.renderer.addClass(this.wrapper.nativeElement, getFillModeClass('input', this.fillMode));
    }
  }
  openActionSheet() {
    this.actionSheet.toggle(true);
    // Stores the current value state until the user either accepts or cancels it
    this._valueHolder = [...this.value];
    this.cdr.detectChanges();
    if (!this.dataService.grouped) {
      setListBoxAriaLabelledBy(this.optionsList, this.searchbar.input, this.renderer);
    }
    this.adaptiveTitle = setActionSheetTitle(this.searchbar.input, this.adaptiveTitle);
    this.cdr.detectChanges();
    this.opened.emit();
    // wait for the ActionSheet animation to complete to ensure the scroll calculation is accurate
    this.actionSheet.expand.pipe(take(1)).subscribe(() => {
      this.optionsList.scrollToItem(this.selectionService.focused);
    });
    this.selectionService.focus(this.selectionService.focused);
    this.actionSheetSearchBar.focus();
  }
  blurComponent() {
    if (!this.isFocused) {
      return;
    }
    this.isFocused = false;
    if (hasObservers(this.onBlur) || hasObservers(this.filterChange) || hasObservers(this.close) || isUntouched(this.wrapper.nativeElement)) {
      this._zone.run(() => {
        this.closePopup();
        if (!(this.isOpen && this.allowCustom)) {
          this.clearFilter();
        }
        this.onBlur.emit();
        this.onTouchedCallback();
      });
    } else {
      if (!this.allowCustom) {
        this.clearFilter();
      }
      this.closePopup();
    }
  }
  static ɵfac = function MultiSelectComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MultiSelectComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.LocalizationService), i0.ɵɵdirectiveInject(i2.PopupService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(SelectionService), i0.ɵɵdirectiveInject(NavigationService), i0.ɵɵdirectiveInject(DisabledItemsService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.KeyValueDiffers), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i7.AdaptiveService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MultiSelectComponent,
    selectors: [["kendo-multiselect"]],
    contentQueries: function MultiSelectComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, ItemTemplateDirective, 5)(dirIndex, CustomItemTemplateDirective, 5)(dirIndex, GroupTemplateDirective, 5)(dirIndex, FixedGroupTemplateDirective, 5)(dirIndex, HeaderTemplateDirective, 5)(dirIndex, FooterTemplateDirective, 5)(dirIndex, TagTemplateDirective, 5)(dirIndex, GroupTagTemplateDirective, 5)(dirIndex, NoDataTemplateDirective, 5)(dirIndex, SuffixTemplateDirective, 5)(dirIndex, PrefixTemplateDirective, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customItemTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.groupTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fixedGroupTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tagTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.groupTagTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.noDataTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.suffixTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.prefixTemplate = _t.first);
      }
    },
    viewQuery: function MultiSelectComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(AdaptiveRendererComponent, 5)(_c12, 7, ViewContainerRef)(SearchBarComponent, 7)(TagListComponent, 7)(_c13, 7)(_c14, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.adaptiveRendererComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchbar = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tagList = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popupTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.optionsList = _t.first);
      }
    },
    hostVars: 7,
    hostBindings: function MultiSelectComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("dir", ctx.dir);
        i0.ɵɵclassProp("k-readonly", ctx.readonly)("k-disabled", ctx.disabledClass)("k-loading", ctx.isLoading);
      }
    },
    inputs: {
      showStickyHeader: "showStickyHeader",
      focusableId: "focusableId",
      autoClose: "autoClose",
      loading: "loading",
      data: "data",
      value: "value",
      valueField: "valueField",
      textField: "textField",
      tabindex: "tabindex",
      tabIndex: "tabIndex",
      size: "size",
      rounded: "rounded",
      fillMode: "fillMode",
      placeholder: "placeholder",
      adaptiveMode: "adaptiveMode",
      adaptiveTitle: "adaptiveTitle",
      adaptiveSubtitle: "adaptiveSubtitle",
      disabled: "disabled",
      itemDisabled: "itemDisabled",
      checkboxes: "checkboxes",
      readonly: "readonly",
      filterable: "filterable",
      virtual: "virtual",
      popupSettings: "popupSettings",
      listHeight: "listHeight",
      valuePrimitive: "valuePrimitive",
      clearButton: "clearButton",
      tagMapper: "tagMapper",
      allowCustom: "allowCustom",
      valueNormalizer: "valueNormalizer",
      inputAttributes: "inputAttributes"
    },
    outputs: {
      filterChange: "filterChange",
      valueChange: "valueChange",
      open: "open",
      opened: "opened",
      close: "close",
      closed: "closed",
      onFocus: "focus",
      onBlur: "blur",
      inputFocus: "inputFocus",
      inputBlur: "inputBlur",
      removeTag: "removeTag"
    },
    exportAs: ["kendoMultiSelect"],
    features: [i0.ɵɵProvidersFeature([MULTISELECT_VALUE_ACCESSOR, DataService, SelectionService, NavigationService, DisabledItemsService, LocalizationService, {
      provide: L10N_PREFIX,
      useValue: 'kendo.multiselect'
    }, {
      provide: FilterableComponent,
      useExisting: forwardRef(() => MultiSelectComponent)
    }, {
      provide: KendoInput,
      useExisting: forwardRef(() => MultiSelectComponent)
    }, {
      provide: KENDO_WEBMCP_HOST,
      useExisting: forwardRef(() => MultiSelectComponent)
    }]), i0.ɵɵNgOnChangesFeature],
    decls: 20,
    vars: 43,
    consts: () => {
      let i18n_14;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text displayed in the popup when there are no items
         * @meaning kendo.multiselect.noDataText
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_14 = goog.getMsg("NO DATA FOUND");
        i18n_14 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_14;
      } else {
        i18n_14 = $localize`:kendo.multiselect.noDataText|The text displayed in the popup when there are no items:NO DATA FOUND`;
      }
      let i18n_15;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the clear button
         * @meaning kendo.multiselect.clearTitle
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_15 = goog.getMsg("clear");
        i18n_15 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_15;
      } else {
        i18n_15 = $localize`:kendo.multiselect.clearTitle|The title of the clear button:clear`;
      }
      let i18n_16;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The label of the popup element that contains the list of options when its role is 'region'
         * @meaning kendo.multiselect.popupLabel
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_16 = goog.getMsg("Options list");
        i18n_16 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_16;
      } else {
        i18n_16 = $localize`:kendo.multiselect.popupLabel|The label of the popup element that contains the list of options when its role is 'region':Options list`;
      }
      let i18n_17;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode.
         * @meaning kendo.multiselect.adaptiveCloseButtonTitle
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_17 = goog.getMsg("Close");
        i18n_17 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_17;
      } else {
        i18n_17 = $localize`:kendo.multiselect.adaptiveCloseButtonTitle|The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode.:Close`;
      }
      let i18n_18;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text displayed when the user types a custom value that is not in the list of options.
         * @meaning kendo.multiselect.useCustomValueText
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_18 = goog.getMsg("{$interpolation}", {
          "interpolation": "\uFFFD0\uFFFD"
        }, {
          original_code: {
            "interpolation": "{{ 'Use &quot;{customValue}&quot;' }}"
          }
        });
        i18n_18 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_18;
      } else {
        i18n_18 = $localize`:kendo.multiselect.useCustomValueText|The text displayed when the user types a custom value that is not in the list of options.:${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
      }
      return [["popupTemplate", ""], ["container", ""], ["sharedPopupActionSheetTemplate", ""], ["optionsList", ""], ["useCustomValueText", i18n_18], ["kendoMultiSelectLocalizedMessages", "", "noDataText", i18n_14, "clearTitle", i18n_15, "popupLabel", i18n_16, "adaptiveCloseButtonTitle", i18n_17, 6, "useCustomValueText"], ["kendoDropDownSharedEvents", "", 3, "isFocusedChange", "handleBlur", "onFocus", "hostElement", "isFocused"], [1, "k-input-prefix", "k-input-prefix-horizontal"], [1, "k-input-values"], [3, "removeTag", "size", "rounded", "fillMode", "id", "tags", "textField", "valueField", "focused", "disabled", "template", "groupTemplate", "tagPrefix", "disabledIndices"], ["kendoSearchbar", "", 3, "onNavigate", "valueChange", "onBlur", "onFocus", "click", "ariaControls", "ariaExpanded", "id", "tagListId", "isLoading", "isFilterable", "activeDescendant", "userInput", "disabled", "readonly", "tabIndex", "isRequired", "placeholder", "inputAttributes"], ["role", "button", "tabindex", "-1", 1, "k-clear-value", 3, "visibility"], [1, "k-icon", "k-i-loading", "k-input-loading-icon"], [1, "k-input-suffix", "k-input-suffix-horizontal"], [3, "closePopup", "textInputChange", "navigate", "sharedPopupActionSheetTemplate", "title", "showTextInput", "subtitle", "placeholder", "searchBarValue"], [3, "ngTemplateOutlet"], ["role", "button", "tabindex", "-1", 1, "k-clear-value", 3, "mousedown"], ["name", "x", 1, "k-icon", 3, "svgIcon"], [4, "ngTemplateOutlet"], [3, "resize"], [3, "templateContext"], [3, "pageChange", "size", "rounded", "id", "optionPrefix", "data", "textField", "valueField", "template", "groupTemplate", "fixedGroupTemplate", "height", "show", "multipleSelection", "virtual", "checkboxes", "isMultiselect", "isActionSheetExpanded", "showStickyHeader", "customItemTemplate", "text", "allowCustom"], [1, "k-no-data"]];
    },
    template: function MultiSelectComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementContainerStart(0, 5);
        i0.ɵɵi18nAttributes(1, 4);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementContainerStart(2, 6);
        i0.ɵɵtwoWayListener("isFocusedChange", function MultiSelectComponent_Template_ng_container_isFocusedChange_2_listener($event) {
          i0.ɵɵrestoreView(_r1);
          i0.ɵɵtwoWayBindingSet(ctx.isFocused, $event) || (ctx.isFocused = $event);
          return i0.ɵɵresetView($event);
        });
        i0.ɵɵlistener("handleBlur", function MultiSelectComponent_Template_ng_container_handleBlur_2_listener() {
          return ctx.handleBlur();
        })("onFocus", function MultiSelectComponent_Template_ng_container_onFocus_2_listener() {
          return ctx.handleFocus();
        });
        i0.ɵɵconditionalCreate(3, MultiSelectComponent_Conditional_3_Template, 2, 1, "span", 7);
        i0.ɵɵconditionalCreate(4, MultiSelectComponent_Conditional_4_Template, 1, 0, "kendo-separator");
        i0.ɵɵelementStart(5, "div", 8)(6, "kendo-taglist", 9);
        i0.ɵɵlistener("removeTag", function MultiSelectComponent_Template_kendo_taglist_removeTag_6_listener($event) {
          return ctx.handleRemoveTag($event);
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "input", 10);
        i0.ɵɵlistener("onNavigate", function MultiSelectComponent_Template_input_onNavigate_7_listener($event) {
          return ctx.handleNavigate($event);
        })("valueChange", function MultiSelectComponent_Template_input_valueChange_7_listener($event) {
          return ctx.handleFilter($event);
        })("onBlur", function MultiSelectComponent_Template_input_onBlur_7_listener() {
          return ctx.handleInputBlur();
        })("onFocus", function MultiSelectComponent_Template_input_onFocus_7_listener() {
          return ctx.handleInputFocus();
        })("click", function MultiSelectComponent_Template_input_click_7_listener() {
          return ctx.handleClick();
        });
        i0.ɵɵelementEnd()();
        i0.ɵɵconditionalCreate(8, MultiSelectComponent_Conditional_8_Template, 2, 4, "span", 11);
        i0.ɵɵconditionalCreate(9, MultiSelectComponent_Conditional_9_Template, 1, 0, "span", 12);
        i0.ɵɵconditionalCreate(10, MultiSelectComponent_Conditional_10_Template, 1, 0, "kendo-separator");
        i0.ɵɵconditionalCreate(11, MultiSelectComponent_Conditional_11_Template, 2, 1, "span", 13);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵtemplate(12, MultiSelectComponent_ng_template_12_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵconditionalCreate(14, MultiSelectComponent_Conditional_14_Template, 1, 0, "kendo-resize-sensor");
        i0.ɵɵelementContainer(15, null, 1);
        i0.ɵɵelementStart(17, "kendo-adaptive-renderer", 14);
        i0.ɵɵlistener("closePopup", function MultiSelectComponent_Template_kendo_adaptive_renderer_closePopup_17_listener() {
          return ctx.applyValue();
        })("textInputChange", function MultiSelectComponent_Template_kendo_adaptive_renderer_textInputChange_17_listener($event) {
          return ctx.handleFilter($event);
        })("navigate", function MultiSelectComponent_Template_kendo_adaptive_renderer_navigate_17_listener($event) {
          return ctx.handleNavigate($event);
        });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(18, MultiSelectComponent_ng_template_18_Template, 5, 24, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const sharedPopupActionSheetTemplate_r4 = i0.ɵɵreference(19);
        i0.ɵɵi18nExp("Use \"{customValue}\"");
        i0.ɵɵi18nApply(1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("hostElement", ctx.wrapper);
        i0.ɵɵtwoWayProperty("isFocused", ctx.isFocused);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.prefixTemplate ? 3 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.prefixTemplate && ctx.prefixTemplate.showSeparator ? 4 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("size", ctx.size)("rounded", ctx.rounded)("fillMode", ctx.fillMode)("id", ctx.tagListId)("tags", ctx.tags)("textField", ctx.textField)("valueField", ctx.valueField)("focused", ctx.focusedTagIndex)("disabled", ctx.disabled)("template", ctx.tagTemplate)("groupTemplate", ctx.groupTagTemplate)("tagPrefix", ctx.tagPrefix)("disabledIndices", ctx.disabledIndices);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ariaControls", ctx.ariaControls)("ariaExpanded", ctx.isOpen)("id", ctx.focusableId)("tagListId", ctx.tagListId)("isLoading", ctx.loading)("isFilterable", ctx.filterable)("activeDescendant", ctx.activeDescendant)("userInput", ctx.text)("disabled", ctx.disabled)("readonly", ctx.readonly || ctx.isAdaptive)("tabIndex", ctx.tabIndex)("isRequired", ctx.isControlRequired)("placeholder", ctx.placeholder)("inputAttributes", ctx.inputAttributes);
        i0.ɵɵadvance();
        i0.ɵɵconditional(!ctx.loading && !ctx.readonly && ctx.clearButton && ((ctx.tags == null ? null : ctx.tags.length) || (ctx.text == null ? null : ctx.text.length)) ? 8 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.loading ? 9 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.suffixTemplate && ctx.suffixTemplate.showSeparator ? 10 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.suffixTemplate ? 11 : -1);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.isOpen || ctx.isAdaptiveModeEnabled ? 14 : -1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("sharedPopupActionSheetTemplate", sharedPopupActionSheetTemplate_r4)("title", ctx.adaptiveTitle)("showTextInput", true)("subtitle", ctx.adaptiveSubtitle)("placeholder", ctx.placeholder)("searchBarValue", ctx.text);
      }
    },
    dependencies: [LocalizedMessagesDirective, SharedDropDownEventsDirective, NgTemplateOutlet, SeparatorComponent, TagListComponent, SearchBarComponent, IconWrapperComponent, ResizeSensorComponent, AdaptiveRendererComponent, TemplateContextDirective, ListComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiSelectComponent, [{
    type: Component,
    args: [{
      exportAs: 'kendoMultiSelect',
      providers: [MULTISELECT_VALUE_ACCESSOR, DataService, SelectionService, NavigationService, DisabledItemsService, LocalizationService, {
        provide: L10N_PREFIX,
        useValue: 'kendo.multiselect'
      }, {
        provide: FilterableComponent,
        useExisting: forwardRef(() => MultiSelectComponent)
      }, {
        provide: KendoInput,
        useExisting: forwardRef(() => MultiSelectComponent)
      }, {
        provide: KENDO_WEBMCP_HOST,
        useExisting: forwardRef(() => MultiSelectComponent)
      }],
      selector: 'kendo-multiselect',
      template: `
        <ng-container kendoMultiSelectLocalizedMessages
          i18n-noDataText="kendo.multiselect.noDataText|The text displayed in the popup when there are no items"
          noDataText="NO DATA FOUND"

          i18n-clearTitle="kendo.multiselect.clearTitle|The title of the clear button"
          clearTitle="clear"

          i18n-popupLabel="kendo.multiselect.popupLabel|The label of the popup element that contains the list of options when its role is 'region'"
          popupLabel="Options list"

          i18n-adaptiveCloseButtonTitle="kendo.multiselect.adaptiveCloseButtonTitle|The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode."
          adaptiveCloseButtonTitle="Close"

          i18n-useCustomValueText="kendo.multiselect.useCustomValueText|The text displayed when the user types a custom value that is not in the list of options."
          useCustomValueText="{{ 'Use &quot;{customValue}&quot;' }}"
          >
        </ng-container>

        <ng-container
          kendoDropDownSharedEvents
          [hostElement]="wrapper"
          [(isFocused)]="isFocused"
          (handleBlur)="handleBlur()"
          (onFocus)="handleFocus()"
          >
          @if (prefixTemplate) {
            <span class="k-input-prefix k-input-prefix-horizontal">
              <ng-template [ngTemplateOutlet]="prefixTemplate?.templateRef">
              </ng-template>
            </span>
          }
          @if (prefixTemplate && prefixTemplate.showSeparator) {
            <kendo-separator></kendo-separator>
          }
          <div class="k-input-values">
            <kendo-taglist
              [size]="size"
              [rounded]="rounded"
              [fillMode]="fillMode"
              [id]="tagListId"
              [tags]="tags"
              [textField]="textField"
              [valueField]="valueField"
              [focused]="focusedTagIndex"
              [disabled]="disabled"
              [template]="tagTemplate"
              [groupTemplate]="groupTagTemplate"
              [tagPrefix]="tagPrefix"
              [disabledIndices]="disabledIndices"
              (removeTag)="handleRemoveTag($event)"
              >
            </kendo-taglist>
            <input
              kendoSearchbar
              [ariaControls]="ariaControls"
              [ariaExpanded]="isOpen"
              [id]="focusableId"
              [tagListId]="tagListId"
              [isLoading]="loading"
              [isFilterable]="filterable"
              [activeDescendant]="activeDescendant"
              [userInput]="text"
              [disabled]="disabled"
              [readonly]="readonly || this.isAdaptive"
              [tabIndex]="tabIndex"
              [isRequired]="isControlRequired"
              [placeholder]="placeholder"
              [inputAttributes]="inputAttributes"
              (onNavigate)="handleNavigate($event)"
              (valueChange)="handleFilter($event)"
              (onBlur)="handleInputBlur()"
              (onFocus)="handleInputFocus()"
              (click)="handleClick()"
              />
          </div>

          @if (!loading && !readonly && clearButton && (tags?.length || text?.length)) {
            <span
              class="k-clear-value"
              [style.visibility]="clearButtonVisibility"
              [attr.title]="messageFor('clearTitle')"
              role="button"
              tabindex="-1"
              (mousedown)="clearAll($event)"
              >
              <kendo-icon-wrapper
                class="k-icon"
                name="x"
                [svgIcon]="xIcon"
                >
              </kendo-icon-wrapper>
            </span>
          }
          @if (loading) {
            <span
              class="k-icon k-i-loading k-input-loading-icon"
              >
            </span>
          }
          @if (suffixTemplate && suffixTemplate.showSeparator) {
            <kendo-separator></kendo-separator>
          }
          @if (suffixTemplate) {
            <span class="k-input-suffix k-input-suffix-horizontal">
              <ng-template [ngTemplateOutlet]="suffixTemplate?.templateRef">
              </ng-template>
            </span>
          }
        </ng-container>

        <ng-template #popupTemplate>
          <ng-container *ngTemplateOutlet="sharedPopupActionSheetTemplate"></ng-container>
        </ng-template>
        @if (isOpen || isAdaptiveModeEnabled) {
          <kendo-resize-sensor (resize)="onResize()"></kendo-resize-sensor>
        }
        <ng-container #container></ng-container>

        <kendo-adaptive-renderer
          [sharedPopupActionSheetTemplate]="sharedPopupActionSheetTemplate"
          [title]="adaptiveTitle"
          [showTextInput]="true"
          [subtitle]="adaptiveSubtitle"
          (closePopup)="applyValue()"
          (textInputChange)="handleFilter($event)"
          [placeholder]="placeholder"
          (navigate)="handleNavigate($event)"
          [searchBarValue]="text">
        </kendo-adaptive-renderer>

        <ng-template #sharedPopupActionSheetTemplate>
          <!--header template-->
          @if (headerTemplate) {
            <ng-template
                [templateContext]="{
                    templateRef: headerTemplate.templateRef
                }">
            </ng-template>
          }
          <!--list-->
          <kendo-list
            #optionsList
            [size]="isAdaptive ? 'large' : size"
            [rounded]="rounded"
            [id]="listBoxId"
            [optionPrefix]="optionPrefix"
            [data]="data"
            [textField]="textField"
            [valueField]="valueField"
            [template]="template"
            [groupTemplate]="groupTemplate"
            [fixedGroupTemplate]="fixedGroupTemplate"
            [height]="listHeight"
            [show]="isOpen"
            [multipleSelection]="true"
            [virtual]="virtual"
            (pageChange)="pageChange($event)"
            [checkboxes]="checkboxes"
            [isMultiselect]="true"
            [isActionSheetExpanded]="isActionSheetExpanded"
            [showStickyHeader]="showStickyHeader"
            [customItemTemplate]="customItemTemplate"
            [text]="text"
            [allowCustom]="allowCustom"
            >
          </kendo-list>
          <!--no data template-->
          @if (data.length === 0) {
            <div class="k-no-data" [attr.aria-live]="'polite'">
              @if (noDataTemplate) {
                <ng-template
                    [templateContext]="{
                        templateRef: noDataTemplate ? noDataTemplate.templateRef : undefined
                    }">
                </ng-template>
              }
              @if (!noDataTemplate) {
                <div>{{ messageFor('noDataText') }}</div>
              }
            </div>
          }
          <!--footer template-->
          @if (footerTemplate) {
            <ng-template
                [templateContext]="{
                    templateRef: footerTemplate.templateRef
                }">
            </ng-template>
          }
        </ng-template>
        `,
      standalone: true,
      imports: [LocalizedMessagesDirective, SharedDropDownEventsDirective, NgTemplateOutlet, SeparatorComponent, TagListComponent, SearchBarComponent, IconWrapperComponent, ResizeSensorComponent, AdaptiveRendererComponent, TemplateContextDirective, ListComponent]
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i1.LocalizationService
  }, {
    type: i2.PopupService
  }, {
    type: DataService
  }, {
    type: SelectionService
  }, {
    type: NavigationService
  }, {
    type: DisabledItemsService
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i0.KeyValueDiffers
  }, {
    type: i0.Renderer2
  }, {
    type: i0.NgZone
  }, {
    type: i0.Injector
  }, {
    type: i7.AdaptiveService
  }], {
    adaptiveRendererComponent: [{
      type: ViewChild,
      args: [AdaptiveRendererComponent]
    }],
    showStickyHeader: [{
      type: Input
    }],
    focusableId: [{
      type: Input
    }],
    autoClose: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    data: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    valueField: [{
      type: Input
    }],
    textField: [{
      type: Input
    }],
    tabindex: [{
      type: Input
    }],
    tabIndex: [{
      type: Input,
      args: ["tabIndex"]
    }],
    size: [{
      type: Input
    }],
    rounded: [{
      type: Input
    }],
    fillMode: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    adaptiveMode: [{
      type: Input
    }],
    adaptiveTitle: [{
      type: Input
    }],
    adaptiveSubtitle: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    itemDisabled: [{
      type: Input
    }],
    checkboxes: [{
      type: Input
    }],
    readonly: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['class.k-readonly']
    }],
    filterable: [{
      type: Input
    }],
    virtual: [{
      type: Input
    }],
    popupSettings: [{
      type: Input
    }],
    listHeight: [{
      type: Input
    }],
    valuePrimitive: [{
      type: Input
    }],
    clearButton: [{
      type: Input
    }],
    tagMapper: [{
      type: Input
    }],
    allowCustom: [{
      type: Input
    }],
    valueNormalizer: [{
      type: Input
    }],
    inputAttributes: [{
      type: Input
    }],
    filterChange: [{
      type: Output
    }],
    valueChange: [{
      type: Output
    }],
    open: [{
      type: Output
    }],
    opened: [{
      type: Output
    }],
    close: [{
      type: Output
    }],
    closed: [{
      type: Output
    }],
    onFocus: [{
      type: Output,
      args: ['focus']
    }],
    onBlur: [{
      type: Output,
      args: ['blur']
    }],
    inputFocus: [{
      type: Output
    }],
    inputBlur: [{
      type: Output
    }],
    removeTag: [{
      type: Output
    }],
    container: [{
      type: ViewChild,
      args: ['container', {
        read: ViewContainerRef,
        static: true
      }]
    }],
    searchbar: [{
      type: ViewChild,
      args: [SearchBarComponent, {
        static: true
      }]
    }],
    tagList: [{
      type: ViewChild,
      args: [TagListComponent, {
        static: true
      }]
    }],
    popupTemplate: [{
      type: ViewChild,
      args: ['popupTemplate', {
        static: true
      }]
    }],
    optionsList: [{
      type: ViewChild,
      args: ['optionsList', {
        static: false
      }]
    }],
    template: [{
      type: ContentChild,
      args: [ItemTemplateDirective, {
        static: false
      }]
    }],
    customItemTemplate: [{
      type: ContentChild,
      args: [CustomItemTemplateDirective, {
        static: false
      }]
    }],
    groupTemplate: [{
      type: ContentChild,
      args: [GroupTemplateDirective, {
        static: false
      }]
    }],
    fixedGroupTemplate: [{
      type: ContentChild,
      args: [FixedGroupTemplateDirective, {
        static: false
      }]
    }],
    headerTemplate: [{
      type: ContentChild,
      args: [HeaderTemplateDirective, {
        static: false
      }]
    }],
    footerTemplate: [{
      type: ContentChild,
      args: [FooterTemplateDirective, {
        static: false
      }]
    }],
    tagTemplate: [{
      type: ContentChild,
      args: [TagTemplateDirective, {
        static: false
      }]
    }],
    groupTagTemplate: [{
      type: ContentChild,
      args: [GroupTagTemplateDirective, {
        static: false
      }]
    }],
    noDataTemplate: [{
      type: ContentChild,
      args: [NoDataTemplateDirective, {
        static: false
      }]
    }],
    suffixTemplate: [{
      type: ContentChild,
      args: [SuffixTemplateDirective]
    }],
    prefixTemplate: [{
      type: ContentChild,
      args: [PrefixTemplateDirective]
    }],
    dir: [{
      type: HostBinding,
      args: ['attr.dir']
    }],
    disabledClass: [{
      type: HostBinding,
      args: ['class.k-disabled']
    }],
    isLoading: [{
      type: HostBinding,
      args: ['class.k-loading']
    }]
  });
})();

/**
 * Renders the column cell content of the MultiColumnComboBox component.
 *
 * To define a column cell template, nest an `<ng-template>` tag with the `kendoMultiColumnComboBoxColumnCellTemplate` directive inside the [`<kendo-combobox-column>`](https://www.telerik.com/kendo-angular-ui/components/dropdowns/api/comboboxcolumncomponent) tag.
 * [See example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multicolumncombobox/templates).
 *
 * The context variables are:
 * - `let-dataItem="dataItem"` (`any`)&mdash;The current data item. Also available as the implicit context variable.
 * - `let-column="column"` ([`ColumnComponent`](https://www.telerik.com/kendo-angular-ui/components/dropdowns/api/comboboxcolumncomponent))&mdash;The current column configuration object.
 *
 * @example
 * ```html
 * <kendo-multicolumncombobox ...>
 *   <kendo-combobox-column field="name" title="Name">
 *     <ng-template kendoMultiColumnComboBoxColumnCellTemplate let-dataItem="dataItem" let-column="column">
 *       {{ dataItem[column.field] }}
 *     </ng-template>
 *   </kendo-combobox-column>
 * </kendo-multicolumncombobox>
 * ```
 */
class ColumnCellTemplateDirective {
  templateRef;
  constructor(templateRef) {
    this.templateRef = templateRef;
  }
  static ɵfac = function ColumnCellTemplateDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ColumnCellTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ColumnCellTemplateDirective,
    selectors: [["", "kendoMultiColumnComboBoxColumnCellTemplate", ""]]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ColumnCellTemplateDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoMultiColumnComboBoxColumnCellTemplate]',
      standalone: true
    }]
  }], () => [{
    type: i0.TemplateRef
  }], null);
})();

/**
 * Renders the column header content of the MultiColumnComboBox component.
 *
 * To define a column header template, nest an `<ng-template>` tag with the `kendoMultiColumnComboBoxColumnHeaderTemplate` directive inside the [`<kendo-combobox-column>`](https://www.telerik.com/kendo-angular-ui/components/dropdowns/api/comboboxcolumncomponent) tag.
 * [See example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multicolumncombobox/templates).
 *
 * The current [`column`](https://www.telerik.com/kendo-angular-ui/components/dropdowns/api/comboboxcolumncomponent) is available as the implicit context variable.
 *
 * @example
 * ```html
 * <kendo-multicolumncombobox ...>
 *   <kendo-combobox-column field="name" title="Name">
 *     <ng-template kendoMultiColumnComboBoxColumnHeaderTemplate let-column="column">
 *       {{ column.title }}
 *     </ng-template>
 *   </kendo-combobox-column>
 * </kendo-multicolumncombobox>
 * ```
 */
class ColumnHeaderTemplateDirective {
  templateRef;
  constructor(templateRef) {
    this.templateRef = templateRef;
  }
  static ɵfac = function ColumnHeaderTemplateDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ColumnHeaderTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ColumnHeaderTemplateDirective,
    selectors: [["", "kendoMultiColumnComboBoxColumnHeaderTemplate", ""]]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ColumnHeaderTemplateDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoMultiColumnComboBoxColumnHeaderTemplate]',
      standalone: true
    }]
  }], () => [{
    type: i0.TemplateRef
  }], null);
})();

/**
 * Represents the column definition for the MultiColumnComboBox component.
 *
 * Use this component to define columns inside the MultiColumnComboBox.
 * [See example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multicolumncombobox/columns).
 *
 * @example
 * ```html
 * <kendo-multicolumncombobox ...>
 *   <kendo-combobox-column field="name" title="Name" width="200"></kendo-combobox-column>
 * </kendo-multicolumncombobox>
 * ```
 */
class ComboBoxColumnComponent {
  /**
   * @hidden
   */
  cellTemplate;
  /**
   * @hidden
   */
  headerTemplate;
  /**
   * Sets the field to which the column is bound.
   *
   * > The `field` property can be set to point to a nested property value - e.g. `category.name`.
   */
  field;
  /**
   * Sets the title of the column.
   */
  title;
  /**
   * Sets the width of the column (in pixels).
   */
  width;
  /**
   * Controls the visibility of the column. When `true`, hides the column from view.
   * @default false
   */
  hidden = false;
  /**
   * Sets custom styles for the table cells of the column (except for the header cells).
   *
   * The `style` property uses the NgStyle directive to apply styles.
   */
  style;
  /**
   * Sets custom styles for the header cell of the column.
   *
   * The `headerStyle` property uses the NgStyle directive to apply styles.
   */
  headerStyle;
  /**
   * Sets custom CSS classes for the column cells.
   *
   * The `class` property uses the NgClass directive to apply classes.
   */
  class;
  /**
   * Sets custom CSS classes for the column header cell.
   *
   * The `headerClass` property uses the NgClass directive to apply classes.
   */
  headerClass;
  /**
   * Sets the condition that needs to be satisfied for a column to remain visible. If you set the [`hidden`](https://www.telerik.com/kendo-angular-ui/components/dropdowns/api/comboboxcolumncomponent#hidden) property, the behavior of media is overridden.
   */
  media;
  /**
   * @hidden
   */
  matchesMedia = true;
  static ɵfac = function ComboBoxColumnComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ComboBoxColumnComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ComboBoxColumnComponent,
    selectors: [["kendo-combobox-column"]],
    contentQueries: function ComboBoxColumnComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, ColumnCellTemplateDirective, 5)(dirIndex, ColumnHeaderTemplateDirective, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cellTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
      }
    },
    inputs: {
      field: "field",
      title: "title",
      width: "width",
      hidden: "hidden",
      style: "style",
      headerStyle: "headerStyle",
      class: "class",
      headerClass: "headerClass",
      media: "media"
    },
    decls: 0,
    vars: 0,
    template: function ComboBoxColumnComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComboBoxColumnComponent, [{
    type: Component,
    args: [{
      selector: 'kendo-combobox-column',
      template: '',
      standalone: true
    }]
  }], null, {
    cellTemplate: [{
      type: ContentChild,
      args: [ColumnCellTemplateDirective, {
        static: false
      }]
    }],
    headerTemplate: [{
      type: ContentChild,
      args: [ColumnHeaderTemplateDirective, {
        static: false
      }]
    }],
    field: [{
      type: Input
    }],
    title: [{
      type: Input
    }],
    width: [{
      type: Input
    }],
    hidden: [{
      type: Input
    }],
    style: [{
      type: Input
    }],
    headerStyle: [{
      type: Input
    }],
    class: [{
      type: Input
    }],
    headerClass: [{
      type: Input
    }],
    media: [{
      type: Input
    }]
  });
})();

/**
 * Checks if all columns have a valid user-defined width.
 *
 * Returns `true` if all columns have a valid width, otherwise returns `false`.
 */
const allColumnsWidthsSet = columns => {
  if (!isPresent(columns) || columns.length === 0) {
    return false;
  }
  return columns.toArray().every(column => !isNaN(column.width) && column.width > 0);
};
/**
 * @hidden
 *
 * Calculates the row width based on the columns' width configuration.
 *
 * Ignores hidden columns and columns that do not match the provided media query.
 * Returns `null` if any column does not have a valid width.
 */
const getRowWidthFromColumnsMeta = columns => {
  if (!allColumnsWidthsSet(columns)) {
    return null;
  }
  const bordersWidth = 2;
  const initialRowWidht = scrollbarWidth() + bordersWidth;
  return columns.reduce((totalWidth, column) => {
    if (!column.hidden && column.matchesMedia) {
      totalWidth += parseInt(column.width, 10);
    }
    return totalWidth;
  }, initialRowWidht);
};

/**
 * Represents the Kendo UI MultiColumnComboBox component for Angular.
 *
 * Use the `MultiColumnComboBoxComponent` to show a dropdown list with multiple columns.
 * [See example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multicolumncombobox).
 *
 * @example
 * ```html
 * <kendo-multicolumncombobox [data]="data" [columns]="columns"></kendo-multicolumncombobox>
 * ```
 *
 * @remarks
 * Supported children components are: {@link ComboBoxColumnComponent}, {@link CustomMessagesComponent}.
 */
class MultiColumnComboBoxComponent extends ComboBoxComponent {
  hostElement;
  /**
   * @hidden
   */
  animationDuration = animationDuration;
  /**
   * @hidden
   */
  hostClasses = true;
  /**
   * @hidden
   */
  get isDisabled() {
    return this.disabled;
  }
  /**
   * Contains a query list of all declared `ComboBoxColumnComponent` columns.
   * Use this property to access and configure the columns displayed in the dropdown.
   */
  columns;
  /**
   * @hidden
   */
  set header(header) {
    // updates the header padding on initial render as the resize senzor doesn't kick in as early
    this.updateHeaderPadding(header && header.nativeElement);
  }
  /**
   * @hidden
   */
  set headerTable(headerTable) {
    this._headerTable = headerTable;
    if (this.headerTable) {
      this.zone.onStable.pipe(take(1)).subscribe(() => {
        this.rowWidth = this.calculateRowWidth();
      });
    }
  }
  get headerTable() {
    return this._headerTable;
  }
  /**
   * @hidden
   */
  set headerColumns(columns) {
    this.zone.onStable.pipe(take(1)).subscribe(() => {
      this.headerColumnWidths = columns.map(column => column.nativeElement.offsetWidth);
    });
  }
  /**
   * @hidden
   */
  rowWidth;
  /**
   * @hidden
   */
  headerColumnWidths = [];
  /**
   * @hidden
   */
  totalColumnsWidth;
  get popupWidth() {
    const wrapperOffsetWidth = this.wrapper.nativeElement.offsetWidth;
    const min = `${wrapperOffsetWidth}px`;
    const width = this.popupSettings.width || getRowWidthFromColumnsMeta(this.columns) || wrapperOffsetWidth;
    const max = isNaN(width) ? width : `${width}px`;
    return {
      min,
      max
    };
  }
  _headerTable;
  removeWindowResizeListener = noop;
  columnsChangeSubscription = new Subscription();
  /**
   * @hidden
   */
  get tableSizeClass() {
    return `${this.size ? getSizeClass('table', this.size) : ''}`;
  }
  /**
   * @hidden
   */
  get listContainerClasses() {
    const containerClasses = ['k-popup', 'k-dropdowngrid-popup'];
    if (!this.popupSettings.popupClass) {
      return containerClasses;
    }
    const parsedPopupClasses = parseCSSClassNames(this.popupSettings.popupClass);
    if (parsedPopupClasses?.length) {
      containerClasses.push(...parsedPopupClasses);
    }
    return containerClasses;
  }
  constructor(localization, popupService, selectionService, navigationService, disabledItemsService, dataService, zone, changeDetector, renderer, wrapper, injector, hostElement, adaptiveService) {
    super(wrapper, localization, popupService, selectionService, navigationService, disabledItemsService, dataService, zone, changeDetector, renderer, injector, hostElement, adaptiveService);
    this.hostElement = hostElement;
    // the row height in @progress/kendo-theme-default
    this.defaultVirtualItemHeight = 36;
    // use a smaller virtual page size as columns with multiple cells can cause poor performance
    this.defaultVirtualPageSize = 30;
  }
  ngAfterViewInit() {
    this.updateColumnsMediaState();
    this.addWindowResizeListener();
    this.windowSize = this.adaptiveService.size;
    this.rowWidth = this.calculateRowWidth();
    this.totalColumnsWidth = this.columns.reduce((total, currentColumn) => total + currentColumn.width, 0);
    this.columnsChangeSubscription = this.columns.changes.subscribe(() => {
      this.rowWidth = this.calculateRowWidth();
      this.totalColumnsWidth = this.columns.reduce((total, currentColumn) => total + currentColumn.width, 0);
    });
    this.cdr.detectChanges();
  }
  ngOnDestroy() {
    super.ngOnDestroy();
    this.removeWindowResizeListener();
    if (this.columnsChangeSubscription) {
      this.columnsChangeSubscription.unsubscribe();
    }
  }
  /**
   * @hidden
   */
  textFrom(dataItem, field) {
    return getter(dataItem, field);
  }
  /**
   * @hidden
   *
   * Adds or removes a padding value at the end of the header container equal to the size of the scrollbar.
   * As when the items container has a scrollbar, the column headers and the cells are misaligned.
   * When the container has a scrollbar, the padding style is added, and when there is none - it is removed.
   */
  updateHeaderPadding(header) {
    if (!isPresent(header)) {
      return;
    }
    // the scrollbar is rendered on the left in rtl
    const headerPaddingPosition = this.localization.rtl ? 'padding-left' : 'padding-right';
    if (this.optionsList.hasScrollbar() && scrollbarWidth() > 0) {
      this.renderer.setStyle(header, headerPaddingPosition, `${scrollbarWidth()}px`);
    } else {
      this.renderer.removeStyle(header, headerPaddingPosition);
    }
  }
  /**
   *
   * @hidden
   */
  getColumnWidth(index) {
    if (!this.virtual) {
      return this.columns.get(index).width;
    }
    return this.headerColumnWidths[index];
  }
  verifySettings() {
    if (!isDevMode()) {
      return;
    }
    if (isPresent(this.data) && this.data.length > 0 && this.data.some(item => !isObject(item))) {
      throw new Error(MultiColumnComboBoxMessages.data);
    }
    if (!isPresent(this.valueField) || !isPresent(this.textField)) {
      throw new Error(MultiColumnComboBoxMessages.textAndValue);
    }
    super.verifySettings();
  }
  addWindowResizeListener() {
    if (!isDocumentAvailable()) {
      return;
    }
    this.zone.runOutsideAngular(() => this.removeWindowResizeListener = this.renderer.listen(window, 'resize', this.updateColumnsMediaState.bind(this)));
  }
  updateColumnsMediaState() {
    if (!(isPresent(this.columns) && isDocumentAvailable()) || this.isActionSheetExpanded) {
      return;
    }
    this.columns.forEach(column => {
      const matchesMedia = !column.media || window.matchMedia(column.media).matches;
      if (column.matchesMedia !== matchesMedia) {
        column.matchesMedia = matchesMedia;
        if (this.isOpen) {
          // enter the zone only if the popup is actually open
          // update its width in case it's dependent on the columns' width
          this.zone.run(() => this.popupRef.popupElement.style.width = this.popupWidth.max);
        }
      }
    });
  }
  calculateRowWidth() {
    if (this.isActionSheetExpanded || !this.virtual) {
      return;
    }
    return this.headerTable?.nativeElement.offsetWidth;
  }
  static ɵfac = function MultiColumnComboBoxComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MultiColumnComboBoxComponent)(i0.ɵɵdirectiveInject(i1.LocalizationService), i0.ɵɵdirectiveInject(i2.PopupService), i0.ɵɵdirectiveInject(SelectionService), i0.ɵɵdirectiveInject(NavigationService), i0.ɵɵdirectiveInject(DisabledItemsService), i0.ɵɵdirectiveInject(DataService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i7.AdaptiveService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MultiColumnComboBoxComponent,
    selectors: [["kendo-multicolumncombobox"]],
    contentQueries: function MultiColumnComboBoxComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, ComboBoxColumnComponent, 4);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.columns = _t);
      }
    },
    viewQuery: function MultiColumnComboBoxComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c21, 5)(_c22, 5)(_c23, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.header = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTable = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerColumns = _t);
      }
    },
    hostVars: 4,
    hostBindings: function MultiColumnComboBoxComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("k-dropdowngrid", ctx.hostClasses)("k-disabled", ctx.isDisabled);
      }
    },
    features: [i0.ɵɵProvidersFeature([SelectionService, DataService, NavigationService, DisabledItemsService, LocalizationService, {
      provide: L10N_PREFIX,
      useValue: 'kendo.multicolumncombobox'
    }, {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiColumnComboBoxComponent)
    }, {
      provide: KendoInput,
      useExisting: forwardRef(() => MultiColumnComboBoxComponent)
    }, {
      provide: FilterableComponent,
      useExisting: forwardRef(() => MultiColumnComboBoxComponent)
    }, {
      provide: MultiTabStop,
      useExisting: forwardRef(() => MultiColumnComboBoxComponent)
    }, {
      provide: KENDO_WEBMCP_HOST,
      useExisting: forwardRef(() => MultiColumnComboBoxComponent)
    }]), i0.ɵɵInheritDefinitionFeature],
    decls: 20,
    vars: 38,
    consts: () => {
      let i18n_19;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text displayed in the popup when there are no items
         * @meaning kendo.multicolumncombobox.noDataText
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_19 = goog.getMsg("NO DATA FOUND");
        i18n_19 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_19;
      } else {
        i18n_19 = $localize`:kendo.multicolumncombobox.noDataText|The text displayed in the popup when there are no items:NO DATA FOUND`;
      }
      let i18n_20;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the clear button
         * @meaning kendo.multicolumncombobox.clearTitle
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_20 = goog.getMsg("clear");
        i18n_20 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_20;
      } else {
        i18n_20 = $localize`:kendo.multicolumncombobox.clearTitle|The title of the clear button:clear`;
      }
      let i18n_21;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the select button
         * @meaning kendo.multicolumncombobox.selectButtonText
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_21 = goog.getMsg("Select");
        i18n_21 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_21;
      } else {
        i18n_21 = $localize`:kendo.multicolumncombobox.selectButtonText|The title of the select button:Select`;
      }
      let i18n_22;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The label of the popup element that contains the list of options
         *                 when its role is 'region'
         * @meaning kendo.multicolumncombobox.popupLabel
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_22 = goog.getMsg("Options list");
        i18n_22 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_22;
      } else {
        i18n_22 = $localize`:kendo.multicolumncombobox.popupLabel|The label of the popup element that contains the list of options
                when its role is 'region':Options list`;
      }
      let i18n_23;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode
         * @meaning kendo.multicolumncombobox.adaptiveCloseButtonTitle
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_23 = goog.getMsg("Close");
        i18n_23 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_23;
      } else {
        i18n_23 = $localize`:kendo.multicolumncombobox.adaptiveCloseButtonTitle|The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode:Close`;
      }
      return [["select", ""], ["popupTemplate", ""], ["container", ""], ["sharedPopupActionSheetTemplate", ""], ["header", ""], ["headerWrap", ""], ["headerTable", ""], ["rowTemplate", ""], ["optionsList", ""], ["columnHeader", ""], ["kendoMultiColumnComboBoxLocalizedMessages", "", "noDataText", i18n_19, "clearTitle", i18n_20, "selectButtonText", i18n_21, "popupLabel", i18n_22, "adaptiveCloseButtonTitle", i18n_23], ["kendoDropDownSharedEvents", "", 3, "isFocusedChange", "handleBlur", "onFocus", "hostElement", "isFocused"], [1, "k-input-prefix", "k-input-prefix-horizontal"], ["kendoSearchbar", "", 3, "onNavigate", "valueChange", "onBlur", "onFocus", "click", "ariaControls", "ariaExpanded", "id", "isLoading", "isSuggestable", "isFilterable", "activeDescendant", "userInput", "suggestedText", "disabled", "readonly", "tabIndex", "isRequired", "placeholder", "inputAttributes"], ["aria-hidden", "true", 1, "k-clear-value", 3, "visibility", "kendoEventsOutsideAngular"], [1, "k-i-loading", "k-input-loading-icon", "k-icon"], [1, "k-input-suffix", "k-input-suffix-horizontal"], ["tabindex", "-1", "unselectable", "on", "type", "button", 1, "k-input-button", "k-button", "k-icon-button", 3, "ngClass", "kendoEventsOutsideAngular"], ["innerCssClass", "k-button-icon", 3, "name", "svgIcon"], [3, "closePopup", "textInputChange", "navigate", "sharedPopupActionSheetTemplate", "title", "showTextInput", "subtitle", "placeholder", "searchBarValue"], [3, "ngTemplateOutlet"], ["aria-hidden", "true", 1, "k-clear-value", 3, "click", "kendoEventsOutsideAngular"], ["name", "x", 3, "svgIcon"], [4, "ngTemplateOutlet"], [3, "resize"], [3, "templateContext"], [1, "k-data-table", 3, "ngClass"], [1, "k-table-header"], [1, "k-table-header-wrap"], ["role", "presentation", 1, "k-table"], [1, "k-table-thead"], [1, "k-table-row"], [3, "pageChange", "listResize", "popupListScroll", "optionPrefix", "data", "size", "textField", "valueField", "template", "groupTemplate", "fixedGroupTemplate", "height", "show", "id", "virtual", "type", "rowWidth", "showStickyHeader"], [1, "k-no-data"], [1, "k-table-footer"], [3, "width"], [1, "k-table-th", 3, "ngStyle", "ngClass"], [1, "k-table-td", 3, "ngClass", "width", "max-width", "ngStyle"], [1, "k-table-td", 3, "ngClass", "ngStyle"], [1, "k-table"], [1, "k-table-tfoot"], [1, "k-table-td"]];
    },
    template: function MultiColumnComboBoxComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementContainer(0, 10);
        i0.ɵɵelementContainerStart(1, 11);
        i0.ɵɵtwoWayListener("isFocusedChange", function MultiColumnComboBoxComponent_Template_ng_container_isFocusedChange_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          i0.ɵɵtwoWayBindingSet(ctx.isFocused, $event) || (ctx.isFocused = $event);
          return i0.ɵɵresetView($event);
        });
        i0.ɵɵlistener("handleBlur", function MultiColumnComboBoxComponent_Template_ng_container_handleBlur_1_listener() {
          return ctx.handleBlur();
        })("onFocus", function MultiColumnComboBoxComponent_Template_ng_container_onFocus_1_listener() {
          return ctx.handleFocus();
        });
        i0.ɵɵconditionalCreate(2, MultiColumnComboBoxComponent_Conditional_2_Template, 2, 1, "span", 12);
        i0.ɵɵconditionalCreate(3, MultiColumnComboBoxComponent_Conditional_3_Template, 1, 0, "kendo-separator");
        i0.ɵɵelementStart(4, "input", 13);
        i0.ɵɵlistener("onNavigate", function MultiColumnComboBoxComponent_Template_input_onNavigate_4_listener($event) {
          return ctx.handleNavigate($event);
        })("valueChange", function MultiColumnComboBoxComponent_Template_input_valueChange_4_listener($event) {
          return ctx.searchBarChange($event);
        })("onBlur", function MultiColumnComboBoxComponent_Template_input_onBlur_4_listener() {
          return ctx.handleInputBlur();
        })("onFocus", function MultiColumnComboBoxComponent_Template_input_onFocus_4_listener() {
          return ctx.handleInputFocus();
        })("click", function MultiColumnComboBoxComponent_Template_input_click_4_listener() {
          return ctx.handleClick();
        });
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(5, MultiColumnComboBoxComponent_Conditional_5_Template, 2, 7, "span", 14);
        i0.ɵɵconditionalCreate(6, MultiColumnComboBoxComponent_Conditional_6_Template, 1, 0, "span", 15);
        i0.ɵɵconditionalCreate(7, MultiColumnComboBoxComponent_Conditional_7_Template, 1, 0, "kendo-separator");
        i0.ɵɵconditionalCreate(8, MultiColumnComboBoxComponent_Conditional_8_Template, 2, 1, "span", 16);
        i0.ɵɵelementStart(9, "button", 17, 0);
        i0.ɵɵelement(11, "kendo-icon-wrapper", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerEnd();
        i0.ɵɵtemplate(12, MultiColumnComboBoxComponent_ng_template_12_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵconditionalCreate(14, MultiColumnComboBoxComponent_Conditional_14_Template, 1, 0, "kendo-resize-sensor");
        i0.ɵɵelementContainer(15, null, 2);
        i0.ɵɵelementStart(17, "kendo-adaptive-renderer", 19);
        i0.ɵɵlistener("closePopup", function MultiColumnComboBoxComponent_Template_kendo_adaptive_renderer_closePopup_17_listener() {
          return ctx.closeActionSheet();
        })("textInputChange", function MultiColumnComboBoxComponent_Template_kendo_adaptive_renderer_textInputChange_17_listener($event) {
          return ctx.searchBarChange($event);
        })("navigate", function MultiColumnComboBoxComponent_Template_kendo_adaptive_renderer_navigate_17_listener($event) {
          return ctx.handleNavigate($event);
        });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(18, MultiColumnComboBoxComponent_ng_template_18_Template, 21, 21, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const sharedPopupActionSheetTemplate_r4 = i0.ɵɵreference(19);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hostElement", ctx.hostElement);
        i0.ɵɵtwoWayProperty("isFocused", ctx.isFocused);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.prefixTemplate ? 2 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.prefixTemplate && ctx.prefixTemplate.showSeparator ? 3 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ariaControls", ctx.ariaControls)("ariaExpanded", ctx.isOpen)("id", ctx.focusableId)("isLoading", ctx.loading)("isSuggestable", ctx.suggest)("isFilterable", ctx.filterable)("activeDescendant", ctx.activeDescendant)("userInput", ctx.text)("suggestedText", ctx.getSuggestion())("disabled", ctx.disabled)("readonly", ctx.readonly)("tabIndex", ctx.tabIndex)("isRequired", ctx.isControlRequired)("placeholder", ctx.placeholder)("inputAttributes", ctx.inputAttributes);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.clearButton && !ctx.loading && !ctx.disabled && (!ctx.readonly || ctx.readonly && ctx.isAdaptiveModeEnabled && ctx.windowSize !== "large") && (ctx.text == null ? null : ctx.text.length) ? 5 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.loading ? 6 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.suffixTemplate && ctx.suffixTemplate.showSeparator ? 7 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.suffixTemplate ? 8 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", ctx.selectButtonClasses)("kendoEventsOutsideAngular", i0.ɵɵpureFunction1(36, _c17, ctx.preventEventDefault));
        i0.ɵɵattribute("aria-label", ctx.messageFor("selectButtonText"))("disabled", ctx.disabled ? "" : null);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("name", ctx.icon || "chevron-down")("svgIcon", ctx.svgIcon || ctx.chevronDownIcon);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.isOpen || ctx.isAdaptiveModeEnabled ? 14 : -1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("sharedPopupActionSheetTemplate", sharedPopupActionSheetTemplate_r4)("title", ctx.adaptiveTitle)("showTextInput", true)("subtitle", ctx.adaptiveSubtitle)("placeholder", ctx.placeholder)("searchBarValue", ctx.text);
      }
    },
    dependencies: [LocalizedMessagesDirective, SharedDropDownEventsDirective, NgTemplateOutlet, SeparatorComponent, SearchBarComponent, EventsOutsideAngularDirective, IconWrapperComponent, NgClass, ResizeSensorComponent, AdaptiveRendererComponent, TemplateContextDirective, NgStyle, ListComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiColumnComboBoxComponent, [{
    type: Component,
    args: [{
      providers: [SelectionService, DataService, NavigationService, DisabledItemsService, LocalizationService, {
        provide: L10N_PREFIX,
        useValue: 'kendo.multicolumncombobox'
      }, {
        multi: true,
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => MultiColumnComboBoxComponent)
      }, {
        provide: KendoInput,
        useExisting: forwardRef(() => MultiColumnComboBoxComponent)
      }, {
        provide: FilterableComponent,
        useExisting: forwardRef(() => MultiColumnComboBoxComponent)
      }, {
        provide: MultiTabStop,
        useExisting: forwardRef(() => MultiColumnComboBoxComponent)
      }, {
        provide: KENDO_WEBMCP_HOST,
        useExisting: forwardRef(() => MultiColumnComboBoxComponent)
      }],
      selector: 'kendo-multicolumncombobox',
      template: `
        <ng-container
          kendoMultiColumnComboBoxLocalizedMessages
            i18n-noDataText="
                kendo.multicolumncombobox.noDataText|The text displayed in the popup when there are no items
            "
          noDataText="NO DATA FOUND"
          i18n-clearTitle="kendo.multicolumncombobox.clearTitle|The title of the clear button"
          clearTitle="clear"
          i18n-selectButtonText="kendo.multicolumncombobox.selectButtonText|The title of the select button"
          selectButtonText="Select"
            i18n-popupLabel="
                kendo.multicolumncombobox.popupLabel|The label of the popup element that contains the list of options
                when its role is 'region'
            "
          popupLabel="Options list"
          i18n-adaptiveCloseButtonTitle="kendo.multicolumncombobox.adaptiveCloseButtonTitle|The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode"
          adaptiveCloseButtonTitle="Close"
        ></ng-container>

        <ng-container
          kendoDropDownSharedEvents
          [hostElement]="hostElement"
          [(isFocused)]="isFocused"
          (handleBlur)="handleBlur()"
          (onFocus)="handleFocus()"
          >
          @if (prefixTemplate) {
            <span class="k-input-prefix k-input-prefix-horizontal">
              <ng-template [ngTemplateOutlet]="prefixTemplate?.templateRef">
              </ng-template>
            </span>
          }
          @if (prefixTemplate && prefixTemplate.showSeparator) {
            <kendo-separator></kendo-separator>
          }
          <input
            kendoSearchbar
            [ariaControls]="ariaControls"
            [ariaExpanded]="isOpen"
            [id]="focusableId"
            [isLoading]="loading"
            [isSuggestable]="suggest"
            [isFilterable]="filterable"
            [activeDescendant]="activeDescendant"
            [userInput]="text"
            [suggestedText]="getSuggestion()"
            [disabled]="disabled"
            [readonly]="readonly"
            [tabIndex]="tabIndex"
            [isRequired]="isControlRequired"
            [placeholder]="placeholder"
            [inputAttributes]="inputAttributes"
            (onNavigate)="handleNavigate($event)"
            (valueChange)="searchBarChange($event)"
            (onBlur)="handleInputBlur()"
            (onFocus)="handleInputFocus()"
            (click)="handleClick()"
            />
          @if (clearButton && !loading && !disabled && (!readonly || readonly && isAdaptiveModeEnabled && windowSize !== 'large')  && text?.length) {
            <span
              class="k-clear-value"
              [style.visibility]="clearButtonVisibility"
              aria-hidden="true"
              [attr.title]="messageFor('clearTitle')"
              (click)="clearValue($event)"
                [kendoEventsOutsideAngular]="{
                    mousedown: preventEventDefault
                }"
              >
              <kendo-icon-wrapper name="x" [svgIcon]="xIcon"> </kendo-icon-wrapper>
            </span>
          }

          @if (loading) {
            <span class="k-i-loading k-input-loading-icon k-icon"></span>
          }
          @if (suffixTemplate && suffixTemplate.showSeparator) {
            <kendo-separator></kendo-separator>
          }
          @if (suffixTemplate) {
            <span class="k-input-suffix k-input-suffix-horizontal">
              <ng-template [ngTemplateOutlet]="suffixTemplate?.templateRef">
              </ng-template>
            </span>
          }
          <button
            #select
            tabindex="-1"
            unselectable="on"
            type="button"
            class="k-input-button k-button k-icon-button"
            [ngClass]="selectButtonClasses"
            [attr.aria-label]="messageFor('selectButtonText')"
            [attr.disabled]="disabled ? '' : null"
                [kendoEventsOutsideAngular]="{
                    mousedown: preventEventDefault
                }"
            >
            <kendo-icon-wrapper
              [name]="icon || 'chevron-down'"
              innerCssClass="k-button-icon"
              [svgIcon]="svgIcon || chevronDownIcon"
              >
            </kendo-icon-wrapper>
          </button>
        </ng-container>

        <ng-template #popupTemplate>
          <!--popup/actionsheet content-->
          <ng-container *ngTemplateOutlet="sharedPopupActionSheetTemplate"></ng-container>
        </ng-template>

        @if (isOpen || isAdaptiveModeEnabled) {
          <kendo-resize-sensor (resize)="onResize()"> </kendo-resize-sensor>
        }

        <!-- when the popupSettings.appendTo value is set to 'component', this container is used -->
        <ng-container #container></ng-container>

        <kendo-adaptive-renderer
          [sharedPopupActionSheetTemplate]="sharedPopupActionSheetTemplate"
          [title]="adaptiveTitle"
          [showTextInput]="true"
          [subtitle]="adaptiveSubtitle"
          (closePopup)="closeActionSheet()"
          (textInputChange)="searchBarChange($event)"
          (navigate)="handleNavigate($event)"
          [placeholder]="placeholder"
          [searchBarValue]="text">
        </kendo-adaptive-renderer>

        <ng-template #sharedPopupActionSheetTemplate>
          <!--user-defined header template -->
          @if (headerTemplate) {
            <ng-template
                [templateContext]="{
                    templateRef: headerTemplate?.templateRef
                }"
              >
            </ng-template>
          }
          <!--data table-->
          <div class="k-data-table" [ngClass]="tableSizeClass">
            <!--grid header-->
            <div #header class="k-table-header">
              <div #headerWrap class="k-table-header-wrap">
                <table #headerTable class="k-table" role="presentation">
                  <colgroup>
                  @for (column of columns; track column) {
                    @if (!column.hidden && column.matchesMedia) {
                      <col [style.width.px]="column.width" />
                    }
                  }
                </colgroup>
                <thead class="k-table-thead">
                  <tr class="k-table-row">
                    @for (column of columns; track column) {
                      @if (!column.hidden && column.matchesMedia) {
                        <th
                          #columnHeader
                          class="k-table-th"
                          [ngStyle]="column.headerStyle"
                          [ngClass]="column.headerClass"
                          >
                          @if (!column.headerTemplate) {
                            {{ column.title || column.field }}
                          }
                          @if (column.headerTemplate) {
                            <ng-template
                                                [templateContext]="{
                                                    templateRef: column.headerTemplate?.templateRef,
                                                    $implicit: column,
                                                    column: column
                                                }"
                              >
                            </ng-template>
                          }
                        </th>
                      }
                    }
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!-- item template -->
          <ng-template #rowTemplate let-dataItem>
            @for (column of columns; track $index; let i = $index) {
              @if (!column.hidden && column.matchesMedia) {
                <span
                  class="k-table-td"
                  [ngClass]="column.class"
                  [style.width.px]="getColumnWidth(i)"
                  [style.max-width.px]="getColumnWidth(i)"
                  [ngStyle]="column.style"
                  >
                  @if (!column.cellTemplate) {
                    {{ textFrom(dataItem, column.field) }}
                  }
                  @if (column.cellTemplate) {
                    <ng-template
                                [templateContext]="{
                                    templateRef: column.cellTemplate?.templateRef,
                                    $implicit: dataItem,
                                    dataItem: dataItem,
                                    column: column
                                }"
                      >
                    </ng-template>
                  }
                </span>
              }
            }
          </ng-template>
          <kendo-list
            #optionsList
            [optionPrefix]="optionPrefix"
            [data]="data"
            [size]="isAdaptive ? 'large' : size"
            [textField]="textField"
            [valueField]="valueField"
            [template]="{ templateRef: rowTemplate }"
            [groupTemplate]="groupTemplate"
            [fixedGroupTemplate]="fixedGroupTemplate"
            [height]="listHeight"
            [show]="isOpen"
            [id]="listBoxId"
            [virtual]="virtual"
            [type]="'dropdowngrid'"
            [rowWidth]="rowWidth"
            [showStickyHeader]="showStickyHeader"
            (pageChange)="pageChange($event)"
            (listResize)="updateHeaderPadding(header)"
            (popupListScroll)="headerWrap.scrollLeft = $event.target.scrollLeft;"
            >
          </kendo-list>

          <!--no-data template-->
          @if (data.length === 0) {
            <div class="k-no-data" [attr.aria-live]="'polite'">
              @if (noDataTemplate) {
                <ng-template
                        [templateContext]="{
                            templateRef: noDataTemplate?.templateRef
                        }"
                  >
                </ng-template>
              }
              @if (!noDataTemplate) {
                <div>{{ messageFor('noDataText') }}</div>
              }
            </div>
          }

          <!--user-defined footer template-->
          @if (footerTemplate) {
            <div class="k-table-footer">
              <table class="k-table">
                <tfoot class="k-table-tfoot">
                  <tr class="k-table-row">
                    <td class="k-table-td">
                      <ng-template
                                            [templateContext]="{
                                                templateRef: footerTemplate.templateRef
                                            }"
                        >
                      </ng-template>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          }
        </div>
        </ng-template>
        `,
      standalone: true,
      imports: [LocalizedMessagesDirective, SharedDropDownEventsDirective, NgTemplateOutlet, SeparatorComponent, SearchBarComponent, EventsOutsideAngularDirective, IconWrapperComponent, NgClass, ResizeSensorComponent, AdaptiveRendererComponent, TemplateContextDirective, NgStyle, ListComponent]
    }]
  }], () => [{
    type: i1.LocalizationService
  }, {
    type: i2.PopupService
  }, {
    type: SelectionService
  }, {
    type: NavigationService
  }, {
    type: DisabledItemsService
  }, {
    type: DataService
  }, {
    type: i0.NgZone
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i0.Renderer2
  }, {
    type: i0.ElementRef
  }, {
    type: i0.Injector
  }, {
    type: i0.ElementRef
  }, {
    type: i7.AdaptiveService
  }], {
    hostClasses: [{
      type: HostBinding,
      args: ['class.k-dropdowngrid']
    }],
    isDisabled: [{
      type: HostBinding,
      args: ['class.k-disabled']
    }],
    columns: [{
      type: ContentChildren,
      args: [ComboBoxColumnComponent]
    }],
    header: [{
      type: ViewChild,
      args: ['header', {
        static: false
      }]
    }],
    headerTable: [{
      type: ViewChild,
      args: ['headerTable', {
        static: false
      }]
    }],
    headerColumns: [{
      type: ViewChildren,
      args: ['columnHeader']
    }]
  });
})();

/**
 * Renders the content of each node in the DropDownTree. To define a node template, nest an `<ng-template>` tag
 * with the `kendoDropDownTreeNodeTemplate` directive inside the `<kendo-dropdowntree>` tag.
 * To define a node template, nest an `<ng-template>` tag with the `kendoDropDownTreeNodeTemplate` directive inside the `<kendo-dropdowntree>` tag.
 *
 * You can use these context variables in the template:
 *
 * - `let-dataItem` (`any`) - The current data item. This is the implicit context variable.
 * - `let-index="index"` (`string`) - The current item's hierarchical index.
 */
class NodeTemplateDirective {
  templateRef;
  constructor(templateRef) {
    this.templateRef = templateRef;
  }
  static ɵfac = function NodeTemplateDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NodeTemplateDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: NodeTemplateDirective,
    selectors: [["", "kendoDropDownTreeNodeTemplate", ""], ["", "kendoMultiSelectTreeNodeTemplate", ""]]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NodeTemplateDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoDropDownTreeNodeTemplate], [kendoMultiSelectTreeNodeTemplate]',
      standalone: true
    }]
  }], () => [{
    type: i0.TemplateRef
  }], null);
})();
const DEFAULT_POPUP_SETTINGS$1 = {
  animate: true
};
const hasChildren$1 = () => false;
const fetchChildren$1 = () => of([]);
const itemDisabled$1 = () => false;
const isNodeVisible$1 = () => true;
const stopPropagation = event => event.stopImmediatePropagation();
/**
 * Represents the [Kendo UI DropDownTree component for Angular](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdowntree).
 * @example
 * ```html
 * <kendo-dropdowntree [data]="data" textField="text" valueField="value"></kendo-dropdowntree>
 * ```
 *
 * @remarks
 * Supported children components are: {@link CustomMessagesComponent}.
 */
class DropDownTreeComponent {
  injector;
  wrapper;
  popupService;
  navigationService;
  renderer;
  _zone;
  cdr;
  localization;
  adaptiveService;
  /**
   * @hidden
   */
  icon;
  /**
   * @hidden
   */
  svgIcon;
  /**
   * @hidden
   */
  touchEnabled = touchEnabled;
  /**
   * @hidden
   */
  animationDuration = animationDuration;
  /**
   * @hidden
   */
  searchIcon = searchIcon;
  /**
   * @hidden
   */
  chevronDownIcon = chevronDownIcon;
  /**
   * @hidden
   */
  xIcon = xIcon;
  /**
   * @hidden
   */
  adaptiveRendererComponent;
  /**
   * @hidden
   */
  get actionSheet() {
    return this.adaptiveRendererComponent?.actionSheet;
  }
  /**
   * @hidden
   */
  get actionSheetSearchBar() {
    return this.adaptiveRendererComponent?.actionSheetSearchBar;
  }
  hostClasses = true;
  get isReadonly() {
    return this.readonly ? '' : null;
  }
  get hostAriaInvalid() {
    return this.formControl?.invalid ? true : null;
  }
  get isDisabled() {
    return this.disabled || null;
  }
  get isLoading() {
    return this.loading;
  }
  get isBusy() {
    return this.loading ? 'true' : null;
  }
  get hostAriaControls() {
    return this.isOpen ? this.treeViewId : null;
  }
  get id() {
    return this.focusableId;
  }
  direction;
  get hostTabIndex() {
    return this.tabindex;
  }
  role = 'combobox';
  ariaHasPopup = 'tree';
  get isAriaExpanded() {
    return this.isOpen;
  }
  get hostAriaAutocomplete() {
    return this.filterable ? 'list' : null;
  }
  noDataTemplate;
  headerTemplate;
  footerTemplate;
  nodeTemplate;
  valueTemplate;
  popupTemplate;
  container;
  set treeview(treeview) {
    if (treeview) {
      if (this.isFocused && !this.filterable || this.touchEnabled) {
        treeview.focus();
      }
      // the treeview animations are initially disabled (we don't want expand animations during popup opening)
      // re-enables the animations for user interaction
      treeview.animate = true;
      this._treeview = treeview;
    }
  }
  get treeview() {
    return this._treeview;
  }
  filterInput;
  /**
   * Fires each time the popup is about to open
   * ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdowntree/open-state)).
   * This event is preventable. If you cancel it, the popup will remain closed.
   */
  open = new EventEmitter();
  /**
   * Fires after the popup has been opened.
   */
  opened = new EventEmitter();
  /**
   * Fires each time the popup is about to close
   * ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdowntree/open-state)).
   * This event is preventable. If you cancel it, the popup will remain open.
   */
  close = new EventEmitter();
  /**
   * Fires after the popup has been closed.
   */
  closed = new EventEmitter();
  /**
   * Fires when the user expands a node in the popup TreeView.
   */
  nodeExpand = new EventEmitter();
  /**
   * Fires when the user collapses a node in the popup TreeView.
   */
  nodeCollapse = new EventEmitter();
  /**
   * Fires each time the user focuses the DropDownTree.
   */
  onFocus = new EventEmitter();
  /**
   * Fires each time the DropDownTree gets blurred.
   */
  onBlur = new EventEmitter();
  /**
   * Fires each time the value is changed
   * ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdowntree/events)).
   */
  valueChange = new EventEmitter();
  /**
   * Fires when the value of the built-in filter input element changes.
   */
  filterChange = new EventEmitter();
  /**
   * Sets and gets the loading state of the DropDownTree.
   */
  loading;
  /**
   * If set to `true`, renders a button on hovering over the component.
   * Clicking this button resets the value of the component to `undefined` and triggers the `change` event.
   */
  clearButton = true;
  /**
   * Sets the data of the DropDownTree.
   *
   * > The data has to be provided in an array-like list with objects.
   */
  set data(data) {
    this._nodes = data;
    this.setState();
  }
  get data() {
    return this._nodes;
  }
  /**
   * Sets the value of the DropDownTree.
   * It can either be of the primitive (string, numbers) or of the complex (objects) type.
   * To define the type, use the `valuePrimitive` option.
   *
   */
  set value(newValue) {
    this._value = newValue;
    this.setState();
  }
  get value() {
    return this._value;
  }
  /**
   * The fields of the data item that provide the text content of the nodes inside the
   * DropDownTree ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdowntree/data-binding)). If the `textField`
   * input is set to an array, each hierarchical level uses the field that corresponds
   * to the same index in the array, or the last item in the array.
   *
   * > The `textField` property can be set to point to a nested property value - e.g. `category.name`.
   */
  textField;
  /**
   * The fields of the data item that provide the value of the nodes inside the
   * DropDownTree ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdowntree/data-binding)). If the `valueField`
   * input is set to an array, each hierarchical level uses the field that corresponds
   * to the same index in the array, or the last item in the array.
   *
   * > The `valueField` property can be set to point to a nested property value - e.g. `category.id`.
   */
  valueField;
  /**
   * Sets the level in the data set where the value can be found when `valueField` is an Array.
   * The field serves to correctly allocate a data item used when the DropDownTree is initialized with a value.
   */
  valueDepth;
  /**
   * A function which determines if a specific node has child nodes.
   */
  hasChildren = hasChildren$1;
  /**
   * A function which provides the child nodes for a given parent node.
   */
  fetchChildren = fetchChildren$1;
  /**
   * Sets the placeholder of the input element of the DropDownTree.
   */
  placeholder = "";
  /**
   * Configures the popup of the DropDownTree.
   *
   * The available options are:
   * - `animate: Boolean`&mdash;Controls the popup animation. By default, the open and close animations are enabled.
   * - `width: Number | String`&mdash;Sets the width of the popup container. By default, the width of the host element is used. If set to `auto`, the component automatically adjusts the width of the popup and no item labels are wrapped.
   * - `height: Number`&mdash;Sets the height of the popup container.
   * - `popupClass: String`&mdash;Specifies a list of CSS classes that are used to style the popup.
   * - `appendTo: "root" | "component" | ViewContainerRef`&mdash;Specifies the component to which the popup will be appended.
   */
  set popupSettings(settings) {
    this._popupSettings = Object.assign({}, DEFAULT_POPUP_SETTINGS$1, settings);
  }
  get popupSettings() {
    return this._popupSettings;
  }
  /**
   * Keeps the current `dataItem` object in order to resolve selection.
   * Needs to be provided when `value` is bound in and `valuePrimitive` is set to true.
   */
  set dataItem(item) {
    this._dataItem = item;
    this.setState();
  }
  get dataItem() {
    return this._dataItem ? this._dataItem : this.value;
  }
  /**
   * Sets the height of the options list in the popup. By default, `listHeight` is 200px.
   *
   * > The `listHeight` property affects only the list of options and not the whole popup container.
   * > To set the height of the popup container, use `popupSettings.height`.
   *
   * When using `adaptiveMode` and the screen size is `small` or `medium` the `listHeight` property is set to null.
   */
  set listHeight(_listHeight) {
    this._listHeight = _listHeight;
  }
  get listHeight() {
    if (this.isAdaptive) {
      return;
    }
    return this._listHeight;
  }
  _listHeight = 200;
  /**
   * Sets the disabled state of the component. To learn how to disable the component in reactive forms, refer to the article on [Forms Support](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdowntree/forms#managing-the-dropdowntree-disabled-state-in-reactive-forms).
   */
  disabled = false;
  /**
   * Sets the read-only state of the component.
   *
   * @default false
   */
  readonly = false;
  /**
   * Specifies the type of the selected value
   * ([more information and example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdowntree/value-binding#primitive-values)).
   * If set to `true`, the selected value has to be of a primitive value.
   */
  valuePrimitive = false;
  /**
   * Specifies the [`tabindex`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex) of the component.
   *
   * @default 0
   */
  set tabindex(value) {
    const providedTabIndex = Number(value);
    const defaultTabIndex = 0;
    this._tabindex = !isNaN(providedTabIndex) ? providedTabIndex : defaultTabIndex;
  }
  get tabindex() {
    return this.disabled ? -1 : this._tabindex;
  }
  /**
   * Sets the size of the component. The default value is set by the Kendo theme.
   */
  set size(size) {
    this.renderer.removeClass(this.wrapper.nativeElement, getSizeClass('picker', this.size));
    if (size) {
      this.renderer.addClass(this.wrapper.nativeElement, getSizeClass('picker', size));
    }
    this._size = size;
  }
  get size() {
    return this._size;
  }
  /**
   * Sets the border radius of the component. The default value is set by the Kendo theme.
   */
  set rounded(rounded) {
    this.renderer.removeClass(this.wrapper.nativeElement, getRoundedClass(this.rounded));
    if (rounded) {
      this.renderer.addClass(this.wrapper.nativeElement, getRoundedClass(rounded));
    }
    this._rounded = rounded;
  }
  get rounded() {
    return this._rounded;
  }
  /**
   * Sets the fillMode of the component. The default value is set by the Kendo theme.
   */
  set fillMode(fillMode) {
    this.renderer.removeClass(this.wrapper.nativeElement, getFillModeClass('picker', this.fillMode));
    if (fillMode) {
      this.renderer.addClass(this.wrapper.nativeElement, getFillModeClass('picker', fillMode));
    }
    this._fillMode = fillMode;
  }
  get fillMode() {
    return this._fillMode;
  }
  /**
   * A function that is executed for each data item and determines if a specific item is disabled.
   */
  itemDisabled = itemDisabled$1;
  /**
   * A function that is executed for each data item and determines if a specific node is expanded.
   */
  isNodeExpanded;
  /**
   * A callback which determines whether a tree node should be rendered as hidden. The utility `.k-hidden` class is used to hide the nodes.
   * Useful for custom filtering implementations.
   */
  isNodeVisible = isNodeVisible$1;
  /**
   * Indicates whether the child nodes will be fetched on node expand or will be initially prefetched.
   * @default true
   */
  loadOnDemand = true;
  /**
   * Renders the built-in input element for filtering the DropDownTree.
   * If set to `true`, the component emits the `filterChange` event, which can be used to [filter the DropDownTree manually](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdowntree/filtering#manual-filtering).
   * A built-in filtering implementation is available to use with the [`kendoDropDownTreeHierarchyBinding`](https://www.telerik.com/kendo-angular-ui/components/dropdowns/api/dropdowntreehierarchybindingdirective) and [`kendoDropDownTreeFlatBinding`](https://www.telerik.com/kendo-angular-ui/components/dropdowns/api/dropdowntreeflatbindingdirective) directives.
   */
  filterable = false;
  /**
   * @hidden
   */
  filter = '';
  /**
   * @hidden
   *
   * Used by the kendo-label and kendo-floatinglabel to access and associate the focusable element with the provided label via aria-labelledby.
   */
  focusableId = `k-${guid()}`;
  set isFocused(isFocused) {
    this.renderer[isFocused ? 'addClass' : 'removeClass'](this.wrapper.nativeElement, 'k-focus');
    this._isFocused = isFocused;
  }
  get isFocused() {
    return this._isFocused;
  }
  get width() {
    const wrapperWidth = this.wrapper.nativeElement.offsetWidth;
    const width = this.popupSettings.width || wrapperWidth;
    const minWidth = isNaN(wrapperWidth) ? wrapperWidth : `${wrapperWidth}px`;
    const maxWidth = isNaN(width) ? width : `${width}px`;
    return {
      min: minWidth,
      max: maxWidth
    };
  }
  get height() {
    const popupHeight = this.popupSettings.height;
    return isPresent(popupHeight) ? `${popupHeight}px` : 'auto';
  }
  /**
   * Returns the current open state. Returns `true` if the popup or actionSheet is open.
   */
  get isOpen() {
    return isTruthy(isPresent(this.popupRef) || this.isActionSheetExpanded);
  }
  get clearButtonVisibility() {
    if (this.touchEnabled) {
      return 'visible';
    }
  }
  get isFilterActive() {
    return this.filterInput && document.activeElement === this.filterInput.nativeElement;
  }
  popupRef;
  /**
   * @hidden
   */
  selectedKeys = [];
  /**
   * @hidden
   */
  selectBy;
  /**
   * @hidden
   */
  text;
  /**
   * @hidden
   */
  onFilterChange(text) {
    if (this.filterable) {
      this.filterChange.emit(text);
    }
  }
  /**
   * Enables or disables the adaptive mode. By default the adaptive rendering is disabled.
   */
  adaptiveMode = 'none';
  /**
   * Sets the title of the ActionSheet that is rendered instead of the Popup when using small screen devices.
   * By default the ActionSheet title uses the text provided for the label of the DropDownTree.
   */
  adaptiveTitle = '';
  /**
   * Sets the subtitle of the ActionSheet that is rendered instead of the Popup when using small screen devices.
   * By default the ActionSheet does not render a subtitle.
  */
  adaptiveSubtitle = '';
  /**
   * @hidden
   */
  get isAdaptiveModeEnabled() {
    return this.adaptiveMode === 'auto';
  }
  /**
  * @hidden
  */
  windowSize = 'large';
  /**
   * @hidden
   */
  get isActionSheetExpanded() {
    return this.actionSheet?.expanded;
  }
  /**
   * @hidden
   */
  get isAdaptive() {
    return this.isAdaptiveModeEnabled && this.windowSize !== 'large';
  }
  /**
   * @hidden
   *
   * Alias for `isNodeExpanded`. Used for compatibility with the `ExpandableComponent` interface.
   * Required for the expand-directive.
   */
  set isExpanded(callback) {
    this.isNodeExpanded = callback;
  }
  get isExpanded() {
    return this.isNodeExpanded;
  }
  /**
   * @hidden
   *
   * Alias for `nodeExpand`. Used for compatibility with the `ExpandableComponent` interface.
   * Required for the expand-directive.
   */
  get expand() {
    return this.nodeExpand;
  }
  /**
   * @hidden
   *
   * Alias for `nodeCollapse`. Used for compatibility with the `ExpandableComponent` interface.
   * Required for the expand-directive.
   */
  get collapse() {
    return this.nodeCollapse;
  }
  /**
   * @hidden
   *
   * Alias for `data`. Used for compatibility with the `DataBoundComponent` interface.
   * Required for the data-binding directives.
   */
  set nodes(nodes) {
    this.data = nodes;
  }
  get nodes() {
    return this.data;
  }
  /**
   * @hidden
   *
   * Alias for `fetchChildren`. Used for compatibility with the `DataBoundComponent` interface.
   * Required for the data-binding directives
   */
  set children(callback) {
    this.fetchChildren = callback;
  }
  get children() {
    return this.fetchChildren;
  }
  /**
   * @hidden
   *
   * Alias for `isNodeVisible`. Used for compatibility with the `DataBoundComponent` interface.
   * The `DataBoundComponent` interface is used in the data-binding directives.
   */
  set isVisible(callback) {
    this.isNodeVisible = callback;
  }
  get isVisible() {
    return this.isNodeVisible;
  }
  /**
   * @hidden
   */
  filterStateChange = new EventEmitter();
  /**
   * @hidden
   */
  allNodesHidden = false;
  /**
   * @hidden
   *
   * Used to associate the value label with the wrapper via aria-describedby.
   */
  valueLabelId = `k-${guid()}`;
  /**
   * @hidden
   */
  get formControl() {
    const ngControl = this.injector.get(NgControl, null);
    return ngControl?.control || null;
  }
  treeViewId = `k-${guid()}`;
  _nodes;
  _value;
  _popupSettings = DEFAULT_POPUP_SETTINGS$1;
  _tabindex = 0;
  _isFocused = false;
  _dataItem;
  _treeview;
  _size;
  _rounded;
  _fillMode;
  _searchableNodes = [];
  _typedValue = '';
  printableCharacters = new Subject();
  subs = new Subscription();
  touchstartDisposeHandler;
  // Keep an instance of the last focused node for when the popup close is prevented
  // in order to be able to properly restore the focus
  lastNodeOnFocus;
  constructor(injector, wrapper, popupService, navigationService, renderer, _zone, cdr, localization, adaptiveService) {
    this.injector = injector;
    this.wrapper = wrapper;
    this.popupService = popupService;
    this.navigationService = navigationService;
    this.renderer = renderer;
    this._zone = _zone;
    this.cdr = cdr;
    this.localization = localization;
    this.adaptiveService = adaptiveService;
    this.direction = localization.rtl ? 'rtl' : 'ltr';
    this.subscribeEvents();
    this.subscribeTouchEvents();
    this.subscribeFocusEvents();
  }
  ngOnInit() {
    this.subs.add(this.printableCharacters.pipe(tap(char => {
      this._typedValue += char;
      const itemToFocus = this._searchableNodes.find(node => {
        return node.text.toLowerCase().startsWith(this._typedValue);
      });
      this.treeview?.focus(itemToFocus?.index);
    }), debounceTime(1000)).subscribe(() => {
      this._typedValue = '';
    }));
    this.renderer.removeAttribute(this.wrapper.nativeElement, 'tabindex');
    this.assignAriaDescribedBy();
    this.subs.add(this.localization.changes.subscribe(({
      rtl
    }) => {
      this.direction = rtl ? 'rtl' : 'ltr';
      this.cdr.markForCheck();
    }));
    this.setComponentClasses();
  }
  /**
   * @hidden
   */
  ngOnDestroy() {
    this.destroyPopup();
    this.unsubscribeEvents();
  }
  /**
   * @hidden
   */
  ngOnChanges(changes) {
    if (anyChanged(['textField', 'valueField', 'valuePrimitive'], changes, false)) {
      this.setState();
    }
    if (isChanged('value', changes, false)) {
      if (changes['value'] && !changes['dataItem'] && !this.valuePrimitive) {
        // Update the dataItem if the value is updated programmatically (non-primitive values only)
        this.dataItem = this.value;
      }
    }
  }
  /**
   * @hidden
   */
  ngAfterContentChecked() {
    this.verifySettings();
    if (this.data?.length > 0 && this.popupRef) {
      this.allNodesHidden = this.areNodesHidden(this.data);
    }
  }
  ngAfterViewInit() {
    this.windowSize = this.adaptiveService.size;
    this.subs.add(this.renderer.listen(this.wrapper.nativeElement, 'click', this.handleClick.bind(this)));
    this.subs.add(this.renderer.listen(this.wrapper.nativeElement, 'keydown', this.handleKeydown.bind(this)));
  }
  /**
   * @hidden
   */
  onResize() {
    const currentWindowSize = this.adaptiveService.size;
    if (this.isAdaptiveModeEnabled && this.windowSize !== currentWindowSize) {
      if (this.isOpen) {
        this.togglePopup(false);
      }
      this.windowSize = currentWindowSize;
    }
    if (this.isOpen && !this.isActionSheetExpanded) {
      const popupWrapper = this.popupRef.popupElement;
      const {
        min,
        max
      } = this.width;
      popupWrapper.style.minWidth = min;
      popupWrapper.style.width = max;
    }
  }
  /**
   * @hidden
   *
   * Used by the kendo-floatinglabel component to determine if the floating label
   * should be rendered inside the input when the component is not focused.
   */
  isEmpty() {
    return !this.text && !this.placeholder;
  }
  /**
   * @hidden
   */
  togglePopup(open) {
    const isDisabled = this.disabled || this.readonly;
    const sameState = this.isOpen === open;
    if (isDisabled || sameState) {
      return;
    }
    const togglePrevented = this.triggerPopupEvents(open);
    if (!togglePrevented) {
      if (open) {
        this.createPopup();
      } else {
        this.destroyPopup();
      }
    }
  }
  /**
   * @hidden
   */
  handleFocus(event) {
    if (event.target !== this.wrapper.nativeElement) {
      return;
    }
    event.stopImmediatePropagation();
    if (!this.isFocused) {
      this.isFocused = true;
      if (hasObservers(this.onFocus)) {
        this._zone.run(() => {
          this.onFocus.emit();
        });
      }
    }
  }
  /**
   * @hidden
   */
  handleBlur(e) {
    if (!this.isActionSheetExpanded) {
      const relatedTarget = e && e.relatedTarget;
      if (this.wrapper.nativeElement.contains(relatedTarget) || this.isOpen && this.popupRef.popupElement.contains(relatedTarget)) {
        return;
      }
      this.isFocused = false;
      this.togglePopup(false);
      if (hasObservers(this.onBlur) || isUntouched(this.wrapper.nativeElement) || this.formControl?.updateOn === 'blur') {
        this._zone.run(() => {
          this.onBlur.emit();
          this.onTouchedCallback();
        });
      }
    }
  }
  /**
   * @hidden
   */
  handleKeydown(event, input) {
    if (this.disabled || this.readonly) {
      return;
    }
    if (event.code === Keys.Tab && this.isActionSheetExpanded) {
      this.togglePopup(false);
      return;
    }
    if (!this.isFilterActive && isLetter(event.key) && !this.actionSheetSearchBar?.onFocus) {
      this.printableCharacters.next(event.key);
    }
    const eventData = event;
    this.navigationService.process({
      originalEvent: eventData,
      openOnSpace: !this.isOpen,
      closeOnSpace: this.isOpen && !input && !(event.target instanceof HTMLInputElement)
    });
  }
  /**
   * Focuses a specific item of the DropDownTree based on a provided index in the format of `1_1`.
   * The targeted item should be expanded in order for it to be focused.
   * If null or invalid index is provided the focus will be set on the first item.
   */
  focusItemAt(index) {
    if (this.treeview) {
      const lookup = this.treeview.itemLookup(index);
      const isItemDisabled = !isPresent(lookup) || this.treeview.isDisabled(lookup.item.dataItem, lookup.item.index);
      if (!isItemDisabled) {
        this.treeview.focus(index);
      }
    }
  }
  /**
   * Focuses the DropDownTree.
   */
  focus() {
    if (!this.disabled) {
      this.wrapper.nativeElement.focus();
    }
  }
  /**
   * Blurs the DropDownTree.
   */
  blur() {
    if (!this.disabled) {
      this.wrapper.nativeElement.blur();
    }
  }
  /**
   * Resets the value of the DropDownTree.
   * If you use the `reset` method to clear the value of the component,
   * the model will not update automatically and the `valueChange` event will not be fired.
   */
  reset() {
    this.value = undefined;
    this.dataItem = undefined;
  }
  /**
   * Toggles the visibility of the popup or actionSheet.
   * ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/dropdowntree/open-state)).
   * If you use the `toggle` method to open or close the popup or actionSheet, the `open` and `close` events will not be fired.
   *
   * @param open - The state of the popup.
   */
  toggle(open) {
    // The Promise is required to open the popup on load.
    // Otherwise, the "ViewContainerRef not found..." error will be thrown.
    Promise.resolve(null).then(() => {
      const shouldOpen = isPresent(open) ? open : !isPresent(this.popupRef);
      this.destroyPopup();
      if (shouldOpen) {
        this.createPopup();
      }
    });
  }
  /**
   * @hidden
   */
  get popupContainerClasses() {
    const containerClasses = ['k-dropdowntree-popup'];
    if (!this.popupSettings.popupClass) {
      return containerClasses;
    }
    const parsedPopupClasses = parseCSSClassNames(this.popupSettings.popupClass);
    if (parsedPopupClasses?.length) {
      containerClasses.push(...parsedPopupClasses);
    }
    return containerClasses;
  }
  /**
   * @hidden
   */
  onSelectionChange({
    dataItem,
    index
  }) {
    this.valueDepth = index.split('_').length - 1;
    const valueField = this.getField(this.valueField, dataItem);
    const newValue = this.valuePrimitive ? getter$1(valueField)(dataItem) : dataItem;
    const shouldUpdateValue = newValue !== this.value;
    if (shouldUpdateValue) {
      this.value = newValue;
      this.dataItem = dataItem;
      this.emitValueChange(this.value);
    }
    this.togglePopup(false);
    this.focus();
  }
  /**
   * @hidden
   */
  messageFor(key) {
    return this.localization.get(key);
  }
  /**
   * @hidden
   */
  clearValue(event) {
    event?.stopImmediatePropagation();
    this.focus();
    this.value = undefined;
    this.dataItem = undefined;
    this.clearState();
    this.emitValueChange();
  }
  get appendTo() {
    const {
      appendTo
    } = this.popupSettings;
    if (!appendTo || appendTo === 'root') {
      return undefined;
    }
    return appendTo === 'component' ? this.container : appendTo;
  }
  /**
   * @hidden
   */
  preventEventDefault(event) {
    event.preventDefault();
  }
  /**
   * @hidden
   */
  writeValue(value) {
    // If the user resets the value by providing null/undefined we need to reset the `dataItem`
    // Because upon initialization of the component the `writeValue` is being called twice -
    // first time with `null` value regardless of sync/async value - an extra check is added to
    // distinguish between client reset and initial phantom 'null' value
    if (!isPresent(value) && isPresent(this.value)) {
      this.dataItem = null;
    }
    this.value = value === null ? undefined : value;
    // Update the dataItem if the value is updated programmatically via a form control (non-primitive values only)
    if (isPresent(this.value) && !this.valuePrimitive) {
      this.dataItem = this.value;
    }
  }
  /**
   * @hidden
   */
  registerOnChange(fn) {
    this.onChangeCallback = fn;
  }
  /**
   * @hidden
   */
  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }
  /**
   * @hidden
   */
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
    this.cdr.markForCheck();
  }
  /**
   * @hidden
   */
  handleFilterInputChange(input) {
    const value = typeof input === 'string' ? input : input.value;
    this.filter = value;
    this.filterChange.next(value);
    this.allNodesHidden = this.areNodesHidden(this.nodes);
    this._zone.onStable.pipe(take(1)).subscribe(() => {
      if (this.data.length === 0 || this.allNodesHidden || this.filter === '') {
        this.filterInput?.nativeElement.focus();
      }
    });
  }
  /**
   * @hidden
   */
  get selectButtonClasses() {
    return `${this.size ? getSizeClass('button', this.size) : ''} ${this.fillMode ? 'k-input-' + this.fillMode : ''}`;
  }
  /**
   * @hidden
   */
  get filterInputClasses() {
    return `${this.size ? getSizeClass('input', this.size) : ''} ${this.fillMode ? 'k-input-' + this.fillMode : ''} ${this.rounded ? getRoundedClass(this.rounded) : ''}`;
  }
  onTouchedCallback = noop;
  onChangeCallback = noop;
  verifySettings() {
    if (!isDevMode()) {
      return;
    }
    if (this.valuePrimitive === true && isPresent(this.value) && typeof this.value === "object") {
      throw new Error(DropDownTreeMessages.primitive);
    }
    if (this.valuePrimitive === true && isPresent(this.value) && typeof this.dataItem !== "object") {
      throw new Error(DropDownTreeMessages.dataItem);
    }
    if (this.valuePrimitive === false && isPresent(this.value) && typeof this.value !== "object") {
      throw new Error(DropDownTreeMessages.object);
    }
    if (!isPresent(this.valueField) || !isPresent(this.textField)) {
      throw new Error(DropDownTreeMessages.textAndValue);
    }
    if ((isArray(this.valueField) || isArray(this.textField)) && isPresent(this.value) && !isPresent(this.valueDepth)) {
      throw new Error(DropDownTreeMessages.valueDepth);
    }
  }
  emitValueChange(value) {
    this.onChangeCallback(value);
    this.valueChange.emit(value);
  }
  getText(textField, dataItem) {
    if (isPresent(dataItem) && isPresent(textField)) {
      const field = this.getField(textField, dataItem);
      return getter$1(field)(dataItem);
    }
    return null;
  }
  /**
   * @hidden
   */
  onChildrenLoaded() {
    setTimeout(() => {
      if (this.popupRef) {
        this._searchableNodes = getSearchableItems(this.treeViewId, this.popupRef.popupElement);
      }
      if (this.isActionSheetExpanded) {
        this._searchableNodes = getSearchableItems(this.treeViewId, this.actionSheet.element.nativeElement);
      }
    });
  }
  /**
   * @hidden
   *
   * Determines the `valueField` and `textField` for a specific level in the data set
   *  @param field - the field value (string | string[])
   *  @param value - current value
   */
  getField(field, value) {
    const fieldsCount = field.length - 1;
    if (typeof field === 'string') {
      // If the `valueField` | `textField` is the same for all levels
      return field;
    } else if (isPresent(this.valueDepth)) {
      // When `valueDepth` can be defined from the index on selectionChange or provided by the user
      return fieldsCount < this.valueDepth ? field[fieldsCount] : field[this.valueDepth];
    } else if (value && typeof value === 'object') {
      // Fallback: Look to find a match of each field in the current data item
      // Side effect may occur if all of the listed fields are present in the data item
      return field.find(item => item in value);
    }
  }
  areNodesHidden(nodes) {
    return nodes.every((node, index) => !this.isVisible(node, String(index)));
  }
  triggerPopupEvents(open) {
    const eventArgs = new PreventableEvent();
    if (open) {
      this.open.emit(eventArgs);
    } else {
      this.close.emit(eventArgs);
    }
    return eventArgs.isDefaultPrevented();
  }
  createPopup() {
    this.windowSize = this.adaptiveService.size;
    if (this.isAdaptive) {
      this.openActionSheet();
      this.cdr.detectChanges();
      return;
    }
    const horizontalAlign = this.direction === "rtl" ? "right" : "left";
    const anchorPosition = {
      horizontal: horizontalAlign,
      vertical: 'bottom'
    };
    const popupPosition = {
      horizontal: horizontalAlign,
      vertical: 'top'
    };
    const appendToComponent = typeof this.popupSettings.appendTo === 'string' && this.popupSettings.appendTo === 'component';
    this.popupRef = this.popupService.open({
      anchor: this.wrapper,
      appendTo: this.appendTo,
      anchorAlign: anchorPosition,
      animate: this.popupSettings.animate,
      content: this.popupTemplate,
      popupAlign: popupPosition,
      positionMode: appendToComponent ? 'fixed' : 'absolute',
      popupClass: this.popupContainerClasses
    });
    const popupWrapper = this.popupRef.popupElement;
    const {
      min,
      max
    } = this.width;
    this.renderer.setStyle(popupWrapper, 'minWidth', min);
    this.renderer.setStyle(popupWrapper, 'width', max);
    this.renderer.setStyle(popupWrapper, 'height', this.height);
    this.renderer.setAttribute(popupWrapper, 'dir', this.direction);
    if (!this.appendTo) {
      this.renderer.setAttribute(popupWrapper, 'role', 'region');
      this.renderer.setAttribute(popupWrapper, 'aria-label', this.messageFor('popupLabel'));
    }
    this.popupRef.popupOpen.subscribe(() => {
      this.allNodesHidden = this.areNodesHidden(this.data);
      this.popupRef.popupElement.addEventListener('click', event => stopPropagation(event));
      this.cdr.detectChanges();
      this.opened.emit();
      this._searchableNodes = getSearchableItems(this.treeViewId, this.popupRef.popupElement);
    });
    this.popupRef.popupClose.subscribe(() => {
      this.closed.emit();
    });
  }
  destroyPopup() {
    if (this.isActionSheetExpanded) {
      this.closeActionSheet();
    }
    if (this.popupRef) {
      this.popupRef.popupElement.removeEventListener('click', event => stopPropagation(event));
      this.popupRef.close();
      this.popupRef = null;
      this.clearFilter();
      // Trigger change detection to update aria-controls attribute
      this.cdr.markForCheck();
    }
  }
  clearFilter() {
    if (this.filter !== "") {
      this.filter = "";
      this.allNodesHidden = false;
      if (hasObservers(this.filterChange)) {
        this._zone.run(() => {
          this.filterChange.emit("");
        });
      }
    }
  }
  handleClick(e) {
    // The check is needed otherwise when appended to the component, the popup reopens on click
    // https://github.com/telerik/kendo-angular/issues/3738
    this.windowSize = this.adaptiveService.size;
    if (!this.isActionSheetExpanded) {
      if (this.popupRef && !this.popupRef.popupElement.contains(e.target) || !this.popupRef && !e.target.className.includes('k-treeview-leaf')) {
        this.togglePopup(!this.isOpen);
      }
    }
  }
  handleEscape() {
    this.togglePopup(false);
    this.focus();
  }
  setState() {
    if (isPresent(this.value) && isPresent(this.dataItem) && isPresent(this.valueField)) {
      this.text = this.getText(this.textField, this.dataItem);
      const valueField = this.getField(this.valueField, this.dataItem);
      this.selectBy = valueField;
      this.selectedKeys = [getter$1(valueField)(this.dataItem)];
    } else {
      this.clearState();
    }
    this.cdr.markForCheck();
  }
  clearState() {
    this.text = undefined;
    this.selectedKeys = [];
  }
  subscribeEvents() {
    [this.navigationService.open.subscribe(event => {
      event.originalEvent.preventDefault();
      this.togglePopup(true);
    }), this.navigationService.close.subscribe(event => {
      event.originalEvent.preventDefault();
      this.togglePopup(false);
      this.focus();
    }), this.navigationService.enter.pipe(tap(event => event.originalEvent.preventDefault())).subscribe(e => {
      // The check is needed otherwise when appended to the component, the popup reopens on click
      // https://github.com/telerik/kendo-angular/issues/3738
      if (e.originalEvent.target === this.wrapper.nativeElement) {
        this.togglePopup(true);
      }
      if (!this.isOpen) {
        this.focus();
      }
    }), this.navigationService.esc.subscribe(() => {
      if (this.isOpen) {
        this.handleEscape();
      } else if (this.isFocused && this.selectedKeys.length > 0) {
        this.clearValue();
      }
    }), this.navigationService.tab.subscribe(() => {
      this.focus();
      if (this.isOpen) {
        this.treeview.blur();
        this.removeTreeViewFromTabOrder();
      }
    }), this.navigationService.down.subscribe(event => {
      if (!this.treeview) {
        return;
      }
      event.originalEvent.preventDefault();
      if (!this.treeview.isActive) {
        this.treeview.focus();
      }
    }), this.navigationService.up.subscribe(event => {
      if (!this.treeview) {
        return;
      }
      event.originalEvent.preventDefault();
      if (this.filterable && this.treeview['navigationService']['activeIndex'] === '0') {
        if (this.isActionSheetExpanded) {
          this.actionSheetSearchBar.focus();
        } else {
          this.filterInput.nativeElement.focus();
        }
      }
    })].forEach(sub => this.subs.add(sub));
  }
  subscribeTouchEvents() {
    if (!isDocumentAvailable() || !this.touchEnabled) {
      return;
    }
    this._zone.runOutsideAngular(() =>
    // Roll up DropDownTree on iOS when tapped outside
    this.touchstartDisposeHandler = this.renderer.listen(document, 'touchstart', e => {
      const target = e.target;
      if (this.isFocused && !inDropDown(this.wrapper, target, this.popupRef)) {
        this._zone.run(() => {
          if (this.isOpen) {
            this.treeview.blur();
          }
          this.blur();
        });
      }
    }));
  }
  subscribeFocusEvents() {
    if (isDocumentAvailable()) {
      this.handleFocus = this.handleFocus.bind(this);
      this.handleDocumentBlur = this.handleDocumentBlur.bind(this);
      this._zone.runOutsideAngular(() => {
        const useCapture = true;
        document.addEventListener('focus', this.handleFocus, useCapture);
        document.addEventListener('blur', this.handleDocumentBlur, useCapture);
      });
    }
  }
  unSubscribeFocusEvents() {
    if (isDocumentAvailable()) {
      const useCapture = true;
      document.removeEventListener('focus', this.handleFocus, useCapture);
      document.removeEventListener('blur', this.handleDocumentBlur, useCapture);
    }
  }
  unsubscribeEvents() {
    this.subs.unsubscribe();
    this.unSubscribeFocusEvents();
    if (this.touchstartDisposeHandler) {
      this.touchstartDisposeHandler();
    }
  }
  handleDocumentBlur(event) {
    if (event.target !== this.wrapper.nativeElement) {
      return;
    }
    event.stopImmediatePropagation();
    this.handleBlur(event);
  }
  assignAriaDescribedBy() {
    const currentValue = this.wrapper.nativeElement.getAttribute('aria-describedby') || '';
    // add to the current value - don't replace it (the aria-describedby is used by the FormField component as well)
    const newValue = `${this.valueLabelId} ${currentValue.trim()}`.trim();
    this.renderer.setAttribute(this.wrapper.nativeElement, 'aria-describedby', newValue);
  }
  setComponentClasses() {
    if (this.size) {
      this.renderer.addClass(this.wrapper.nativeElement, getSizeClass('picker', this.size));
    }
    if (this.rounded) {
      this.renderer.addClass(this.wrapper.nativeElement, getRoundedClass(this.rounded));
    }
    if (this.fillMode) {
      this.renderer.addClass(this.wrapper.nativeElement, getFillModeClass('picker', this.fillMode));
    }
  }
  /**
   * Remove the `TreeView` from the tab order, otherwise a focus loop between the page elements will occur
   * and the user will not be able to tab to the rest of the browser elements
   */
  removeTreeViewFromTabOrder() {
    const nodes = this.treeview.element.nativeElement.querySelectorAll('li');
    nodes.forEach(item => {
      if (item.getAttribute('tabindex') === '0') {
        this.lastNodeOnFocus = item;
        this.lastNodeOnFocus.setAttribute('tabindex', '-1');
      }
    });
  }
  closeActionSheet() {
    this.actionSheet.toggle(false);
    if (this.filterable) {
      this.clearFilter();
    }
    this.wrapper.nativeElement.focus();
    this.closed.emit();
  }
  openActionSheet() {
    this.actionSheet.toggle(true);
    this.adaptiveTitle = setActionSheetTitle(this.wrapper, this.adaptiveTitle);
    this.cdr.detectChanges();
    this.opened.emit();
    this.removeTreeViewFromTabOrder();
  }
  static ɵfac = function DropDownTreeComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropDownTreeComponent)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.PopupService), i0.ɵɵdirectiveInject(NavigationService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.LocalizationService), i0.ɵɵdirectiveInject(i7.AdaptiveService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DropDownTreeComponent,
    selectors: [["kendo-dropdowntree"]],
    contentQueries: function DropDownTreeComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, NoDataTemplateDirective, 5)(dirIndex, HeaderTemplateDirective, 5)(dirIndex, FooterTemplateDirective, 5)(dirIndex, NodeTemplateDirective, 5)(dirIndex, ValueTemplateDirective, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.noDataTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nodeTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.valueTemplate = _t.first);
      }
    },
    viewQuery: function DropDownTreeComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(AdaptiveRendererComponent, 5)(_c13, 7)(_c12, 7, ViewContainerRef)(_c26, 5)(_c27, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.adaptiveRendererComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popupTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.treeview = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterInput = _t.first);
      }
    },
    hostVars: 22,
    hostBindings: function DropDownTreeComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("readonly", ctx.isReadonly)("aria-invalid", ctx.hostAriaInvalid)("aria-disabled", ctx.isDisabled)("aria-busy", ctx.isBusy)("aria-controls", ctx.hostAriaControls)("id", ctx.id)("dir", ctx.direction)("tabindex", ctx.hostTabIndex)("role", ctx.role)("aria-haspopup", ctx.ariaHasPopup)("aria-expanded", ctx.isAriaExpanded)("aria-autocomplete", ctx.hostAriaAutocomplete);
        i0.ɵɵclassProp("k-dropdowntree", ctx.hostClasses)("k-picker", ctx.hostClasses)("k-disabled", ctx.isDisabled)("k-loading", ctx.isLoading)("k-readonly", ctx.readonly);
      }
    },
    inputs: {
      icon: "icon",
      svgIcon: "svgIcon",
      loading: "loading",
      clearButton: "clearButton",
      data: "data",
      value: "value",
      textField: "textField",
      valueField: "valueField",
      valueDepth: "valueDepth",
      hasChildren: "hasChildren",
      fetchChildren: "fetchChildren",
      placeholder: "placeholder",
      popupSettings: "popupSettings",
      dataItem: "dataItem",
      listHeight: "listHeight",
      disabled: "disabled",
      readonly: "readonly",
      valuePrimitive: "valuePrimitive",
      tabindex: "tabindex",
      size: "size",
      rounded: "rounded",
      fillMode: "fillMode",
      itemDisabled: "itemDisabled",
      isNodeExpanded: "isNodeExpanded",
      isNodeVisible: "isNodeVisible",
      loadOnDemand: "loadOnDemand",
      filterable: "filterable",
      filter: "filter",
      focusableId: "focusableId",
      adaptiveMode: "adaptiveMode",
      adaptiveTitle: "adaptiveTitle",
      adaptiveSubtitle: "adaptiveSubtitle"
    },
    outputs: {
      open: "open",
      opened: "opened",
      close: "close",
      closed: "closed",
      nodeExpand: "nodeExpand",
      nodeCollapse: "nodeCollapse",
      onFocus: "focus",
      onBlur: "blur",
      valueChange: "valueChange",
      filterChange: "filterChange"
    },
    exportAs: ["kendoDropDownTree"],
    features: [i0.ɵɵProvidersFeature([DataService, SelectionService, NavigationService, DisabledItemsService, LocalizationService, {
      provide: L10N_PREFIX,
      useValue: 'kendo.dropdowntree'
    }, {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropDownTreeComponent)
    }, {
      provide: KendoInput,
      useExisting: forwardRef(() => DropDownTreeComponent)
    }, {
      provide: DataBoundComponent,
      useExisting: forwardRef(() => DropDownTreeComponent)
    }, {
      provide: ExpandableComponent,
      useExisting: forwardRef(() => DropDownTreeComponent)
    }, {
      provide: KENDO_WEBMCP_HOST,
      useExisting: forwardRef(() => DropDownTreeComponent)
    }]), i0.ɵɵNgOnChangesFeature],
    decls: 15,
    vars: 17,
    consts: () => {
      let i18n_24;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text displayed in the popup when there are no items
         * @meaning kendo.dropdowntree.noDataText
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_24 = goog.getMsg("NO DATA FOUND");
        i18n_24 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_24;
      } else {
        i18n_24 = $localize`:kendo.dropdowntree.noDataText|The text displayed in the popup when there are no items:NO DATA FOUND`;
      }
      let i18n_25;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the clear button
         * @meaning kendo.dropdowntree.clearTitle
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_25 = goog.getMsg("clear");
        i18n_25 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_25;
      } else {
        i18n_25 = $localize`:kendo.dropdowntree.clearTitle|The title of the clear button:clear`;
      }
      let i18n_26;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text set as aria-label on the select button
         * @meaning kendo.dropdowntree.selectButtonText
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_26 = goog.getMsg("Select");
        i18n_26 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_26;
      } else {
        i18n_26 = $localize`:kendo.dropdowntree.selectButtonText|The text set as aria-label on the select button:Select`;
      }
      let i18n_27;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text set as aria-label on the filter input
         * @meaning kendo.dropdowntree.filterInputLabel
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_27 = goog.getMsg("Filter");
        i18n_27 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_27;
      } else {
        i18n_27 = $localize`:kendo.dropdowntree.filterInputLabel|The text set as aria-label on the filter input:Filter`;
      }
      let i18n_28;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The label of the popup element that contains the list of options when its role is 'region'
         * @meaning kendo.dropdowntree.popupLabel
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_28 = goog.getMsg("Options list");
        i18n_28 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_28;
      } else {
        i18n_28 = $localize`:kendo.dropdowntree.popupLabel|The label of the popup element that contains the list of options when its role is 'region':Options list`;
      }
      let i18n_29;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode
         * @meaning kendo.dropdowntree.adaptiveCloseButtonTitle
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_29 = goog.getMsg("Close");
        i18n_29 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_29;
      } else {
        i18n_29 = $localize`:kendo.dropdowntree.adaptiveCloseButtonTitle|The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode:Close`;
      }
      let i18n_30;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text for the input's placeholder when filtering is enabled
         * @meaning kendo.dropdowntree.filterInputPlaceholder
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_30 = goog.getMsg("Filter");
        i18n_30 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_30;
      } else {
        i18n_30 = $localize`:kendo.dropdowntree.filterInputPlaceholder|The text for the input's placeholder when filtering is enabled:Filter`;
      }
      return [["popupTemplate", ""], ["container", ""], ["sharedPopupActionSheetTemplate", ""], ["filterInput", ""], ["treeview", ""], ["kendoDropDownTreeLocalizedMessages", "", "noDataText", i18n_24, "clearTitle", i18n_25, "selectButtonText", i18n_26, "filterInputLabel", i18n_27, "popupLabel", i18n_28, "adaptiveCloseButtonTitle", i18n_29, "filterInputPlaceholder", i18n_30], [1, "k-input-inner", 3, "click"], [1, "k-input-value-text"], ["aria-hidden", "true", 1, "k-clear-value", 3, "visibility"], [1, "k-i-loading", "k-input-loading-icon", "k-icon"], ["tabindex", "-1", "type", "button", 1, "k-input-button", "k-button", "k-icon-button", 3, "ngClass"], ["innerCssClass", "k-button-icon", 3, "name", "svgIcon"], [3, "closePopup", "textInputChange", "sharedPopupActionSheetTemplate", "title", "showTextInput", "subtitle", "placeholder", "searchBarValue", "filterable"], [3, "templateContext"], ["aria-hidden", "true", 1, "k-clear-value", 3, "click"], ["name", "x", 3, "svgIcon"], [4, "ngTemplateOutlet"], [1, "k-list-filter"], ["kendoTreeViewSelectable", "", 3, "size", "nodes", "maxHeight", "animate", "selectedKeys", "selectBy", "textField", "children", "hasChildren", "loadOnDemand", "isExpanded", "isDisabled", "nodeTemplate", "filter", "isVisible"], [1, "k-no-data"], [1, "k-textbox", "k-input", 3, "ngClass"], [1, "k-input-prefix"], ["name", "search", 1, "k-icon", 3, "svgIcon"], ["role", "textbox", 1, "k-input-inner", 3, "input", "keydown.arrowdown", "keydown.alt.arrowup", "keydown.escape", "filterInput", "value", "kendoEventsOutsideAngular", "scope"], ["kendoTreeViewSelectable", "", 3, "selectedKeysChange", "focusout", "keydown", "selectionChange", "expand", "collapse", "childrenLoaded", "size", "nodes", "animate", "selectedKeys", "selectBy", "textField", "children", "hasChildren", "loadOnDemand", "isExpanded", "isDisabled", "nodeTemplate", "filter", "isVisible"], [3, "resize"]];
    },
    template: function DropDownTreeComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementContainer(0, 5);
        i0.ɵɵelementStart(1, "span", 6);
        i0.ɵɵlistener("click", function DropDownTreeComponent_Template_span_click_1_listener($event) {
          return $event.preventDefault();
        });
        i0.ɵɵconditionalCreate(2, DropDownTreeComponent_Conditional_2_Template, 3, 2, "span", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(3, DropDownTreeComponent_Conditional_3_Template, 2, 4, "span", 8);
        i0.ɵɵconditionalCreate(4, DropDownTreeComponent_Conditional_4_Template, 1, 0, "span", 9);
        i0.ɵɵelementStart(5, "button", 10);
        i0.ɵɵelement(6, "kendo-icon-wrapper", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, DropDownTreeComponent_ng_template_7_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementContainer(9, null, 1);
        i0.ɵɵelementStart(11, "kendo-adaptive-renderer", 12);
        i0.ɵɵlistener("closePopup", function DropDownTreeComponent_Template_kendo_adaptive_renderer_closePopup_11_listener() {
          return ctx.togglePopup(false);
        })("textInputChange", function DropDownTreeComponent_Template_kendo_adaptive_renderer_textInputChange_11_listener($event) {
          return ctx.handleFilterInputChange($event);
        });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, DropDownTreeComponent_ng_template_12_Template, 5, 5, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵconditionalCreate(14, DropDownTreeComponent_Conditional_14_Template, 1, 0, "kendo-resize-sensor");
      }
      if (rf & 2) {
        const sharedPopupActionSheetTemplate_r3 = i0.ɵɵreference(13);
        i0.ɵɵadvance();
        i0.ɵɵattribute("id", ctx.valueLabelId);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.valueTemplate || ctx.text || ctx.placeholder ? 2 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(!ctx.loading && !ctx.readonly && ctx.clearButton && (ctx.text == null ? null : ctx.text.length) && !ctx.disabled ? 3 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.loading ? 4 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", ctx.selectButtonClasses);
        i0.ɵɵattribute("aria-label", ctx.messageFor("selectButtonText"))("disabled", ctx.disabled ? "" : null);
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", ctx.icon || "chevron-down")("svgIcon", ctx.svgIcon || ctx.chevronDownIcon);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("sharedPopupActionSheetTemplate", sharedPopupActionSheetTemplate_r3)("title", ctx.adaptiveTitle)("showTextInput", ctx.filterable)("subtitle", ctx.adaptiveSubtitle)("placeholder", ctx.placeholder)("searchBarValue", ctx.filter)("filterable", ctx.filterable);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.isOpen || ctx.isAdaptiveModeEnabled ? 14 : -1);
      }
    },
    dependencies: [LocalizedMessagesDirective, TemplateContextDirective, IconWrapperComponent, NgClass, NgTemplateOutlet, AdaptiveRendererComponent, FilterInputDirective, EventsOutsideAngularDirective, TreeViewComponent, SelectDirective, ResizeSensorComponent],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropDownTreeComponent, [{
    type: Component,
    args: [{
      exportAs: 'kendoDropDownTree',
      providers: [DataService, SelectionService, NavigationService, DisabledItemsService, LocalizationService, {
        provide: L10N_PREFIX,
        useValue: 'kendo.dropdowntree'
      }, {
        multi: true,
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DropDownTreeComponent)
      }, {
        provide: KendoInput,
        useExisting: forwardRef(() => DropDownTreeComponent)
      }, {
        provide: DataBoundComponent,
        useExisting: forwardRef(() => DropDownTreeComponent)
      }, {
        provide: ExpandableComponent,
        useExisting: forwardRef(() => DropDownTreeComponent)
      }, {
        provide: KENDO_WEBMCP_HOST,
        useExisting: forwardRef(() => DropDownTreeComponent)
      }],
      selector: 'kendo-dropdowntree',
      template: `
        <ng-container kendoDropDownTreeLocalizedMessages
          i18n-noDataText="kendo.dropdowntree.noDataText|The text displayed in the popup when there are no items"
          noDataText="NO DATA FOUND"

          i18n-clearTitle="kendo.dropdowntree.clearTitle|The title of the clear button"
          clearTitle="clear"

          i18n-selectButtonText="kendo.dropdowntree.selectButtonText|The text set as aria-label on the select button"
          selectButtonText="Select"

          i18n-filterInputLabel="kendo.dropdowntree.filterInputLabel|The text set as aria-label on the filter input"
          filterInputLabel="Filter"

          i18n-popupLabel="kendo.dropdowntree.popupLabel|The label of the popup element that contains the list of options when its role is 'region'"
          popupLabel="Options list"

          i18n-adaptiveCloseButtonTitle="kendo.dropdowntree.adaptiveCloseButtonTitle|The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode"
          adaptiveCloseButtonTitle="Close"

          i18n-filterInputPlaceholder="kendo.dropdowntree.filterInputPlaceholder|The text for the input's placeholder when filtering is enabled"
          filterInputPlaceholder="Filter"
          >
        </ng-container>
        <span
          [attr.id]="valueLabelId"
          class="k-input-inner"
          (click)="$event.preventDefault()"
          >
          @if (valueTemplate || text || placeholder) {
            <span class="k-input-value-text">
              @if (valueTemplate) {
                <ng-template
                    [templateContext]="{
                        templateRef: valueTemplate.templateRef,
                        $implicit: dataItem
                    }">
                </ng-template>
              }
              @if (!valueTemplate) {
                {{ text || placeholder }}
              }
            </span>
          }
        </span>
        @if (!loading && !readonly && clearButton && text?.length && !disabled) {
          <span
            class="k-clear-value"
            [style.visibility]="clearButtonVisibility"
            [attr.title]="messageFor('clearTitle')"
            aria-hidden="true"
            (click)="clearValue($event)"
            >
            <kendo-icon-wrapper
              name="x"
              [svgIcon]="xIcon"
              >
            </kendo-icon-wrapper>
          </span>
        }
        @if (loading) {
          <span class="k-i-loading k-input-loading-icon k-icon"></span>
        }
        <button
          tabindex="-1"
          type="button"
          class="k-input-button k-button k-icon-button"
          [ngClass]="selectButtonClasses"
          [attr.aria-label]="messageFor('selectButtonText')"
          [attr.disabled]="disabled ? '' : null"
          >
          <kendo-icon-wrapper
            [name]="icon || 'chevron-down'"
            innerCssClass="k-button-icon"
            [svgIcon]="svgIcon || chevronDownIcon"
            >
          </kendo-icon-wrapper>
        </button>
        <ng-template #popupTemplate>
          <ng-container *ngTemplateOutlet="sharedPopupActionSheetTemplate"></ng-container>
        </ng-template>
        <ng-container #container></ng-container>

        <kendo-adaptive-renderer
          [sharedPopupActionSheetTemplate]="sharedPopupActionSheetTemplate"
          [title]="adaptiveTitle"
          [showTextInput]="filterable"
          [subtitle]="adaptiveSubtitle"
          (closePopup)="togglePopup(false)"
          (textInputChange)="handleFilterInputChange($event)"
          [placeholder]="placeholder"
          [searchBarValue]="filter"
          [filterable]="filterable">
        </kendo-adaptive-renderer>

        <ng-template #sharedPopupActionSheetTemplate>
          @if (filterable && !isActionSheetExpanded) {
            <span
              class="k-list-filter"
              >
              <span
                class="k-textbox k-input"
                [ngClass]="filterInputClasses"
                >
                <span class="k-input-prefix">
                  <kendo-icon-wrapper
                    class="k-icon"
                    name="search"
                    [svgIcon]="searchIcon"
                    >
                  </kendo-icon-wrapper>
                </span>
                <input
                  #filterInput
                  (input)="handleFilterInputChange($event.target)"
                  [filterInput]="filterable && !touchEnabled"
                  (keydown.arrowdown)="handleKeydown($event, filterInput)"
                  (keydown.alt.arrowup)="handleKeydown($event, filterInput)"
                  (keydown.escape)="handleKeydown($event, filterInput)"
                  [attr.aria-label]="messageFor('filterInputLabel')"
                  [value]="filter"
                  class="k-input-inner"
                  role="textbox"
                        [kendoEventsOutsideAngular]="{
                            blur: handleBlur
                        }"
                  [scope]="this"
                  >
              </span>
            </span>
          }
          <!--header template-->
          @if (headerTemplate) {
            <ng-template
                [templateContext]="{
                    templateRef: headerTemplate?.templateRef
                }">
            </ng-template>
          }
          @if (data.length !== 0 && !allNodesHidden) {
            <kendo-treeview
              #treeview
              [attr.id]="treeViewId"
              [size]="windowSize !== 'large' ? 'large' : size"
              [nodes]="data"
              [style.maxHeight.px]="listHeight"
              [animate]="false"
              [(selectedKeys)]="selectedKeys"
              [selectBy]="selectBy"
              [textField]="textField"
              kendoTreeViewSelectable
              [children]="children"
              [hasChildren]="hasChildren"
              [loadOnDemand]="loadOnDemand"
              [isExpanded]="isNodeExpanded"
              [isDisabled]="itemDisabled"
              [nodeTemplate]="nodeTemplate"
              [filter]="filter"
              [isVisible]="isNodeVisible"
              (focusout)="handleBlur($event)"
              (keydown)="handleKeydown($event)"
              (selectionChange)="onSelectionChange($event)"
              (expand)="nodeExpand.emit($event)"
              (collapse)="nodeCollapse.emit($event)"
              (childrenLoaded)="onChildrenLoaded()"
              >
            </kendo-treeview>
          }
          <!--footer template-->
          @if (footerTemplate) {
            <ng-template
                [templateContext]="{
                    templateRef: footerTemplate?.templateRef
                }">
            </ng-template>
          }
          <!--no-data template-->
          @if (data.length === 0 || allNodesHidden) {
            <div class="k-no-data" [attr.aria-live]="'polite'">
              @if (noDataTemplate) {
                <ng-template
                    [templateContext]="{
                        templateRef: noDataTemplate?.templateRef
                    }">
                </ng-template>
              }
              @if (!noDataTemplate) {
                <div>{{ messageFor('noDataText') }}</div>
              }
            </div>
          }
        </ng-template>

        @if (isOpen || isAdaptiveModeEnabled) {
          <kendo-resize-sensor (resize)="onResize()"></kendo-resize-sensor>
        }
        `,
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: true,
      imports: [LocalizedMessagesDirective, TemplateContextDirective, IconWrapperComponent, NgClass, NgTemplateOutlet, AdaptiveRendererComponent, FilterInputDirective, EventsOutsideAngularDirective, TreeViewComponent, SelectDirective, ResizeSensorComponent]
    }]
  }], () => [{
    type: i0.Injector
  }, {
    type: i0.ElementRef
  }, {
    type: i2.PopupService
  }, {
    type: NavigationService
  }, {
    type: i0.Renderer2
  }, {
    type: i0.NgZone
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i1.LocalizationService
  }, {
    type: i7.AdaptiveService
  }], {
    icon: [{
      type: Input
    }],
    svgIcon: [{
      type: Input
    }],
    adaptiveRendererComponent: [{
      type: ViewChild,
      args: [AdaptiveRendererComponent]
    }],
    hostClasses: [{
      type: HostBinding,
      args: ['class.k-dropdowntree']
    }, {
      type: HostBinding,
      args: ['class.k-picker']
    }],
    isReadonly: [{
      type: HostBinding,
      args: ['attr.readonly']
    }],
    hostAriaInvalid: [{
      type: HostBinding,
      args: ['attr.aria-invalid']
    }],
    isDisabled: [{
      type: HostBinding,
      args: ['class.k-disabled']
    }, {
      type: HostBinding,
      args: ['attr.aria-disabled']
    }],
    isLoading: [{
      type: HostBinding,
      args: ['class.k-loading']
    }],
    isBusy: [{
      type: HostBinding,
      args: ['attr.aria-busy']
    }],
    hostAriaControls: [{
      type: HostBinding,
      args: ['attr.aria-controls']
    }],
    id: [{
      type: HostBinding,
      args: ['attr.id']
    }],
    direction: [{
      type: HostBinding,
      args: ['attr.dir']
    }],
    hostTabIndex: [{
      type: HostBinding,
      args: ['attr.tabindex']
    }],
    role: [{
      type: HostBinding,
      args: ['attr.role']
    }],
    ariaHasPopup: [{
      type: HostBinding,
      args: ['attr.aria-haspopup']
    }],
    isAriaExpanded: [{
      type: HostBinding,
      args: ['attr.aria-expanded']
    }],
    hostAriaAutocomplete: [{
      type: HostBinding,
      args: ['attr.aria-autocomplete']
    }],
    noDataTemplate: [{
      type: ContentChild,
      args: [NoDataTemplateDirective, {
        static: false
      }]
    }],
    headerTemplate: [{
      type: ContentChild,
      args: [HeaderTemplateDirective, {
        static: false
      }]
    }],
    footerTemplate: [{
      type: ContentChild,
      args: [FooterTemplateDirective, {
        static: false
      }]
    }],
    nodeTemplate: [{
      type: ContentChild,
      args: [NodeTemplateDirective, {
        static: false
      }]
    }],
    valueTemplate: [{
      type: ContentChild,
      args: [ValueTemplateDirective, {
        static: false
      }]
    }],
    popupTemplate: [{
      type: ViewChild,
      args: ['popupTemplate', {
        static: true
      }]
    }],
    container: [{
      type: ViewChild,
      args: ['container', {
        read: ViewContainerRef,
        static: true
      }]
    }],
    treeview: [{
      type: ViewChild,
      args: ['treeview', {
        static: false
      }]
    }],
    filterInput: [{
      type: ViewChild,
      args: ['filterInput', {
        static: false
      }]
    }],
    open: [{
      type: Output
    }],
    opened: [{
      type: Output
    }],
    close: [{
      type: Output
    }],
    closed: [{
      type: Output
    }],
    nodeExpand: [{
      type: Output
    }],
    nodeCollapse: [{
      type: Output
    }],
    onFocus: [{
      type: Output,
      args: ['focus']
    }],
    onBlur: [{
      type: Output,
      args: ['blur']
    }],
    valueChange: [{
      type: Output
    }],
    filterChange: [{
      type: Output
    }],
    loading: [{
      type: Input
    }],
    clearButton: [{
      type: Input
    }],
    data: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    textField: [{
      type: Input
    }],
    valueField: [{
      type: Input
    }],
    valueDepth: [{
      type: Input
    }],
    hasChildren: [{
      type: Input
    }],
    fetchChildren: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    popupSettings: [{
      type: Input
    }],
    dataItem: [{
      type: Input
    }],
    listHeight: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    readonly: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['class.k-readonly']
    }],
    valuePrimitive: [{
      type: Input
    }],
    tabindex: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    rounded: [{
      type: Input
    }],
    fillMode: [{
      type: Input
    }],
    itemDisabled: [{
      type: Input
    }],
    isNodeExpanded: [{
      type: Input
    }],
    isNodeVisible: [{
      type: Input
    }],
    loadOnDemand: [{
      type: Input
    }],
    filterable: [{
      type: Input
    }],
    filter: [{
      type: Input
    }],
    focusableId: [{
      type: Input
    }],
    adaptiveMode: [{
      type: Input
    }],
    adaptiveTitle: [{
      type: Input
    }],
    adaptiveSubtitle: [{
      type: Input
    }]
  });
})();

/**
 * @hidden
 */
const nodeIndex = item => (item || {}).key;
/**
 * @hidden
 */
const buildTreeIndex = (parentIndex, itemIndex) => {
  return [parentIndex, itemIndex].filter(part => isPresent(part)).join('_');
};
/**
 * @hidden
 */
const buildTreeItem = (dataItem, valueField, currentLevelIndex) => {
  if (!isPresent(dataItem)) {
    return null;
  }
  return {
    dataItem,
    key: valueFrom({
      dataItem,
      level: currentLevelIndex
    }, valueField) + '_' + currentLevelIndex
  };
};
/**
 * @hidden
 */
class MultiSelectTreeLookupService {
  map = new Map();
  reset() {
    this.map.clear();
  }
  registerChildren(index, children) {
    const item = this.item(index);
    if (!item) {
      return;
    }
    item.children = children;
  }
  item(index) {
    return this.map.get(index) || null;
  }
  registerItem(item, parent) {
    const currentLookup = {
      children: [],
      item,
      parent: this.item(nodeIndex(parent))
    };
    this.map.set(item.key, currentLookup);
  }
  itemLookup(index) {
    const item = this.item(index);
    if (!item) {
      return null;
    }
    return {
      children: this.mapChildren(item.children),
      item: item.item,
      parent: item.parent
    };
  }
  mapChildren(children = []) {
    return children.map(c => {
      const {
        item,
        parent,
        children
      } = this.item(c.key);
      return {
        children: this.mapChildren(children),
        item,
        parent
      };
    });
  }
  static ɵfac = function MultiSelectTreeLookupService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MultiSelectTreeLookupService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MultiSelectTreeLookupService,
    factory: MultiSelectTreeLookupService.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiSelectTreeLookupService, [{
    type: Injectable
  }], null, null);
})();

/**
 * @hidden
 *
 * A directive which manages the in-memory checked state of the MultiSelectTree nodes.
 */
class BaseCheckDirective {
  /**
   * @hidden
   * The flag is needed in order to determine how to construct the items map keys.
   * If `true`, then the key consists of the item's value and level (depth),
   * else the key consists of the item's value and 0 (no leveling required)
   */
  isHeterogeneous;
  addItem(item) {
    if (this.isItemChecked(item)) {
      return;
    }
    const level = getHierarchicalItemLevel(item.index);
    const key = this.getKey(item, level);
    const candidate = {
      ...item,
      level,
      key
    };
    this.checkedItems.push(candidate);
    this.checkedKeys.add(key);
  }
  removeItem(item) {
    if (!this.isItemChecked(item)) {
      return;
    }
    const level = getHierarchicalItemLevel(item.index);
    const key = this.getKey(item, level);
    const candidate = {
      ...item,
      level,
      key
    };
    this.checkedItems = this.checkedItems.filter(item => {
      const valueMatch = valueFrom(item, this.valueField) === valueFrom(candidate, this.valueField);
      const levelMatch = item.level === candidate.level;
      return this.isHeterogeneous ? !(valueMatch && levelMatch) : !valueMatch;
    });
    this.checkedKeys.delete(key);
  }
  isItemChecked(item) {
    const level = item.index.split('_').length - 1;
    item.level = level;
    const key = this.getKey(item, level);
    return this.checkedKeys.has(key);
  }
  updateItems() {
    this.checkedItems = this.checkedItems || [];
    this.checkedKeys = new Set(this.checkedItems.map(item => item.key));
  }
  /**
   * Add the item's depth to its value so you can have duplicate values on different levels.
   *
   * @param item - The checked key.
   * @returns { string } - A string key consisting of the item's `valueField` value and its depth (depth is 0 if data is homogeneous).
   */
  getKey(item, level) {
    return valueFrom(item, this.valueField) + '_' + (this.isHeterogeneous ? level : 0);
  }
  static ɵfac = function BaseCheckDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BaseCheckDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: BaseCheckDirective,
    inputs: {
      valueField: "valueField",
      checkedItems: "checkedItems",
      isHeterogeneous: "isHeterogeneous"
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseCheckDirective, [{
    type: Directive
  }], null, {
    valueField: [{
      type: Input
    }],
    checkedItems: [{
      type: Input
    }],
    isHeterogeneous: [{
      type: Input
    }]
  });
})();

/**
 * @hidden
 *
 * A directive which manages the in-memory checked state of the MultiSelectTree nodes.
 */
class CheckDirective extends BaseCheckDirective {
  treeView;
  /**
   * Specifies whether items are checked on click and if checking a node also checks its children.
   * The `checkChildren` property also controls parent item checking (checking all child items automatically checks the parent).
   */
  checkable;
  /**
   * Sets the item key or keys to compare data items.
   */
  valueField;
  /**
   * Sets the collection that stores all checked items.
   */
  checkedItems;
  /**
   * Fires when the `checkedItems` collection updates.
   */
  checkedItemsChange = new EventEmitter();
  /**
   * Holds a `Set` with only the checked item keys. Updates this set each time the `checkedItems` value or content changes and uses it for fast look-up to check if an item is checked.
   */
  checkedKeys = new Set();
  subscriptions = new Subscription();
  clickSubscription;
  constructor(treeView) {
    super();
    this.treeView = treeView;
    this.subscriptions.add(this.treeView.checkedChange.subscribe(this.handleCheckedChange.bind(this)));
    this.treeView.isChecked = this.getCheckedState.bind(this);
  }
  ngOnChanges(changes) {
    if (isPresent(changes['checkable'])) {
      this.toggleCheckOnClick();
    }
    if (isPresent(changes['checkedItems'])) {
      this.updateItems();
    }
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.unsubscribeClick();
  }
  getCheckedState(dataItem, index) {
    if (this.isItemChecked({
      dataItem,
      index
    })) {
      return 'checked';
    } else if (this.checkable.checkChildren && this.isItemIndeterminate(this.treeView.itemLookup(index))) {
      return 'indeterminate';
    } else {
      return 'none';
    }
  }
  handleCheckedChange(node) {
    this.checkNode(node);
    // parents should be checked if `checkChildren` is set to `true` (single config option for both)
    const checkParents = this.checkable.checkChildren;
    if (checkParents) {
      this.checkParents(node.parent);
    }
    this.checkedItemsChange.emit(this.checkedItems.slice());
  }
  toggleCheckOnClick() {
    this.unsubscribeClick();
    if (this.checkable.checkOnClick) {
      this.clickSubscription = this.treeView.nodeClick.pipe(filter(event => event.type === 'click')).subscribe(event => {
        const lookup = this.treeView.itemLookup(event.item.index);
        this.handleCheckedChange(lookup);
      });
    }
  }
  unsubscribeClick() {
    if (this.clickSubscription) {
      this.clickSubscription.unsubscribe();
      this.clickSubscription = null;
    }
  }
  checkNode(lookup) {
    if (this.treeView.isDisabled(lookup.item.dataItem, lookup.item.index)) {
      return;
    }
    const target = lookup.item;
    const pendingCheck = [target];
    // TODO: extract in a separate `checkChildren` method?
    if (this.checkable.checkChildren) {
      const filter = item => this.treeView.isVisible(item.dataItem, item.index) && !this.treeView.isDisabled(item.dataItem, item.index);
      fetchDescendentNodes(lookup, filter).forEach(lookup => pendingCheck.push(lookup.item));
    }
    const shouldCheck = !this.isItemChecked(target);
    pendingCheck.forEach(item => {
      if (shouldCheck) {
        this.addItem(item);
      } else {
        this.removeItem(item);
      }
    });
  }
  checkParents(parent) {
    let currentParent = parent;
    while (currentParent) {
      const allChildrenSelected = currentParent.children.every(item => this.isItemChecked(item));
      if (allChildrenSelected) {
        this.addItem(currentParent.item);
      } else {
        this.removeItem(currentParent.item);
      }
      currentParent = currentParent.parent;
    }
  }
  isItemIndeterminate(lookup) {
    const children = lookup.children;
    if (!Array.isArray(children) || children.length === 0) {
      return false;
    }
    let index = 0;
    let child = children[index];
    while (isPresent(child)) {
      if (this.isItemChecked(child.item) || this.isItemIndeterminate(child)) {
        return true;
      }
      index += 1;
      child = children[index];
    }
    return false;
  }
  static ɵfac = function CheckDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CheckDirective)(i0.ɵɵdirectiveInject(i1$1.TreeViewComponent));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CheckDirective,
    selectors: [["", "kendoMultiSelectTreeCheckable", ""]],
    inputs: {
      checkable: "checkable",
      valueField: "valueField",
      checkedItems: "checkedItems"
    },
    outputs: {
      checkedItemsChange: "checkedItemsChange"
    },
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoMultiSelectTreeCheckable]',
      standalone: true
    }]
  }], () => [{
    type: i1$1.TreeViewComponent
  }], {
    checkable: [{
      type: Input
    }],
    valueField: [{
      type: Input
    }],
    checkedItems: [{
      type: Input
    }],
    checkedItemsChange: [{
      type: Output
    }]
  });
})();

/**
 * @hidden
 *
 * A directive which manages the in-memory checked state of the MultiSelectTree nodes.
 */
class CheckAllDirective extends BaseCheckDirective {
  element;
  zone;
  cdr;
  renderer;
  lastAction;
  treeview;
  /**
   * Sets the collection that stores all checked items.
   */
  checkedItems;
  /**
   * Sets the item key or keys to compare data items.
   */
  valueField;
  focused;
  /**
   * Fires when the `checkedItems` collection updates.
   */
  checkedItemsChange = new EventEmitter();
  /**
   * Holds a `Set` with only the checked item keys. Updates this set each time the `checkedItems` value or content changes and uses it for fast look-up to check if an item is checked.
   */
  checkedKeys = new Set();
  currentCheckedState;
  currentIndeterminateState;
  handleChange(event) {
    // Need to store the current checkbox state at the moment of click
    this.currentCheckedState = event.checked;
    this.currentIndeterminateState = this.isIndeterminate;
    this.treeview.nodes.forEach((_value, index) => {
      const itemIndex = String(index);
      const itemLookup = this.treeview.itemLookup(itemIndex);
      this.checkNode(itemLookup);
    });
    this.checkedItemsChange.emit(this.checkedItems.slice());
  }
  get isIndeterminate() {
    const isIndeterminate = this.treeview.nodes.some((_node, index) => {
      const itemIndex = String(index);
      const itemLookup = this.treeview.itemLookup(itemIndex);
      return this.someChecked(itemLookup);
    });
    return this.isChecked ? false : isIndeterminate;
  }
  get isChecked() {
    const isChecked = this.treeview.nodes.every((_node, index) => {
      const itemIndex = String(index);
      const itemLookup = this.treeview.itemLookup(itemIndex);
      return this.allChecked(itemLookup);
    });
    return isChecked;
  }
  constructor(element, zone, cdr, renderer) {
    super();
    this.element = element;
    this.zone = zone;
    this.cdr = cdr;
    this.renderer = renderer;
  }
  ngOnChanges(changes) {
    if (isPresent(changes['checkedItems'])) {
      this.updateItems();
      this.renderer.setProperty(this.element.nativeElement, 'checked', this.isChecked);
      this.renderer.setProperty(this.element.nativeElement, 'indeterminate', this.isIndeterminate);
    }
  }
  ngOnInit() {
    if (this.focused) {
      this.nextTick(() => this.element.nativeElement.focus());
    }
  }
  nextTick(fn) {
    this.zone.runOutsideAngular(() => setTimeout(fn));
  }
  checkNode(itemLookup) {
    if (this.treeview.isDisabled(itemLookup.item.dataItem, itemLookup.item.index)) {
      return;
    }
    const pendingCheck = [];
    const filter = item => this.treeview.isVisible(item.dataItem, item.index) && !this.treeview.isDisabled(item.dataItem, item.index);
    pendingCheck.push(itemLookup.item);
    fetchDescendentNodes(itemLookup, filter).forEach(lookup => pendingCheck.push(lookup.item));
    pendingCheck.forEach(item => {
      if (this.currentIndeterminateState) {
        if (this.lastAction === 'check') {
          this.addItem(item);
        } else {
          this.removeItem(item);
        }
        return;
      }
      if (this.currentCheckedState) {
        this.addItem(item);
      } else {
        this.removeItem(item);
      }
    });
  }
  allChecked(lookup) {
    const children = lookup && lookup.children;
    if (!Array.isArray(children)) {
      return;
    }
    const childrenChecked = children.every(child => {
      if (child.children.length) {
        return this.isItemChecked(child.item) && this.allChecked(child);
      }
      return this.isItemChecked(child.item);
    });
    return childrenChecked && this.isItemChecked(lookup.item);
  }
  someChecked(lookup) {
    const children = lookup && lookup.children;
    if (!Array.isArray(children)) {
      return;
    }
    const childrenChecked = children.some(child => {
      if (child.children.length) {
        return this.isItemChecked(child.item) || this.someChecked(child);
      }
      return this.isItemChecked(child.item);
    });
    return childrenChecked || this.isItemChecked(lookup.item);
  }
  static ɵfac = function CheckAllDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CheckAllDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CheckAllDirective,
    selectors: [["", "checkAll", ""]],
    hostBindings: function CheckAllDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("change", function CheckAllDirective_change_HostBindingHandler($event) {
          return ctx.handleChange($event.target);
        });
      }
    },
    inputs: {
      lastAction: "lastAction",
      treeview: "treeview",
      checkedItems: "checkedItems",
      valueField: "valueField",
      focused: [0, "checkAll", "focused"]
    },
    outputs: {
      checkedItemsChange: "checkedItemsChange"
    },
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckAllDirective, [{
    type: Directive,
    args: [{
      selector: '[checkAll]',
      standalone: true
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.NgZone
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i0.Renderer2
  }], {
    lastAction: [{
      type: Input
    }],
    treeview: [{
      type: Input
    }],
    checkedItems: [{
      type: Input
    }],
    valueField: [{
      type: Input
    }],
    focused: [{
      type: Input,
      args: ['checkAll']
    }],
    checkedItemsChange: [{
      type: Output
    }],
    handleChange: [{
      type: HostListener,
      args: ['change', ['$event.target']]
    }]
  });
})();
const DEFAULT_POPUP_SETTINGS = {
  animate: true
};
const DEFAULT_CHECKABLE_SETTINGS = {
  checkChildren: true,
  checkOnClick: true
};
const hasChildren = () => false;
const fetchChildren = () => of([]);
const itemDisabled = () => false;
const isNodeVisible = () => true;
/**
 * Represents the Kendo UI for Angular [MultiSelectTree](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselecttree) component.
 *
 * The `MultiSelectTree` lets you select multiple items from hierarchical data in a tree structure.
 * It provides built-in filtering, checkboxes, and adaptive rendering for mobile devices.
 *
 * @example
 * ```typescript
 * @Component({
 *   selector: 'my-app',
 *   template: `
 *     <kendo-multiselecttree
 *       [data]="data"
 *       textField="text"
 *       valueField="value"
 *       [(value)]="selectedValues">
 *     </kendo-multiselecttree>
 *   `
 * })
 * export class AppComponent {
 *   public data = [
 *     { text: 'Root', value: 1, items: [
 *       { text: 'Child 1', value: 2 },
 *       { text: 'Child 2', value: 3 }
 *     ]}
 *   ];
 *   public selectedValues = [2, 3];
 * }
 * ```
 * @remarks
 * Supported children components are: {@link CustomMessagesComponent}.
 */
class MultiSelectTreeComponent {
  injector;
  wrapper;
  popupService;
  renderer;
  navigationService;
  _zone;
  localization;
  cdr;
  lookup;
  adaptiveService;
  /**
   * @hidden
   */
  touchEnabled = touchEnabled;
  /**
   * @hidden
   */
  animationDuration = animationDuration;
  /**
   * @hidden
   */
  searchIcon = searchIcon;
  /**
   * @hidden
   */
  xIcon = xIcon;
  hostClasses = true;
  get isDisabled() {
    return this.disabled || null;
  }
  treeViewId = `k-${guid()}`;
  get hostAriaAutocomplete() {
    return this.filterable ? 'list' : null;
  }
  get isLoading() {
    return this.loading;
  }
  get hostAriaInvalid() {
    return this.formControl?.invalid ? true : null;
  }
  get isBusy() {
    return this.loading ? 'true' : null;
  }
  get id() {
    return this.focusableId;
  }
  direction;
  get hostTabIndex() {
    return this.tabindex;
  }
  role = 'combobox';
  ariaHasPopup = 'tree';
  get isReadonly() {
    return this.readonly ? '' : null;
  }
  get ariaDescribedBy() {
    return this.tagListId;
  }
  get ariaActiveDescendant() {
    return this.focusedTagId;
  }
  /**
   * @hidden
   */
  get formControl() {
    const ngControl = this.injector.get(NgControl, null);
    return ngControl?.control || null;
  }
  /**
   * @hidden
   */
  onFilterChange(text) {
    if (this.filterable) {
      this.filter = text;
      this.filterChange.emit(text);
    }
  }
  /**
   * Controls the adaptive mode behavior of the component.
   * Set to `auto` to enable automatic adaptive rendering on small screens.
   *
   * @default 'none'
   */
  adaptiveMode = 'none';
  /**
   * Sets the title text for the ActionSheet in adaptive mode on small screens.
   * Uses the component label by default if not set.
   *
   * @default ''
   */
  adaptiveTitle = '';
  /**
   * Sets the subtitle text for the ActionSheet in adaptive mode on small screens.
   * No subtitle appears by default.
   */
  adaptiveSubtitle;
  /**
   * @hidden
   */
  get isAdaptiveModeEnabled() {
    return this.adaptiveMode === 'auto';
  }
  /**
  * @hidden
  */
  windowSize = 'large';
  /**
   * @hidden
   */
  get isActionSheetExpanded() {
    return this.actionSheet?.expanded;
  }
  /**
   * @hidden
   */
  handleKeydown(event, input) {
    const code = normalizeKeys(event);
    if (event.target === this.filterInput?.nativeElement && (code === Keys.ArrowLeft || code === Keys.ArrowRight)) {
      return;
    }
    if (input) {
      event.stopImmediatePropagation();
    }
    const deleteTag = this.isWrapperActive && code === Keys.Backspace && this.tags.length > 0;
    if (deleteTag) {
      this.handleBackspace();
      return;
    }
    if (this.disabled || this.readonly) {
      return;
    }
    if (!this.isFilterActive && isLetter(event.key) && !this.actionSheetSearchBar?.onFocus) {
      this.printableCharacters.next(event.key);
    }
    const eventData = event;
    const action = this.navigationService.process({
      originalEvent: eventData,
      openOnSpace: !this.isOpen,
      closeOnSpace: false
    });
    if (action === NavigationAction.Open) {
      eventData.preventDefault();
    }
    if (this.isOpen && action === NavigationAction.Enter) {
      const spaceKeyDownEvent = new KeyboardEvent('keydown', {
        'key': ' ',
        'code': 'Space',
        'keyCode': 32,
        'which': 32
      });
      this.treeview?.element.nativeElement.dispatchEvent(spaceKeyDownEvent);
    }
  }
  /**
   * @hidden
   */
  adaptiveRendererComponent;
  /**
   * @hidden
   */
  get actionSheet() {
    return this.adaptiveRendererComponent?.actionSheet;
  }
  /**
   * @hidden
   */
  get actionSheetSearchBar() {
    return this.adaptiveRendererComponent?.actionSheetSearchBar;
  }
  /**
   * @hidden
   */
  get isAdaptive() {
    return this.isAdaptiveModeEnabled && this.windowSize !== 'large';
  }
  headerTemplate;
  footerTemplate;
  nodeTemplate;
  noDataTemplate;
  tagTemplate;
  groupTagTemplate;
  popupTemplate;
  container;
  set treeview(treeview) {
    this._treeview = treeview;
    if (treeview) {
      // If filtering is enabled, focus the TreeView on mobile devices instead of the filter input
      if (this.isFocused && !this.filterable && !this.checkAll || this.touchEnabled) {
        treeview.focus();
      }
      /**
       * the treeview animations are initially disabled (we don't want expand animations during popup opening)
       * re-enables the animations for user interaction
       * The Promise is required to properly change the `animate` property when
       * the popup is appended to a container and opened upon initialization.
       * Otherwise, the "Expression has changed..." type error will be thrown.
       */
      Promise.resolve(null).then(() => this.treeview.animate = true);
    }
  }
  get treeview() {
    return this._treeview;
  }
  filterInput;
  checkAllInput;
  /**
   * Sets the tab index for keyboard navigation.
   * Use `-1` to remove the component from the tab sequence.
   *
   * @default 0
   */
  set tabindex(value) {
    const providedTabIndex = parseNumber(value);
    const defaultTabIndex = 0;
    this._tabindex = !isNaN(providedTabIndex) ? providedTabIndex : defaultTabIndex;
  }
  get tabindex() {
    return this.disabled ? -1 : this._tabindex;
  }
  /**
   * Sets the visual size of the component. The default value is set by the Kendo theme.
   */
  set size(size) {
    this.renderer.removeClass(this.wrapper.nativeElement, getSizeClass('input', this.size));
    if (size) {
      this.renderer.addClass(this.wrapper.nativeElement, getSizeClass('input', size));
    }
    this._size = size;
  }
  get size() {
    return this._size;
  }
  /**
   * Sets the border radius style of the component. The default value is set by the Kendo theme.
   */
  set rounded(rounded) {
    this.renderer.removeClass(this.wrapper.nativeElement, getRoundedClass(this.rounded));
    if (rounded) {
      this.renderer.addClass(this.wrapper.nativeElement, getRoundedClass(rounded));
    }
    this._rounded = rounded;
  }
  get rounded() {
    return this._rounded;
  }
  /**
   * Sets the fill style for the component background and borders. The default value is set by the Kendo theme.
   */
  set fillMode(fillMode) {
    this.renderer.removeClass(this.wrapper.nativeElement, getFillModeClass('input', this.fillMode));
    if (fillMode) {
      this.renderer.addClass(this.wrapper.nativeElement, getFillModeClass('input', fillMode));
    }
    this._fillMode = fillMode;
  }
  get fillMode() {
    return this._fillMode;
  }
  /**
   * Configures the popup container settings: animation, dimensions, styling and positioning.
   */
  set popupSettings(settings) {
    this._popupSettings = Object.assign({}, DEFAULT_POPUP_SETTINGS, settings);
    // `detectChanges` needed, otherwise upon value initialization and `appendTo` property
    // an error is thrown => ExpressionChangedAfterItHasBeenCheckedError
    this.cdr.detectChanges();
  }
  get popupSettings() {
    return this._popupSettings;
  }
  /**
   * Configures the checkbox behavior for the MultiSelecTree nodes.
   * Use `checkableSettings` to control parent-child selection relationships and click interactions.
   *
   * @default '{ checkChildren: true, checkOnClick: true }'
   */
  set checkableSettings(settings) {
    this._checkableSettings = Object.assign({}, DEFAULT_CHECKABLE_SETTINGS, settings);
  }
  get checkableSettings() {
    return this._checkableSettings;
  }
  /**
   * Sets the hierarchical data source for the tree structure.
   * Provide an array of objects that contain the tree data and structure.
   */
  set data(data) {
    this._nodes = data;
    this.setState();
    if (this.isContentInit) {
      // Needed for when the data is loaded later/asynchronously because it would not exist on ngContentInit
      this.registerLookupItems(data);
    }
  }
  get data() {
    return this._nodes;
  }
  /**
   * Sets the selected values in the component.
   * Accepts primitive values if `valuePrimitive` is `true`, or objects if `false`.
   */
  set value(value) {
    this._value = value ? value : [];
    this.setState();
  }
  get value() {
    return this._value;
  }
  /**
   * Sets the data items that correspond to the selected values.
   * Required when using primitive values to resolve the full data objects.
   */
  set dataItems(items) {
    this._dataItems = (items || []).map((dataItem, index) => {
      if (hasProps(dataItem, ['dataItem', 'index', 'level'])) {
        return dataItem;
      }
      const level = this.valueDepth[index] || 0;
      const key = valueFrom({
        dataItem,
        level
      }, this.valueField) + '_' + (this.isHeterogeneous ? this.valueDepth[index] : 0);
      return {
        dataItem,
        index: null,
        level,
        key
      };
    });
    this.setState();
  }
  get dataItems() {
    return this._dataItems || this.value.map((value, index) => {
      const level = this.valueDepth[index] || 0;
      const key = valueFrom({
        dataItem: value,
        level
      }, this.valueField) + '_' + (this.isHeterogeneous ? this.valueDepth[index] : 0);
      return {
        dataItem: value,
        index: null,
        level,
        key
      };
    });
  }
  /**
   * Specifies which data field provides the display text for tree nodes.
   * > The `textField` property can be set to point to a nested property value - e.g. `category.name`.
   */
  textField;
  /**
   * Specifies which data field provides the unique values for tree nodes.
   * > The `valueField` property can be set to point to a nested property value - e.g. `category.id`.
   */
  valueField;
  /**
   * Sets the levels in the data set where the values can be found when `valueField` is an Array.
   * The field serves to correctly allocate a data item used when the MultiSelectTree is initialized with a value.
   *
   * @default []
   */
  valueDepth = [];
  /**
   * Controls the loading state visual indicator.
   * Shows a loading spinner when set to `true`.
   *
   * @default false
   */
  loading;
  /**
   * Sets the placeholder text shown when no items are selected.
   * Helps guide users on what action to take.
   *
   * @default ''
   */
  placeholder = '';
  /**
   * Sets the maximum height of the options list in the popup.
   * Controls vertical scrolling when content exceeds this height.
   *
   * @default 200
   */
  set listHeight(_listHeight) {
    this._listHeight = _listHeight;
  }
  get listHeight() {
    if (this.isAdaptive) {
      return;
    }
    return this._listHeight;
  }
  _listHeight = 200;
  /**
   * Controls whether the component accepts user input.
   * Prevents all user interactions when set to `true`.
   *
   * @default false
   */
  disabled = false;
  /**
   * Sets the component to read-only mode.
   * Displays current selections but prevents changes.
   *
   * @default false
   */
  readonly = false;
  /**
   * Determines the data type of selected values.
   * Set to `true` for primitive values, false for complex objects.
   *
   * @default false
   */
  valuePrimitive = false;
  /**
   * Controls when child nodes load from the data source.
   * Set to `true` to load children only when parent nodes expand.
   *
   * @default false
   */
  loadOnDemand = false;
  /**
   * Sets the unique identifier for the focusable element.
   * Used internally for accessibility and label association.
   */
  focusableId = `k-${guid()}`;
  /**
   * Shows a clear button to reset all selections.
   * Appears on hover when selections exist and the component is not disabled.
   *
   * @default true
   */
  clearButton = true;
  /**
   * Enables the built-in filter input for searching tree nodes.
   * Shows a search box above the tree when enabled.
   *
   * @default false
   */
  filterable = false;
  /**
   * Shows a checkbox to select or deselect all visible tree nodes.
   * Appears above the tree when checkboxes are enabled.
   *
   * @default false
   */
  checkAll = false;
  /**
   * Determines if a tree node contains child nodes.
   * Return `true` if the node has children, false otherwise.
   */
  hasChildren = hasChildren;
  /**
   * Function that provides child nodes for a parent node.
   * Return an Observable of child objects for the given parent.
   */
  fetchChildren = fetchChildren;
  /**
   * Determines if a specific node is expanded. The function is executed for each data item.
   */
  isNodeExpanded;
  /**
   * Determines if a tree node should be hidden.
   */
  isNodeVisible = isNodeVisible;
  /**
   * Determines if a tree node is disabled. The function is executed for each data item.
   */
  itemDisabled = itemDisabled;
  /**
   * @param { Any[] } dataItems - The selected data items from the list.
   * @returns { Any[] } - The tags that will be rendered by the component.
   * Transforms the provided array of data items into an array of tags.
   */
  tagMapper = tags => tags || [];
  /**
   * Fires when the component receives focus.
   */
  onFocus = new EventEmitter();
  /**
   * Fires when the component gets blurred.
   */
  onBlur = new EventEmitter();
  /**
   * Fires when the popup is about to open. ([See example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselecttree/open-state)).
   * This event is preventable. When cancelled, the popup remains closed.
   */
  open = new EventEmitter();
  /**
   * Fires after the popup opens completely.
   * Use this event to perform actions when the popup becomes visible.
   */
  opened = new EventEmitter();
  /**
   * Fires before the popup closes.
   * Cancel this event to prevent the popup from closing.
   */
  close = new EventEmitter();
  /**
   * Fires after the popup closes completely.
   * Use this event to perform cleanup actions when the popup becomes hidden.
   */
  closed = new EventEmitter();
  /**
   * Fires when a tree node is expanded.
   * Use this event to respond to node expansion actions.
   */
  nodeExpand = new EventEmitter();
  /**
   * Fires when a user collapses a tree node.
   * Use this event to respond to node collapse actions.
   */
  nodeCollapse = new EventEmitter();
  /**
   * Fires when the selected value changes.
   * Use this event to respond to selection changes.
   */
  valueChange = new EventEmitter();
  /**
   * Fires before a tag is removed.
   * Cancel this event to prevent tag removal.
   */
  removeTag = new EventEmitter();
  /**
   * Fires when the filter input value changes.
   * Use this event to implement custom filtering logic.
   */
  filterChange = new EventEmitter();
  /**
   * @hidden
   */
  get focusedTagId() {
    if (!isPresent(this.focusedTagIndex) || this.isOpen) {
      return null;
    }
    return this.tagPrefix + '-' + this.focusedTagIndex;
  }
  set isFocused(isFocused) {
    this.renderer[isFocused ? 'addClass' : 'removeClass'](this.wrapper.nativeElement, 'k-focus');
    this._isFocused = isFocused;
  }
  get isFocused() {
    return this._isFocused;
  }
  /**
   * Returns the current open state. Returns `true` if the popup or actionSheet is open.
   */
  get isOpen() {
    return isTruthy(isPresent(this.popupRef) || this.isActionSheetExpanded);
  }
  get width() {
    const wrapperWidth = this.wrapper.nativeElement.offsetWidth;
    const width = this.popupSettings.width || wrapperWidth;
    const minWidth = isNaN(wrapperWidth) ? wrapperWidth : `${wrapperWidth}px`;
    const maxWidth = isNaN(width) ? width : `${width}px`;
    return {
      min: minWidth,
      max: maxWidth
    };
  }
  get height() {
    const popupHeight = this.popupSettings.height;
    return isPresent(popupHeight) ? `${popupHeight}px` : 'auto';
  }
  get appendTo() {
    const {
      appendTo
    } = this.popupSettings;
    if (!appendTo || appendTo === 'root') {
      return undefined;
    }
    return appendTo === 'component' ? this.container : appendTo;
  }
  /**
   * @hidden
   */
  get popupContainerClasses() {
    const containerClasses = ['k-multiselecttree-popup'];
    if (!this.popupSettings.popupClass) {
      return containerClasses;
    }
    const parsedPopupClasses = parseCSSClassNames(this.popupSettings.popupClass);
    if (parsedPopupClasses?.length) {
      containerClasses.push(...parsedPopupClasses);
    }
    return containerClasses;
  }
  /**
   * @hidden
   *
   * Alias for `data`. Used for compatibility with the `DataBoundComponent` interface.
   * Required for the data-binding directives.
   */
  set nodes(nodes) {
    this.data = nodes;
  }
  get nodes() {
    return this.data;
  }
  /**
   * @hidden
   *
   * Alias for `fetchChildren`. Used for compatibility with the `DataBoundComponent` interface.
   * Required for the data-binding directives
   */
  set children(callback) {
    this.fetchChildren = callback;
  }
  get children() {
    return this.fetchChildren;
  }
  /**
   * @hidden
   *
   * Alias for `nodeExpand`. Used for compatibility with the `ExpandableComponent` interface.
   * Required for the expand-directive.
   */
  get expand() {
    return this.nodeExpand;
  }
  /**
   * @hidden
   *
   * Alias for `nodeCollapse`. Used for compatibility with the `ExpandableComponent` interface.
   * Required for the expand-directive.
   */
  get collapse() {
    return this.nodeCollapse;
  }
  /**
   * @hidden
   *
   * Alias for `isNodeExpanded`. Used for compatibility with the `ExpandableComponent` interface.
   * Required for the expand-directive.
   */
  set isExpanded(callback) {
    this.isNodeExpanded = callback;
  }
  get isExpanded() {
    return this.isNodeExpanded;
  }
  /**
   * @hidden
   *
   * Alias for `isNodeVisible`. Used for compatibility with the `DataBoundComponent` interface.
   * The `DataBoundComponent` interface is used in the data-binding directives.
   */
  set isVisible(callback) {
    this.isNodeVisible = callback;
  }
  get isVisible() {
    return this.isNodeVisible;
  }
  get isTagFocused() {
    return !this.isOpen && this.focusedTagIndex !== undefined;
  }
  get isTreeViewActive() {
    return this.treeview && this.treeview.isActive;
  }
  get isWrapperActive() {
    return document.activeElement === this.wrapper.nativeElement;
  }
  get isFilterActive() {
    return this.filterInput && document.activeElement === this.filterInput.nativeElement;
  }
  get isCheckAllActive() {
    return this.checkAllInput && document.activeElement === this.checkAllInput.nativeElement;
  }
  /**
   * @hidden
   */
  onResize() {
    const currentWindowSize = this.adaptiveService.size;
    if (this.isAdaptiveModeEnabled && this.windowSize !== currentWindowSize) {
      if (this.isOpen) {
        this.togglePopup(false);
      }
      this.windowSize = currentWindowSize;
    }
    if (this.isOpen && !this.isActionSheetExpanded) {
      const popupWrapper = this.popupRef.popupElement;
      const {
        min,
        max
      } = this.width;
      popupWrapper.style.minWidth = min;
      popupWrapper.style.width = max;
    }
  }
  /**
   * @hidden
   */
  filterStateChange = new EventEmitter();
  /**
   * @hidden
   */
  filter = '';
  /**
   * @hidden
   */
  checkedItems = [];
  /**
   * @hidden
   * The flag is needed in order to determine how to construct the items map keys.
   * If `true`, then the key consists of the item's value and level (depth),
   * else the key consists of the item's value and 0 (no leveling required)
   */
  isHeterogeneous;
  /**
   * @hidden
   */
  showAfter = 0;
  /**
   * @hidden
   */
  allNodesHidden = false;
  tagListId = `k-${guid()}`;
  tagPrefix = "tag-" + guid();
  popupRef;
  tags;
  focusedTagIndex = undefined;
  disabledIndices;
  _nodes;
  _value = [];
  _tabindex = 0;
  _popupSettings = DEFAULT_POPUP_SETTINGS;
  _checkableSettings = DEFAULT_CHECKABLE_SETTINGS;
  _isFocused = false;
  _treeview;
  _dataItems;
  _size;
  _rounded;
  _fillMode;
  _searchableNodes = [];
  _typedValue = '';
  printableCharacters = new Subject();
  subs = new Subscription();
  // Keep an instance of the last focused node for when the popup close is prevented
  // in order to be able to properly restore the focus
  lastNodeOnFocus;
  // Used as check to avoid unnecessary 'registerLookupItems()' calls upon initialization
  isContentInit;
  constructor(injector, wrapper, popupService, renderer, navigationService, _zone, localization, cdr, lookup, adaptiveService) {
    this.injector = injector;
    this.wrapper = wrapper;
    this.popupService = popupService;
    this.renderer = renderer;
    this.navigationService = navigationService;
    this._zone = _zone;
    this.localization = localization;
    this.cdr = cdr;
    this.lookup = lookup;
    this.adaptiveService = adaptiveService;
    this.direction = localization.rtl ? 'rtl' : 'ltr';
    this.subscribeEvents();
    this.subscribeFocusEvents();
  }
  ngOnInit() {
    this.subs.add(this.printableCharacters.pipe(tap(char => {
      this._typedValue += char;
      const itemToFocus = this._searchableNodes.find(node => {
        return node.text.toLowerCase().startsWith(this._typedValue);
      });
      this.treeview?.focus(itemToFocus?.index);
    }), debounceTime(1000)).subscribe(() => {
      this._typedValue = '';
    }));
    this.renderer.removeAttribute(this.wrapper.nativeElement, 'tabindex');
    this.renderer.setAttribute(this.wrapper.nativeElement, 'aria-expanded', String(this.isOpen));
    this.subs.add(this.localization.changes.subscribe(({
      rtl
    }) => {
      this.direction = rtl ? 'rtl' : 'ltr';
      this.cdr.markForCheck();
    }));
    this.setComponentClasses();
  }
  ngAfterViewInit() {
    this.windowSize = this.adaptiveService.size;
    this.subs.add(this.renderer.listen(this.wrapper.nativeElement, 'click', this.handleClick.bind(this)));
    this.subs.add(this.renderer.listen(this.wrapper.nativeElement, 'keydown', this.handleKeydown.bind(this)));
  }
  /**
   * @hidden
   */
  ngOnDestroy() {
    this.destroyPopup();
    this.unsubscribeEvents();
  }
  /**
   * @hidden
   */
  ngOnChanges(changes) {
    if (anyChanged(['textField', 'valueField', 'valuePrimitive'], changes, false)) {
      this.isHeterogeneous = this.valueField && isArray(this.valueField);
      this.setState();
    }
    if (anyChanged(['valueDepth', 'value', 'dataItems'], changes, false)) {
      if (changes['value'] && !changes['dataItems'] && !this.valuePrimitive) {
        // Update the dataItems if the value is updated programmatically (non-primitive values only)
        // In the primitive case, the client should update the dataItems as well
        this.dataItems = this.value;
      } else {
        // Re-map the dataItems because `valueDepth` is not yet available when the check directive parses the items
        this.dataItems = this.dataItems.map((item, index) => ({
          ...item,
          key: valueFrom({
            dataItem: item.dataItem,
            index: null,
            level: this.valueDepth[index] || 0
          }, this.valueField) + '_' + (this.isHeterogeneous ? this.valueDepth[index] : 0),
          level: this.valueDepth[index] || 0
        }));
      }
    }
    if (anyChanged(['data', 'children', 'hasChildren', 'loadOnDemand', 'valueField'], changes, true) && !this.loadOnDemand) {
      this.lookup.reset();
      this.registerLookupItems(this.data);
    }
  }
  /**
   * @hidden
   */
  ngAfterContentChecked() {
    this.verifySettings();
    if (this.data?.length > 0 && this.popupRef) {
      this.allNodesHidden = this.areNodesHidden(this.data);
    }
  }
  ngAfterContentInit() {
    this.isContentInit = true;
    // Still need to keep the call of 'registerLookupItems()' from ngAfterContentInit in the cases when the data is passed initially
    // The call is execute here because we have to make sure it happens after all input properties are loaded (not the case in the data setter initially)
    this.registerLookupItems(this.data);
  }
  /**
   * @hidden
   *
   * Used by the kendo-floatinglabel component to determine if the floating label
   * should be rendered inside the input when the component is not focused.
   */
  isEmpty() {
    return !this.placeholder && (!isPresent(this.value) || this.value.length === 0);
  }
  /**
   * Sets focus to the component.
   * Call this method to programmatically focus the MultiSelectTree.
   */
  focus() {
    if (!this.disabled) {
      this.wrapper.nativeElement.focus();
    }
  }
  /**
   * Removes focus from the component.
   * Call this method to programmatically blur the MultiSelectTree.
   */
  blur() {
    if (!this.disabled) {
      this.wrapper.nativeElement.blur();
    }
  }
  /**
   * Sets focus to a specific tree item by index.
   * Provide the item index in format like '1_1' to focus that item.
   * The item must be expanded and enabled to receive focus.
   */
  focusItemAt(index) {
    if (this.treeview) {
      const lookup = this.treeview.itemLookup(index);
      const isItemDisabled = !isPresent(lookup) || this.treeview.isDisabled(lookup.item.dataItem, lookup.item.index);
      if (!isItemDisabled) {
        this.treeview.focus(index);
      }
    }
  }
  /**
   * Clears all selected values from the component.
   * This method does not trigger the valueChange event.
   */
  reset() {
    this.value = [];
    this.dataItems = [];
    this.valueDepth = [];
  }
  /**
   * Opens or closes the popup programmatically.
   * Pass `true` to open, false to close, or omit the parameter to toggle.
   * This method does not trigger open or close events.
   */
  toggle(open) {
    // The Promise is required to open the popup on load.
    // Otherwise, the "ViewContainerRef not found..." error will be thrown.
    Promise.resolve(null).then(() => {
      const shouldOpen = isPresent(open) ? open : !isPresent(this.popupRef);
      this.destroyPopup();
      if (shouldOpen) {
        this.createPopup();
      }
    });
  }
  /**
   * @hidden
   */
  handleFocus(event) {
    if (event.target !== this.wrapper.nativeElement) {
      return;
    }
    event.stopImmediatePropagation();
    if (!this.isFocused) {
      this.isFocused = true;
      if (hasObservers(this.onFocus)) {
        this._zone.run(() => {
          this.onFocus.emit();
        });
      }
      // Re-focus the treeview if `close` is prevented
      if (this.isOpen && this.treeview) {
        if (this.lastNodeOnFocus) {
          this.lastNodeOnFocus.setAttribute('tabindex', '0');
        }
        this.treeview.focus();
      }
    }
  }
  /**
   * @hidden
   */
  handleBlur(e) {
    if (!this.isActionSheetExpanded) {
      const relatedTarget = e && e.relatedTarget;
      if (this.wrapper.nativeElement.contains(relatedTarget) || this.isOpen && this.popupRef.popupElement.contains(relatedTarget)) {
        return;
      }
      this.isFocused = false;
      this.togglePopup(false);
      //this is needed for Ang 18 not to throw ng0100 error when closing the popup
      //the component could be refactored using kendoDropDownSharedEvents directive
      //once we are able to debug against Angular 18
      this.cdr.markForCheck();
      if (hasObservers(this.onBlur) || isUntouched(this.wrapper.nativeElement) || this.formControl?.updateOn === 'blur') {
        this._zone.run(() => {
          this.onBlur.emit();
          this.onTouchedCallback();
        });
      }
    }
  }
  /**
   * @hidden
   */
  handleNodeClick(node) {
    if (!this.isFocused) {
      // Re-focus the MultiSelectTree when popup close is prevented and a node is clicked
      // On click the focus should be on the clicked element which is why we need to update the lastNodeOnFocus
      const parent = node.originalEvent.target.parentElement.parentElement;
      this.lastNodeOnFocus = parent;
      this.focus();
    }
  }
  /**
   * @hidden
   */
  togglePopup(open) {
    const isDisabled = this.disabled || this.readonly;
    const sameState = this.isOpen === open;
    this._zone.run(() => {
      this.focusedTagIndex = undefined;
    });
    if (isDisabled || sameState) {
      return;
    }
    const togglePrevented = this.triggerPopupEvents(open);
    if (!togglePrevented) {
      if (open) {
        this.createPopup();
      } else {
        this.destroyPopup();
      }
    } else {
      this.removeTreeViewFromTabOrder();
    }
  }
  /**
   * @hidden
   */
  messageFor(key) {
    return this.localization.get(key);
  }
  lastAction = 'check';
  /**
   * @hidden
   */
  handleCheckedItemsChange(items) {
    this.valueDepth = items.map(item => item.level);
    this.lastAction = items.length > this.dataItems.length ? 'check' : 'uncheck';
    this.dataItems = items.slice();
    this.updateValue(this.dataItems);
  }
  /**
   * @hidden
   */
  handleRemoveTag({
    tag,
    index
  }) {
    if (this.disabled || this.readonly) {
      return;
    }
    const eventArgs = new RemoveTagEvent(tag);
    this.removeTag.emit(eventArgs);
    if (eventArgs.isDefaultPrevented()) {
      return;
    }
    // Remove tags based on their position index
    if (tag instanceof Array) {
      // Remove group tag
      this.dataItems = this.dataItems.filter((_item, i) => i < this.showAfter || this.disabledIndices.has(i));
      this.valueDepth = this.valueDepth.filter((_item, i) => i < this.showAfter || this.disabledIndices.has(i));
    } else if (this.loadOnDemand) {
      // Remove single tag when the child items are fetched on demand
      this.dataItems = this.dataItems.filter((_item, i) => i !== index || this.disabledIndices.has(i));
      this.valueDepth = this.valueDepth.filter((_item, i) => i !== index || this.disabledIndices.has(i));
    } else {
      // Remove single tag when the child items are pre-fetched
      const dataItem = this.dataItems.find(item => item.tagPositionIndex === index);
      const itemKey = dataItem.key;
      const lookup = this.lookup.itemLookup(itemKey);
      const pendingCheck = [lookup.item];
      if (this.checkableSettings.checkChildren) {
        fetchDescendentNodes(lookup).forEach(lookup => pendingCheck.push(lookup.item));
        pendingCheck.push(...this.removeParents(lookup.parent));
      }
      const keysToRemove = pendingCheck.map(item => item.key);
      // Holds the position indexes of the items to be removed
      const valueDepthIndices = [];
      this.dataItems = this.dataItems.filter((_item, i) => {
        const shouldStay = !keysToRemove.includes(_item.key) || this.disabledIndices.has(i);
        if (!shouldStay) {
          // We need to know the index position of the data item to be able to update the valueDepth array accordignly
          // as each data item's position is corresponding to the same position in valueDepth
          valueDepthIndices.push(i);
        }
        return shouldStay;
      });
      this.valueDepth = this.valueDepth.filter((_item, i) => {
        return !valueDepthIndices.includes(i) || this.disabledIndices.has(i);
      });
    }
    this.updateValue(this.dataItems);
    if (!this.isFocused) {
      this.focus();
    }
  }
  /**
   * @hidden
   */
  handleTagMapperChange(showAfter) {
    this.showAfter = parseNumber(showAfter);
    this.setTags();
  }
  /**
   * @hidden
   */
  clearAll(event) {
    event?.stopImmediatePropagation();
    event?.preventDefault();
    this.focus();
    this.value = this.value.filter((_item, index) => this.disabledIndices.has(index));
    this.dataItems = this.dataItems.filter((_item, index) => this.disabledIndices.has(index));
    this.valueDepth = this.valueDepth.filter((_depth, index) => this.disabledIndices.has(index));
    this.emitValueChange(this.value);
  }
  /**
   * @hidden
   */
  writeValue(value) {
    if (!this.valuePrimitive && isPresent(value)) {
      this.dataItems = value;
    }
    if (!isPresent(value) && isPresent(this.value)) {
      this.dataItems = null;
    }
    this.value = value || [];
  }
  /**
   * @hidden
   */
  registerOnChange(fn) {
    this.onChangeCallback = fn;
  }
  /**
   * @hidden
   */
  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }
  /**
   * @hidden
   */
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
    this.cdr.markForCheck();
  }
  /**
   * @hidden
   */
  handleFilterInputChange(input) {
    this.filter = input.value;
    this.filterChange.next(input.value);
  }
  /**
   * @hidden
   */
  get filterInputClasses() {
    return `${this.size ? getSizeClass('input', this.size) : ''} ${this.fillMode ? 'k-input-' + this.fillMode : ''} ${this.rounded ? getRoundedClass(this.rounded) : ''}`;
  }
  /**
   * @hidden
   */
  get checkAllCheckboxClasses() {
    return `${this.size ? getSizeClass('checkbox', this.size) : ''}`;
  }
  /**
   * @hidden
   */
  toggleCheckAll() {
    this.checkAllInput.nativeElement.focus();
    this.checkAllInput.nativeElement.click();
  }
  onTouchedCallback = noop;
  onChangeCallback = noop;
  verifySettings() {
    if (!isDevMode()) {
      return;
    }
    if (!isPresent(this.valueField) || !isPresent(this.textField)) {
      throw new Error(MultiSelectTreeMessages.textAndValue);
    }
    if (!isArray(this.value)) {
      throw new Error(MultiSelectTreeMessages.array);
    }
    if (this.value.length > 0) {
      if (this.valuePrimitive && this.value.some(item => isObject(item))) {
        throw new Error(MultiSelectTreeMessages.primitive);
      }
      const isEveryDataItemObject = this.dataItems.every(item => isObject(item.dataItem));
      if (this.valuePrimitive && !isArray(this.dataItems)) {
        throw new Error(MultiSelectTreeMessages.dataItems);
      }
      if (this.valuePrimitive && !isEveryDataItemObject) {
        throw new Error(MultiSelectTreeMessages.dataItems);
      }
      if (this.valuePrimitive && this.dataItems.length !== this.value.length) {
        throw new Error(MultiSelectTreeMessages.dataItemsLength);
      }
      if (!this.valuePrimitive && !isObjectArray(this.value)) {
        throw new Error(MultiSelectTreeMessages.object);
      }
      if ((isArray(this.valueField) || isArray(this.textField)) && !isArray(this.valueDepth)) {
        throw new Error(MultiSelectTreeMessages.valueDepth);
      }
      if ((isArray(this.valueField) || isArray(this.textField)) && this.valueDepth.length === 0) {
        throw new Error(MultiSelectTreeMessages.valueDepth);
      }
      if ((isArray(this.valueField) || isArray(this.textField)) && this.valueDepth.length !== this.value.length) {
        throw new Error(MultiSelectTreeMessages.valueDepthLength);
      }
    }
  }
  areNodesHidden(nodes) {
    return nodes.every((node, index) => !this.isVisible(node, String(index)));
  }
  emitValueChange(value) {
    this.onChangeCallback(value);
    this.valueChange.emit(value);
  }
  triggerPopupEvents(open) {
    const eventArgs = new PreventableEvent();
    if (hasObservers(this.open) || hasObservers(this.close)) {
      this._zone.run(() => {
        if (open) {
          this.open.emit(eventArgs);
        } else {
          this.close.emit(eventArgs);
        }
      });
    }
    return eventArgs.isDefaultPrevented();
  }
  createPopup() {
    this.windowSize = this.adaptiveService.size;
    if (this.isAdaptive) {
      this.openActionSheet();
      this.cdr.detectChanges();
      return;
    }
    const horizontalAlign = this.direction === "rtl" ? "right" : "left";
    const anchorPosition = {
      horizontal: horizontalAlign,
      vertical: 'bottom'
    };
    const popupPosition = {
      horizontal: horizontalAlign,
      vertical: 'top'
    };
    const appendToComponent = typeof this.popupSettings.appendTo === 'string' && this.popupSettings.appendTo === 'component';
    this.popupRef = this.popupService.open({
      anchor: this.wrapper,
      appendTo: this.appendTo,
      anchorAlign: anchorPosition,
      animate: this.popupSettings.animate,
      content: this.popupTemplate,
      popupAlign: popupPosition,
      positionMode: appendToComponent ? 'fixed' : 'absolute',
      popupClass: this.popupContainerClasses
    });
    const popupWrapper = this.popupRef.popupElement;
    const {
      min,
      max
    } = this.width;
    if (!this.appendTo) {
      this.renderer.setAttribute(popupWrapper, 'role', 'region');
      this.renderer.setAttribute(popupWrapper, 'aria-label', this.messageFor('popupLabel'));
    }
    popupWrapper.style.minWidth = min;
    popupWrapper.style.width = max;
    popupWrapper.style.height = this.height;
    this.renderer.setAttribute(this.wrapper.nativeElement, 'aria-controls', this.treeViewId);
    this.renderer.setAttribute(popupWrapper, 'dir', this.direction);
    this.renderer.setAttribute(this.wrapper.nativeElement, 'aria-expanded', 'true');
    this.popupRef.popupOpen.subscribe(() => {
      this.cdr.detectChanges();
      this.opened.emit();
      this._searchableNodes = getSearchableItems(this.treeViewId, this.popupRef.popupElement);
    });
    this.popupRef.popupClose.subscribe(() => {
      if (hasObservers(this.closed)) {
        this._zone.run(() => {
          this.closed.emit();
        });
      }
    });
  }
  destroyPopup() {
    if (this.isActionSheetExpanded) {
      this.closeActionSheet();
    }
    if (this.popupRef) {
      this.popupRef.close();
      this.popupRef = null;
      this.renderer.setAttribute(this.wrapper.nativeElement, 'aria-expanded', 'false');
      this.renderer.removeAttribute(this.wrapper.nativeElement, 'aria-controls');
      this.clearFilter();
    }
  }
  clearFilter() {
    if (this.filter !== "") {
      this.filter = "";
      this.allNodesHidden = false;
      if (hasObservers(this.filterChange)) {
        this._zone.run(() => {
          this.filterChange.emit("");
        });
      }
    }
  }
  handleClick(e) {
    // The check is needed otherwise when appended to the component, the popup reopens on click
    // https://github.com/telerik/kendo-angular/issues/3738
    if (this.popupRef && this.popupRef.popupElement.contains(e.target) || this.isActionSheetExpanded) {
      return;
    }
    this.togglePopup(!this.isOpen);
  }
  subscribeEvents() {
    [this.navigationService.open.subscribe(event => {
      event.originalEvent.preventDefault();
      this.togglePopup(true);
    }), this.navigationService.enter.pipe(tap(event => event.originalEvent.preventDefault())).subscribe(() => this.togglePopup(true)), merge(this.navigationService.close).subscribe(event => {
      event.originalEvent.preventDefault();
      this.focus();
      this.togglePopup(false);
    }), this.navigationService.tab.subscribe(this.handleTabKey.bind(this)), this.navigationService.up.subscribe(this.handleUpKey.bind(this)), this.navigationService.down.subscribe(this.handleDownKey.bind(this)), this.navigationService.esc.subscribe(() => {
      if (this.isOpen) {
        this.togglePopup(false);
        this.focus();
      } else if (this.isFocused && this.checkedItems.length > 0) {
        this.clearAll();
      }
    }), this.navigationService.left.pipe(filter(() => !this.isTreeViewActive)).subscribe(this.direction === 'rtl' ? this.handleRightKey.bind(this) : this.handleLeftKey.bind(this)), this.navigationService.right.pipe(filter(() => !this.isTreeViewActive)).subscribe(this.direction === 'rtl' ? this.handleLeftKey.bind(this) : this.handleRightKey.bind(this)), this.navigationService.home.pipe(filter(() => !this.isOpen)).subscribe(this.handleHome.bind(this)), this.navigationService.end.pipe(filter(() => !this.isOpen)).subscribe(this.handleEnd.bind(this)), this.navigationService.backspace.pipe(filter(() => this.isTagFocused)).subscribe(this.handleBackspace.bind(this)), this.navigationService.delete.pipe(filter(() => this.isTagFocused)).subscribe(this.handleDelete.bind(this))].forEach(sub => this.subs.add(sub));
  }
  subscribeFocusEvents() {
    if (isDocumentAvailable()) {
      this.handleFocus = this.handleFocus.bind(this);
      this.handleDocumentBlur = this.handleDocumentBlur.bind(this);
      this._zone.runOutsideAngular(() => {
        const useCapture = true;
        document.addEventListener('focus', this.handleFocus, useCapture);
        document.addEventListener('blur', this.handleDocumentBlur, useCapture);
      });
    }
  }
  unSubscribeFocusEvents() {
    if (isDocumentAvailable()) {
      const useCapture = true;
      document.removeEventListener('focus', this.handleFocus, useCapture);
      document.removeEventListener('blur', this.handleDocumentBlur, useCapture);
    }
  }
  handleDocumentBlur(event) {
    if (event.target !== this.wrapper.nativeElement) {
      return;
    }
    event.stopImmediatePropagation();
    this.handleBlur(event);
  }
  handleTabKey() {
    if (!this.isActionSheetExpanded) {
      this.focus();
    }
    if (this.isOpen) {
      this.treeview.blur();
      this.removeTreeViewFromTabOrder();
    }
  }
  handleUpKey(event) {
    if (!this.treeview) {
      return;
    }
    event.originalEvent.preventDefault();
    // Prevent toggling the focus between the filterInput and the wrapper elements with `up` key
    if (this.isWrapperActive) {
      return;
    }
    const isFirstNodeActive = this.treeview['navigationService']['activeIndex'] === '0';
    // Current focus is on the filter input => should focus the wrapper
    if (this.filterable && this.isFilterActive) {
      this.focus();
      // Current focus is on the treeview first node => should focus the check all checkbox if enabled
    } else if (this.checkAll && !this.isCheckAllActive && isFirstNodeActive) {
      this.checkAllInput.nativeElement.focus();
      // Current focus is either on the check all checkbox or the treeview's first node
      // => should focus either the filter input (if enabled) or the wrapper
    } else if (this.isCheckAllActive || isFirstNodeActive) {
      if (this.filterable) {
        this.isActionSheetExpanded ? this.actionSheetSearchBar.focus() : this.filterInput.nativeElement.focus();
      } else if (!this.isActionSheetExpanded) {
        this.focus();
      }
    }
  }
  handleDownKey(event) {
    if (!this.treeview) {
      return;
    }
    event.originalEvent.preventDefault();
    // Current focus is on the wrapper => should focus the filter input
    if (this.filterable && this.isWrapperActive) {
      this.filterInput.nativeElement.focus();
      // Current focus is on the wrapper/filter input => should focus check all checkbox if enabled
    } else if (this.checkAll && (this.isWrapperActive || this.isFilterActive)) {
      this.checkAllInput.nativeElement.focus();
      // Should focus the treeview if filterable and check all are disabled
    } else if (!this.treeview.isActive) {
      this.treeview.focus();
    }
    this.focusedTagIndex = undefined;
  }
  handleRightKey(event) {
    event.originalEvent.preventDefault();
    const last = this.tags.length - 1;
    if (this.focusedTagIndex === last) {
      this.focusedTagIndex = undefined;
    } else if (this.focusedTagIndex < last) {
      this.focusedTagIndex++;
    } else if (!this.focusedTagIndex) {
      this.focusedTagIndex = 0;
    }
  }
  handleLeftKey(event) {
    event.originalEvent.preventDefault();
    if (this.focusedTagIndex === undefined || this.focusedTagIndex < 0) {
      this.focusedTagIndex = this.tags.length - 1;
    } else if (this.focusedTagIndex !== 0) {
      this.focusedTagIndex--;
    }
  }
  handleEnd(event) {
    event.originalEvent.preventDefault();
    this.focusedTagIndex = this.tags.length - 1;
  }
  handleHome(event) {
    event.originalEvent.preventDefault();
    this.focusedTagIndex = 0;
  }
  handleBackspace() {
    if (this.focusedTagIndex !== undefined) {
      this.handleDelete();
    } else {
      const tag = this.tags[this.tags.length - 1];
      const index = this.tags.length - 1;
      this.handleRemoveTag({
        tag,
        index
      });
    }
  }
  handleDelete() {
    const tag = this.tags[this.focusedTagIndex];
    const index = this.focusedTagIndex;
    this.handleRemoveTag({
      tag,
      index
    });
    if (this.focusedTagIndex === this.tags.length) {
      this.focusedTagIndex = undefined;
    }
  }
  unsubscribeEvents() {
    this.subs.unsubscribe();
    this.unSubscribeFocusEvents();
  }
  /**
   * Remove the `TreeView` from the tab order, otherwise a focus loop between the page elements will occur
   * and the user will not be able to tab to the rest of the browser elements
   */
  removeTreeViewFromTabOrder() {
    const nodes = this.treeview.element.nativeElement.querySelectorAll('li');
    nodes.forEach(item => {
      if (item.getAttribute('tabindex') === '0') {
        this.lastNodeOnFocus = item;
        this.lastNodeOnFocus.setAttribute('tabindex', '-1');
      }
    });
  }
  setState() {
    if (isPresent(this.dataItems) && isPresent(this.valueField)) {
      this.setTags();
      this.checkedItems = this.dataItems.slice();
    }
    this.cdr.markForCheck();
  }
  setTags() {
    const source = this.dataItems.map(item => item.dataItem);
    this.tags = this.tagMapper(source);
    this.disabledIndices = this.disabledItemsMapper();
    // Create a mapping of tags to position indices
    const tagIndexMap = new Map(this.tags.map((tag, index) => [JSON.stringify(tag), index]));
    // Modify dataItems by adding a property to hold the item's position as displayed in the tags
    this.dataItems.forEach(item => {
      const serializedDataItem = JSON.stringify(item.dataItem);
      item.tagPositionIndex = tagIndexMap.has(serializedDataItem) ? tagIndexMap.get(serializedDataItem) // Use the index from tags if it exists
      : null; // Assign a null value if the dataItem is not visible in the tags
    });
  }
  updateValue(value) {
    const newValue = this.valuePrimitive ? value.map(item => valueFrom(item, this.valueField)) : value.map(item => item.dataItem);
    this.value = newValue;
    this.emitValueChange(this.value);
  }
  /**
   * @hidden
   */
  onChildrenLoaded() {
    setTimeout(() => {
      if (this.popupRef) {
        this._searchableNodes = getSearchableItems(this.treeViewId, this.popupRef.popupElement);
      }
      if (this.isActionSheetExpanded) {
        this._searchableNodes = getSearchableItems(this.treeViewId, this.actionSheet.element.nativeElement);
      }
    });
  }
  /**
   * @hidden
   *
   * Determines which of the provided tags should be disabled and stores their position indices
   */
  disabledItemsMapper() {
    return new Set(this.dataItems.reduce((indices, item, index) => {
      if (this.itemDisabled(item.dataItem, item.index)) {
        indices.push(index);
      }
      return indices;
    }, []));
  }
  setComponentClasses() {
    if (this.size) {
      this.renderer.addClass(this.wrapper.nativeElement, getSizeClass('input', this.size));
    }
    if (this.rounded) {
      this.renderer.addClass(this.wrapper.nativeElement, getRoundedClass(this.rounded));
    }
    if (this.fillMode) {
      this.renderer.addClass(this.wrapper.nativeElement, getFillModeClass('input', this.fillMode));
    }
  }
  removeParents(parent) {
    let currentParent = parent;
    const nodes = [];
    while (currentParent) {
      nodes.push(currentParent.item);
      currentParent = currentParent.parent;
    }
    return nodes;
  }
  /**
   * Creates an internal map of the available tree items to be used as a reference
   * to retrieve the item's children/parent and determine the checked sate
   */
  registerLookupItems(data, parentItem = null, levelIndex = 0) {
    if (!isPresent(data) || data.length === 0) {
      return;
    }
    const parentIndex = nodeIndex(parentItem);
    const treeItems = data.map(node => buildTreeItem(node, this.valueField, levelIndex));
    if (isPresent(parentItem)) {
      this.lookup.registerChildren(parentIndex, treeItems);
    }
    treeItems.forEach(item => {
      this.lookup.registerItem(item, parentItem);
      if (!this.loadOnDemand) {
        this.registerChildLookupItems(item, levelIndex);
      }
    });
  }
  registerChildLookupItems(item, levelIndex) {
    if (this.hasChildren(item.dataItem)) {
      this.children(item.dataItem).subscribe(children => {
        const index = this.isHeterogeneous ? levelIndex + 1 : 0;
        this.registerLookupItems(children, item, index);
      });
    }
  }
  closeActionSheet() {
    this.wrapper.nativeElement.focus();
    this.actionSheet.toggle(false);
    this.renderer.removeAttribute(this.wrapper.nativeElement, 'aria-controls');
    this.renderer.setAttribute(this.wrapper.nativeElement, 'aria-expanded', 'false');
    this.clearFilter();
    this.closed.emit();
  }
  openActionSheet() {
    this.actionSheet.toggle(true);
    this.adaptiveTitle = setActionSheetTitle(this.wrapper, this.adaptiveTitle);
    this.cdr.detectChanges();
    this.renderer.setAttribute(this.wrapper.nativeElement, 'aria-controls', this.treeViewId);
    this.renderer.setAttribute(this.wrapper.nativeElement, 'aria-expanded', 'true');
    this.cdr.detectChanges();
    this.opened.emit();
  }
  static ɵfac = function MultiSelectTreeComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MultiSelectTreeComponent)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.PopupService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(NavigationService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i1.LocalizationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(MultiSelectTreeLookupService), i0.ɵɵdirectiveInject(i7.AdaptiveService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MultiSelectTreeComponent,
    selectors: [["kendo-multiselecttree"]],
    contentQueries: function MultiSelectTreeComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, HeaderTemplateDirective, 5)(dirIndex, FooterTemplateDirective, 5)(dirIndex, NodeTemplateDirective, 5)(dirIndex, NoDataTemplateDirective, 5)(dirIndex, TagTemplateDirective, 5)(dirIndex, GroupTagTemplateDirective, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nodeTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.noDataTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tagTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.groupTagTemplate = _t.first);
      }
    },
    viewQuery: function MultiSelectTreeComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(AdaptiveRendererComponent, 5)(_c13, 7)(_c12, 7, ViewContainerRef)(_c26, 5)(_c27, 5)(_c29, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.adaptiveRendererComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popupTemplate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.treeview = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterInput = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.checkAllInput = _t.first);
      }
    },
    hostVars: 22,
    hostBindings: function MultiSelectTreeComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("aria-disabled", ctx.isDisabled)("aria-autocomplete", ctx.hostAriaAutocomplete)("aria-invalid", ctx.hostAriaInvalid)("aria-busy", ctx.isBusy)("id", ctx.id)("dir", ctx.direction)("tabindex", ctx.hostTabIndex)("role", ctx.role)("aria-haspopup", ctx.ariaHasPopup)("readonly", ctx.isReadonly)("aria-describedby", ctx.ariaDescribedBy)("aria-activedescendant", ctx.ariaActiveDescendant);
        i0.ɵɵclassProp("k-multiselecttree", ctx.hostClasses)("k-input", ctx.hostClasses)("k-disabled", ctx.isDisabled)("k-loading", ctx.isLoading)("k-readonly", ctx.readonly);
      }
    },
    inputs: {
      adaptiveMode: "adaptiveMode",
      adaptiveTitle: "adaptiveTitle",
      adaptiveSubtitle: "adaptiveSubtitle",
      tabindex: "tabindex",
      size: "size",
      rounded: "rounded",
      fillMode: "fillMode",
      popupSettings: "popupSettings",
      checkableSettings: "checkableSettings",
      data: "data",
      value: "value",
      dataItems: "dataItems",
      textField: "textField",
      valueField: "valueField",
      valueDepth: "valueDepth",
      loading: "loading",
      placeholder: "placeholder",
      listHeight: "listHeight",
      disabled: "disabled",
      readonly: "readonly",
      valuePrimitive: "valuePrimitive",
      loadOnDemand: "loadOnDemand",
      focusableId: "focusableId",
      clearButton: "clearButton",
      filterable: "filterable",
      checkAll: "checkAll",
      hasChildren: "hasChildren",
      fetchChildren: "fetchChildren",
      isNodeExpanded: "isNodeExpanded",
      isNodeVisible: "isNodeVisible",
      itemDisabled: "itemDisabled",
      tagMapper: "tagMapper"
    },
    outputs: {
      onFocus: "focus",
      onBlur: "blur",
      open: "open",
      opened: "opened",
      close: "close",
      closed: "closed",
      nodeExpand: "nodeExpand",
      nodeCollapse: "nodeCollapse",
      valueChange: "valueChange",
      removeTag: "removeTag",
      filterChange: "filterChange"
    },
    exportAs: ["kendoMultiSelectTree"],
    features: [i0.ɵɵProvidersFeature([LocalizationService, NavigationService, DataService, DisabledItemsService, SelectionService, MultiSelectTreeLookupService, {
      provide: L10N_PREFIX,
      useValue: 'kendo.multiselecttree'
    }, {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectTreeComponent)
    }, {
      provide: DataBoundComponent,
      useExisting: forwardRef(() => MultiSelectTreeComponent)
    }, {
      provide: ExpandableComponent,
      useExisting: forwardRef(() => MultiSelectTreeComponent)
    }, {
      provide: KendoInput,
      useExisting: forwardRef(() => MultiSelectTreeComponent)
    }]), i0.ɵɵNgOnChangesFeature],
    decls: 14,
    vars: 25,
    consts: () => {
      let i18n_31;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text displayed in the popup when there are no items
         * @meaning kendo.multiselecttree.noDataText
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_31 = goog.getMsg("NO DATA FOUND");
        i18n_31 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_31;
      } else {
        i18n_31 = $localize`:kendo.multiselecttree.noDataText|The text displayed in the popup when there are no items:NO DATA FOUND`;
      }
      let i18n_32;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the clear button
         * @meaning kendo.multiselecttree.clearTitle
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_32 = goog.getMsg("clear");
        i18n_32 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_32;
      } else {
        i18n_32 = $localize`:kendo.multiselecttree.clearTitle|The title of the clear button:clear`;
      }
      let i18n_33;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text displayed for the check-all checkbox
         * @meaning kendo.multiselecttree.checkAllText
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_33 = goog.getMsg("Check all");
        i18n_33 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_33;
      } else {
        i18n_33 = $localize`:kendo.multiselecttree.checkAllText|The text displayed for the check-all checkbox:Check all`;
      }
      let i18n_34;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text set as aria-label on the filter input
         * @meaning kendo.multiselecttree.filterInputLabel
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_34 = goog.getMsg("Filter");
        i18n_34 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_34;
      } else {
        i18n_34 = $localize`:kendo.multiselecttree.filterInputLabel|The text set as aria-label on the filter input:Filter`;
      }
      let i18n_35;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The label of the popup element that contains the list of options when its role is 'region'
         * @meaning kendo.multiselecttree.popupLabel
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_35 = goog.getMsg("Options list");
        i18n_35 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_35;
      } else {
        i18n_35 = $localize`:kendo.multiselecttree.popupLabel|The label of the popup element that contains the list of options when its role is 'region':Options list`;
      }
      let i18n_36;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode
         * @meaning kendo.multiselecttree.adaptiveCloseButtonTitle
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_36 = goog.getMsg("Close");
        i18n_36 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_36;
      } else {
        i18n_36 = $localize`:kendo.multiselecttree.adaptiveCloseButtonTitle|The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode:Close`;
      }
      let i18n_37;
      if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc The text for the input's placeholder when filtering is enabled
         * @meaning kendo.multiselecttree.filterInputPlaceholder
         */
        const MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_37 = goog.getMsg("Filter");
        i18n_37 = MSG_D__PROJECTS_FOREVER_MEMORIES_PROJ_FOREVER_MEMORIES_FOREVER_WEB_NODE_MODULES__PROGRESS_KENDO_ANGULAR_DROPDOWNS_FESM2022_PROGRESS_KENDO_ANGULAR_DROPDOWNS_MJS_37;
      } else {
        i18n_37 = $localize`:kendo.multiselecttree.filterInputPlaceholder|The text for the input's placeholder when filtering is enabled:Filter`;
      }
      return [["popupTemplate", ""], ["container", ""], ["sharedPopupActionSheetTemplate", ""], ["treeview", ""], ["filterInput", ""], ["checkAllInput", ""], ["kendoMultiSelectTreeLocalizedMessages", "", "noDataText", i18n_31, "clearTitle", i18n_32, "checkAllText", i18n_33, "filterInputLabel", i18n_34, "popupLabel", i18n_35, "adaptiveCloseButtonTitle", i18n_36, "filterInputPlaceholder", i18n_37], [1, "k-input-values", 3, "removeTag", "size", "rounded", "fillMode", "id", "tags", "focused", "textField", "valueField", "valueDepth", "disabled", "tagPrefix", "template", "groupTemplate", "disabledIndices"], [1, "k-input-inner"], [1, "k-input-value-text"], ["role", "button", "tabindex", "-1", 1, "k-clear-value"], [1, "k-icon", "k-i-loading", "k-input-loading-icon"], [3, "closePopup", "textInputChange", "sharedPopupActionSheetTemplate", "title", "showTextInput", "subtitle", "searchBarValue", "placeholder", "filterable"], ["role", "button", "tabindex", "-1", 1, "k-clear-value", 3, "click"], ["name", "x", 1, "k-icon", 3, "svgIcon"], [4, "ngTemplateOutlet"], [1, "k-list-filter"], [3, "templateContext"], [1, "k-check-all"], ["kendoMultiSelectTreeCheckable", "", 3, "keydown", "nodeClick", "expand", "collapse", "checkedItemsChange", "childrenLoaded", "size", "nodes", "animate", "isHeterogeneous", "checkable", "checkedItems", "valueField", "textField", "children", "hasChildren", "isExpanded", "isDisabled", "nodeTemplate", "loadOnDemand", "filter", "isVisible", "kendoEventsOutsideAngular", "scope"], [1, "k-no-data"], [1, "k-textbox", "k-input", 3, "ngClass"], [1, "k-input-prefix"], ["name", "search", 1, "k-icon", 3, "svgIcon"], ["role", "searchbox", "tabindex", "0", "aria-disabled", "false", "aria-readonly", "false", 1, "k-input-inner", 3, "input", "keydown", "filterInput", "value", "kendoEventsOutsideAngular", "scope"], [1, "k-checkbox-wrap"], ["type", "checkbox", "role", "checkbox", "tabindex", "0", "aria-disabled", "false", "aria-readonly", "false", 1, "k-checkbox", 3, "checkedItemsChange", "keydown", "checkAll", "ngClass", "treeview", "checkedItems", "valueField", "lastAction", "kendoEventsOutsideAngular", "scope"], [1, "k-checkbox-label", 3, "click", "mousedown"], [3, "resize"]];
    },
    template: function MultiSelectTreeComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementContainer(0, 6);
        i0.ɵɵelementStart(1, "kendo-taglist", 7);
        i0.ɵɵlistener("removeTag", function MultiSelectTreeComponent_Template_kendo_taglist_removeTag_1_listener($event) {
          return ctx.handleRemoveTag($event);
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "span", 8);
        i0.ɵɵconditionalCreate(3, MultiSelectTreeComponent_Conditional_3_Template, 2, 1, "span", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(4, MultiSelectTreeComponent_Conditional_4_Template, 2, 2, "span", 10);
        i0.ɵɵconditionalCreate(5, MultiSelectTreeComponent_Conditional_5_Template, 1, 0, "span", 11);
        i0.ɵɵtemplate(6, MultiSelectTreeComponent_ng_template_6_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementContainer(8, null, 1);
        i0.ɵɵelementStart(10, "kendo-adaptive-renderer", 12);
        i0.ɵɵlistener("closePopup", function MultiSelectTreeComponent_Template_kendo_adaptive_renderer_closePopup_10_listener() {
          return ctx.togglePopup(false);
        })("textInputChange", function MultiSelectTreeComponent_Template_kendo_adaptive_renderer_textInputChange_10_listener($event) {
          return ctx.onFilterChange($event);
        });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, MultiSelectTreeComponent_ng_template_11_Template, 7, 28, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵconditionalCreate(13, MultiSelectTreeComponent_Conditional_13_Template, 1, 0, "kendo-resize-sensor");
      }
      if (rf & 2) {
        const sharedPopupActionSheetTemplate_r3 = i0.ɵɵreference(12);
        i0.ɵɵadvance();
        i0.ɵɵproperty("size", ctx.size)("rounded", ctx.rounded)("fillMode", ctx.fillMode)("id", ctx.tagListId)("tags", ctx.tags)("focused", ctx.focusedTagIndex)("textField", ctx.textField)("valueField", ctx.valueField)("valueDepth", ctx.valueDepth)("disabled", ctx.disabled)("tagPrefix", ctx.tagPrefix)("template", ctx.tagTemplate)("groupTemplate", ctx.groupTagTemplate)("disabledIndices", ctx.disabledIndices);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(!ctx.tags || !ctx.tags.length ? 3 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(!ctx.disabled && !ctx.loading && !ctx.readonly && ctx.clearButton && (ctx.tags == null ? null : ctx.tags.length) ? 4 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.loading ? 5 : -1);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("sharedPopupActionSheetTemplate", sharedPopupActionSheetTemplate_r3)("title", ctx.adaptiveTitle)("showTextInput", ctx.filterable)("subtitle", ctx.adaptiveSubtitle)("searchBarValue", ctx.filter)("placeholder", ctx.placeholder)("filterable", ctx.filterable);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.isOpen || ctx.isAdaptiveModeEnabled ? 13 : -1);
      }
    },
    dependencies: [LocalizedMessagesDirective, TagListComponent, IconWrapperComponent, NgTemplateOutlet, AdaptiveRendererComponent, NgClass, FilterInputDirective, EventsOutsideAngularDirective, TemplateContextDirective, CheckAllDirective, TreeViewComponent, CheckDirective, ResizeSensorComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiSelectTreeComponent, [{
    type: Component,
    args: [{
      exportAs: 'kendoMultiSelectTree',
      providers: [LocalizationService, NavigationService, DataService, DisabledItemsService, SelectionService, MultiSelectTreeLookupService, {
        provide: L10N_PREFIX,
        useValue: 'kendo.multiselecttree'
      }, {
        multi: true,
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => MultiSelectTreeComponent)
      }, {
        provide: DataBoundComponent,
        useExisting: forwardRef(() => MultiSelectTreeComponent)
      }, {
        provide: ExpandableComponent,
        useExisting: forwardRef(() => MultiSelectTreeComponent)
      }, {
        provide: KendoInput,
        useExisting: forwardRef(() => MultiSelectTreeComponent)
      }],
      selector: 'kendo-multiselecttree',
      template: `
        <ng-container kendoMultiSelectTreeLocalizedMessages
          i18n-noDataText="kendo.multiselecttree.noDataText|The text displayed in the popup when there are no items"
          noDataText="NO DATA FOUND"

          i18n-clearTitle="kendo.multiselecttree.clearTitle|The title of the clear button"
          clearTitle="clear"

          i18n-checkAllText="kendo.multiselecttree.checkAllText|The text displayed for the check-all checkbox"
          checkAllText="Check all"

          i18n-filterInputLabel="kendo.multiselecttree.filterInputLabel|The text set as aria-label on the filter input"
          filterInputLabel="Filter"

          i18n-popupLabel="kendo.multiselecttree.popupLabel|The label of the popup element that contains the list of options when its role is 'region'"
          popupLabel="Options list"

          i18n-adaptiveCloseButtonTitle="kendo.multiselecttree.adaptiveCloseButtonTitle|The title of the Close button of the ActionSheet that is rendered instead of the Popup when using small screen devices in adaptive mode"
          adaptiveCloseButtonTitle="Close"

          i18n-filterInputPlaceholder="kendo.multiselecttree.filterInputPlaceholder|The text for the input's placeholder when filtering is enabled"
          filterInputPlaceholder="Filter"
          >
        </ng-container>
        <kendo-taglist
          class="k-input-values"
          [size]="size"
          [rounded]="rounded"
          [fillMode]="fillMode"
          [id]="tagListId"
          [tags]="tags"
          [focused]="focusedTagIndex"
          [textField]="textField"
          [valueField]="valueField"
          [valueDepth]="valueDepth"
          [disabled]="disabled"
          [tagPrefix]="tagPrefix"
          [template]="tagTemplate"
          [groupTemplate]="groupTagTemplate"
          [disabledIndices]="disabledIndices"
          (removeTag)="handleRemoveTag($event)"
          >
        </kendo-taglist>
        <span class="k-input-inner">
          @if (!tags || !tags.length) {
            <span
              class="k-input-value-text"
              >
              {{ placeholder }}
            </span>
          }
        </span>
        @if (!disabled && !loading && !readonly && clearButton && tags?.length) {
          <span
            class="k-clear-value"
            [attr.title]="messageFor('clearTitle')"
            role="button"
            tabindex="-1"
            (click)="clearAll($event)"
            >
            <kendo-icon-wrapper
              class="k-icon"
              name="x"
              [svgIcon]="xIcon"
              >
            </kendo-icon-wrapper>
          </span>
        }
        @if (loading) {
          <span
            class="k-icon k-i-loading k-input-loading-icon"
            >
          </span>
        }
        <ng-template #popupTemplate>
          <ng-container *ngTemplateOutlet="sharedPopupActionSheetTemplate"></ng-container>
        </ng-template>
        <ng-container #container></ng-container>

        <kendo-adaptive-renderer
          [sharedPopupActionSheetTemplate]="sharedPopupActionSheetTemplate"
          [title]="adaptiveTitle"
          [showTextInput]="filterable"
          [subtitle]="adaptiveSubtitle"
          (closePopup)="togglePopup(false)"
          (textInputChange)="onFilterChange($event)"
          [searchBarValue]="filter"
          [placeholder]="placeholder"
          [filterable]="filterable">
        </kendo-adaptive-renderer>

        <ng-template #sharedPopupActionSheetTemplate>
          @if (filterable && !isActionSheetExpanded) {
            <div
              class="k-list-filter"
              >
              <span
                class="k-textbox k-input"
                [ngClass]="filterInputClasses"
                >
                <span class="k-input-prefix">
                  <kendo-icon-wrapper
                    class="k-icon"
                    name="search"
                    [svgIcon]="searchIcon"
                    >
                  </kendo-icon-wrapper>
                </span>
                <input
                  #filterInput
                  (input)="handleFilterInputChange($event.target)"
                  [filterInput]="filterable && !touchEnabled"
                  [attr.aria-label]="messageFor('filterInputLabel')"
                  (keydown)="handleKeydown($event, filterInput)"
                  [value]="filter"
                  class="k-input-inner"
                  role="searchbox"
                  tabindex="0"
                  aria-disabled="false"
                  aria-readonly="false"
                        [kendoEventsOutsideAngular]="{
                            blur: handleBlur
                        }"
                  [scope]="this"
                  >
              </span>
            </div>
          }
          <!--header template-->
          @if (headerTemplate) {
            <ng-template
                [templateContext]="{
                    templateRef: headerTemplate?.templateRef
                }">
            </ng-template>
          }
          @if (checkAll) {
            <div class="k-check-all">
              <span class="k-checkbox-wrap">
                <input
                  #checkAllInput
                  [checkAll]="!filterable && !touchEnabled"
                  type="checkbox"
                  class="k-checkbox"
                  [ngClass]="checkAllCheckboxClasses"
                  role="checkbox"
                  tabindex="0"
                  aria-disabled="false"
                  aria-readonly="false"
                  [treeview]="treeview"
                  [checkedItems]="checkedItems"
                  [valueField]="valueField"
                  [lastAction]="lastAction"
                  (checkedItemsChange)="handleCheckedItemsChange($event)"
                  (keydown)="handleKeydown($event)"
                        [kendoEventsOutsideAngular]="{
                            blur: handleBlur
                        }"
                  [scope]="this"
                  >
              </span>
              <span
                class="k-checkbox-label"
                (click)="toggleCheckAll()"
                (mousedown)="$event.preventDefault()"
                >
                {{ messageFor('checkAllText') }}
              </span>
            </div>
          }
          <kendo-treeview
            #treeview
            [size]="windowSize !== 'large' ? 'large' : size"
            [attr.id]="treeViewId"
            [nodes]="data"
            [style.maxHeight.px]="listHeight"
            [animate]="false"
            kendoMultiSelectTreeCheckable
            [isHeterogeneous]="isHeterogeneous"
            [checkable]="checkableSettings"
            [checkedItems]="checkedItems"
            [valueField]="valueField"
            [textField]="textField"
            [children]="children"
            [hasChildren]="hasChildren"
            [isExpanded]="isNodeExpanded"
            [isDisabled]="itemDisabled"
            [nodeTemplate]="nodeTemplate"
            [loadOnDemand]="loadOnDemand"
            [filter]="filter"
            [isVisible]="isNodeVisible"
            (keydown)="handleKeydown($event)"
            (nodeClick)="handleNodeClick($event)"
            (expand)="nodeExpand.emit($event)"
            (collapse)="nodeCollapse.emit($event)"
            (checkedItemsChange)="handleCheckedItemsChange($event)"
                [kendoEventsOutsideAngular]="{
                    focusout: handleBlur
                }"
            [scope]="this"
            (childrenLoaded)="onChildrenLoaded()"
            >
          </kendo-treeview>
          <!--footer template-->
          @if (footerTemplate) {
            <ng-template
                [templateContext]="{
                    templateRef: footerTemplate?.templateRef
                }">
            </ng-template>
          }
          <!--no-data template-->
          @if (!data || data?.length === 0 || allNodesHidden) {
            <div class="k-no-data" [attr.aria-live]="'polite'">
              @if (noDataTemplate) {
                <ng-template
                    [templateContext]="{
                        templateRef: noDataTemplate?.templateRef
                    }">
                </ng-template>
              }
              @if (!noDataTemplate) {
                <div>{{ messageFor('noDataText') }}</div>
              }
            </div>
          }
        </ng-template>

        @if (isOpen || isAdaptiveModeEnabled) {
          <kendo-resize-sensor (resize)="onResize()"></kendo-resize-sensor>
        }
        `,
      standalone: true,
      imports: [LocalizedMessagesDirective, TagListComponent, IconWrapperComponent, NgTemplateOutlet, AdaptiveRendererComponent, NgClass, FilterInputDirective, EventsOutsideAngularDirective, TemplateContextDirective, CheckAllDirective, TreeViewComponent, CheckDirective, ResizeSensorComponent]
    }]
  }], () => [{
    type: i0.Injector
  }, {
    type: i0.ElementRef
  }, {
    type: i2.PopupService
  }, {
    type: i0.Renderer2
  }, {
    type: NavigationService
  }, {
    type: i0.NgZone
  }, {
    type: i1.LocalizationService
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: MultiSelectTreeLookupService
  }, {
    type: i7.AdaptiveService
  }], {
    hostClasses: [{
      type: HostBinding,
      args: ['class.k-multiselecttree']
    }, {
      type: HostBinding,
      args: ['class.k-input']
    }],
    isDisabled: [{
      type: HostBinding,
      args: ['class.k-disabled']
    }, {
      type: HostBinding,
      args: ['attr.aria-disabled']
    }],
    hostAriaAutocomplete: [{
      type: HostBinding,
      args: ['attr.aria-autocomplete']
    }],
    isLoading: [{
      type: HostBinding,
      args: ['class.k-loading']
    }],
    hostAriaInvalid: [{
      type: HostBinding,
      args: ['attr.aria-invalid']
    }],
    isBusy: [{
      type: HostBinding,
      args: ['attr.aria-busy']
    }],
    id: [{
      type: HostBinding,
      args: ['attr.id']
    }],
    direction: [{
      type: HostBinding,
      args: ['attr.dir']
    }],
    hostTabIndex: [{
      type: HostBinding,
      args: ['attr.tabindex']
    }],
    role: [{
      type: HostBinding,
      args: ['attr.role']
    }],
    ariaHasPopup: [{
      type: HostBinding,
      args: ['attr.aria-haspopup']
    }],
    isReadonly: [{
      type: HostBinding,
      args: ['attr.readonly']
    }],
    ariaDescribedBy: [{
      type: HostBinding,
      args: ['attr.aria-describedby']
    }],
    ariaActiveDescendant: [{
      type: HostBinding,
      args: ['attr.aria-activedescendant']
    }],
    adaptiveMode: [{
      type: Input
    }],
    adaptiveTitle: [{
      type: Input
    }],
    adaptiveSubtitle: [{
      type: Input
    }],
    adaptiveRendererComponent: [{
      type: ViewChild,
      args: [AdaptiveRendererComponent]
    }],
    headerTemplate: [{
      type: ContentChild,
      args: [HeaderTemplateDirective, {
        static: false
      }]
    }],
    footerTemplate: [{
      type: ContentChild,
      args: [FooterTemplateDirective, {
        static: false
      }]
    }],
    nodeTemplate: [{
      type: ContentChild,
      args: [NodeTemplateDirective, {
        static: false
      }]
    }],
    noDataTemplate: [{
      type: ContentChild,
      args: [NoDataTemplateDirective, {
        static: false
      }]
    }],
    tagTemplate: [{
      type: ContentChild,
      args: [TagTemplateDirective, {
        static: false
      }]
    }],
    groupTagTemplate: [{
      type: ContentChild,
      args: [GroupTagTemplateDirective, {
        static: false
      }]
    }],
    popupTemplate: [{
      type: ViewChild,
      args: ['popupTemplate', {
        static: true
      }]
    }],
    container: [{
      type: ViewChild,
      args: ['container', {
        read: ViewContainerRef,
        static: true
      }]
    }],
    treeview: [{
      type: ViewChild,
      args: ['treeview', {
        static: false
      }]
    }],
    filterInput: [{
      type: ViewChild,
      args: ['filterInput', {
        static: false
      }]
    }],
    checkAllInput: [{
      type: ViewChild,
      args: ['checkAllInput', {
        static: false
      }]
    }],
    tabindex: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    rounded: [{
      type: Input
    }],
    fillMode: [{
      type: Input
    }],
    popupSettings: [{
      type: Input
    }],
    checkableSettings: [{
      type: Input
    }],
    data: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    dataItems: [{
      type: Input
    }],
    textField: [{
      type: Input
    }],
    valueField: [{
      type: Input
    }],
    valueDepth: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    listHeight: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    readonly: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['class.k-readonly']
    }],
    valuePrimitive: [{
      type: Input
    }],
    loadOnDemand: [{
      type: Input
    }],
    focusableId: [{
      type: Input
    }],
    clearButton: [{
      type: Input
    }],
    filterable: [{
      type: Input
    }],
    checkAll: [{
      type: Input
    }],
    hasChildren: [{
      type: Input
    }],
    fetchChildren: [{
      type: Input
    }],
    isNodeExpanded: [{
      type: Input
    }],
    isNodeVisible: [{
      type: Input
    }],
    itemDisabled: [{
      type: Input
    }],
    tagMapper: [{
      type: Input
    }],
    onFocus: [{
      type: Output,
      args: ['focus']
    }],
    onBlur: [{
      type: Output,
      args: ['blur']
    }],
    open: [{
      type: Output
    }],
    opened: [{
      type: Output
    }],
    close: [{
      type: Output
    }],
    closed: [{
      type: Output
    }],
    nodeExpand: [{
      type: Output
    }],
    nodeCollapse: [{
      type: Output
    }],
    valueChange: [{
      type: Output
    }],
    removeTag: [{
      type: Output
    }],
    filterChange: [{
      type: Output
    }]
  });
})();

/**
 * Retrieves child nodes when the provided data is flat.
 *
 * @example
 * ```html
 * <kendo-dropdowntree kendoDropDownTreeFlatBinding [nodes]="data" [valueField]="'id'"></kendo-dropdowntree>
 * ```
 *
 * @remarks
 * Applied to: {@link DropDownTreeComponent}.
 */
class DropDownTreeFlatBindingDirective extends FlatDataBindingDirective {
  dropDownTree;
  /**
   * Sets the nodes to display in the DropDownTree.
   */
  set nodes(nodes) {
    // Needs to be a setter so that it matches the accessor in FlatDataBindingDirective it extends
    this._nodes = nodes;
  }
  get nodes() {
    return this._nodes;
  }
  /**
   * Sets the unique field that identifies a node.
   */
  idField;
  /**
   * @hidden
   */
  set filter(term) {
    super.filter = term;
  }
  constructor(dropDownTree) {
    super(dropDownTree);
    this.dropDownTree = dropDownTree;
  }
  ngOnChanges(changes) {
    if (isChanged('nodes', changes, false)) {
      this.dropDownTree.nodes = changes['nodes'].currentValue;
      super.nodes = changes['nodes'].currentValue;
    }
    super.ngOnChanges(changes);
  }
  static ɵfac = function DropDownTreeFlatBindingDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropDownTreeFlatBindingDirective)(i0.ɵɵdirectiveInject(i1$1.DataBoundComponent));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DropDownTreeFlatBindingDirective,
    selectors: [["", "kendoDropDownTreeFlatBinding", ""]],
    inputs: {
      nodes: [0, "kendoDropDownTreeFlatBinding", "nodes"],
      idField: [0, "valueField", "idField"]
    },
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropDownTreeFlatBindingDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoDropDownTreeFlatBinding]',
      standalone: true
    }]
  }], () => [{
    type: i1$1.DataBoundComponent
  }], {
    nodes: [{
      type: Input,
      args: ['kendoDropDownTreeFlatBinding']
    }],
    idField: [{
      type: Input,
      args: ['valueField']
    }]
  });
})();

/**
 * Retrieves child nodes when the provided data is hierarchical.
 *
 * @example
 * ```html
 * <kendo-dropdowntree kendoDropDownTreeHierarchyBinding [nodes]="data" [valueField]="'id'"></kendo-dropdowntree>
 * ```
 *
 * @remarks
 * Applied to: {@link DropDownTreeComponent}.
 */
class DropDownTreeHierarchyBindingDirective extends HierarchyBindingDirective {
  dropDownTree;
  /**
   * Sets the nodes to display in the DropDownTree.
   */
  set nodes(nodes) {
    // Needs to be a setter so that it matches the accessor in FlatDataBindingDirective it extends
    this._nodes = nodes;
  }
  get nodes() {
    return this._nodes;
  }
  /**
   * @hidden
   */
  set filter(term) {
    super.filter = term;
  }
  constructor(dropDownTree) {
    super(dropDownTree);
    this.dropDownTree = dropDownTree;
  }
  ngOnChanges(changes) {
    if (isChanged('nodes', changes, false)) {
      this.dropDownTree.nodes = changes['nodes'].currentValue;
      super.nodes = changes['nodes'].currentValue;
    }
    super.ngOnChanges(changes);
  }
  static ɵfac = function DropDownTreeHierarchyBindingDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropDownTreeHierarchyBindingDirective)(i0.ɵɵdirectiveInject(i1$1.DataBoundComponent));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DropDownTreeHierarchyBindingDirective,
    selectors: [["", "kendoDropDownTreeHierarchyBinding", ""]],
    inputs: {
      nodes: [0, "kendoDropDownTreeHierarchyBinding", "nodes"]
    },
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropDownTreeHierarchyBindingDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoDropDownTreeHierarchyBinding]',
      standalone: true
    }]
  }], () => [{
    type: i1$1.DataBoundComponent
  }], {
    nodes: [{
      type: Input,
      args: ['kendoDropDownTreeHierarchyBinding']
    }]
  });
})();

/**
 * Retrieves child nodes when the provided data is flat for the MultiSelectTree.
 *
 * @example
 * ```html
 * <kendo-multiselecttree kendoMultiSelectTreeFlatBinding [nodes]="data" [valueField]="'id'"></kendo-multiselecttree>
 * ```
 *
 * @remarks
 * Applied to: {@link MultiSelectTreeComponent}.
 */
class MultiSelectTreeFlatBindingDirective extends FlatDataBindingDirective {
  multiSelectTree;
  /**
   * Sets the nodes to display in the MultiSelectTree.
   */
  set nodes(nodes) {
    // Needs to be a setter so that it matches the accessor in FlatDataBindingDirective it extends
    this._nodes = nodes;
  }
  get nodes() {
    return this._nodes;
  }
  /**
   * Sets the unique field that identifies a node.
   */
  idField;
  /**
   * @hidden
   */
  set filter(term) {
    super.filter = term;
  }
  constructor(multiSelectTree) {
    super(multiSelectTree);
    this.multiSelectTree = multiSelectTree;
  }
  ngOnChanges(changes) {
    if (isChanged('nodes', changes, false)) {
      this.multiSelectTree.nodes = changes['nodes'].currentValue;
      super.nodes = changes['nodes'].currentValue;
    }
    super.ngOnChanges(changes);
  }
  static ɵfac = function MultiSelectTreeFlatBindingDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MultiSelectTreeFlatBindingDirective)(i0.ɵɵdirectiveInject(i1$1.DataBoundComponent));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: MultiSelectTreeFlatBindingDirective,
    selectors: [["", "kendoMultiSelectTreeFlatBinding", ""]],
    inputs: {
      nodes: [0, "kendoMultiSelectTreeFlatBinding", "nodes"],
      idField: [0, "valueField", "idField"]
    },
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiSelectTreeFlatBindingDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoMultiSelectTreeFlatBinding]',
      standalone: true
    }]
  }], () => [{
    type: i1$1.DataBoundComponent
  }], {
    nodes: [{
      type: Input,
      args: ['kendoMultiSelectTreeFlatBinding']
    }],
    idField: [{
      type: Input,
      args: ['valueField']
    }]
  });
})();

/**
 * Retrieves child nodes when the provided data is hierarchical for the MultiSelectTree.
 *
 * * @example
 * ```html
 * <kendo-multiselecttree kendoMultiSelectTreeHierarchyBinding [nodes]="data" [valueField]="'id'"></kendo-multiselecttree>
 * ```
 *
 * @remarks
 * Applied to: {@link MultiSelectTreeComponent}.
 */
class MultiSelectTreeHierarchyBindingDirective extends HierarchyBindingDirective {
  multiSelectTree;
  /**
   * Sets the nodes to display in the MultiSelectTree.
   */
  set nodes(nodes) {
    // Needs to be a setter so that it matches the accessor in FlatDataBindingDirective it extends
    this._nodes = nodes;
  }
  get nodes() {
    return this._nodes;
  }
  /**
   * @hidden
   */
  set filter(term) {
    super.filter = term;
  }
  constructor(multiSelectTree) {
    super(multiSelectTree);
    this.multiSelectTree = multiSelectTree;
  }
  ngOnChanges(changes) {
    if (isChanged('nodes', changes, false)) {
      this.multiSelectTree.nodes = changes['nodes'].currentValue;
      super.nodes = changes['nodes'].currentValue;
    }
    super.ngOnChanges(changes);
  }
  static ɵfac = function MultiSelectTreeHierarchyBindingDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MultiSelectTreeHierarchyBindingDirective)(i0.ɵɵdirectiveInject(i1$1.DataBoundComponent));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: MultiSelectTreeHierarchyBindingDirective,
    selectors: [["", "kendoMultiSelectTreeHierarchyBinding", ""]],
    inputs: {
      nodes: [0, "kendoMultiSelectTreeHierarchyBinding", "nodes"]
    },
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiSelectTreeHierarchyBindingDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoMultiSelectTreeHierarchyBinding]',
      standalone: true
    }]
  }], () => [{
    type: i1$1.DataBoundComponent
  }], {
    nodes: [{
      type: Input,
      args: ['kendoMultiSelectTreeHierarchyBinding']
    }]
  });
})();

/**
 * Manages the expanded state of the popup TreeView.
 * @example
 * ```html
 * <kendo-dropdowntree kendoDropDownTreeExpandable></kendo-dropdowntree>
 * ```
 * @example
 * ```html
 * <kendo-multiselecttree kendoMultiSelectTreeExpandable> </kendo-multiselecttree>
 * ```
 * @remarks
 * Applied to: {@link DropDownTreeComponent}, {@link MultiSelectTreeComponent}.
 */
class DropDownTreesExpandDirective extends ExpandDirective {
  dropDownTree;
  /**
   * @hidden
   *
   * Ensures a user-defined `isNodeExpanded` callback will not be overriden by the default directive setup.
   * Implemented as a value setter in the base directive, this just overrides the input name.
   */
  set isExpanded(value) {
    this.dropDownTree.isExpanded = value;
  }
  constructor(dropDownTree) {
    super(dropDownTree);
    this.dropDownTree = dropDownTree;
  }
  static ɵfac = function DropDownTreesExpandDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropDownTreesExpandDirective)(i0.ɵɵdirectiveInject(i1$1.ExpandableComponent));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DropDownTreesExpandDirective,
    selectors: [["", "kendoDropDownTreeExpandable", ""], ["", "kendoMultiSelectTreeExpandable", ""]],
    inputs: {
      isExpanded: [0, "isNodeExpanded", "isExpanded"]
    },
    features: [i0.ɵɵInheritDefinitionFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropDownTreesExpandDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoDropDownTreeExpandable], [kendoMultiSelectTreeExpandable]',
      standalone: true
    }]
  }], () => [{
    type: i1$1.ExpandableComponent
  }], {
    isExpanded: [{
      type: Input,
      args: ['isNodeExpanded']
    }]
  });
})();
const DEFAULT_FILTER_SETTINGS = {
  caseSensitive: false,
  operator: 'startsWith'
};
/**
 * Implements an event handler for the `filterChange` event of a DropDowns component
 * which performs simple data filtering.
 * Currently, the built-in filtering does not work with [grouped data](https://www.telerik.com/kendo-angular-ui/components/data-query/api/groupby).
 *
 * @example
 * ```ts
 * @Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-autocomplete
 *      [data]="data"
 *      kendoDropDownFilter
 *      placeholder="e.g. Andorra"
 *  >
 *  </kendo-autocomplete>
 * `
 * })
 * class AppComponent {
 *     public data: Array<string> = ["Albania", "Andorra", "Armenia", "Austria", "Azerbaijan"];
 * }
 * ```
 * @remarks
 * Applied to: {@link AutoCompleteComponent}, {@link ComboBoxComponent}, {@link DropDownListComponent}, {@link MultiColumnComboBoxComponent}, {@link MultiSelectComponent}.
 */
class FilterDirective {
  component;
  /**
   * The initial data that will be used as a source array for the filtering operations.
   */
  set data(data) {
    this._data = data || [];
  }
  get data() {
    return this._data;
  }
  /**
   * The configuration object which sets the behavior of the `kendoDropDownFilter` directive.
   * If no [DropDownFilterSettings](https://www.telerik.com/kendo-angular-ui/components/dropdowns/api/dropdownfiltersettings) object is provided to this input, the directive will use the default interface settings.
   */
  rawSettings;
  /**
   * @hidden
   *
   * Sets whether the filtering functionality is enabled on component init.
   */
  filterable = true;
  _data = [];
  filterChangeSubscription;
  constructor(component) {
    this.component = component;
  }
  ngOnInit() {
    this.component.filterable = this.filterable;
    this.filterChangeSubscription = this.component.filterChange.subscribe(this.handleFilterChange.bind(this));
  }
  ngOnDestroy() {
    if (isPresent(this.filterChangeSubscription)) {
      this.filterChangeSubscription.unsubscribe();
    }
  }
  handleFilterChange(query) {
    this.component.data = this.data.filter(item => this.matchesAnyField(item, query));
  }
  matchesAnyField(item, query) {
    const normalizedQuery = this.normalizeValue(query);
    const {
      fields
    } = this.filterSettings;
    // if no filter fields are present, we are dealing with primitive data
    if (fields.length === 0) {
      return this.checkItem(item, normalizedQuery);
    }
    return fields.some(field => this.checkItem(getter(item, field), normalizedQuery));
  }
  checkItem(target, query) {
    target = this.normalizeValue(target);
    if (this.filterSettings.operator === 'contains') {
      return target.indexOf(query) !== -1;
    } else {
      return target.startsWith(query);
    }
  }
  normalizeValue(value) {
    const normalizedValue = isPresent(value) ? value.toString() : '';
    return this.filterSettings.caseSensitive ? normalizedValue : normalizedValue.toLowerCase();
  }
  getFilterFields(providedFields) {
    // ignore provided fields if the component deals with primitive data
    if (!this.component.textField && !this.component.valueField) {
      return [];
    }
    if (isArray(providedFields) && providedFields.length > 0) {
      return providedFields;
    } else {
      // the autocomplete uses `valueField` for text extraction
      const textField = this.component.textField || this.component.valueField;
      return [textField];
    }
  }
  get filterSettings() {
    const settings = this.rawSettings;
    const providedFields = isPresent(settings) && typeof settings === 'object' ? settings.fields : [];
    return Object.assign({}, DEFAULT_FILTER_SETTINGS, settings, {
      fields: this.getFilterFields(providedFields)
    });
  }
  static ɵfac = function FilterDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || FilterDirective)(i0.ɵɵdirectiveInject(FilterableComponent));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: FilterDirective,
    selectors: [["", "kendoDropDownFilter", ""]],
    inputs: {
      data: "data",
      rawSettings: [0, "kendoDropDownFilter", "rawSettings"],
      filterable: "filterable"
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoDropDownFilter]',
      standalone: true
    }]
  }], () => [{
    type: FilterableComponent
  }], {
    data: [{
      type: Input
    }],
    rawSettings: [{
      type: Input,
      args: ['kendoDropDownFilter']
    }],
    filterable: [{
      type: Input
    }]
  });
})();

/**
 * Custom component messages override default component messages
 * ([see example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/globalization#messages)).
 *
 * @example
 * ```html
 * <kendo-dropdownlist>
 *   <kendo-dropdownlist-messages
 *     noDataText="No items found"
 *     clearTitle="Clear selection">
 *   </kendo-dropdownlist-messages>
 * </kendo-dropdownlist>
 *
 * <kendo-combobox>
 *   <kendo-combobox-messages
 *     noDataText="No items found"
 *     filterInputPlaceholder="Search items">
 *   </kendo-combobox-messages>
 * </kendo-combobox>
 *
 * <kendo-multicolumncombobox>
 *   <kendo-multicolumncombobox-messages
 *     noDataText="No items found"
 *     clearTitle="Clear selection">
 *   </kendo-multicolumncombobox-messages>
 * </kendo-multicolumncombobox>
 *
 * <kendo-autocomplete>
 *   <kendo-autocomplete-messages
 *     noDataText="No items found"
 *     filterInputPlaceholder="Type to search">
 *   </kendo-autocomplete-messages>
 * </kendo-autocomplete>
 *
 * <kendo-multiselect>
 *   <kendo-multiselect-messages
 *     checkAllText="Select all"
 *     clearTitle="Clear all">
 *   </kendo-multiselect-messages>
 * </kendo-multiselect>
 *
 * <kendo-dropdowntree>
 *   <kendo-dropdowntree-messages
 *     noDataText="No items found"
 *     selectButtonText="Select item">
 *   </kendo-dropdowntree-messages>
 * </kendo-dropdowntree>
 *
 * <kendo-multiselecttree>
 *   <kendo-multiselecttree-messages
 *     checkAllText="Select all"
 *     clearTitle="Clear all">
 *   </kendo-multiselecttree-messages>
 * </kendo-multiselecttree>
 * ```
 */
class CustomMessagesComponent extends Messages {
  service;
  constructor(service) {
    super();
    this.service = service;
  }
  get override() {
    return true;
  }
  static ɵfac = function CustomMessagesComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CustomMessagesComponent)(i0.ɵɵdirectiveInject(i1.LocalizationService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CustomMessagesComponent,
    selectors: [["kendo-dropdownlist-messages"], ["kendo-combobox-messages"], ["kendo-multicolumncombobox-messages"], ["kendo-autocomplete-messages"], ["kendo-multiselect-messages"], ["kendo-dropdowntree-messages"], ["kendo-multiselecttree-messages"]],
    features: [i0.ɵɵProvidersFeature([{
      provide: Messages,
      useExisting: forwardRef(() => CustomMessagesComponent)
    }]), i0.ɵɵInheritDefinitionFeature],
    decls: 0,
    vars: 0,
    template: function CustomMessagesComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomMessagesComponent, [{
    type: Component,
    args: [{
      providers: [{
        provide: Messages,
        useExisting: forwardRef(() => CustomMessagesComponent)
      }],
      selector: 'kendo-dropdownlist-messages,kendo-combobox-messages,kendo-multicolumncombobox-messages,kendo-autocomplete-messages,kendo-multiselect-messages,kendo-dropdowntree-messages,kendo-multiselecttree-messages',
      template: ``,
      standalone: true
    }]
  }], () => [{
    type: i1.LocalizationService
  }], null);
})();

/**
 * Configures the MultiSelect to show one summary tag for all selected items.
 * Set a number to display the summary tag after the respective number of items are selected.
 * [See example](https://www.telerik.com/kendo-angular-ui/components/dropdowns/multiselect/summary-tag-mode).
 *
 * @example
 * ```ts-no-run
 * <kendo-multiselect kendoMultiSelectSummaryTag [data]="data"></kendo-multiselect>
 * ```
 *
 * @example
 * ```ts-no-run
 * <kendo-multiselect [kendoMultiSelectSummaryTag]="2" [data]="data"></kendo-multiselect>
 * ```
 */
class SummaryTagDirective {
  multiSelectComponent;
  /**
   * Sets the number of selected items after which the summary tag appears.
   *
   * @default 0
   */
  showAfter = 0;
  constructor(multiSelectComponent) {
    this.multiSelectComponent = multiSelectComponent;
    this.createTagMapper();
  }
  ngOnChanges(changes) {
    if (isPresent(changes.showAfter)) {
      this.createTagMapper();
      this.multiSelectComponent.onTagMapperChange();
    }
  }
  createTagMapper() {
    const showAfter = parseNumber(this.showAfter);
    this.multiSelectComponent.tagMapper = tags => {
      if (tags.length > showAfter) {
        const result = tags.slice(0, showAfter);
        result.push(tags.slice(showAfter, tags.length));
        return result;
      } else {
        return tags;
      }
    };
  }
  static ɵfac = function SummaryTagDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SummaryTagDirective)(i0.ɵɵdirectiveInject(MultiSelectComponent));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: SummaryTagDirective,
    selectors: [["", "kendoMultiSelectSummaryTag", ""]],
    inputs: {
      showAfter: [0, "kendoMultiSelectSummaryTag", "showAfter"]
    },
    features: [i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SummaryTagDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoMultiSelectSummaryTag]',
      standalone: true
    }]
  }], () => [{
    type: MultiSelectComponent
  }], {
    showAfter: [{
      type: Input,
      args: ['kendoMultiSelectSummaryTag']
    }]
  });
})();

/**
 * Configures the MultiSelectTree to show one single summary tag for all selected data items.
 * When a number is set, the summary tag is shown after the corresponding number of data items are selected (see examples).
 * See [more information and examples](https://www.telerik.com/kendo-angular-ui/components/dropdowns/api/multiselecttreesummarytagdirective).
 *
 * @example
 * ```html
 * <kendo-multiselecttree kendoMultiSelectTreeSummaryTag [data]="data"></kendo-multiselecttree>
 * ```
 *
 * @example
 * ```html
 * <kendo-multiselecttree [kendoMultiSelectTreeSummaryTag]="2" [data]="data"></kendo-multiselecttree>
 * ```
 *
 * @remarks
 * Applied to: {@link MultiSelectTreeComponent}.
 */
class MultiSelectTreeSummaryTagDirective {
  multiSelectTreeComponent;
  /**
   * Sets the number of data items that need to be selected before the summary tag appears.
   *
   * @default 0
   */
  showAfter = 0;
  constructor(multiSelectTreeComponent) {
    this.multiSelectTreeComponent = multiSelectTreeComponent;
    this.createTagMapper();
  }
  ngOnChanges(changes) {
    if (isPresent(changes.showAfter)) {
      this.createTagMapper();
      this.multiSelectTreeComponent.handleTagMapperChange(this.showAfter);
    }
  }
  createTagMapper() {
    const showAfter = parseNumber(this.showAfter);
    this.multiSelectTreeComponent.tagMapper = tags => {
      if (tags.length > showAfter) {
        // tags provided in an array are rendered as a single group tag
        return [...tags.slice(0, showAfter), tags.slice(showAfter)];
      } else {
        return tags;
      }
    };
  }
  static ɵfac = function MultiSelectTreeSummaryTagDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MultiSelectTreeSummaryTagDirective)(i0.ɵɵdirectiveInject(MultiSelectTreeComponent));
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: MultiSelectTreeSummaryTagDirective,
    selectors: [["", "kendoMultiSelectTreeSummaryTag", ""]],
    inputs: {
      showAfter: [0, "kendoMultiSelectTreeSummaryTag", "showAfter"]
    },
    features: [i0.ɵɵNgOnChangesFeature]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiSelectTreeSummaryTagDirective, [{
    type: Directive,
    args: [{
      selector: '[kendoMultiSelectTreeSummaryTag]',
      standalone: true
    }]
  }], () => [{
    type: MultiSelectTreeComponent
  }], {
    showAfter: [{
      type: Input,
      args: ['kendoMultiSelectTreeSummaryTag']
    }]
  });
})();

/**
 * Utility array that contains all `AutoComplete` related components and directives
 */
const KENDO_AUTOCOMPLETE = [AutoCompleteComponent, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, SuffixTemplateDirective, PrefixTemplateDirective, SeparatorComponent];
/**
 * Utility array that contains all `ComboBox` related components and directives
 */
const KENDO_COMBOBOX = [ComboBoxComponent, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, SuffixTemplateDirective, PrefixTemplateDirective, SeparatorComponent, ToggleButtonTabStopDirective];
/**
 * Utility array that contains all `MultiColumnComboBox` related components and directives
 */
const KENDO_MULTICOLUMNCOMBOBOX = [MultiColumnComboBoxComponent, ComboBoxColumnComponent, ColumnHeaderTemplateDirective, ColumnCellTemplateDirective, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, SuffixTemplateDirective, PrefixTemplateDirective, SeparatorComponent, ToggleButtonTabStopDirective];
/**
 * Utility array that contains all `DropDownList` related components and directives
 */
const KENDO_DROPDOWNLIST = [DropDownListComponent, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, ValueTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent];
/**
 * Utility array that contains all `MultiSelect` related components and directives
 */
const KENDO_MULTISELECT = [MultiSelectComponent, SummaryTagDirective, CustomItemTemplateDirective, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, GroupTagTemplateDirective, TagTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, SuffixTemplateDirective, PrefixTemplateDirective, SeparatorComponent];
/**
 * Utility array that contains all `DropDownTree` related components and directives
 */
const KENDO_DROPDOWNTREE = [DropDownTreeComponent, DropDownTreeFlatBindingDirective, DropDownTreeHierarchyBindingDirective, DropDownTreesExpandDirective, NodeTemplateDirective, HeaderTemplateDirective, FooterTemplateDirective, ValueTemplateDirective, NoDataTemplateDirective, CustomMessagesComponent];
/**
 * Utility array that contains all `MultiSelectTree` related components and directives
 */
const KENDO_MULTISELECTTREE = [MultiSelectTreeComponent, MultiSelectTreeFlatBindingDirective, MultiSelectTreeHierarchyBindingDirective, DropDownTreesExpandDirective, NodeTemplateDirective, MultiSelectTreeSummaryTagDirective, GroupTagTemplateDirective, TagTemplateDirective, HeaderTemplateDirective, FooterTemplateDirective, ValueTemplateDirective, NoDataTemplateDirective, CustomMessagesComponent];
/**
 * Utility array that contains all `@progress/kendo-angular-dropdowns` related components and directives
 */
const KENDO_DROPDOWNS = [...KENDO_AUTOCOMPLETE, ...KENDO_COMBOBOX, ...KENDO_MULTICOLUMNCOMBOBOX, ...KENDO_DROPDOWNLIST, ...KENDO_MULTISELECT, ...KENDO_DROPDOWNTREE, ...KENDO_MULTISELECTTREE];

// IMPORTANT: NgModule export kept for backwards compatibility
/**
 * Required for adding all DropDownTree features in NgModule-based Angular applications.
 * - `MultiSelectTreeComponent`&mdash;The MultiSelectTree component class.
 * - `DropDownTreeComponent`&mdash;The DropDownTree component class.
 * - `MultiSelectTreeFlatBindingDirective`&mdash;The MultiSelectTree flat binding directive.
 * - `DropDownTreeFlatBindingDirective`&mdash;The DropDownTree flat binding directive.
 * - `MultiSelectTreeHierarchyBindingDirective`&mdash;The MultiSelectTree hierarchy binding directive.
 * - `DropDownTreeHierarchyBindingDirective`&mdash;The DropDownTree hierarchy binding directive.
 * - `DropDownTreesExpandDirective`&mdash;The DropDownTreesExpand directive.
 * - `NodeTemplateDirective`&mdash;The node template directive.
 * - `MultiSelectTreeSummaryTagDirective`&mdash;The MultiSelectTreeSummaryTag directive.
 * - `TagTemplateDirective`&mdash;The tag template directive.
 * - `GroupTagTemplateDirective`&mdash;The group tag template directive.
 * - `HeaderTemplateDirective`&mdash;The header template directive.
 * - `FooterTemplateDirective`&mdash;The footer template directive.
 * - `ValueTemplateDirective`&mdash;The value template directive.
 * - `NoDataTemplateDirective`&mdash;The no-data template directive.
 * - `CustomMessagesComponent`&mdash;The custom messages component.
 */
class DropDownTreesModule {
  static ɵfac = function DropDownTreesModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropDownTreesModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DropDownTreesModule,
    imports: [DropDownTreeComponent, DropDownTreeFlatBindingDirective, DropDownTreeHierarchyBindingDirective, DropDownTreesExpandDirective, NodeTemplateDirective, HeaderTemplateDirective, FooterTemplateDirective, ValueTemplateDirective, NoDataTemplateDirective, CustomMessagesComponent, MultiSelectTreeComponent, MultiSelectTreeFlatBindingDirective, MultiSelectTreeHierarchyBindingDirective, DropDownTreesExpandDirective, NodeTemplateDirective, MultiSelectTreeSummaryTagDirective, GroupTagTemplateDirective, TagTemplateDirective, HeaderTemplateDirective, FooterTemplateDirective, ValueTemplateDirective, NoDataTemplateDirective, CustomMessagesComponent],
    exports: [DropDownTreeComponent, DropDownTreeFlatBindingDirective, DropDownTreeHierarchyBindingDirective, DropDownTreesExpandDirective, NodeTemplateDirective, HeaderTemplateDirective, FooterTemplateDirective, ValueTemplateDirective, NoDataTemplateDirective, CustomMessagesComponent, MultiSelectTreeComponent, MultiSelectTreeFlatBindingDirective, MultiSelectTreeHierarchyBindingDirective, DropDownTreesExpandDirective, NodeTemplateDirective, MultiSelectTreeSummaryTagDirective, GroupTagTemplateDirective, TagTemplateDirective, HeaderTemplateDirective, FooterTemplateDirective, ValueTemplateDirective, NoDataTemplateDirective, CustomMessagesComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [IconsService, PopupService, ResizeBatchService, DialogContainerService, DialogService, WindowService, WindowContainerService, AdaptiveService],
    imports: [DropDownTreeComponent, MultiSelectTreeComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropDownTreesModule, [{
    type: NgModule,
    args: [{
      imports: [...KENDO_DROPDOWNTREE, ...KENDO_MULTISELECTTREE],
      exports: [...KENDO_DROPDOWNTREE, ...KENDO_MULTISELECTTREE],
      providers: [IconsService, PopupService, ResizeBatchService, DialogContainerService, DialogService, WindowService, WindowContainerService, AdaptiveService]
    }]
  }], null, null);
})();

// IMPORTANT: NgModule export kept for backwards compatibility
/**
 * Required for adding all DropDowns features in NgModule-based Angular applications.
 *
 * @example
 * ```typescript
 * // Import the DropDownsModule
 * import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
 * import { NgModule } from '@angular/core';
 * import { BrowserModule } from '@angular/platform-browser';
 * import { AppComponent } from './app.component';
 *
 * @NgModule({
 *   declarations: [AppComponent],
 *   imports: [BrowserModule, DropDownsModule],
 *   bootstrap: [AppComponent]
 * })
 * export class AppModule {}
 * ```
 */
class DropDownsModule {
  static ɵfac = function DropDownsModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropDownsModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DropDownsModule,
    imports: [AutoCompleteComponent, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, i10.SuffixTemplateDirective, i10.PrefixTemplateDirective, i10.SeparatorComponent, ComboBoxComponent, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, i10.SuffixTemplateDirective, i10.PrefixTemplateDirective, i10.SeparatorComponent, i10.ToggleButtonTabStopDirective, MultiColumnComboBoxComponent, ComboBoxColumnComponent, ColumnHeaderTemplateDirective, ColumnCellTemplateDirective, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, i10.SuffixTemplateDirective, i10.PrefixTemplateDirective, i10.SeparatorComponent, i10.ToggleButtonTabStopDirective, DropDownListComponent, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, ValueTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, MultiSelectComponent, SummaryTagDirective, CustomItemTemplateDirective, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, GroupTagTemplateDirective, TagTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, i10.SuffixTemplateDirective, i10.PrefixTemplateDirective, i10.SeparatorComponent, DropDownTreeComponent, DropDownTreeFlatBindingDirective, DropDownTreeHierarchyBindingDirective, DropDownTreesExpandDirective, NodeTemplateDirective, HeaderTemplateDirective, FooterTemplateDirective, ValueTemplateDirective, NoDataTemplateDirective, CustomMessagesComponent, MultiSelectTreeComponent, MultiSelectTreeFlatBindingDirective, MultiSelectTreeHierarchyBindingDirective, DropDownTreesExpandDirective, NodeTemplateDirective, MultiSelectTreeSummaryTagDirective, GroupTagTemplateDirective, TagTemplateDirective, HeaderTemplateDirective, FooterTemplateDirective, ValueTemplateDirective, NoDataTemplateDirective, CustomMessagesComponent, i10.PrefixTemplateDirective, i10.SuffixTemplateDirective, i10.SeparatorComponent, i10.ToggleButtonTabStopDirective],
    exports: [AutoCompleteComponent, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, i10.SuffixTemplateDirective, i10.PrefixTemplateDirective, i10.SeparatorComponent, ComboBoxComponent, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, i10.SuffixTemplateDirective, i10.PrefixTemplateDirective, i10.SeparatorComponent, i10.ToggleButtonTabStopDirective, MultiColumnComboBoxComponent, ComboBoxColumnComponent, ColumnHeaderTemplateDirective, ColumnCellTemplateDirective, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, i10.SuffixTemplateDirective, i10.PrefixTemplateDirective, i10.SeparatorComponent, i10.ToggleButtonTabStopDirective, DropDownListComponent, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, ValueTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, MultiSelectComponent, SummaryTagDirective, CustomItemTemplateDirective, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, GroupTagTemplateDirective, TagTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, i10.SuffixTemplateDirective, i10.PrefixTemplateDirective, i10.SeparatorComponent, DropDownTreeComponent, DropDownTreeFlatBindingDirective, DropDownTreeHierarchyBindingDirective, DropDownTreesExpandDirective, NodeTemplateDirective, HeaderTemplateDirective, FooterTemplateDirective, ValueTemplateDirective, NoDataTemplateDirective, CustomMessagesComponent, MultiSelectTreeComponent, MultiSelectTreeFlatBindingDirective, MultiSelectTreeHierarchyBindingDirective, DropDownTreesExpandDirective, NodeTemplateDirective, MultiSelectTreeSummaryTagDirective, GroupTagTemplateDirective, TagTemplateDirective, HeaderTemplateDirective, FooterTemplateDirective, ValueTemplateDirective, NoDataTemplateDirective, CustomMessagesComponent, i10.PrefixTemplateDirective, i10.SuffixTemplateDirective, i10.SeparatorComponent, i10.ToggleButtonTabStopDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [PopupService, ResizeBatchService, IconsService, DialogContainerService, DialogService, WindowService, WindowContainerService, AdaptiveService],
    imports: [AutoCompleteComponent, i10.SeparatorComponent, ComboBoxComponent, i10.SeparatorComponent, MultiColumnComboBoxComponent, i10.SeparatorComponent, DropDownListComponent, MultiSelectComponent, i10.SeparatorComponent, DropDownTreeComponent, MultiSelectTreeComponent, i10.SeparatorComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropDownsModule, [{
    type: NgModule,
    args: [{
      exports: [...KENDO_DROPDOWNS, ...KENDO_ADORNMENTS, ...KENDO_TOGGLEBUTTONTABSTOP],
      imports: [...KENDO_DROPDOWNS, ...KENDO_ADORNMENTS, ...KENDO_TOGGLEBUTTONTABSTOP],
      providers: [PopupService, ResizeBatchService, IconsService, DialogContainerService, DialogService, WindowService, WindowContainerService, AdaptiveService]
    }]
  }], null, null);
})();

// IMPORTANT: NgModule export kept for backwards compatibility
/**
 * Required for adding all MultiSelect features in NgModule-based Angular applications.
 *
 * This module exports all MultiSelect-related components and directives:
 * - `MultiSelectComponent`&mdash;The main MultiSelect component class.
 * - `SummaryTagDirective`&mdash;The summary tag directive for MultiSelect.
 * - `ItemTemplateDirective`&mdash;The item template directive.
 * - `CustomItemTemplateDirective`&mdash;The custom item template directive.
 * - `TagTemplateDirective`&mdash;The tag template directive.
 * - `GroupTagTemplateDirective`&mdash;The group tag template directive.
 * - `SummaryTagTemplateDirective`&mdash;The summary tag template directive.
 * - `HeaderTemplateDirective`&mdash;The header template directive.
 * - `FooterTemplateDirective`&mdash;The footer template directive.
 * - `NoDataTemplateDirective`&mdash;The no-data template directive.
 * - `FilterDirective`&mdash;The filter directive.
 * - `CustomMessagesComponent`&mdash;The custom messages component.
 * - `GroupTemplateDirective`&mdash;The group template directive.
 * - `FixedGroupTemplateDirective`&mdash;The fixed group template directive.
 * - `SuffixTemplateDirective`&mdash;The suffix template directive.
 * - `PrefixTemplateDirective`&mdash;The prefix template directive.
 *
 * ```ts
 * import { MultiSelectModule } from '@progress/kendo-angular-dropdowns';
 * @NgModule({
 *  imports: [ MultiSelectModule ],
 *  declarations: [ AppComponent ],
 *  bootstrap: [ AppComponent ],
 * })
 * ```
 */
class MultiSelectModule {
  static ɵfac = function MultiSelectModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MultiSelectModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MultiSelectModule,
    imports: [MultiSelectComponent, SummaryTagDirective, CustomItemTemplateDirective, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, GroupTagTemplateDirective, TagTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, i10.SuffixTemplateDirective, i10.PrefixTemplateDirective, i10.SeparatorComponent, i10.PrefixTemplateDirective, i10.SuffixTemplateDirective, i10.SeparatorComponent],
    exports: [MultiSelectComponent, SummaryTagDirective, CustomItemTemplateDirective, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, GroupTagTemplateDirective, TagTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, i10.SuffixTemplateDirective, i10.PrefixTemplateDirective, i10.SeparatorComponent, i10.PrefixTemplateDirective, i10.SuffixTemplateDirective, i10.SeparatorComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [PopupService, ResizeBatchService, IconsService, AdaptiveService],
    imports: [MultiSelectComponent, i10.SeparatorComponent, i10.SeparatorComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiSelectModule, [{
    type: NgModule,
    args: [{
      imports: [...KENDO_MULTISELECT, ...KENDO_ADORNMENTS],
      exports: [...KENDO_MULTISELECT, ...KENDO_ADORNMENTS],
      providers: [PopupService, ResizeBatchService, IconsService, AdaptiveService]
    }]
  }], null, null);
})();

// IMPORTANT: NgModule export kept for backwards compatibility
/**
 * Required for adding all AutoComplete features in NgModule-based Angular applications.
 *
 *  ```typescript
 *  import { AutoCompleteModule } from '@progress/kendo-angular-dropdowns';
 *  @NgModule({
 *  imports: [AutoCompleteModule],
 *  declarations: [AppComponent],
 *  bootstrap: [AppComponent]
 *  })
 *  ```
 *
 * The package exports:
 * - `AutoCompleteComponent`&mdash;The AutoComplete component class.
 * - `ItemTemplateDirective`&mdash;The item template directive.
 * - `HeaderTemplateDirective`&mdash;The header template directive.
 * - `FooterTemplateDirective`&mdash;The footer template directive.
 * - `NoDataTemplateDirective`&mdash;The no data template directive.
 * - `FixedGroupTemplateDirective`&mdash;The fixed group template directive.
 * - `GroupTemplateDirective`&mdash;The group template directive.
 * - `FilterDirective`&mdash;The filter directive.
 * - `CustomMessagesComponent`&mdash;The custom messages component.
 * - `SuffixTemplateDirective`&mdash;The suffix template directive.
 * - `PrefixTemplateDirective`&mdash;The prefix template directive.
 */
class AutoCompleteModule {
  static ɵfac = function AutoCompleteModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AutoCompleteModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: AutoCompleteModule,
    imports: [AutoCompleteComponent, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, i10.SuffixTemplateDirective, i10.PrefixTemplateDirective, i10.SeparatorComponent, i10.PrefixTemplateDirective, i10.SuffixTemplateDirective, i10.SeparatorComponent],
    exports: [AutoCompleteComponent, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, i10.SuffixTemplateDirective, i10.PrefixTemplateDirective, i10.SeparatorComponent, i10.PrefixTemplateDirective, i10.SuffixTemplateDirective, i10.SeparatorComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [PopupService, ResizeBatchService, IconsService, AdaptiveService],
    imports: [AutoCompleteComponent, i10.SeparatorComponent, i10.SeparatorComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AutoCompleteModule, [{
    type: NgModule,
    args: [{
      imports: [...KENDO_AUTOCOMPLETE, ...KENDO_ADORNMENTS],
      exports: [...KENDO_AUTOCOMPLETE, ...KENDO_ADORNMENTS],
      providers: [PopupService, ResizeBatchService, IconsService, AdaptiveService]
    }]
  }], null, null);
})();

// IMPORTANT: NgModule export kept for backwards compatibility
/**
 * Required for adding all ComboBox features in NgModule-based Angular applications.
 *
 * The package exports:
 * - `ComboBoxComponent`&mdash;The ComboBox component class.
 * - `ComboBoxColumnComponent`&mdash;The ComboBoxColumn component class.
 * - `MultiColumnComboBoxComponent`&mdash;The MultiColumnComboBox component class.
 * - `ItemTemplateDirective`&mdash;The item template directive.
 * - `HeaderTemplateDirective`&mdash;The header template directive.
 * - `FooterTemplateDirective`&mdash;The footer template directive.
 * - `NoDataTemplateDirective`&mdash;The no data template directive.
 * - `FixedGroupTemplateDirective`&mdash;The fixed group template directive.
 * - `GroupTemplateDirective`&mdash;The group template directive.
 * - `FilterDirective`&mdash;The filter directive.
 * - `CustomMessagesComponent`&mdash;The custom messages component.
 * - `SuffixTemplateDirective`&mdash;The suffix template directive.
 * - `PrefixTemplateDirective`&mdash;The prefix template directive.
 *
 * @example
 * ```typescript
 * import { ComboBoxModule } from '@progress/kendo-angular-dropdowns';
 *
 * @NgModule({
 *   imports: [ComboBoxModule]
 * })
 * class AppModule {}
 * ```
 */
class ComboBoxModule {
  static ɵfac = function ComboBoxModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ComboBoxModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: ComboBoxModule,
    imports: [ComboBoxComponent, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, i10.SuffixTemplateDirective, i10.PrefixTemplateDirective, i10.SeparatorComponent, i10.ToggleButtonTabStopDirective, MultiColumnComboBoxComponent, ComboBoxColumnComponent, ColumnHeaderTemplateDirective, ColumnCellTemplateDirective, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, i10.SuffixTemplateDirective, i10.PrefixTemplateDirective, i10.SeparatorComponent, i10.ToggleButtonTabStopDirective, i10.PrefixTemplateDirective, i10.SuffixTemplateDirective, i10.SeparatorComponent, i10.ToggleButtonTabStopDirective],
    exports: [ComboBoxComponent, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, i10.SuffixTemplateDirective, i10.PrefixTemplateDirective, i10.SeparatorComponent, i10.ToggleButtonTabStopDirective, MultiColumnComboBoxComponent, ComboBoxColumnComponent, ColumnHeaderTemplateDirective, ColumnCellTemplateDirective, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent, i10.SuffixTemplateDirective, i10.PrefixTemplateDirective, i10.SeparatorComponent, i10.ToggleButtonTabStopDirective, i10.PrefixTemplateDirective, i10.SuffixTemplateDirective, i10.SeparatorComponent, i10.ToggleButtonTabStopDirective]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [PopupService, ResizeBatchService, IconsService, AdaptiveService],
    imports: [ComboBoxComponent, i10.SeparatorComponent, MultiColumnComboBoxComponent, i10.SeparatorComponent, i10.SeparatorComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComboBoxModule, [{
    type: NgModule,
    args: [{
      imports: [...KENDO_COMBOBOX, ...KENDO_MULTICOLUMNCOMBOBOX, ...KENDO_ADORNMENTS, ...KENDO_TOGGLEBUTTONTABSTOP],
      exports: [...KENDO_COMBOBOX, ...KENDO_MULTICOLUMNCOMBOBOX, ...KENDO_ADORNMENTS, ...KENDO_TOGGLEBUTTONTABSTOP],
      providers: [PopupService, ResizeBatchService, IconsService, AdaptiveService]
    }]
  }], null, null);
})();

// IMPORTANT: NgModule export kept for backwards compatibility
/**
 * Required for adding all DropDownList features in NgModule-based Angular applications.
 *
 * ```typescript
 * import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
 * @NgModule({
 *  imports: [DropDownListModule],
 *  declarations: [AppComponent],
 *  bootstrap: [AppComponent]
 * })
 * ```
 *
 * The package exports:
 * - `DropDownListComponent`&mdash;The `DropDownListComponent` class.
 * - `ItemTemplateDirective`&mdash;The `ItemTemplateDirective` directive.
 * - `ValueTemplateDirective`&mdash;The `ValueTemplateDirective` directive.
 * - `HeaderTemplateDirective`&mdash;The `HeaderTemplateDirective` directive.
 * - `FooterTemplateDirective`&mdash;The `FooterTemplateDirective` directive.
 * - `NoDataTemplateDirective`&mdash;The `NoDataTemplateDirective` directive.
 * - `GroupTemplateDirective`&mdash;The `GroupTemplateDirective` directive.
 * - `FixedGroupTemplateDirective`&mdash;The `FixedGroupTemplateDirective` directive.
 * - `FilterDirective`&mdash;The `FilterDirective` directive.
 * - `CustomMessagesComponent`&mdash;The `CustomMessagesComponent` component.
 *
 * @example
 * ```typescript
 * import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
 *
 * @NgModule({
 *   imports: [DropDownListModule],
 * })
 * export class AppModule {}
 * ```
 */
class DropDownListModule {
  static ɵfac = function DropDownListModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DropDownListModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DropDownListModule,
    imports: [DropDownListComponent, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, ValueTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent],
    exports: [DropDownListComponent, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, ValueTemplateDirective, NoDataTemplateDirective, FilterDirective, CustomMessagesComponent]
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [PopupService, ResizeBatchService, IconsService, AdaptiveService],
    imports: [DropDownListComponent]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropDownListModule, [{
    type: NgModule,
    args: [{
      imports: [...KENDO_DROPDOWNLIST],
      exports: [...KENDO_DROPDOWNLIST],
      providers: [PopupService, ResizeBatchService, IconsService, AdaptiveService]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AdaptiveRendererComponent, AutoCompleteComponent, AutoCompleteModule, CheckAllDirective, CheckDirective, ColumnCellTemplateDirective, ColumnHeaderTemplateDirective, ComboBoxColumnComponent, ComboBoxComponent, ComboBoxModule, CustomItemTemplateDirective, CustomMessagesComponent, DataService, DisabledItemsService, DropDownListComponent, DropDownListModule, DropDownTreeComponent, DropDownTreeFlatBindingDirective, DropDownTreeHierarchyBindingDirective, DropDownTreesExpandDirective, DropDownTreesModule, DropDownsModule, FilterDirective, FilterInputDirective, FilterableComponent, FixedGroupTemplateDirective, FooterTemplateDirective, GroupTagTemplateDirective, GroupTemplateDirective, HeaderTemplateDirective, ItemTemplateDirective, KENDO_AUTOCOMPLETE, KENDO_COMBOBOX, KENDO_DROPDOWNLIST, KENDO_DROPDOWNS, KENDO_DROPDOWNTREE, KENDO_MULTICOLUMNCOMBOBOX, KENDO_MULTISELECT, KENDO_MULTISELECTTREE, ListComponent, ListItemDirective, LocalizedMessagesDirective, MultiColumnComboBoxComponent, MultiSelectComponent, MultiSelectModule, MultiSelectTreeComponent, MultiSelectTreeFlatBindingDirective, MultiSelectTreeHierarchyBindingDirective, MultiSelectTreeSummaryTagDirective, NavigationService, NoDataTemplateDirective, NodeTemplateDirective, PreventableEvent, RemoveTagEvent, SearchBarComponent, SelectableDirective, SelectionService, SummaryTagDirective, TagListComponent, TagTemplateDirective, ValueTemplateDirective };